import Pt, { createElement as Zp, useState as yn, useRef as wl, useEffect as Ie, createContext as Vv, useContext as Gv, useMemo as Yv } from "react";
import Iv from "react-dom";
function Fv(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var sf = { exports: {} }, zo = {}, ff = { exports: {} }, df = {};
var xA;
function kv() {
  return xA || (xA = 1, (function(l) {
    function o(V, j) {
      var q = V.length;
      V.push(j);
      t: for (; 0 < q; ) {
        var ut = q - 1 >>> 1, ht = V[ut];
        if (0 < u(ht, j))
          V[ut] = j, V[q] = ht, q = ut;
        else break t;
      }
    }
    function c(V) {
      return V.length === 0 ? null : V[0];
    }
    function s(V) {
      if (V.length === 0) return null;
      var j = V[0], q = V.pop();
      if (q !== j) {
        V[0] = q;
        t: for (var ut = 0, ht = V.length, Wt = ht >>> 1; ut < Wt; ) {
          var Ct = 2 * (ut + 1) - 1, lt = V[Ct], W = Ct + 1, Ot = V[W];
          if (0 > u(lt, q))
            W < ht && 0 > u(Ot, lt) ? (V[ut] = Ot, V[W] = q, ut = W) : (V[ut] = lt, V[Ct] = q, ut = Ct);
          else if (W < ht && 0 > u(Ot, q))
            V[ut] = Ot, V[W] = q, ut = W;
          else break t;
        }
      }
      return j;
    }
    function u(V, j) {
      var q = V.sortIndex - j.sortIndex;
      return q !== 0 ? q : V.id - j.id;
    }
    if (l.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var d = performance;
      l.unstable_now = function() {
        return d.now();
      };
    } else {
      var h = Date, A = h.now();
      l.unstable_now = function() {
        return h.now() - A;
      };
    }
    var y = [], S = [], B = 1, w = null, C = 3, _ = !1, H = !1, G = !1, F = !1, K = typeof setTimeout == "function" ? setTimeout : null, X = typeof clearTimeout == "function" ? clearTimeout : null, nt = typeof setImmediate < "u" ? setImmediate : null;
    function ot(V) {
      for (var j = c(S); j !== null; ) {
        if (j.callback === null) s(S);
        else if (j.startTime <= V)
          s(S), j.sortIndex = j.expirationTime, o(y, j);
        else break;
        j = c(S);
      }
    }
    function I(V) {
      if (G = !1, ot(V), !H)
        if (c(y) !== null)
          H = !0, k || (k = !0, Gt());
        else {
          var j = c(S);
          j !== null && xt(I, j.startTime - V);
        }
    }
    var k = !1, Y = -1, Z = 5, ct = -1;
    function wt() {
      return F ? !0 : !(l.unstable_now() - ct < Z);
    }
    function At() {
      if (F = !1, k) {
        var V = l.unstable_now();
        ct = V;
        var j = !0;
        try {
          t: {
            H = !1, G && (G = !1, X(Y), Y = -1), _ = !0;
            var q = C;
            try {
              e: {
                for (ot(V), w = c(y); w !== null && !(w.expirationTime > V && wt()); ) {
                  var ut = w.callback;
                  if (typeof ut == "function") {
                    w.callback = null, C = w.priorityLevel;
                    var ht = ut(
                      w.expirationTime <= V
                    );
                    if (V = l.unstable_now(), typeof ht == "function") {
                      w.callback = ht, ot(V), j = !0;
                      break e;
                    }
                    w === c(y) && s(y), ot(V);
                  } else s(y);
                  w = c(y);
                }
                if (w !== null) j = !0;
                else {
                  var Wt = c(S);
                  Wt !== null && xt(
                    I,
                    Wt.startTime - V
                  ), j = !1;
                }
              }
              break t;
            } finally {
              w = null, C = q, _ = !1;
            }
            j = void 0;
          }
        } finally {
          j ? Gt() : k = !1;
        }
      }
    }
    var Gt;
    if (typeof nt == "function")
      Gt = function() {
        nt(At);
      };
    else if (typeof MessageChannel < "u") {
      var Tt = new MessageChannel(), St = Tt.port2;
      Tt.port1.onmessage = At, Gt = function() {
        St.postMessage(null);
      };
    } else
      Gt = function() {
        K(At, 0);
      };
    function xt(V, j) {
      Y = K(function() {
        V(l.unstable_now());
      }, j);
    }
    l.unstable_IdlePriority = 5, l.unstable_ImmediatePriority = 1, l.unstable_LowPriority = 4, l.unstable_NormalPriority = 3, l.unstable_Profiling = null, l.unstable_UserBlockingPriority = 2, l.unstable_cancelCallback = function(V) {
      V.callback = null;
    }, l.unstable_forceFrameRate = function(V) {
      0 > V || 125 < V ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : Z = 0 < V ? Math.floor(1e3 / V) : 5;
    }, l.unstable_getCurrentPriorityLevel = function() {
      return C;
    }, l.unstable_next = function(V) {
      switch (C) {
        case 1:
        case 2:
        case 3:
          var j = 3;
          break;
        default:
          j = C;
      }
      var q = C;
      C = j;
      try {
        return V();
      } finally {
        C = q;
      }
    }, l.unstable_requestPaint = function() {
      F = !0;
    }, l.unstable_runWithPriority = function(V, j) {
      switch (V) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          V = 3;
      }
      var q = C;
      C = V;
      try {
        return j();
      } finally {
        C = q;
      }
    }, l.unstable_scheduleCallback = function(V, j, q) {
      var ut = l.unstable_now();
      switch (typeof q == "object" && q !== null ? (q = q.delay, q = typeof q == "number" && 0 < q ? ut + q : ut) : q = ut, V) {
        case 1:
          var ht = -1;
          break;
        case 2:
          ht = 250;
          break;
        case 5:
          ht = 1073741823;
          break;
        case 4:
          ht = 1e4;
          break;
        default:
          ht = 5e3;
      }
      return ht = q + ht, V = {
        id: B++,
        callback: j,
        priorityLevel: V,
        startTime: q,
        expirationTime: ht,
        sortIndex: -1
      }, q > ut ? (V.sortIndex = q, o(S, V), c(y) === null && V === c(S) && (G ? (X(Y), Y = -1) : G = !0, xt(I, q - ut))) : (V.sortIndex = ht, o(y, V), H || _ || (H = !0, k || (k = !0, Gt()))), V;
    }, l.unstable_shouldYield = wt, l.unstable_wrapCallback = function(V) {
      var j = C;
      return function() {
        var q = C;
        C = j;
        try {
          return V.apply(this, arguments);
        } finally {
          C = q;
        }
      };
    };
  })(df)), df;
}
var CA;
function qv() {
  return CA || (CA = 1, ff.exports = kv()), ff.exports;
}
var NA;
function Kv() {
  if (NA) return zo;
  NA = 1;
  var l = { env: { NODE_ENV: "production" } };
  var o = qv(), c = Pt, s = Iv;
  function u(t) {
    var e = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      e += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        e += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function d(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11);
  }
  function h(t) {
    var e = t, n = t;
    if (t.alternate) for (; e.return; ) e = e.return;
    else {
      t = e;
      do
        e = t, (e.flags & 4098) !== 0 && (n = e.return), t = e.return;
      while (t);
    }
    return e.tag === 3 ? n : null;
  }
  function A(t) {
    if (t.tag === 13) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function y(t) {
    if (t.tag === 31) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function S(t) {
    if (h(t) !== t)
      throw Error(u(188));
  }
  function B(t) {
    var e = t.alternate;
    if (!e) {
      if (e = h(t), e === null) throw Error(u(188));
      return e !== t ? null : t;
    }
    for (var n = t, a = e; ; ) {
      var i = n.return;
      if (i === null) break;
      var r = i.alternate;
      if (r === null) {
        if (a = i.return, a !== null) {
          n = a;
          continue;
        }
        break;
      }
      if (i.child === r.child) {
        for (r = i.child; r; ) {
          if (r === n) return S(i), t;
          if (r === a) return S(i), e;
          r = r.sibling;
        }
        throw Error(u(188));
      }
      if (n.return !== a.return) n = i, a = r;
      else {
        for (var f = !1, m = i.child; m; ) {
          if (m === n) {
            f = !0, n = i, a = r;
            break;
          }
          if (m === a) {
            f = !0, a = i, n = r;
            break;
          }
          m = m.sibling;
        }
        if (!f) {
          for (m = r.child; m; ) {
            if (m === n) {
              f = !0, n = r, a = i;
              break;
            }
            if (m === a) {
              f = !0, a = r, n = i;
              break;
            }
            m = m.sibling;
          }
          if (!f) throw Error(u(189));
        }
      }
      if (n.alternate !== a) throw Error(u(190));
    }
    if (n.tag !== 3) throw Error(u(188));
    return n.stateNode.current === n ? t : e;
  }
  function w(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t;
    for (t = t.child; t !== null; ) {
      if (e = w(t), e !== null) return e;
      t = t.sibling;
    }
    return null;
  }
  var C = Object.assign, _ = Symbol.for("react.element"), H = Symbol.for("react.transitional.element"), G = Symbol.for("react.portal"), F = Symbol.for("react.fragment"), K = Symbol.for("react.strict_mode"), X = Symbol.for("react.profiler"), nt = Symbol.for("react.consumer"), ot = Symbol.for("react.context"), I = Symbol.for("react.forward_ref"), k = Symbol.for("react.suspense"), Y = Symbol.for("react.suspense_list"), Z = Symbol.for("react.memo"), ct = Symbol.for("react.lazy"), wt = Symbol.for("react.activity"), At = Symbol.for("react.memo_cache_sentinel"), Gt = Symbol.iterator;
  function Tt(t) {
    return t === null || typeof t != "object" ? null : (t = Gt && t[Gt] || t["@@iterator"], typeof t == "function" ? t : null);
  }
  var St = Symbol.for("react.client.reference");
  function xt(t) {
    if (t == null) return null;
    if (typeof t == "function")
      return t.$$typeof === St ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case F:
        return "Fragment";
      case X:
        return "Profiler";
      case K:
        return "StrictMode";
      case k:
        return "Suspense";
      case Y:
        return "SuspenseList";
      case wt:
        return "Activity";
    }
    if (typeof t == "object")
      switch (t.$$typeof) {
        case G:
          return "Portal";
        case ot:
          return t.displayName || "Context";
        case nt:
          return (t._context.displayName || "Context") + ".Consumer";
        case I:
          var e = t.render;
          return t = t.displayName, t || (t = e.displayName || e.name || "", t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
        case Z:
          return e = t.displayName || null, e !== null ? e : xt(t.type) || "Memo";
        case ct:
          e = t._payload, t = t._init;
          try {
            return xt(t(e));
          } catch {
          }
      }
    return null;
  }
  var V = Array.isArray, j = c.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, q = s.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ut = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, ht = [], Wt = -1;
  function Ct(t) {
    return { current: t };
  }
  function lt(t) {
    0 > Wt || (t.current = ht[Wt], ht[Wt] = null, Wt--);
  }
  function W(t, e) {
    Wt++, ht[Wt] = t.current, t.current = e;
  }
  var Ot = Ct(null), Mt = Ct(null), me = Ct(null), Ut = Ct(null);
  function we(t, e) {
    switch (W(me, e), W(Mt, t), W(Ot, null), e.nodeType) {
      case 9:
      case 11:
        t = (t = e.documentElement) && (t = t.namespaceURI) ? Zg(t) : 0;
        break;
      default:
        if (t = e.tagName, e = e.namespaceURI)
          e = Zg(e), t = Pg(e, t);
        else
          switch (t) {
            case "svg":
              t = 1;
              break;
            case "math":
              t = 2;
              break;
            default:
              t = 0;
          }
    }
    lt(Ot), W(Ot, t);
  }
  function ie() {
    lt(Ot), lt(Mt), lt(me);
  }
  function nn(t) {
    t.memoizedState !== null && W(Ut, t);
    var e = Ot.current, n = Pg(e, t.type);
    e !== n && (W(Mt, t), W(Ot, n));
  }
  function ll(t) {
    Mt.current === t && (lt(Ot), lt(Mt)), Ut.current === t && (lt(Ut), Do._currentValue = ut);
  }
  var il, Qi;
  function Rn(t) {
    if (il === void 0)
      try {
        throw Error();
      } catch (n) {
        var e = n.stack.trim().match(/\n( *(at )?)/);
        il = e && e[1] || "", Qi = -1 < n.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < n.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + il + t + Qi;
  }
  var an = !1;
  function Pn(t, e) {
    if (!t || an) return "";
    an = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (e) {
              var R = function() {
                throw Error();
              };
              if (Object.defineProperty(R.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(R, []);
                } catch (M) {
                  var N = M;
                }
                Reflect.construct(t, [], R);
              } else {
                try {
                  R.call();
                } catch (M) {
                  N = M;
                }
                t.call(R.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (M) {
                N = M;
              }
              (R = t()) && typeof R.catch == "function" && R.catch(function() {
              });
            }
          } catch (M) {
            if (M && N && typeof M.stack == "string")
              return [M.stack, N.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var i = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      i && i.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var r = a.DetermineComponentFrameRoot(), f = r[0], m = r[1];
      if (f && m) {
        var p = f.split(`
`), x = m.split(`
`);
        for (i = a = 0; a < p.length && !p[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; i < x.length && !x[i].includes(
          "DetermineComponentFrameRoot"
        ); )
          i++;
        if (a === p.length || i === x.length)
          for (a = p.length - 1, i = x.length - 1; 1 <= a && 0 <= i && p[a] !== x[i]; )
            i--;
        for (; 1 <= a && 0 <= i; a--, i--)
          if (p[a] !== x[i]) {
            if (a !== 1 || i !== 1)
              do
                if (a--, i--, 0 > i || p[a] !== x[i]) {
                  var L = `
` + p[a].replace(" at new ", " at ");
                  return t.displayName && L.includes("<anonymous>") && (L = L.replace("<anonymous>", t.displayName)), L;
                }
              while (1 <= a && 0 <= i);
            break;
          }
      }
    } finally {
      an = !1, Error.prepareStackTrace = n;
    }
    return (n = t ? t.displayName || t.name : "") ? Rn(n) : "";
  }
  function Wn(t, e) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return Rn(t.type);
      case 16:
        return Rn("Lazy");
      case 13:
        return t.child !== e && e !== null ? Rn("Suspense Fallback") : Rn("Suspense");
      case 19:
        return Rn("SuspenseList");
      case 0:
      case 15:
        return Pn(t.type, !1);
      case 11:
        return Pn(t.type.render, !1);
      case 1:
        return Pn(t.type, !0);
      case 31:
        return Rn("Activity");
      default:
        return "";
    }
  }
  function Rl(t) {
    try {
      var e = "", n = null;
      do
        e += Wn(t, n), n = t, t = t.return;
      while (t);
      return e;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var ol = Object.prototype.hasOwnProperty, Un = o.unstable_scheduleCallback, ba = o.unstable_cancelCallback, Ul = o.unstable_shouldYield, ar = o.unstable_requestPaint, xe = o.unstable_now, lr = o.unstable_getCurrentPriorityLevel, Hl = o.unstable_ImmediatePriority, Sa = o.unstable_UserBlockingPriority, Sn = o.unstable_NormalPriority, ln = o.unstable_LowPriority, jl = o.unstable_IdlePriority, ir = o.log, or = o.unstable_setDisableYieldValue, Jn = null, Ce = null;
  function Fe(t) {
    if (typeof ir == "function" && or(t), Ce && typeof Ce.setStrictMode == "function")
      try {
        Ce.setStrictMode(Jn, t);
      } catch {
      }
  }
  var Ae = Math.clz32 ? Math.clz32 : Vi, on = Math.log, Oa = Math.LN2;
  function Vi(t) {
    return t >>>= 0, t === 0 ? 32 : 31 - (on(t) / Oa | 0) | 0;
  }
  var Ea = 256, Xl = 262144, Ta = 4194304;
  function On(t) {
    var e = t & 42;
    if (e !== 0) return e;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return t & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return t & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function Ql(t, e, n) {
    var a = t.pendingLanes;
    if (a === 0) return 0;
    var i = 0, r = t.suspendedLanes, f = t.pingedLanes;
    t = t.warmLanes;
    var m = a & 134217727;
    return m !== 0 ? (a = m & ~r, a !== 0 ? i = On(a) : (f &= m, f !== 0 ? i = On(f) : n || (n = m & ~t, n !== 0 && (i = On(n))))) : (m = a & ~r, m !== 0 ? i = On(m) : f !== 0 ? i = On(f) : n || (n = a & ~t, n !== 0 && (i = On(n)))), i === 0 ? 0 : e !== 0 && e !== i && (e & r) === 0 && (r = i & -i, n = e & -e, r >= n || r === 32 && (n & 4194048) !== 0) ? e : i;
  }
  function En(t, e) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & e) === 0;
  }
  function tu(t, e) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return e + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function rr() {
    var t = Ta;
    return Ta <<= 1, (Ta & 62914560) === 0 && (Ta = 4194304), t;
  }
  function Jt(t) {
    for (var e = [], n = 0; 31 > n; n++) e.push(t);
    return e;
  }
  function rn(t, e) {
    t.pendingLanes |= e, e !== 268435456 && (t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0);
  }
  function eu(t, e, n, a, i, r) {
    var f = t.pendingLanes;
    t.pendingLanes = n, t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0, t.expiredLanes &= n, t.entangledLanes &= n, t.errorRecoveryDisabledLanes &= n, t.shellSuspendCounter = 0;
    var m = t.entanglements, p = t.expirationTimes, x = t.hiddenUpdates;
    for (n = f & ~n; 0 < n; ) {
      var L = 31 - Ae(n), R = 1 << L;
      m[L] = 0, p[L] = -1;
      var N = x[L];
      if (N !== null)
        for (x[L] = null, L = 0; L < N.length; L++) {
          var M = N[L];
          M !== null && (M.lane &= -536870913);
        }
      n &= ~R;
    }
    a !== 0 && Gi(t, a, 0), r !== 0 && i === 0 && t.tag !== 0 && (t.suspendedLanes |= r & ~(f & ~e));
  }
  function Gi(t, e, n) {
    t.pendingLanes |= e, t.suspendedLanes &= ~e;
    var a = 31 - Ae(e);
    t.entangledLanes |= e, t.entanglements[a] = t.entanglements[a] | 1073741824 | n & 261930;
  }
  function Vl(t, e) {
    var n = t.entangledLanes |= e;
    for (t = t.entanglements; n; ) {
      var a = 31 - Ae(n), i = 1 << a;
      i & e | t[a] & e && (t[a] |= e), n &= ~i;
    }
  }
  function Yi(t, e) {
    var n = e & -e;
    return n = (n & 42) !== 0 ? 1 : Gl(n), (n & (t.suspendedLanes | e)) !== 0 ? 0 : n;
  }
  function Gl(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function Ii(t) {
    return t &= -t, 2 < t ? 8 < t ? (t & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function Re() {
    var t = q.p;
    return t !== 0 ? t : (t = window.event, t === void 0 ? 32 : yA(t.type));
  }
  function Hn(t, e) {
    var n = q.p;
    try {
      return q.p = t, e();
    } finally {
      q.p = n;
    }
  }
  var Tn = Math.random().toString(36).slice(2), oe = "__reactFiber$" + Tn, ye = "__reactProps$" + Tn, jn = "__reactContainer$" + Tn, xa = "__reactEvents$" + Tn, xn = "__reactListeners$" + Tn, cr = "__reactHandles$" + Tn, Fi = "__reactResources$" + Tn, rl = "__reactMarker$" + Tn;
  function Yl(t) {
    delete t[oe], delete t[ye], delete t[xa], delete t[xn], delete t[cr];
  }
  function _n(t) {
    var e = t[oe];
    if (e) return e;
    for (var n = t.parentNode; n; ) {
      if (e = n[jn] || n[oe]) {
        if (n = e.alternate, e.child !== null || n !== null && n.child !== null)
          for (t = nA(t); t !== null; ) {
            if (n = t[oe]) return n;
            t = nA(t);
          }
        return e;
      }
      t = n, n = t.parentNode;
    }
    return null;
  }
  function Xn(t) {
    if (t = t[oe] || t[jn]) {
      var e = t.tag;
      if (e === 5 || e === 6 || e === 13 || e === 31 || e === 26 || e === 27 || e === 3)
        return t;
    }
    return null;
  }
  function Qn(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t.stateNode;
    throw Error(u(33));
  }
  function $(t) {
    var e = t[Fi];
    return e || (e = t[Fi] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), e;
  }
  function g(t) {
    t[rl] = !0;
  }
  var U = /* @__PURE__ */ new Set(), P = {};
  function rt(t, e) {
    Yt(t, e), Yt(t + "Capture", e);
  }
  function Yt(t, e) {
    for (P[t] = e, t = 0; t < e.length; t++)
      U.add(e[t]);
  }
  var $t = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), ve = {}, Cn = {};
  function Nn(t) {
    return ol.call(Cn, t) ? !0 : ol.call(ve, t) ? !1 : $t.test(t) ? Cn[t] = !0 : (ve[t] = !0, !1);
  }
  function Ca(t, e, n) {
    if (Nn(e))
      if (n === null) t.removeAttribute(e);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            t.removeAttribute(e);
            return;
          case "boolean":
            var a = e.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              t.removeAttribute(e);
              return;
            }
        }
        t.setAttribute(e, "" + n);
      }
  }
  function _t(t, e, n) {
    if (n === null) t.removeAttribute(e);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(e);
          return;
      }
      t.setAttribute(e, "" + n);
    }
  }
  function cn(t, e, n, a) {
    if (a === null) t.removeAttribute(n);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(n);
          return;
      }
      t.setAttributeNS(e, n, "" + a);
    }
  }
  function De(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function Vd(t) {
    var e = t.type;
    return (t = t.nodeName) && t.toLowerCase() === "input" && (e === "checkbox" || e === "radio");
  }
  function z1(t, e, n) {
    var a = Object.getOwnPropertyDescriptor(
      t.constructor.prototype,
      e
    );
    if (!t.hasOwnProperty(e) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var i = a.get, r = a.set;
      return Object.defineProperty(t, e, {
        configurable: !0,
        get: function() {
          return i.call(this);
        },
        set: function(f) {
          n = "" + f, r.call(this, f);
        }
      }), Object.defineProperty(t, e, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return n;
        },
        setValue: function(f) {
          n = "" + f;
        },
        stopTracking: function() {
          t._valueTracker = null, delete t[e];
        }
      };
    }
  }
  function nu(t) {
    if (!t._valueTracker) {
      var e = Vd(t) ? "checked" : "value";
      t._valueTracker = z1(
        t,
        e,
        "" + t[e]
      );
    }
  }
  function Gd(t) {
    if (!t) return !1;
    var e = t._valueTracker;
    if (!e) return !0;
    var n = e.getValue(), a = "";
    return t && (a = Vd(t) ? t.checked ? "true" : "false" : t.value), t = a, t !== n ? (e.setValue(t), !0) : !1;
  }
  function ur(t) {
    if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u") return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var R1 = /[\n"\\]/g;
  function un(t) {
    return t.replace(
      R1,
      function(e) {
        return "\\" + e.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function au(t, e, n, a, i, r, f, m) {
    t.name = "", f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" ? t.type = f : t.removeAttribute("type"), e != null ? f === "number" ? (e === 0 && t.value === "" || t.value != e) && (t.value = "" + De(e)) : t.value !== "" + De(e) && (t.value = "" + De(e)) : f !== "submit" && f !== "reset" || t.removeAttribute("value"), e != null ? lu(t, f, De(e)) : n != null ? lu(t, f, De(n)) : a != null && t.removeAttribute("value"), i == null && r != null && (t.defaultChecked = !!r), i != null && (t.checked = i && typeof i != "function" && typeof i != "symbol"), m != null && typeof m != "function" && typeof m != "symbol" && typeof m != "boolean" ? t.name = "" + De(m) : t.removeAttribute("name");
  }
  function Yd(t, e, n, a, i, r, f, m) {
    if (r != null && typeof r != "function" && typeof r != "symbol" && typeof r != "boolean" && (t.type = r), e != null || n != null) {
      if (!(r !== "submit" && r !== "reset" || e != null)) {
        nu(t);
        return;
      }
      n = n != null ? "" + De(n) : "", e = e != null ? "" + De(e) : n, m || e === t.value || (t.value = e), t.defaultValue = e;
    }
    a = a ?? i, a = typeof a != "function" && typeof a != "symbol" && !!a, t.checked = m ? t.checked : !!a, t.defaultChecked = !!a, f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" && (t.name = f), nu(t);
  }
  function lu(t, e, n) {
    e === "number" && ur(t.ownerDocument) === t || t.defaultValue === "" + n || (t.defaultValue = "" + n);
  }
  function Il(t, e, n, a) {
    if (t = t.options, e) {
      e = {};
      for (var i = 0; i < n.length; i++)
        e["$" + n[i]] = !0;
      for (n = 0; n < t.length; n++)
        i = e.hasOwnProperty("$" + t[n].value), t[n].selected !== i && (t[n].selected = i), i && a && (t[n].defaultSelected = !0);
    } else {
      for (n = "" + De(n), e = null, i = 0; i < t.length; i++) {
        if (t[i].value === n) {
          t[i].selected = !0, a && (t[i].defaultSelected = !0);
          return;
        }
        e !== null || t[i].disabled || (e = t[i]);
      }
      e !== null && (e.selected = !0);
    }
  }
  function Id(t, e, n) {
    if (e != null && (e = "" + De(e), e !== t.value && (t.value = e), n == null)) {
      t.defaultValue !== e && (t.defaultValue = e);
      return;
    }
    t.defaultValue = n != null ? "" + De(n) : "";
  }
  function Fd(t, e, n, a) {
    if (e == null) {
      if (a != null) {
        if (n != null) throw Error(u(92));
        if (V(a)) {
          if (1 < a.length) throw Error(u(93));
          a = a[0];
        }
        n = a;
      }
      n == null && (n = ""), e = n;
    }
    n = De(e), t.defaultValue = n, a = t.textContent, a === n && a !== "" && a !== null && (t.value = a), nu(t);
  }
  function Fl(t, e) {
    if (e) {
      var n = t.firstChild;
      if (n && n === t.lastChild && n.nodeType === 3) {
        n.nodeValue = e;
        return;
      }
    }
    t.textContent = e;
  }
  var U1 = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function kd(t, e, n) {
    var a = e.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === "" ? a ? t.setProperty(e, "") : e === "float" ? t.cssFloat = "" : t[e] = "" : a ? t.setProperty(e, n) : typeof n != "number" || n === 0 || U1.has(e) ? e === "float" ? t.cssFloat = n : t[e] = ("" + n).trim() : t[e] = n + "px";
  }
  function qd(t, e, n) {
    if (e != null && typeof e != "object")
      throw Error(u(62));
    if (t = t.style, n != null) {
      for (var a in n)
        !n.hasOwnProperty(a) || e != null && e.hasOwnProperty(a) || (a.indexOf("--") === 0 ? t.setProperty(a, "") : a === "float" ? t.cssFloat = "" : t[a] = "");
      for (var i in e)
        a = e[i], e.hasOwnProperty(i) && n[i] !== a && kd(t, i, a);
    } else
      for (var r in e)
        e.hasOwnProperty(r) && kd(t, r, e[r]);
  }
  function iu(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var H1 = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), j1 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function sr(t) {
    return j1.test("" + t) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : t;
  }
  function $n() {
  }
  var ou = null;
  function ru(t) {
    return t = t.target || t.srcElement || window, t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
  }
  var kl = null, ql = null;
  function Kd(t) {
    var e = Xn(t);
    if (e && (t = e.stateNode)) {
      var n = t[ye] || null;
      t: switch (t = e.stateNode, e.type) {
        case "input":
          if (au(
            t,
            n.value,
            n.defaultValue,
            n.defaultValue,
            n.checked,
            n.defaultChecked,
            n.type,
            n.name
          ), e = n.name, n.type === "radio" && e != null) {
            for (n = t; n.parentNode; ) n = n.parentNode;
            for (n = n.querySelectorAll(
              'input[name="' + un(
                "" + e
              ) + '"][type="radio"]'
            ), e = 0; e < n.length; e++) {
              var a = n[e];
              if (a !== t && a.form === t.form) {
                var i = a[ye] || null;
                if (!i) throw Error(u(90));
                au(
                  a,
                  i.value,
                  i.defaultValue,
                  i.defaultValue,
                  i.checked,
                  i.defaultChecked,
                  i.type,
                  i.name
                );
              }
            }
            for (e = 0; e < n.length; e++)
              a = n[e], a.form === t.form && Gd(a);
          }
          break t;
        case "textarea":
          Id(t, n.value, n.defaultValue);
          break t;
        case "select":
          e = n.value, e != null && Il(t, !!n.multiple, e, !1);
      }
    }
  }
  var cu = !1;
  function Zd(t, e, n) {
    if (cu) return t(e, n);
    cu = !0;
    try {
      var a = t(e);
      return a;
    } finally {
      if (cu = !1, (kl !== null || ql !== null) && (Jr(), kl && (e = kl, t = ql, ql = kl = null, Kd(e), t)))
        for (e = 0; e < t.length; e++) Kd(t[e]);
    }
  }
  function ki(t, e) {
    var n = t.stateNode;
    if (n === null) return null;
    var a = n[ye] || null;
    if (a === null) return null;
    n = a[e];
    t: switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (t = t.type, a = !(t === "button" || t === "input" || t === "select" || t === "textarea")), t = !a;
        break t;
      default:
        t = !1;
    }
    if (t) return null;
    if (n && typeof n != "function")
      throw Error(
        u(231, e, typeof n)
      );
    return n;
  }
  var ta = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), uu = !1;
  if (ta)
    try {
      var qi = {};
      Object.defineProperty(qi, "passive", {
        get: function() {
          uu = !0;
        }
      }), window.addEventListener("test", qi, qi), window.removeEventListener("test", qi, qi);
    } catch {
      uu = !1;
    }
  var Na = null, su = null, fr = null;
  function Pd() {
    if (fr) return fr;
    var t, e = su, n = e.length, a, i = "value" in Na ? Na.value : Na.textContent, r = i.length;
    for (t = 0; t < n && e[t] === i[t]; t++) ;
    var f = n - t;
    for (a = 1; a <= f && e[n - a] === i[r - a]; a++) ;
    return fr = i.slice(t, 1 < a ? 1 - a : void 0);
  }
  function dr(t) {
    var e = t.keyCode;
    return "charCode" in t ? (t = t.charCode, t === 0 && e === 13 && (t = 13)) : t = e, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
  }
  function mr() {
    return !0;
  }
  function Wd() {
    return !1;
  }
  function Ue(t) {
    function e(n, a, i, r, f) {
      this._reactName = n, this._targetInst = i, this.type = a, this.nativeEvent = r, this.target = f, this.currentTarget = null;
      for (var m in t)
        t.hasOwnProperty(m) && (n = t[m], this[m] = n ? n(r) : r[m]);
      return this.isDefaultPrevented = (r.defaultPrevented != null ? r.defaultPrevented : r.returnValue === !1) ? mr : Wd, this.isPropagationStopped = Wd, this;
    }
    return C(e.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = mr);
      },
      stopPropagation: function() {
        var n = this.nativeEvent;
        n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = mr);
      },
      persist: function() {
      },
      isPersistent: mr
    }), e;
  }
  var cl = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(t) {
      return t.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, hr = Ue(cl), Ki = C({}, cl, { view: 0, detail: 0 }), X1 = Ue(Ki), fu, du, Zi, gr = C({}, Ki, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: hu,
    button: 0,
    buttons: 0,
    relatedTarget: function(t) {
      return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
    },
    movementX: function(t) {
      return "movementX" in t ? t.movementX : (t !== Zi && (Zi && t.type === "mousemove" ? (fu = t.screenX - Zi.screenX, du = t.screenY - Zi.screenY) : du = fu = 0, Zi = t), fu);
    },
    movementY: function(t) {
      return "movementY" in t ? t.movementY : du;
    }
  }), Jd = Ue(gr), Q1 = C({}, gr, { dataTransfer: 0 }), V1 = Ue(Q1), G1 = C({}, Ki, { relatedTarget: 0 }), mu = Ue(G1), Y1 = C({}, cl, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), I1 = Ue(Y1), F1 = C({}, cl, {
    clipboardData: function(t) {
      return "clipboardData" in t ? t.clipboardData : window.clipboardData;
    }
  }), k1 = Ue(F1), q1 = C({}, cl, { data: 0 }), _d = Ue(q1), K1 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Z1 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, P1 = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function W1(t) {
    var e = this.nativeEvent;
    return e.getModifierState ? e.getModifierState(t) : (t = P1[t]) ? !!e[t] : !1;
  }
  function hu() {
    return W1;
  }
  var J1 = C({}, Ki, {
    key: function(t) {
      if (t.key) {
        var e = K1[t.key] || t.key;
        if (e !== "Unidentified") return e;
      }
      return t.type === "keypress" ? (t = dr(t), t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? Z1[t.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: hu,
    charCode: function(t) {
      return t.type === "keypress" ? dr(t) : 0;
    },
    keyCode: function(t) {
      return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    },
    which: function(t) {
      return t.type === "keypress" ? dr(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    }
  }), _1 = Ue(J1), $1 = C({}, gr, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), $d = Ue($1), ty = C({}, Ki, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: hu
  }), ey = Ue(ty), ny = C({}, cl, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), ay = Ue(ny), ly = C({}, gr, {
    deltaX: function(t) {
      return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
    },
    deltaY: function(t) {
      return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), iy = Ue(ly), oy = C({}, cl, {
    newState: 0,
    oldState: 0
  }), ry = Ue(oy), cy = [9, 13, 27, 32], gu = ta && "CompositionEvent" in window, Pi = null;
  ta && "documentMode" in document && (Pi = document.documentMode);
  var uy = ta && "TextEvent" in window && !Pi, tm = ta && (!gu || Pi && 8 < Pi && 11 >= Pi), em = " ", nm = !1;
  function am(t, e) {
    switch (t) {
      case "keyup":
        return cy.indexOf(e.keyCode) !== -1;
      case "keydown":
        return e.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function lm(t) {
    return t = t.detail, typeof t == "object" && "data" in t ? t.data : null;
  }
  var Kl = !1;
  function sy(t, e) {
    switch (t) {
      case "compositionend":
        return lm(e);
      case "keypress":
        return e.which !== 32 ? null : (nm = !0, em);
      case "textInput":
        return t = e.data, t === em && nm ? null : t;
      default:
        return null;
    }
  }
  function fy(t, e) {
    if (Kl)
      return t === "compositionend" || !gu && am(t, e) ? (t = Pd(), fr = su = Na = null, Kl = !1, t) : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
          if (e.char && 1 < e.char.length)
            return e.char;
          if (e.which) return String.fromCharCode(e.which);
        }
        return null;
      case "compositionend":
        return tm && e.locale !== "ko" ? null : e.data;
      default:
        return null;
    }
  }
  var dy = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function im(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e === "input" ? !!dy[t.type] : e === "textarea";
  }
  function om(t, e, n, a) {
    kl ? ql ? ql.push(a) : ql = [a] : kl = a, e = lc(e, "onChange"), 0 < e.length && (n = new hr(
      "onChange",
      "change",
      null,
      n,
      a
    ), t.push({ event: n, listeners: e }));
  }
  var Wi = null, Ji = null;
  function my(t) {
    Yg(t, 0);
  }
  function Ar(t) {
    var e = Qn(t);
    if (Gd(e)) return t;
  }
  function rm(t, e) {
    if (t === "change") return e;
  }
  var cm = !1;
  if (ta) {
    var Au;
    if (ta) {
      var pu = "oninput" in document;
      if (!pu) {
        var um = document.createElement("div");
        um.setAttribute("oninput", "return;"), pu = typeof um.oninput == "function";
      }
      Au = pu;
    } else Au = !1;
    cm = Au && (!document.documentMode || 9 < document.documentMode);
  }
  function sm() {
    Wi && (Wi.detachEvent("onpropertychange", fm), Ji = Wi = null);
  }
  function fm(t) {
    if (t.propertyName === "value" && Ar(Ji)) {
      var e = [];
      om(
        e,
        Ji,
        t,
        ru(t)
      ), Zd(my, e);
    }
  }
  function hy(t, e, n) {
    t === "focusin" ? (sm(), Wi = e, Ji = n, Wi.attachEvent("onpropertychange", fm)) : t === "focusout" && sm();
  }
  function gy(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown")
      return Ar(Ji);
  }
  function Ay(t, e) {
    if (t === "click") return Ar(e);
  }
  function py(t, e) {
    if (t === "input" || t === "change")
      return Ar(e);
  }
  function yy(t, e) {
    return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
  }
  var ke = typeof Object.is == "function" ? Object.is : yy;
  function _i(t, e) {
    if (ke(t, e)) return !0;
    if (typeof t != "object" || t === null || typeof e != "object" || e === null)
      return !1;
    var n = Object.keys(t), a = Object.keys(e);
    if (n.length !== a.length) return !1;
    for (a = 0; a < n.length; a++) {
      var i = n[a];
      if (!ol.call(e, i) || !ke(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  function dm(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function mm(t, e) {
    var n = dm(t);
    t = 0;
    for (var a; n; ) {
      if (n.nodeType === 3) {
        if (a = t + n.textContent.length, t <= e && a >= e)
          return { node: n, offset: e - t };
        t = a;
      }
      t: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break t;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = dm(n);
    }
  }
  function hm(t, e) {
    return t && e ? t === e ? !0 : t && t.nodeType === 3 ? !1 : e && e.nodeType === 3 ? hm(t, e.parentNode) : "contains" in t ? t.contains(e) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(e) & 16) : !1 : !1;
  }
  function gm(t) {
    t = t != null && t.ownerDocument != null && t.ownerDocument.defaultView != null ? t.ownerDocument.defaultView : window;
    for (var e = ur(t.document); e instanceof t.HTMLIFrameElement; ) {
      try {
        var n = typeof e.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) t = e.contentWindow;
      else break;
      e = ur(t.document);
    }
    return e;
  }
  function yu(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e && (e === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || e === "textarea" || t.contentEditable === "true");
  }
  var vy = ta && "documentMode" in document && 11 >= document.documentMode, Zl = null, vu = null, $i = null, bu = !1;
  function Am(t, e, n) {
    var a = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    bu || Zl == null || Zl !== ur(a) || (a = Zl, "selectionStart" in a && yu(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), $i && _i($i, a) || ($i = a, a = lc(vu, "onSelect"), 0 < a.length && (e = new hr(
      "onSelect",
      "select",
      null,
      e,
      n
    ), t.push({ event: e, listeners: a }), e.target = Zl)));
  }
  function ul(t, e) {
    var n = {};
    return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit" + t] = "webkit" + e, n["Moz" + t] = "moz" + e, n;
  }
  var Pl = {
    animationend: ul("Animation", "AnimationEnd"),
    animationiteration: ul("Animation", "AnimationIteration"),
    animationstart: ul("Animation", "AnimationStart"),
    transitionrun: ul("Transition", "TransitionRun"),
    transitionstart: ul("Transition", "TransitionStart"),
    transitioncancel: ul("Transition", "TransitionCancel"),
    transitionend: ul("Transition", "TransitionEnd")
  }, Su = {}, pm = {};
  ta && (pm = document.createElement("div").style, "AnimationEvent" in window || (delete Pl.animationend.animation, delete Pl.animationiteration.animation, delete Pl.animationstart.animation), "TransitionEvent" in window || delete Pl.transitionend.transition);
  function sl(t) {
    if (Su[t]) return Su[t];
    if (!Pl[t]) return t;
    var e = Pl[t], n;
    for (n in e)
      if (e.hasOwnProperty(n) && n in pm)
        return Su[t] = e[n];
    return t;
  }
  var ym = sl("animationend"), vm = sl("animationiteration"), bm = sl("animationstart"), by = sl("transitionrun"), Sy = sl("transitionstart"), Oy = sl("transitioncancel"), Sm = sl("transitionend"), Om = /* @__PURE__ */ new Map(), Ou = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Ou.push("scrollEnd");
  function wn(t, e) {
    Om.set(t, e), rt(e, [t]);
  }
  var pr = typeof reportError == "function" ? reportError : function(t) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var e = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof t == "object" && t !== null && typeof t.message == "string" ? String(t.message) : String(t),
        error: t
      });
      if (!window.dispatchEvent(e)) return;
    } else if (typeof l == "object" && typeof l.emit == "function") {
      l.emit("uncaughtException", t);
      return;
    }
    console.error(t);
  }, sn = [], Wl = 0, Eu = 0;
  function yr() {
    for (var t = Wl, e = Eu = Wl = 0; e < t; ) {
      var n = sn[e];
      sn[e++] = null;
      var a = sn[e];
      sn[e++] = null;
      var i = sn[e];
      sn[e++] = null;
      var r = sn[e];
      if (sn[e++] = null, a !== null && i !== null) {
        var f = a.pending;
        f === null ? i.next = i : (i.next = f.next, f.next = i), a.pending = i;
      }
      r !== 0 && Em(n, i, r);
    }
  }
  function vr(t, e, n, a) {
    sn[Wl++] = t, sn[Wl++] = e, sn[Wl++] = n, sn[Wl++] = a, Eu |= a, t.lanes |= a, t = t.alternate, t !== null && (t.lanes |= a);
  }
  function Tu(t, e, n, a) {
    return vr(t, e, n, a), br(t);
  }
  function fl(t, e) {
    return vr(t, null, null, e), br(t);
  }
  function Em(t, e, n) {
    t.lanes |= n;
    var a = t.alternate;
    a !== null && (a.lanes |= n);
    for (var i = !1, r = t.return; r !== null; )
      r.childLanes |= n, a = r.alternate, a !== null && (a.childLanes |= n), r.tag === 22 && (t = r.stateNode, t === null || t._visibility & 1 || (i = !0)), t = r, r = r.return;
    return t.tag === 3 ? (r = t.stateNode, i && e !== null && (i = 31 - Ae(n), t = r.hiddenUpdates, a = t[i], a === null ? t[i] = [e] : a.push(e), e.lane = n | 536870912), r) : null;
  }
  function br(t) {
    if (50 < Oo)
      throw Oo = 0, zs = null, Error(u(185));
    for (var e = t.return; e !== null; )
      t = e, e = t.return;
    return t.tag === 3 ? t.stateNode : null;
  }
  var Jl = {};
  function Ey(t, e, n, a) {
    this.tag = t, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function qe(t, e, n, a) {
    return new Ey(t, e, n, a);
  }
  function xu(t) {
    return t = t.prototype, !(!t || !t.isReactComponent);
  }
  function ea(t, e) {
    var n = t.alternate;
    return n === null ? (n = qe(
      t.tag,
      e,
      t.key,
      t.mode
    ), n.elementType = t.elementType, n.type = t.type, n.stateNode = t.stateNode, n.alternate = t, t.alternate = n) : (n.pendingProps = e, n.type = t.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = t.flags & 65011712, n.childLanes = t.childLanes, n.lanes = t.lanes, n.child = t.child, n.memoizedProps = t.memoizedProps, n.memoizedState = t.memoizedState, n.updateQueue = t.updateQueue, e = t.dependencies, n.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }, n.sibling = t.sibling, n.index = t.index, n.ref = t.ref, n.refCleanup = t.refCleanup, n;
  }
  function Tm(t, e) {
    t.flags &= 65011714;
    var n = t.alternate;
    return n === null ? (t.childLanes = 0, t.lanes = e, t.child = null, t.subtreeFlags = 0, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null) : (t.childLanes = n.childLanes, t.lanes = n.lanes, t.child = n.child, t.subtreeFlags = 0, t.deletions = null, t.memoizedProps = n.memoizedProps, t.memoizedState = n.memoizedState, t.updateQueue = n.updateQueue, t.type = n.type, e = n.dependencies, t.dependencies = e === null ? null : {
      lanes: e.lanes,
      firstContext: e.firstContext
    }), t;
  }
  function Sr(t, e, n, a, i, r) {
    var f = 0;
    if (a = t, typeof t == "function") xu(t) && (f = 1);
    else if (typeof t == "string")
      f = wv(
        t,
        n,
        Ot.current
      ) ? 26 : t === "html" || t === "head" || t === "body" ? 27 : 5;
    else
      t: switch (t) {
        case wt:
          return t = qe(31, n, e, i), t.elementType = wt, t.lanes = r, t;
        case F:
          return dl(n.children, i, r, e);
        case K:
          f = 8, i |= 24;
          break;
        case X:
          return t = qe(12, n, e, i | 2), t.elementType = X, t.lanes = r, t;
        case k:
          return t = qe(13, n, e, i), t.elementType = k, t.lanes = r, t;
        case Y:
          return t = qe(19, n, e, i), t.elementType = Y, t.lanes = r, t;
        default:
          if (typeof t == "object" && t !== null)
            switch (t.$$typeof) {
              case ot:
                f = 10;
                break t;
              case nt:
                f = 9;
                break t;
              case I:
                f = 11;
                break t;
              case Z:
                f = 14;
                break t;
              case ct:
                f = 16, a = null;
                break t;
            }
          f = 29, n = Error(
            u(130, t === null ? "null" : typeof t, "")
          ), a = null;
      }
    return e = qe(f, n, e, i), e.elementType = t, e.type = a, e.lanes = r, e;
  }
  function dl(t, e, n, a) {
    return t = qe(7, t, a, e), t.lanes = n, t;
  }
  function Cu(t, e, n) {
    return t = qe(6, t, null, e), t.lanes = n, t;
  }
  function xm(t) {
    var e = qe(18, null, null, 0);
    return e.stateNode = t, e;
  }
  function Nu(t, e, n) {
    return e = qe(
      4,
      t.children !== null ? t.children : [],
      t.key,
      e
    ), e.lanes = n, e.stateNode = {
      containerInfo: t.containerInfo,
      pendingChildren: null,
      implementation: t.implementation
    }, e;
  }
  var Cm = /* @__PURE__ */ new WeakMap();
  function fn(t, e) {
    if (typeof t == "object" && t !== null) {
      var n = Cm.get(t);
      return n !== void 0 ? n : (e = {
        value: t,
        source: e,
        stack: Rl(e)
      }, Cm.set(t, e), e);
    }
    return {
      value: t,
      source: e,
      stack: Rl(e)
    };
  }
  var _l = [], $l = 0, Or = null, to = 0, dn = [], mn = 0, wa = null, Vn = 1, Gn = "";
  function na(t, e) {
    _l[$l++] = to, _l[$l++] = Or, Or = t, to = e;
  }
  function Nm(t, e, n) {
    dn[mn++] = Vn, dn[mn++] = Gn, dn[mn++] = wa, wa = t;
    var a = Vn;
    t = Gn;
    var i = 32 - Ae(a) - 1;
    a &= ~(1 << i), n += 1;
    var r = 32 - Ae(e) + i;
    if (30 < r) {
      var f = i - i % 5;
      r = (a & (1 << f) - 1).toString(32), a >>= f, i -= f, Vn = 1 << 32 - Ae(e) + i | n << i | a, Gn = r + t;
    } else
      Vn = 1 << r | n << i | a, Gn = t;
  }
  function wu(t) {
    t.return !== null && (na(t, 1), Nm(t, 1, 0));
  }
  function Du(t) {
    for (; t === Or; )
      Or = _l[--$l], _l[$l] = null, to = _l[--$l], _l[$l] = null;
    for (; t === wa; )
      wa = dn[--mn], dn[mn] = null, Gn = dn[--mn], dn[mn] = null, Vn = dn[--mn], dn[mn] = null;
  }
  function wm(t, e) {
    dn[mn++] = Vn, dn[mn++] = Gn, dn[mn++] = wa, Vn = e.id, Gn = e.overflow, wa = t;
  }
  var be = null, Ft = null, Et = !1, Da = null, hn = !1, Bu = Error(u(519));
  function Ba(t) {
    var e = Error(
      u(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw eo(fn(e, t)), Bu;
  }
  function Dm(t) {
    var e = t.stateNode, n = t.type, a = t.memoizedProps;
    switch (e[oe] = t, e[ye] = a, n) {
      case "dialog":
        yt("cancel", e), yt("close", e);
        break;
      case "iframe":
      case "object":
      case "embed":
        yt("load", e);
        break;
      case "video":
      case "audio":
        for (n = 0; n < To.length; n++)
          yt(To[n], e);
        break;
      case "source":
        yt("error", e);
        break;
      case "img":
      case "image":
      case "link":
        yt("error", e), yt("load", e);
        break;
      case "details":
        yt("toggle", e);
        break;
      case "input":
        yt("invalid", e), Yd(
          e,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        yt("invalid", e);
        break;
      case "textarea":
        yt("invalid", e), Fd(e, a.value, a.defaultValue, a.children);
    }
    n = a.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || e.textContent === "" + n || a.suppressHydrationWarning === !0 || qg(e.textContent, n) ? (a.popover != null && (yt("beforetoggle", e), yt("toggle", e)), a.onScroll != null && yt("scroll", e), a.onScrollEnd != null && yt("scrollend", e), a.onClick != null && (e.onclick = $n), e = !0) : e = !1, e || Ba(t, !0);
  }
  function Bm(t) {
    for (be = t.return; be; )
      switch (be.tag) {
        case 5:
        case 31:
        case 13:
          hn = !1;
          return;
        case 27:
        case 3:
          hn = !0;
          return;
        default:
          be = be.return;
      }
  }
  function ti(t) {
    if (t !== be) return !1;
    if (!Et) return Bm(t), Et = !0, !1;
    var e = t.tag, n;
    if ((n = e !== 3 && e !== 27) && ((n = e === 5) && (n = t.type, n = !(n !== "form" && n !== "button") || Zs(t.type, t.memoizedProps)), n = !n), n && Ft && Ba(t), Bm(t), e === 13) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(317));
      Ft = eA(t);
    } else if (e === 31) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(317));
      Ft = eA(t);
    } else
      e === 27 ? (e = Ft, Fa(t.type) ? (t = $s, $s = null, Ft = t) : Ft = e) : Ft = be ? An(t.stateNode.nextSibling) : null;
    return !0;
  }
  function ml() {
    Ft = be = null, Et = !1;
  }
  function Mu() {
    var t = Da;
    return t !== null && (Qe === null ? Qe = t : Qe.push.apply(
      Qe,
      t
    ), Da = null), t;
  }
  function eo(t) {
    Da === null ? Da = [t] : Da.push(t);
  }
  var Lu = Ct(null), hl = null, aa = null;
  function Ma(t, e, n) {
    W(Lu, e._currentValue), e._currentValue = n;
  }
  function la(t) {
    t._currentValue = Lu.current, lt(Lu);
  }
  function zu(t, e, n) {
    for (; t !== null; ) {
      var a = t.alternate;
      if ((t.childLanes & e) !== e ? (t.childLanes |= e, a !== null && (a.childLanes |= e)) : a !== null && (a.childLanes & e) !== e && (a.childLanes |= e), t === n) break;
      t = t.return;
    }
  }
  function Ru(t, e, n, a) {
    var i = t.child;
    for (i !== null && (i.return = t); i !== null; ) {
      var r = i.dependencies;
      if (r !== null) {
        var f = i.child;
        r = r.firstContext;
        t: for (; r !== null; ) {
          var m = r;
          r = i;
          for (var p = 0; p < e.length; p++)
            if (m.context === e[p]) {
              r.lanes |= n, m = r.alternate, m !== null && (m.lanes |= n), zu(
                r.return,
                n,
                t
              ), a || (f = null);
              break t;
            }
          r = m.next;
        }
      } else if (i.tag === 18) {
        if (f = i.return, f === null) throw Error(u(341));
        f.lanes |= n, r = f.alternate, r !== null && (r.lanes |= n), zu(f, n, t), f = null;
      } else f = i.child;
      if (f !== null) f.return = i;
      else
        for (f = i; f !== null; ) {
          if (f === t) {
            f = null;
            break;
          }
          if (i = f.sibling, i !== null) {
            i.return = f.return, f = i;
            break;
          }
          f = f.return;
        }
      i = f;
    }
  }
  function ei(t, e, n, a) {
    t = null;
    for (var i = e, r = !1; i !== null; ) {
      if (!r) {
        if ((i.flags & 524288) !== 0) r = !0;
        else if ((i.flags & 262144) !== 0) break;
      }
      if (i.tag === 10) {
        var f = i.alternate;
        if (f === null) throw Error(u(387));
        if (f = f.memoizedProps, f !== null) {
          var m = i.type;
          ke(i.pendingProps.value, f.value) || (t !== null ? t.push(m) : t = [m]);
        }
      } else if (i === Ut.current) {
        if (f = i.alternate, f === null) throw Error(u(387));
        f.memoizedState.memoizedState !== i.memoizedState.memoizedState && (t !== null ? t.push(Do) : t = [Do]);
      }
      i = i.return;
    }
    t !== null && Ru(
      e,
      t,
      n,
      a
    ), e.flags |= 262144;
  }
  function Er(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!ke(
        t.context._currentValue,
        t.memoizedValue
      ))
        return !0;
      t = t.next;
    }
    return !1;
  }
  function gl(t) {
    hl = t, aa = null, t = t.dependencies, t !== null && (t.firstContext = null);
  }
  function Se(t) {
    return Mm(hl, t);
  }
  function Tr(t, e) {
    return hl === null && gl(t), Mm(t, e);
  }
  function Mm(t, e) {
    var n = e._currentValue;
    if (e = { context: e, memoizedValue: n, next: null }, aa === null) {
      if (t === null) throw Error(u(308));
      aa = e, t.dependencies = { lanes: 0, firstContext: e }, t.flags |= 524288;
    } else aa = aa.next = e;
    return n;
  }
  var Ty = typeof AbortController < "u" ? AbortController : function() {
    var t = [], e = this.signal = {
      aborted: !1,
      addEventListener: function(n, a) {
        t.push(a);
      }
    };
    this.abort = function() {
      e.aborted = !0, t.forEach(function(n) {
        return n();
      });
    };
  }, xy = o.unstable_scheduleCallback, Cy = o.unstable_NormalPriority, re = {
    $$typeof: ot,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Uu() {
    return {
      controller: new Ty(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function no(t) {
    t.refCount--, t.refCount === 0 && xy(Cy, function() {
      t.controller.abort();
    });
  }
  var ao = null, Hu = 0, ni = 0, ai = null;
  function Ny(t, e) {
    if (ao === null) {
      var n = ao = [];
      Hu = 0, ni = Qs(), ai = {
        status: "pending",
        value: void 0,
        then: function(a) {
          n.push(a);
        }
      };
    }
    return Hu++, e.then(Lm, Lm), e;
  }
  function Lm() {
    if (--Hu === 0 && ao !== null) {
      ai !== null && (ai.status = "fulfilled");
      var t = ao;
      ao = null, ni = 0, ai = null;
      for (var e = 0; e < t.length; e++) (0, t[e])();
    }
  }
  function wy(t, e) {
    var n = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(i) {
        n.push(i);
      }
    };
    return t.then(
      function() {
        a.status = "fulfilled", a.value = e;
        for (var i = 0; i < n.length; i++) (0, n[i])(e);
      },
      function(i) {
        for (a.status = "rejected", a.reason = i, i = 0; i < n.length; i++)
          (0, n[i])(void 0);
      }
    ), a;
  }
  var zm = j.S;
  j.S = function(t, e) {
    Ag = xe(), typeof e == "object" && e !== null && typeof e.then == "function" && Ny(t, e), zm !== null && zm(t, e);
  };
  var Al = Ct(null);
  function ju() {
    var t = Al.current;
    return t !== null ? t : It.pooledCache;
  }
  function xr(t, e) {
    e === null ? W(Al, Al.current) : W(Al, e.pool);
  }
  function Rm() {
    var t = ju();
    return t === null ? null : { parent: re._currentValue, pool: t };
  }
  var li = Error(u(460)), Xu = Error(u(474)), Cr = Error(u(542)), Nr = { then: function() {
  } };
  function Um(t) {
    return t = t.status, t === "fulfilled" || t === "rejected";
  }
  function Hm(t, e, n) {
    switch (n = t[n], n === void 0 ? t.push(e) : n !== e && (e.then($n, $n), e = n), e.status) {
      case "fulfilled":
        return e.value;
      case "rejected":
        throw t = e.reason, Xm(t), t;
      default:
        if (typeof e.status == "string") e.then($n, $n);
        else {
          if (t = It, t !== null && 100 < t.shellSuspendCounter)
            throw Error(u(482));
          t = e, t.status = "pending", t.then(
            function(a) {
              if (e.status === "pending") {
                var i = e;
                i.status = "fulfilled", i.value = a;
              }
            },
            function(a) {
              if (e.status === "pending") {
                var i = e;
                i.status = "rejected", i.reason = a;
              }
            }
          );
        }
        switch (e.status) {
          case "fulfilled":
            return e.value;
          case "rejected":
            throw t = e.reason, Xm(t), t;
        }
        throw yl = e, li;
    }
  }
  function pl(t) {
    try {
      var e = t._init;
      return e(t._payload);
    } catch (n) {
      throw n !== null && typeof n == "object" && typeof n.then == "function" ? (yl = n, li) : n;
    }
  }
  var yl = null;
  function jm() {
    if (yl === null) throw Error(u(459));
    var t = yl;
    return yl = null, t;
  }
  function Xm(t) {
    if (t === li || t === Cr)
      throw Error(u(483));
  }
  var ii = null, lo = 0;
  function wr(t) {
    var e = lo;
    return lo += 1, ii === null && (ii = []), Hm(ii, t, e);
  }
  function io(t, e) {
    e = e.props.ref, t.ref = e !== void 0 ? e : null;
  }
  function Dr(t, e) {
    throw e.$$typeof === _ ? Error(u(525)) : (t = Object.prototype.toString.call(e), Error(
      u(
        31,
        t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t
      )
    ));
  }
  function Qm(t) {
    function e(O, v) {
      if (t) {
        var T = O.deletions;
        T === null ? (O.deletions = [v], O.flags |= 16) : T.push(v);
      }
    }
    function n(O, v) {
      if (!t) return null;
      for (; v !== null; )
        e(O, v), v = v.sibling;
      return null;
    }
    function a(O) {
      for (var v = /* @__PURE__ */ new Map(); O !== null; )
        O.key !== null ? v.set(O.key, O) : v.set(O.index, O), O = O.sibling;
      return v;
    }
    function i(O, v) {
      return O = ea(O, v), O.index = 0, O.sibling = null, O;
    }
    function r(O, v, T) {
      return O.index = T, t ? (T = O.alternate, T !== null ? (T = T.index, T < v ? (O.flags |= 67108866, v) : T) : (O.flags |= 67108866, v)) : (O.flags |= 1048576, v);
    }
    function f(O) {
      return t && O.alternate === null && (O.flags |= 67108866), O;
    }
    function m(O, v, T, z) {
      return v === null || v.tag !== 6 ? (v = Cu(T, O.mode, z), v.return = O, v) : (v = i(v, T), v.return = O, v);
    }
    function p(O, v, T, z) {
      var at = T.type;
      return at === F ? L(
        O,
        v,
        T.props.children,
        z,
        T.key
      ) : v !== null && (v.elementType === at || typeof at == "object" && at !== null && at.$$typeof === ct && pl(at) === v.type) ? (v = i(v, T.props), io(v, T), v.return = O, v) : (v = Sr(
        T.type,
        T.key,
        T.props,
        null,
        O.mode,
        z
      ), io(v, T), v.return = O, v);
    }
    function x(O, v, T, z) {
      return v === null || v.tag !== 4 || v.stateNode.containerInfo !== T.containerInfo || v.stateNode.implementation !== T.implementation ? (v = Nu(T, O.mode, z), v.return = O, v) : (v = i(v, T.children || []), v.return = O, v);
    }
    function L(O, v, T, z, at) {
      return v === null || v.tag !== 7 ? (v = dl(
        T,
        O.mode,
        z,
        at
      ), v.return = O, v) : (v = i(v, T), v.return = O, v);
    }
    function R(O, v, T) {
      if (typeof v == "string" && v !== "" || typeof v == "number" || typeof v == "bigint")
        return v = Cu(
          "" + v,
          O.mode,
          T
        ), v.return = O, v;
      if (typeof v == "object" && v !== null) {
        switch (v.$$typeof) {
          case H:
            return T = Sr(
              v.type,
              v.key,
              v.props,
              null,
              O.mode,
              T
            ), io(T, v), T.return = O, T;
          case G:
            return v = Nu(
              v,
              O.mode,
              T
            ), v.return = O, v;
          case ct:
            return v = pl(v), R(O, v, T);
        }
        if (V(v) || Tt(v))
          return v = dl(
            v,
            O.mode,
            T,
            null
          ), v.return = O, v;
        if (typeof v.then == "function")
          return R(O, wr(v), T);
        if (v.$$typeof === ot)
          return R(
            O,
            Tr(O, v),
            T
          );
        Dr(O, v);
      }
      return null;
    }
    function N(O, v, T, z) {
      var at = v !== null ? v.key : null;
      if (typeof T == "string" && T !== "" || typeof T == "number" || typeof T == "bigint")
        return at !== null ? null : m(O, v, "" + T, z);
      if (typeof T == "object" && T !== null) {
        switch (T.$$typeof) {
          case H:
            return T.key === at ? p(O, v, T, z) : null;
          case G:
            return T.key === at ? x(O, v, T, z) : null;
          case ct:
            return T = pl(T), N(O, v, T, z);
        }
        if (V(T) || Tt(T))
          return at !== null ? null : L(O, v, T, z, null);
        if (typeof T.then == "function")
          return N(
            O,
            v,
            wr(T),
            z
          );
        if (T.$$typeof === ot)
          return N(
            O,
            v,
            Tr(O, T),
            z
          );
        Dr(O, T);
      }
      return null;
    }
    function M(O, v, T, z, at) {
      if (typeof z == "string" && z !== "" || typeof z == "number" || typeof z == "bigint")
        return O = O.get(T) || null, m(v, O, "" + z, at);
      if (typeof z == "object" && z !== null) {
        switch (z.$$typeof) {
          case H:
            return O = O.get(
              z.key === null ? T : z.key
            ) || null, p(v, O, z, at);
          case G:
            return O = O.get(
              z.key === null ? T : z.key
            ) || null, x(v, O, z, at);
          case ct:
            return z = pl(z), M(
              O,
              v,
              T,
              z,
              at
            );
        }
        if (V(z) || Tt(z))
          return O = O.get(T) || null, L(v, O, z, at, null);
        if (typeof z.then == "function")
          return M(
            O,
            v,
            T,
            wr(z),
            at
          );
        if (z.$$typeof === ot)
          return M(
            O,
            v,
            T,
            Tr(v, z),
            at
          );
        Dr(v, z);
      }
      return null;
    }
    function J(O, v, T, z) {
      for (var at = null, Dt = null, tt = v, dt = v = 0, bt = null; tt !== null && dt < T.length; dt++) {
        tt.index > dt ? (bt = tt, tt = null) : bt = tt.sibling;
        var Bt = N(
          O,
          tt,
          T[dt],
          z
        );
        if (Bt === null) {
          tt === null && (tt = bt);
          break;
        }
        t && tt && Bt.alternate === null && e(O, tt), v = r(Bt, v, dt), Dt === null ? at = Bt : Dt.sibling = Bt, Dt = Bt, tt = bt;
      }
      if (dt === T.length)
        return n(O, tt), Et && na(O, dt), at;
      if (tt === null) {
        for (; dt < T.length; dt++)
          tt = R(O, T[dt], z), tt !== null && (v = r(
            tt,
            v,
            dt
          ), Dt === null ? at = tt : Dt.sibling = tt, Dt = tt);
        return Et && na(O, dt), at;
      }
      for (tt = a(tt); dt < T.length; dt++)
        bt = M(
          tt,
          O,
          dt,
          T[dt],
          z
        ), bt !== null && (t && bt.alternate !== null && tt.delete(
          bt.key === null ? dt : bt.key
        ), v = r(
          bt,
          v,
          dt
        ), Dt === null ? at = bt : Dt.sibling = bt, Dt = bt);
      return t && tt.forEach(function(Pa) {
        return e(O, Pa);
      }), Et && na(O, dt), at;
    }
    function it(O, v, T, z) {
      if (T == null) throw Error(u(151));
      for (var at = null, Dt = null, tt = v, dt = v = 0, bt = null, Bt = T.next(); tt !== null && !Bt.done; dt++, Bt = T.next()) {
        tt.index > dt ? (bt = tt, tt = null) : bt = tt.sibling;
        var Pa = N(O, tt, Bt.value, z);
        if (Pa === null) {
          tt === null && (tt = bt);
          break;
        }
        t && tt && Pa.alternate === null && e(O, tt), v = r(Pa, v, dt), Dt === null ? at = Pa : Dt.sibling = Pa, Dt = Pa, tt = bt;
      }
      if (Bt.done)
        return n(O, tt), Et && na(O, dt), at;
      if (tt === null) {
        for (; !Bt.done; dt++, Bt = T.next())
          Bt = R(O, Bt.value, z), Bt !== null && (v = r(Bt, v, dt), Dt === null ? at = Bt : Dt.sibling = Bt, Dt = Bt);
        return Et && na(O, dt), at;
      }
      for (tt = a(tt); !Bt.done; dt++, Bt = T.next())
        Bt = M(tt, O, dt, Bt.value, z), Bt !== null && (t && Bt.alternate !== null && tt.delete(Bt.key === null ? dt : Bt.key), v = r(Bt, v, dt), Dt === null ? at = Bt : Dt.sibling = Bt, Dt = Bt);
      return t && tt.forEach(function(Qv) {
        return e(O, Qv);
      }), Et && na(O, dt), at;
    }
    function Vt(O, v, T, z) {
      if (typeof T == "object" && T !== null && T.type === F && T.key === null && (T = T.props.children), typeof T == "object" && T !== null) {
        switch (T.$$typeof) {
          case H:
            t: {
              for (var at = T.key; v !== null; ) {
                if (v.key === at) {
                  if (at = T.type, at === F) {
                    if (v.tag === 7) {
                      n(
                        O,
                        v.sibling
                      ), z = i(
                        v,
                        T.props.children
                      ), z.return = O, O = z;
                      break t;
                    }
                  } else if (v.elementType === at || typeof at == "object" && at !== null && at.$$typeof === ct && pl(at) === v.type) {
                    n(
                      O,
                      v.sibling
                    ), z = i(v, T.props), io(z, T), z.return = O, O = z;
                    break t;
                  }
                  n(O, v);
                  break;
                } else e(O, v);
                v = v.sibling;
              }
              T.type === F ? (z = dl(
                T.props.children,
                O.mode,
                z,
                T.key
              ), z.return = O, O = z) : (z = Sr(
                T.type,
                T.key,
                T.props,
                null,
                O.mode,
                z
              ), io(z, T), z.return = O, O = z);
            }
            return f(O);
          case G:
            t: {
              for (at = T.key; v !== null; ) {
                if (v.key === at)
                  if (v.tag === 4 && v.stateNode.containerInfo === T.containerInfo && v.stateNode.implementation === T.implementation) {
                    n(
                      O,
                      v.sibling
                    ), z = i(v, T.children || []), z.return = O, O = z;
                    break t;
                  } else {
                    n(O, v);
                    break;
                  }
                else e(O, v);
                v = v.sibling;
              }
              z = Nu(T, O.mode, z), z.return = O, O = z;
            }
            return f(O);
          case ct:
            return T = pl(T), Vt(
              O,
              v,
              T,
              z
            );
        }
        if (V(T))
          return J(
            O,
            v,
            T,
            z
          );
        if (Tt(T)) {
          if (at = Tt(T), typeof at != "function") throw Error(u(150));
          return T = at.call(T), it(
            O,
            v,
            T,
            z
          );
        }
        if (typeof T.then == "function")
          return Vt(
            O,
            v,
            wr(T),
            z
          );
        if (T.$$typeof === ot)
          return Vt(
            O,
            v,
            Tr(O, T),
            z
          );
        Dr(O, T);
      }
      return typeof T == "string" && T !== "" || typeof T == "number" || typeof T == "bigint" ? (T = "" + T, v !== null && v.tag === 6 ? (n(O, v.sibling), z = i(v, T), z.return = O, O = z) : (n(O, v), z = Cu(T, O.mode, z), z.return = O, O = z), f(O)) : n(O, v);
    }
    return function(O, v, T, z) {
      try {
        lo = 0;
        var at = Vt(
          O,
          v,
          T,
          z
        );
        return ii = null, at;
      } catch (tt) {
        if (tt === li || tt === Cr) throw tt;
        var Dt = qe(29, tt, null, O.mode);
        return Dt.lanes = z, Dt.return = O, Dt;
      } finally {
      }
    };
  }
  var vl = Qm(!0), Vm = Qm(!1), La = !1;
  function Qu(t) {
    t.updateQueue = {
      baseState: t.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Vu(t, e) {
    t = t.updateQueue, e.updateQueue === t && (e.updateQueue = {
      baseState: t.baseState,
      firstBaseUpdate: t.firstBaseUpdate,
      lastBaseUpdate: t.lastBaseUpdate,
      shared: t.shared,
      callbacks: null
    });
  }
  function za(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function Ra(t, e, n) {
    var a = t.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (Lt & 2) !== 0) {
      var i = a.pending;
      return i === null ? e.next = e : (e.next = i.next, i.next = e), a.pending = e, e = br(t), Em(t, null, n), e;
    }
    return vr(t, a, e, n), br(t);
  }
  function oo(t, e, n) {
    if (e = e.updateQueue, e !== null && (e = e.shared, (n & 4194048) !== 0)) {
      var a = e.lanes;
      a &= t.pendingLanes, n |= a, e.lanes = n, Vl(t, n);
    }
  }
  function Gu(t, e) {
    var n = t.updateQueue, a = t.alternate;
    if (a !== null && (a = a.updateQueue, n === a)) {
      var i = null, r = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var f = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          r === null ? i = r = f : r = r.next = f, n = n.next;
        } while (n !== null);
        r === null ? i = r = e : r = r.next = e;
      } else i = r = e;
      n = {
        baseState: a.baseState,
        firstBaseUpdate: i,
        lastBaseUpdate: r,
        shared: a.shared,
        callbacks: a.callbacks
      }, t.updateQueue = n;
      return;
    }
    t = n.lastBaseUpdate, t === null ? n.firstBaseUpdate = e : t.next = e, n.lastBaseUpdate = e;
  }
  var Yu = !1;
  function ro() {
    if (Yu) {
      var t = ai;
      if (t !== null) throw t;
    }
  }
  function co(t, e, n, a) {
    Yu = !1;
    var i = t.updateQueue;
    La = !1;
    var r = i.firstBaseUpdate, f = i.lastBaseUpdate, m = i.shared.pending;
    if (m !== null) {
      i.shared.pending = null;
      var p = m, x = p.next;
      p.next = null, f === null ? r = x : f.next = x, f = p;
      var L = t.alternate;
      L !== null && (L = L.updateQueue, m = L.lastBaseUpdate, m !== f && (m === null ? L.firstBaseUpdate = x : m.next = x, L.lastBaseUpdate = p));
    }
    if (r !== null) {
      var R = i.baseState;
      f = 0, L = x = p = null, m = r;
      do {
        var N = m.lane & -536870913, M = N !== m.lane;
        if (M ? (vt & N) === N : (a & N) === N) {
          N !== 0 && N === ni && (Yu = !0), L !== null && (L = L.next = {
            lane: 0,
            tag: m.tag,
            payload: m.payload,
            callback: null,
            next: null
          });
          t: {
            var J = t, it = m;
            N = e;
            var Vt = n;
            switch (it.tag) {
              case 1:
                if (J = it.payload, typeof J == "function") {
                  R = J.call(Vt, R, N);
                  break t;
                }
                R = J;
                break t;
              case 3:
                J.flags = J.flags & -65537 | 128;
              case 0:
                if (J = it.payload, N = typeof J == "function" ? J.call(Vt, R, N) : J, N == null) break t;
                R = C({}, R, N);
                break t;
              case 2:
                La = !0;
            }
          }
          N = m.callback, N !== null && (t.flags |= 64, M && (t.flags |= 8192), M = i.callbacks, M === null ? i.callbacks = [N] : M.push(N));
        } else
          M = {
            lane: N,
            tag: m.tag,
            payload: m.payload,
            callback: m.callback,
            next: null
          }, L === null ? (x = L = M, p = R) : L = L.next = M, f |= N;
        if (m = m.next, m === null) {
          if (m = i.shared.pending, m === null)
            break;
          M = m, m = M.next, M.next = null, i.lastBaseUpdate = M, i.shared.pending = null;
        }
      } while (!0);
      L === null && (p = R), i.baseState = p, i.firstBaseUpdate = x, i.lastBaseUpdate = L, r === null && (i.shared.lanes = 0), Qa |= f, t.lanes = f, t.memoizedState = R;
    }
  }
  function Gm(t, e) {
    if (typeof t != "function")
      throw Error(u(191, t));
    t.call(e);
  }
  function Ym(t, e) {
    var n = t.callbacks;
    if (n !== null)
      for (t.callbacks = null, t = 0; t < n.length; t++)
        Gm(n[t], e);
  }
  var oi = Ct(null), Br = Ct(0);
  function Im(t, e) {
    t = ma, W(Br, t), W(oi, e), ma = t | e.baseLanes;
  }
  function Iu() {
    W(Br, ma), W(oi, oi.current);
  }
  function Fu() {
    ma = Br.current, lt(oi), lt(Br);
  }
  var Ke = Ct(null), gn = null;
  function Ua(t) {
    var e = t.alternate;
    W(ae, ae.current & 1), W(Ke, t), gn === null && (e === null || oi.current !== null || e.memoizedState !== null) && (gn = t);
  }
  function ku(t) {
    W(ae, ae.current), W(Ke, t), gn === null && (gn = t);
  }
  function Fm(t) {
    t.tag === 22 ? (W(ae, ae.current), W(Ke, t), gn === null && (gn = t)) : Ha();
  }
  function Ha() {
    W(ae, ae.current), W(Ke, Ke.current);
  }
  function Ze(t) {
    lt(Ke), gn === t && (gn = null), lt(ae);
  }
  var ae = Ct(0);
  function Mr(t) {
    for (var e = t; e !== null; ) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || Js(n) || _s(n)))
          return e;
      } else if (e.tag === 19 && (e.memoizedProps.revealOrder === "forwards" || e.memoizedProps.revealOrder === "backwards" || e.memoizedProps.revealOrder === "unstable_legacy-backwards" || e.memoizedProps.revealOrder === "together")) {
        if ((e.flags & 128) !== 0) return e;
      } else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) return null;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    return null;
  }
  var ia = 0, ft = null, Xt = null, ce = null, Lr = !1, ri = !1, bl = !1, zr = 0, uo = 0, ci = null, Dy = 0;
  function te() {
    throw Error(u(321));
  }
  function qu(t, e) {
    if (e === null) return !1;
    for (var n = 0; n < e.length && n < t.length; n++)
      if (!ke(t[n], e[n])) return !1;
    return !0;
  }
  function Ku(t, e, n, a, i, r) {
    return ia = r, ft = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, j.H = t === null || t.memoizedState === null ? Nh : cs, bl = !1, r = n(a, i), bl = !1, ri && (r = qm(
      e,
      n,
      a,
      i
    )), km(t), r;
  }
  function km(t) {
    j.H = mo;
    var e = Xt !== null && Xt.next !== null;
    if (ia = 0, ce = Xt = ft = null, Lr = !1, uo = 0, ci = null, e) throw Error(u(300));
    t === null || ue || (t = t.dependencies, t !== null && Er(t) && (ue = !0));
  }
  function qm(t, e, n, a) {
    ft = t;
    var i = 0;
    do {
      if (ri && (ci = null), uo = 0, ri = !1, 25 <= i) throw Error(u(301));
      if (i += 1, ce = Xt = null, t.updateQueue != null) {
        var r = t.updateQueue;
        r.lastEffect = null, r.events = null, r.stores = null, r.memoCache != null && (r.memoCache.index = 0);
      }
      j.H = wh, r = e(n, a);
    } while (ri);
    return r;
  }
  function By() {
    var t = j.H, e = t.useState()[0];
    return e = typeof e.then == "function" ? so(e) : e, t = t.useState()[0], (Xt !== null ? Xt.memoizedState : null) !== t && (ft.flags |= 1024), e;
  }
  function Zu() {
    var t = zr !== 0;
    return zr = 0, t;
  }
  function Pu(t, e, n) {
    e.updateQueue = t.updateQueue, e.flags &= -2053, t.lanes &= ~n;
  }
  function Wu(t) {
    if (Lr) {
      for (t = t.memoizedState; t !== null; ) {
        var e = t.queue;
        e !== null && (e.pending = null), t = t.next;
      }
      Lr = !1;
    }
    ia = 0, ce = Xt = ft = null, ri = !1, uo = zr = 0, ci = null;
  }
  function Be() {
    var t = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return ce === null ? ft.memoizedState = ce = t : ce = ce.next = t, ce;
  }
  function le() {
    if (Xt === null) {
      var t = ft.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = Xt.next;
    var e = ce === null ? ft.memoizedState : ce.next;
    if (e !== null)
      ce = e, Xt = t;
    else {
      if (t === null)
        throw ft.alternate === null ? Error(u(467)) : Error(u(310));
      Xt = t, t = {
        memoizedState: Xt.memoizedState,
        baseState: Xt.baseState,
        baseQueue: Xt.baseQueue,
        queue: Xt.queue,
        next: null
      }, ce === null ? ft.memoizedState = ce = t : ce = ce.next = t;
    }
    return ce;
  }
  function Rr() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function so(t) {
    var e = uo;
    return uo += 1, ci === null && (ci = []), t = Hm(ci, t, e), e = ft, (ce === null ? e.memoizedState : ce.next) === null && (e = e.alternate, j.H = e === null || e.memoizedState === null ? Nh : cs), t;
  }
  function Ur(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return so(t);
      if (t.$$typeof === ot) return Se(t);
    }
    throw Error(u(438, String(t)));
  }
  function Ju(t) {
    var e = null, n = ft.updateQueue;
    if (n !== null && (e = n.memoCache), e == null) {
      var a = ft.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (e = {
        data: a.data.map(function(i) {
          return i.slice();
        }),
        index: 0
      })));
    }
    if (e == null && (e = { data: [], index: 0 }), n === null && (n = Rr(), ft.updateQueue = n), n.memoCache = e, n = e.data[e.index], n === void 0)
      for (n = e.data[e.index] = Array(t), a = 0; a < t; a++)
        n[a] = At;
    return e.index++, n;
  }
  function oa(t, e) {
    return typeof e == "function" ? e(t) : e;
  }
  function Hr(t) {
    var e = le();
    return _u(e, Xt, t);
  }
  function _u(t, e, n) {
    var a = t.queue;
    if (a === null) throw Error(u(311));
    a.lastRenderedReducer = n;
    var i = t.baseQueue, r = a.pending;
    if (r !== null) {
      if (i !== null) {
        var f = i.next;
        i.next = r.next, r.next = f;
      }
      e.baseQueue = i = r, a.pending = null;
    }
    if (r = t.baseState, i === null) t.memoizedState = r;
    else {
      e = i.next;
      var m = f = null, p = null, x = e, L = !1;
      do {
        var R = x.lane & -536870913;
        if (R !== x.lane ? (vt & R) === R : (ia & R) === R) {
          var N = x.revertLane;
          if (N === 0)
            p !== null && (p = p.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: x.action,
              hasEagerState: x.hasEagerState,
              eagerState: x.eagerState,
              next: null
            }), R === ni && (L = !0);
          else if ((ia & N) === N) {
            x = x.next, N === ni && (L = !0);
            continue;
          } else
            R = {
              lane: 0,
              revertLane: x.revertLane,
              gesture: null,
              action: x.action,
              hasEagerState: x.hasEagerState,
              eagerState: x.eagerState,
              next: null
            }, p === null ? (m = p = R, f = r) : p = p.next = R, ft.lanes |= N, Qa |= N;
          R = x.action, bl && n(r, R), r = x.hasEagerState ? x.eagerState : n(r, R);
        } else
          N = {
            lane: R,
            revertLane: x.revertLane,
            gesture: x.gesture,
            action: x.action,
            hasEagerState: x.hasEagerState,
            eagerState: x.eagerState,
            next: null
          }, p === null ? (m = p = N, f = r) : p = p.next = N, ft.lanes |= R, Qa |= R;
        x = x.next;
      } while (x !== null && x !== e);
      if (p === null ? f = r : p.next = m, !ke(r, t.memoizedState) && (ue = !0, L && (n = ai, n !== null)))
        throw n;
      t.memoizedState = r, t.baseState = f, t.baseQueue = p, a.lastRenderedState = r;
    }
    return i === null && (a.lanes = 0), [t.memoizedState, a.dispatch];
  }
  function $u(t) {
    var e = le(), n = e.queue;
    if (n === null) throw Error(u(311));
    n.lastRenderedReducer = t;
    var a = n.dispatch, i = n.pending, r = e.memoizedState;
    if (i !== null) {
      n.pending = null;
      var f = i = i.next;
      do
        r = t(r, f.action), f = f.next;
      while (f !== i);
      ke(r, e.memoizedState) || (ue = !0), e.memoizedState = r, e.baseQueue === null && (e.baseState = r), n.lastRenderedState = r;
    }
    return [r, a];
  }
  function Km(t, e, n) {
    var a = ft, i = le(), r = Et;
    if (r) {
      if (n === void 0) throw Error(u(407));
      n = n();
    } else n = e();
    var f = !ke(
      (Xt || i).memoizedState,
      n
    );
    if (f && (i.memoizedState = n, ue = !0), i = i.queue, ns(Wm.bind(null, a, i, t), [
      t
    ]), i.getSnapshot !== e || f || ce !== null && ce.memoizedState.tag & 1) {
      if (a.flags |= 2048, ui(
        9,
        { destroy: void 0 },
        Pm.bind(
          null,
          a,
          i,
          n,
          e
        ),
        null
      ), It === null) throw Error(u(349));
      r || (ia & 127) !== 0 || Zm(a, e, n);
    }
    return n;
  }
  function Zm(t, e, n) {
    t.flags |= 16384, t = { getSnapshot: e, value: n }, e = ft.updateQueue, e === null ? (e = Rr(), ft.updateQueue = e, e.stores = [t]) : (n = e.stores, n === null ? e.stores = [t] : n.push(t));
  }
  function Pm(t, e, n, a) {
    e.value = n, e.getSnapshot = a, Jm(e) && _m(t);
  }
  function Wm(t, e, n) {
    return n(function() {
      Jm(e) && _m(t);
    });
  }
  function Jm(t) {
    var e = t.getSnapshot;
    t = t.value;
    try {
      var n = e();
      return !ke(t, n);
    } catch {
      return !0;
    }
  }
  function _m(t) {
    var e = fl(t, 2);
    e !== null && Ve(e, t, 2);
  }
  function ts(t) {
    var e = Be();
    if (typeof t == "function") {
      var n = t;
      if (t = n(), bl) {
        Fe(!0);
        try {
          n();
        } finally {
          Fe(!1);
        }
      }
    }
    return e.memoizedState = e.baseState = t, e.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: oa,
      lastRenderedState: t
    }, e;
  }
  function $m(t, e, n, a) {
    return t.baseState = n, _u(
      t,
      Xt,
      typeof a == "function" ? a : oa
    );
  }
  function My(t, e, n, a, i) {
    if (Qr(t)) throw Error(u(485));
    if (t = e.action, t !== null) {
      var r = {
        payload: i,
        action: t,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(f) {
          r.listeners.push(f);
        }
      };
      j.T !== null ? n(!0) : r.isTransition = !1, a(r), n = e.pending, n === null ? (r.next = e.pending = r, th(e, r)) : (r.next = n.next, e.pending = n.next = r);
    }
  }
  function th(t, e) {
    var n = e.action, a = e.payload, i = t.state;
    if (e.isTransition) {
      var r = j.T, f = {};
      j.T = f;
      try {
        var m = n(i, a), p = j.S;
        p !== null && p(f, m), eh(t, e, m);
      } catch (x) {
        es(t, e, x);
      } finally {
        r !== null && f.types !== null && (r.types = f.types), j.T = r;
      }
    } else
      try {
        r = n(i, a), eh(t, e, r);
      } catch (x) {
        es(t, e, x);
      }
  }
  function eh(t, e, n) {
    n !== null && typeof n == "object" && typeof n.then == "function" ? n.then(
      function(a) {
        nh(t, e, a);
      },
      function(a) {
        return es(t, e, a);
      }
    ) : nh(t, e, n);
  }
  function nh(t, e, n) {
    e.status = "fulfilled", e.value = n, ah(e), t.state = n, e = t.pending, e !== null && (n = e.next, n === e ? t.pending = null : (n = n.next, e.next = n, th(t, n)));
  }
  function es(t, e, n) {
    var a = t.pending;
    if (t.pending = null, a !== null) {
      a = a.next;
      do
        e.status = "rejected", e.reason = n, ah(e), e = e.next;
      while (e !== a);
    }
    t.action = null;
  }
  function ah(t) {
    t = t.listeners;
    for (var e = 0; e < t.length; e++) (0, t[e])();
  }
  function lh(t, e) {
    return e;
  }
  function ih(t, e) {
    if (Et) {
      var n = It.formState;
      if (n !== null) {
        t: {
          var a = ft;
          if (Et) {
            if (Ft) {
              e: {
                for (var i = Ft, r = hn; i.nodeType !== 8; ) {
                  if (!r) {
                    i = null;
                    break e;
                  }
                  if (i = An(
                    i.nextSibling
                  ), i === null) {
                    i = null;
                    break e;
                  }
                }
                r = i.data, i = r === "F!" || r === "F" ? i : null;
              }
              if (i) {
                Ft = An(
                  i.nextSibling
                ), a = i.data === "F!";
                break t;
              }
            }
            Ba(a);
          }
          a = !1;
        }
        a && (e = n[0]);
      }
    }
    return n = Be(), n.memoizedState = n.baseState = e, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: lh,
      lastRenderedState: e
    }, n.queue = a, n = Th.bind(
      null,
      ft,
      a
    ), a.dispatch = n, a = ts(!1), r = rs.bind(
      null,
      ft,
      !1,
      a.queue
    ), a = Be(), i = {
      state: e,
      dispatch: null,
      action: t,
      pending: null
    }, a.queue = i, n = My.bind(
      null,
      ft,
      i,
      r,
      n
    ), i.dispatch = n, a.memoizedState = t, [e, n, !1];
  }
  function oh(t) {
    var e = le();
    return rh(e, Xt, t);
  }
  function rh(t, e, n) {
    if (e = _u(
      t,
      e,
      lh
    )[0], t = Hr(oa)[0], typeof e == "object" && e !== null && typeof e.then == "function")
      try {
        var a = so(e);
      } catch (f) {
        throw f === li ? Cr : f;
      }
    else a = e;
    e = le();
    var i = e.queue, r = i.dispatch;
    return n !== e.memoizedState && (ft.flags |= 2048, ui(
      9,
      { destroy: void 0 },
      Ly.bind(null, i, n),
      null
    )), [a, r, t];
  }
  function Ly(t, e) {
    t.action = e;
  }
  function ch(t) {
    var e = le(), n = Xt;
    if (n !== null)
      return rh(e, n, t);
    le(), e = e.memoizedState, n = le();
    var a = n.queue.dispatch;
    return n.memoizedState = t, [e, a, !1];
  }
  function ui(t, e, n, a) {
    return t = { tag: t, create: n, deps: a, inst: e, next: null }, e = ft.updateQueue, e === null && (e = Rr(), ft.updateQueue = e), n = e.lastEffect, n === null ? e.lastEffect = t.next = t : (a = n.next, n.next = t, t.next = a, e.lastEffect = t), t;
  }
  function uh() {
    return le().memoizedState;
  }
  function jr(t, e, n, a) {
    var i = Be();
    ft.flags |= t, i.memoizedState = ui(
      1 | e,
      { destroy: void 0 },
      n,
      a === void 0 ? null : a
    );
  }
  function Xr(t, e, n, a) {
    var i = le();
    a = a === void 0 ? null : a;
    var r = i.memoizedState.inst;
    Xt !== null && a !== null && qu(a, Xt.memoizedState.deps) ? i.memoizedState = ui(e, r, n, a) : (ft.flags |= t, i.memoizedState = ui(
      1 | e,
      r,
      n,
      a
    ));
  }
  function sh(t, e) {
    jr(8390656, 8, t, e);
  }
  function ns(t, e) {
    Xr(2048, 8, t, e);
  }
  function zy(t) {
    ft.flags |= 4;
    var e = ft.updateQueue;
    if (e === null)
      e = Rr(), ft.updateQueue = e, e.events = [t];
    else {
      var n = e.events;
      n === null ? e.events = [t] : n.push(t);
    }
  }
  function fh(t) {
    var e = le().memoizedState;
    return zy({ ref: e, nextImpl: t }), function() {
      if ((Lt & 2) !== 0) throw Error(u(440));
      return e.impl.apply(void 0, arguments);
    };
  }
  function dh(t, e) {
    return Xr(4, 2, t, e);
  }
  function mh(t, e) {
    return Xr(4, 4, t, e);
  }
  function hh(t, e) {
    if (typeof e == "function") {
      t = t();
      var n = e(t);
      return function() {
        typeof n == "function" ? n() : e(null);
      };
    }
    if (e != null)
      return t = t(), e.current = t, function() {
        e.current = null;
      };
  }
  function gh(t, e, n) {
    n = n != null ? n.concat([t]) : null, Xr(4, 4, hh.bind(null, e, t), n);
  }
  function as() {
  }
  function Ah(t, e) {
    var n = le();
    e = e === void 0 ? null : e;
    var a = n.memoizedState;
    return e !== null && qu(e, a[1]) ? a[0] : (n.memoizedState = [t, e], t);
  }
  function ph(t, e) {
    var n = le();
    e = e === void 0 ? null : e;
    var a = n.memoizedState;
    if (e !== null && qu(e, a[1]))
      return a[0];
    if (a = t(), bl) {
      Fe(!0);
      try {
        t();
      } finally {
        Fe(!1);
      }
    }
    return n.memoizedState = [a, e], a;
  }
  function ls(t, e, n) {
    return n === void 0 || (ia & 1073741824) !== 0 && (vt & 261930) === 0 ? t.memoizedState = e : (t.memoizedState = n, t = yg(), ft.lanes |= t, Qa |= t, n);
  }
  function yh(t, e, n, a) {
    return ke(n, e) ? n : oi.current !== null ? (t = ls(t, n, a), ke(t, e) || (ue = !0), t) : (ia & 42) === 0 || (ia & 1073741824) !== 0 && (vt & 261930) === 0 ? (ue = !0, t.memoizedState = n) : (t = yg(), ft.lanes |= t, Qa |= t, e);
  }
  function vh(t, e, n, a, i) {
    var r = q.p;
    q.p = r !== 0 && 8 > r ? r : 8;
    var f = j.T, m = {};
    j.T = m, rs(t, !1, e, n);
    try {
      var p = i(), x = j.S;
      if (x !== null && x(m, p), p !== null && typeof p == "object" && typeof p.then == "function") {
        var L = wy(
          p,
          a
        );
        fo(
          t,
          e,
          L,
          Je(t)
        );
      } else
        fo(
          t,
          e,
          a,
          Je(t)
        );
    } catch (R) {
      fo(
        t,
        e,
        { then: function() {
        }, status: "rejected", reason: R },
        Je()
      );
    } finally {
      q.p = r, f !== null && m.types !== null && (f.types = m.types), j.T = f;
    }
  }
  function Ry() {
  }
  function is(t, e, n, a) {
    if (t.tag !== 5) throw Error(u(476));
    var i = bh(t).queue;
    vh(
      t,
      i,
      e,
      ut,
      n === null ? Ry : function() {
        return Sh(t), n(a);
      }
    );
  }
  function bh(t) {
    var e = t.memoizedState;
    if (e !== null) return e;
    e = {
      memoizedState: ut,
      baseState: ut,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: oa,
        lastRenderedState: ut
      },
      next: null
    };
    var n = {};
    return e.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: oa,
        lastRenderedState: n
      },
      next: null
    }, t.memoizedState = e, t = t.alternate, t !== null && (t.memoizedState = e), e;
  }
  function Sh(t) {
    var e = bh(t);
    e.next === null && (e = t.alternate.memoizedState), fo(
      t,
      e.next.queue,
      {},
      Je()
    );
  }
  function os() {
    return Se(Do);
  }
  function Oh() {
    return le().memoizedState;
  }
  function Eh() {
    return le().memoizedState;
  }
  function Uy(t) {
    for (var e = t.return; e !== null; ) {
      switch (e.tag) {
        case 24:
        case 3:
          var n = Je();
          t = za(n);
          var a = Ra(e, t, n);
          a !== null && (Ve(a, e, n), oo(a, e, n)), e = { cache: Uu() }, t.payload = e;
          return;
      }
      e = e.return;
    }
  }
  function Hy(t, e, n) {
    var a = Je();
    n = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Qr(t) ? xh(e, n) : (n = Tu(t, e, n, a), n !== null && (Ve(n, t, a), Ch(n, e, a)));
  }
  function Th(t, e, n) {
    var a = Je();
    fo(t, e, n, a);
  }
  function fo(t, e, n, a) {
    var i = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Qr(t)) xh(e, i);
    else {
      var r = t.alternate;
      if (t.lanes === 0 && (r === null || r.lanes === 0) && (r = e.lastRenderedReducer, r !== null))
        try {
          var f = e.lastRenderedState, m = r(f, n);
          if (i.hasEagerState = !0, i.eagerState = m, ke(m, f))
            return vr(t, e, i, 0), It === null && yr(), !1;
        } catch {
        } finally {
        }
      if (n = Tu(t, e, i, a), n !== null)
        return Ve(n, t, a), Ch(n, e, a), !0;
    }
    return !1;
  }
  function rs(t, e, n, a) {
    if (a = {
      lane: 2,
      revertLane: Qs(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Qr(t)) {
      if (e) throw Error(u(479));
    } else
      e = Tu(
        t,
        n,
        a,
        2
      ), e !== null && Ve(e, t, 2);
  }
  function Qr(t) {
    var e = t.alternate;
    return t === ft || e !== null && e === ft;
  }
  function xh(t, e) {
    ri = Lr = !0;
    var n = t.pending;
    n === null ? e.next = e : (e.next = n.next, n.next = e), t.pending = e;
  }
  function Ch(t, e, n) {
    if ((n & 4194048) !== 0) {
      var a = e.lanes;
      a &= t.pendingLanes, n |= a, e.lanes = n, Vl(t, n);
    }
  }
  var mo = {
    readContext: Se,
    use: Ur,
    useCallback: te,
    useContext: te,
    useEffect: te,
    useImperativeHandle: te,
    useLayoutEffect: te,
    useInsertionEffect: te,
    useMemo: te,
    useReducer: te,
    useRef: te,
    useState: te,
    useDebugValue: te,
    useDeferredValue: te,
    useTransition: te,
    useSyncExternalStore: te,
    useId: te,
    useHostTransitionStatus: te,
    useFormState: te,
    useActionState: te,
    useOptimistic: te,
    useMemoCache: te,
    useCacheRefresh: te
  };
  mo.useEffectEvent = te;
  var Nh = {
    readContext: Se,
    use: Ur,
    useCallback: function(t, e) {
      return Be().memoizedState = [
        t,
        e === void 0 ? null : e
      ], t;
    },
    useContext: Se,
    useEffect: sh,
    useImperativeHandle: function(t, e, n) {
      n = n != null ? n.concat([t]) : null, jr(
        4194308,
        4,
        hh.bind(null, e, t),
        n
      );
    },
    useLayoutEffect: function(t, e) {
      return jr(4194308, 4, t, e);
    },
    useInsertionEffect: function(t, e) {
      jr(4, 2, t, e);
    },
    useMemo: function(t, e) {
      var n = Be();
      e = e === void 0 ? null : e;
      var a = t();
      if (bl) {
        Fe(!0);
        try {
          t();
        } finally {
          Fe(!1);
        }
      }
      return n.memoizedState = [a, e], a;
    },
    useReducer: function(t, e, n) {
      var a = Be();
      if (n !== void 0) {
        var i = n(e);
        if (bl) {
          Fe(!0);
          try {
            n(e);
          } finally {
            Fe(!1);
          }
        }
      } else i = e;
      return a.memoizedState = a.baseState = i, t = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: i
      }, a.queue = t, t = t.dispatch = Hy.bind(
        null,
        ft,
        t
      ), [a.memoizedState, t];
    },
    useRef: function(t) {
      var e = Be();
      return t = { current: t }, e.memoizedState = t;
    },
    useState: function(t) {
      t = ts(t);
      var e = t.queue, n = Th.bind(null, ft, e);
      return e.dispatch = n, [t.memoizedState, n];
    },
    useDebugValue: as,
    useDeferredValue: function(t, e) {
      var n = Be();
      return ls(n, t, e);
    },
    useTransition: function() {
      var t = ts(!1);
      return t = vh.bind(
        null,
        ft,
        t.queue,
        !0,
        !1
      ), Be().memoizedState = t, [!1, t];
    },
    useSyncExternalStore: function(t, e, n) {
      var a = ft, i = Be();
      if (Et) {
        if (n === void 0)
          throw Error(u(407));
        n = n();
      } else {
        if (n = e(), It === null)
          throw Error(u(349));
        (vt & 127) !== 0 || Zm(a, e, n);
      }
      i.memoizedState = n;
      var r = { value: n, getSnapshot: e };
      return i.queue = r, sh(Wm.bind(null, a, r, t), [
        t
      ]), a.flags |= 2048, ui(
        9,
        { destroy: void 0 },
        Pm.bind(
          null,
          a,
          r,
          n,
          e
        ),
        null
      ), n;
    },
    useId: function() {
      var t = Be(), e = It.identifierPrefix;
      if (Et) {
        var n = Gn, a = Vn;
        n = (a & ~(1 << 32 - Ae(a) - 1)).toString(32) + n, e = "_" + e + "R_" + n, n = zr++, 0 < n && (e += "H" + n.toString(32)), e += "_";
      } else
        n = Dy++, e = "_" + e + "r_" + n.toString(32) + "_";
      return t.memoizedState = e;
    },
    useHostTransitionStatus: os,
    useFormState: ih,
    useActionState: ih,
    useOptimistic: function(t) {
      var e = Be();
      e.memoizedState = e.baseState = t;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return e.queue = n, e = rs.bind(
        null,
        ft,
        !0,
        n
      ), n.dispatch = e, [t, e];
    },
    useMemoCache: Ju,
    useCacheRefresh: function() {
      return Be().memoizedState = Uy.bind(
        null,
        ft
      );
    },
    useEffectEvent: function(t) {
      var e = Be(), n = { impl: t };
      return e.memoizedState = n, function() {
        if ((Lt & 2) !== 0)
          throw Error(u(440));
        return n.impl.apply(void 0, arguments);
      };
    }
  }, cs = {
    readContext: Se,
    use: Ur,
    useCallback: Ah,
    useContext: Se,
    useEffect: ns,
    useImperativeHandle: gh,
    useInsertionEffect: dh,
    useLayoutEffect: mh,
    useMemo: ph,
    useReducer: Hr,
    useRef: uh,
    useState: function() {
      return Hr(oa);
    },
    useDebugValue: as,
    useDeferredValue: function(t, e) {
      var n = le();
      return yh(
        n,
        Xt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = Hr(oa)[0], e = le().memoizedState;
      return [
        typeof t == "boolean" ? t : so(t),
        e
      ];
    },
    useSyncExternalStore: Km,
    useId: Oh,
    useHostTransitionStatus: os,
    useFormState: oh,
    useActionState: oh,
    useOptimistic: function(t, e) {
      var n = le();
      return $m(n, Xt, t, e);
    },
    useMemoCache: Ju,
    useCacheRefresh: Eh
  };
  cs.useEffectEvent = fh;
  var wh = {
    readContext: Se,
    use: Ur,
    useCallback: Ah,
    useContext: Se,
    useEffect: ns,
    useImperativeHandle: gh,
    useInsertionEffect: dh,
    useLayoutEffect: mh,
    useMemo: ph,
    useReducer: $u,
    useRef: uh,
    useState: function() {
      return $u(oa);
    },
    useDebugValue: as,
    useDeferredValue: function(t, e) {
      var n = le();
      return Xt === null ? ls(n, t, e) : yh(
        n,
        Xt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = $u(oa)[0], e = le().memoizedState;
      return [
        typeof t == "boolean" ? t : so(t),
        e
      ];
    },
    useSyncExternalStore: Km,
    useId: Oh,
    useHostTransitionStatus: os,
    useFormState: ch,
    useActionState: ch,
    useOptimistic: function(t, e) {
      var n = le();
      return Xt !== null ? $m(n, Xt, t, e) : (n.baseState = t, [t, n.queue.dispatch]);
    },
    useMemoCache: Ju,
    useCacheRefresh: Eh
  };
  wh.useEffectEvent = fh;
  function us(t, e, n, a) {
    e = t.memoizedState, n = n(a, e), n = n == null ? e : C({}, e, n), t.memoizedState = n, t.lanes === 0 && (t.updateQueue.baseState = n);
  }
  var ss = {
    enqueueSetState: function(t, e, n) {
      t = t._reactInternals;
      var a = Je(), i = za(a);
      i.payload = e, n != null && (i.callback = n), e = Ra(t, i, a), e !== null && (Ve(e, t, a), oo(e, t, a));
    },
    enqueueReplaceState: function(t, e, n) {
      t = t._reactInternals;
      var a = Je(), i = za(a);
      i.tag = 1, i.payload = e, n != null && (i.callback = n), e = Ra(t, i, a), e !== null && (Ve(e, t, a), oo(e, t, a));
    },
    enqueueForceUpdate: function(t, e) {
      t = t._reactInternals;
      var n = Je(), a = za(n);
      a.tag = 2, e != null && (a.callback = e), e = Ra(t, a, n), e !== null && (Ve(e, t, n), oo(e, t, n));
    }
  };
  function Dh(t, e, n, a, i, r, f) {
    return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(a, r, f) : e.prototype && e.prototype.isPureReactComponent ? !_i(n, a) || !_i(i, r) : !0;
  }
  function Bh(t, e, n, a) {
    t = e.state, typeof e.componentWillReceiveProps == "function" && e.componentWillReceiveProps(n, a), typeof e.UNSAFE_componentWillReceiveProps == "function" && e.UNSAFE_componentWillReceiveProps(n, a), e.state !== t && ss.enqueueReplaceState(e, e.state, null);
  }
  function Sl(t, e) {
    var n = e;
    if ("ref" in e) {
      n = {};
      for (var a in e)
        a !== "ref" && (n[a] = e[a]);
    }
    if (t = t.defaultProps) {
      n === e && (n = C({}, n));
      for (var i in t)
        n[i] === void 0 && (n[i] = t[i]);
    }
    return n;
  }
  function Mh(t) {
    pr(t);
  }
  function Lh(t) {
    console.error(t);
  }
  function zh(t) {
    pr(t);
  }
  function Vr(t, e) {
    try {
      var n = t.onUncaughtError;
      n(e.value, { componentStack: e.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function Rh(t, e, n) {
    try {
      var a = t.onCaughtError;
      a(n.value, {
        componentStack: n.stack,
        errorBoundary: e.tag === 1 ? e.stateNode : null
      });
    } catch (i) {
      setTimeout(function() {
        throw i;
      });
    }
  }
  function fs(t, e, n) {
    return n = za(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
      Vr(t, e);
    }, n;
  }
  function Uh(t) {
    return t = za(t), t.tag = 3, t;
  }
  function Hh(t, e, n, a) {
    var i = n.type.getDerivedStateFromError;
    if (typeof i == "function") {
      var r = a.value;
      t.payload = function() {
        return i(r);
      }, t.callback = function() {
        Rh(e, n, a);
      };
    }
    var f = n.stateNode;
    f !== null && typeof f.componentDidCatch == "function" && (t.callback = function() {
      Rh(e, n, a), typeof i != "function" && (Va === null ? Va = /* @__PURE__ */ new Set([this]) : Va.add(this));
      var m = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: m !== null ? m : ""
      });
    });
  }
  function jy(t, e, n, a, i) {
    if (n.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (e = n.alternate, e !== null && ei(
        e,
        n,
        i,
        !0
      ), n = Ke.current, n !== null) {
        switch (n.tag) {
          case 31:
          case 13:
            return gn === null ? _r() : n.alternate === null && ee === 0 && (ee = 3), n.flags &= -257, n.flags |= 65536, n.lanes = i, a === Nr ? n.flags |= 16384 : (e = n.updateQueue, e === null ? n.updateQueue = /* @__PURE__ */ new Set([a]) : e.add(a), Hs(t, a, i)), !1;
          case 22:
            return n.flags |= 65536, a === Nr ? n.flags |= 16384 : (e = n.updateQueue, e === null ? (e = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, n.updateQueue = e) : (n = e.retryQueue, n === null ? e.retryQueue = /* @__PURE__ */ new Set([a]) : n.add(a)), Hs(t, a, i)), !1;
        }
        throw Error(u(435, n.tag));
      }
      return Hs(t, a, i), _r(), !1;
    }
    if (Et)
      return e = Ke.current, e !== null ? ((e.flags & 65536) === 0 && (e.flags |= 256), e.flags |= 65536, e.lanes = i, a !== Bu && (t = Error(u(422), { cause: a }), eo(fn(t, n)))) : (a !== Bu && (e = Error(u(423), {
        cause: a
      }), eo(
        fn(e, n)
      )), t = t.current.alternate, t.flags |= 65536, i &= -i, t.lanes |= i, a = fn(a, n), i = fs(
        t.stateNode,
        a,
        i
      ), Gu(t, i), ee !== 4 && (ee = 2)), !1;
    var r = Error(u(520), { cause: a });
    if (r = fn(r, n), So === null ? So = [r] : So.push(r), ee !== 4 && (ee = 2), e === null) return !0;
    a = fn(a, n), n = e;
    do {
      switch (n.tag) {
        case 3:
          return n.flags |= 65536, t = i & -i, n.lanes |= t, t = fs(n.stateNode, a, t), Gu(n, t), !1;
        case 1:
          if (e = n.type, r = n.stateNode, (n.flags & 128) === 0 && (typeof e.getDerivedStateFromError == "function" || r !== null && typeof r.componentDidCatch == "function" && (Va === null || !Va.has(r))))
            return n.flags |= 65536, i &= -i, n.lanes |= i, i = Uh(i), Hh(
              i,
              t,
              n,
              a
            ), Gu(n, i), !1;
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var ds = Error(u(461)), ue = !1;
  function Oe(t, e, n, a) {
    e.child = t === null ? Vm(e, null, n, a) : vl(
      e,
      t.child,
      n,
      a
    );
  }
  function jh(t, e, n, a, i) {
    n = n.render;
    var r = e.ref;
    if ("ref" in a) {
      var f = {};
      for (var m in a)
        m !== "ref" && (f[m] = a[m]);
    } else f = a;
    return gl(e), a = Ku(
      t,
      e,
      n,
      f,
      r,
      i
    ), m = Zu(), t !== null && !ue ? (Pu(t, e, i), ra(t, e, i)) : (Et && m && wu(e), e.flags |= 1, Oe(t, e, a, i), e.child);
  }
  function Xh(t, e, n, a, i) {
    if (t === null) {
      var r = n.type;
      return typeof r == "function" && !xu(r) && r.defaultProps === void 0 && n.compare === null ? (e.tag = 15, e.type = r, Qh(
        t,
        e,
        r,
        a,
        i
      )) : (t = Sr(
        n.type,
        null,
        a,
        e,
        e.mode,
        i
      ), t.ref = e.ref, t.return = e, e.child = t);
    }
    if (r = t.child, !bs(t, i)) {
      var f = r.memoizedProps;
      if (n = n.compare, n = n !== null ? n : _i, n(f, a) && t.ref === e.ref)
        return ra(t, e, i);
    }
    return e.flags |= 1, t = ea(r, a), t.ref = e.ref, t.return = e, e.child = t;
  }
  function Qh(t, e, n, a, i) {
    if (t !== null) {
      var r = t.memoizedProps;
      if (_i(r, a) && t.ref === e.ref)
        if (ue = !1, e.pendingProps = a = r, bs(t, i))
          (t.flags & 131072) !== 0 && (ue = !0);
        else
          return e.lanes = t.lanes, ra(t, e, i);
    }
    return ms(
      t,
      e,
      n,
      a,
      i
    );
  }
  function Vh(t, e, n, a) {
    var i = a.children, r = t !== null ? t.memoizedState : null;
    if (t === null && e.stateNode === null && (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((e.flags & 128) !== 0) {
        if (r = r !== null ? r.baseLanes | n : n, t !== null) {
          for (a = e.child = t.child, i = 0; a !== null; )
            i = i | a.lanes | a.childLanes, a = a.sibling;
          a = i & ~r;
        } else a = 0, e.child = null;
        return Gh(
          t,
          e,
          r,
          n,
          a
        );
      }
      if ((n & 536870912) !== 0)
        e.memoizedState = { baseLanes: 0, cachePool: null }, t !== null && xr(
          e,
          r !== null ? r.cachePool : null
        ), r !== null ? Im(e, r) : Iu(), Fm(e);
      else
        return a = e.lanes = 536870912, Gh(
          t,
          e,
          r !== null ? r.baseLanes | n : n,
          n,
          a
        );
    } else
      r !== null ? (xr(e, r.cachePool), Im(e, r), Ha(), e.memoizedState = null) : (t !== null && xr(e, null), Iu(), Ha());
    return Oe(t, e, i, n), e.child;
  }
  function ho(t, e) {
    return t !== null && t.tag === 22 || e.stateNode !== null || (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), e.sibling;
  }
  function Gh(t, e, n, a, i) {
    var r = ju();
    return r = r === null ? null : { parent: re._currentValue, pool: r }, e.memoizedState = {
      baseLanes: n,
      cachePool: r
    }, t !== null && xr(e, null), Iu(), Fm(e), t !== null && ei(t, e, a, !0), e.childLanes = i, null;
  }
  function Gr(t, e) {
    return e = Ir(
      { mode: e.mode, children: e.children },
      t.mode
    ), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function Yh(t, e, n) {
    return vl(e, t.child, null, n), t = Gr(e, e.pendingProps), t.flags |= 2, Ze(e), e.memoizedState = null, t;
  }
  function Xy(t, e, n) {
    var a = e.pendingProps, i = (e.flags & 128) !== 0;
    if (e.flags &= -129, t === null) {
      if (Et) {
        if (a.mode === "hidden")
          return t = Gr(e, a), e.lanes = 536870912, ho(null, t);
        if (ku(e), (t = Ft) ? (t = tA(
          t,
          hn
        ), t = t !== null && t.data === "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: wa !== null ? { id: Vn, overflow: Gn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = xm(t), n.return = e, e.child = n, be = e, Ft = null)) : t = null, t === null) throw Ba(e);
        return e.lanes = 536870912, null;
      }
      return Gr(e, a);
    }
    var r = t.memoizedState;
    if (r !== null) {
      var f = r.dehydrated;
      if (ku(e), i)
        if (e.flags & 256)
          e.flags &= -257, e = Yh(
            t,
            e,
            n
          );
        else if (e.memoizedState !== null)
          e.child = t.child, e.flags |= 128, e = null;
        else throw Error(u(558));
      else if (ue || ei(t, e, n, !1), i = (n & t.childLanes) !== 0, ue || i) {
        if (a = It, a !== null && (f = Yi(a, n), f !== 0 && f !== r.retryLane))
          throw r.retryLane = f, fl(t, f), Ve(a, t, f), ds;
        _r(), e = Yh(
          t,
          e,
          n
        );
      } else
        t = r.treeContext, Ft = An(f.nextSibling), be = e, Et = !0, Da = null, hn = !1, t !== null && wm(e, t), e = Gr(e, a), e.flags |= 4096;
      return e;
    }
    return t = ea(t.child, {
      mode: a.mode,
      children: a.children
    }), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function Yr(t, e) {
    var n = e.ref;
    if (n === null)
      t !== null && t.ref !== null && (e.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object")
        throw Error(u(284));
      (t === null || t.ref !== n) && (e.flags |= 4194816);
    }
  }
  function ms(t, e, n, a, i) {
    return gl(e), n = Ku(
      t,
      e,
      n,
      a,
      void 0,
      i
    ), a = Zu(), t !== null && !ue ? (Pu(t, e, i), ra(t, e, i)) : (Et && a && wu(e), e.flags |= 1, Oe(t, e, n, i), e.child);
  }
  function Ih(t, e, n, a, i, r) {
    return gl(e), e.updateQueue = null, n = qm(
      e,
      a,
      n,
      i
    ), km(t), a = Zu(), t !== null && !ue ? (Pu(t, e, r), ra(t, e, r)) : (Et && a && wu(e), e.flags |= 1, Oe(t, e, n, r), e.child);
  }
  function Fh(t, e, n, a, i) {
    if (gl(e), e.stateNode === null) {
      var r = Jl, f = n.contextType;
      typeof f == "object" && f !== null && (r = Se(f)), r = new n(a, r), e.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = ss, e.stateNode = r, r._reactInternals = e, r = e.stateNode, r.props = a, r.state = e.memoizedState, r.refs = {}, Qu(e), f = n.contextType, r.context = typeof f == "object" && f !== null ? Se(f) : Jl, r.state = e.memoizedState, f = n.getDerivedStateFromProps, typeof f == "function" && (us(
        e,
        n,
        f,
        a
      ), r.state = e.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof r.getSnapshotBeforeUpdate == "function" || typeof r.UNSAFE_componentWillMount != "function" && typeof r.componentWillMount != "function" || (f = r.state, typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount(), f !== r.state && ss.enqueueReplaceState(r, r.state, null), co(e, a, r, i), ro(), r.state = e.memoizedState), typeof r.componentDidMount == "function" && (e.flags |= 4194308), a = !0;
    } else if (t === null) {
      r = e.stateNode;
      var m = e.memoizedProps, p = Sl(n, m);
      r.props = p;
      var x = r.context, L = n.contextType;
      f = Jl, typeof L == "object" && L !== null && (f = Se(L));
      var R = n.getDerivedStateFromProps;
      L = typeof R == "function" || typeof r.getSnapshotBeforeUpdate == "function", m = e.pendingProps !== m, L || typeof r.UNSAFE_componentWillReceiveProps != "function" && typeof r.componentWillReceiveProps != "function" || (m || x !== f) && Bh(
        e,
        r,
        a,
        f
      ), La = !1;
      var N = e.memoizedState;
      r.state = N, co(e, a, r, i), ro(), x = e.memoizedState, m || N !== x || La ? (typeof R == "function" && (us(
        e,
        n,
        R,
        a
      ), x = e.memoizedState), (p = La || Dh(
        e,
        n,
        p,
        a,
        N,
        x,
        f
      )) ? (L || typeof r.UNSAFE_componentWillMount != "function" && typeof r.componentWillMount != "function" || (typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount()), typeof r.componentDidMount == "function" && (e.flags |= 4194308)) : (typeof r.componentDidMount == "function" && (e.flags |= 4194308), e.memoizedProps = a, e.memoizedState = x), r.props = a, r.state = x, r.context = f, a = p) : (typeof r.componentDidMount == "function" && (e.flags |= 4194308), a = !1);
    } else {
      r = e.stateNode, Vu(t, e), f = e.memoizedProps, L = Sl(n, f), r.props = L, R = e.pendingProps, N = r.context, x = n.contextType, p = Jl, typeof x == "object" && x !== null && (p = Se(x)), m = n.getDerivedStateFromProps, (x = typeof m == "function" || typeof r.getSnapshotBeforeUpdate == "function") || typeof r.UNSAFE_componentWillReceiveProps != "function" && typeof r.componentWillReceiveProps != "function" || (f !== R || N !== p) && Bh(
        e,
        r,
        a,
        p
      ), La = !1, N = e.memoizedState, r.state = N, co(e, a, r, i), ro();
      var M = e.memoizedState;
      f !== R || N !== M || La || t !== null && t.dependencies !== null && Er(t.dependencies) ? (typeof m == "function" && (us(
        e,
        n,
        m,
        a
      ), M = e.memoizedState), (L = La || Dh(
        e,
        n,
        L,
        a,
        N,
        M,
        p
      ) || t !== null && t.dependencies !== null && Er(t.dependencies)) ? (x || typeof r.UNSAFE_componentWillUpdate != "function" && typeof r.componentWillUpdate != "function" || (typeof r.componentWillUpdate == "function" && r.componentWillUpdate(a, M, p), typeof r.UNSAFE_componentWillUpdate == "function" && r.UNSAFE_componentWillUpdate(
        a,
        M,
        p
      )), typeof r.componentDidUpdate == "function" && (e.flags |= 4), typeof r.getSnapshotBeforeUpdate == "function" && (e.flags |= 1024)) : (typeof r.componentDidUpdate != "function" || f === t.memoizedProps && N === t.memoizedState || (e.flags |= 4), typeof r.getSnapshotBeforeUpdate != "function" || f === t.memoizedProps && N === t.memoizedState || (e.flags |= 1024), e.memoizedProps = a, e.memoizedState = M), r.props = a, r.state = M, r.context = p, a = L) : (typeof r.componentDidUpdate != "function" || f === t.memoizedProps && N === t.memoizedState || (e.flags |= 4), typeof r.getSnapshotBeforeUpdate != "function" || f === t.memoizedProps && N === t.memoizedState || (e.flags |= 1024), a = !1);
    }
    return r = a, Yr(t, e), a = (e.flags & 128) !== 0, r || a ? (r = e.stateNode, n = a && typeof n.getDerivedStateFromError != "function" ? null : r.render(), e.flags |= 1, t !== null && a ? (e.child = vl(
      e,
      t.child,
      null,
      i
    ), e.child = vl(
      e,
      null,
      n,
      i
    )) : Oe(t, e, n, i), e.memoizedState = r.state, t = e.child) : t = ra(
      t,
      e,
      i
    ), t;
  }
  function kh(t, e, n, a) {
    return ml(), e.flags |= 256, Oe(t, e, n, a), e.child;
  }
  var hs = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function gs(t) {
    return { baseLanes: t, cachePool: Rm() };
  }
  function As(t, e, n) {
    return t = t !== null ? t.childLanes & ~n : 0, e && (t |= We), t;
  }
  function qh(t, e, n) {
    var a = e.pendingProps, i = !1, r = (e.flags & 128) !== 0, f;
    if ((f = r) || (f = t !== null && t.memoizedState === null ? !1 : (ae.current & 2) !== 0), f && (i = !0, e.flags &= -129), f = (e.flags & 32) !== 0, e.flags &= -33, t === null) {
      if (Et) {
        if (i ? Ua(e) : Ha(), (t = Ft) ? (t = tA(
          t,
          hn
        ), t = t !== null && t.data !== "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: wa !== null ? { id: Vn, overflow: Gn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = xm(t), n.return = e, e.child = n, be = e, Ft = null)) : t = null, t === null) throw Ba(e);
        return _s(t) ? e.lanes = 32 : e.lanes = 536870912, null;
      }
      var m = a.children;
      return a = a.fallback, i ? (Ha(), i = e.mode, m = Ir(
        { mode: "hidden", children: m },
        i
      ), a = dl(
        a,
        i,
        n,
        null
      ), m.return = e, a.return = e, m.sibling = a, e.child = m, a = e.child, a.memoizedState = gs(n), a.childLanes = As(
        t,
        f,
        n
      ), e.memoizedState = hs, ho(null, a)) : (Ua(e), ps(e, m));
    }
    var p = t.memoizedState;
    if (p !== null && (m = p.dehydrated, m !== null)) {
      if (r)
        e.flags & 256 ? (Ua(e), e.flags &= -257, e = ys(
          t,
          e,
          n
        )) : e.memoizedState !== null ? (Ha(), e.child = t.child, e.flags |= 128, e = null) : (Ha(), m = a.fallback, i = e.mode, a = Ir(
          { mode: "visible", children: a.children },
          i
        ), m = dl(
          m,
          i,
          n,
          null
        ), m.flags |= 2, a.return = e, m.return = e, a.sibling = m, e.child = a, vl(
          e,
          t.child,
          null,
          n
        ), a = e.child, a.memoizedState = gs(n), a.childLanes = As(
          t,
          f,
          n
        ), e.memoizedState = hs, e = ho(null, a));
      else if (Ua(e), _s(m)) {
        if (f = m.nextSibling && m.nextSibling.dataset, f) var x = f.dgst;
        f = x, a = Error(u(419)), a.stack = "", a.digest = f, eo({ value: a, source: null, stack: null }), e = ys(
          t,
          e,
          n
        );
      } else if (ue || ei(t, e, n, !1), f = (n & t.childLanes) !== 0, ue || f) {
        if (f = It, f !== null && (a = Yi(f, n), a !== 0 && a !== p.retryLane))
          throw p.retryLane = a, fl(t, a), Ve(f, t, a), ds;
        Js(m) || _r(), e = ys(
          t,
          e,
          n
        );
      } else
        Js(m) ? (e.flags |= 192, e.child = t.child, e = null) : (t = p.treeContext, Ft = An(
          m.nextSibling
        ), be = e, Et = !0, Da = null, hn = !1, t !== null && wm(e, t), e = ps(
          e,
          a.children
        ), e.flags |= 4096);
      return e;
    }
    return i ? (Ha(), m = a.fallback, i = e.mode, p = t.child, x = p.sibling, a = ea(p, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = p.subtreeFlags & 65011712, x !== null ? m = ea(
      x,
      m
    ) : (m = dl(
      m,
      i,
      n,
      null
    ), m.flags |= 2), m.return = e, a.return = e, a.sibling = m, e.child = a, ho(null, a), a = e.child, m = t.child.memoizedState, m === null ? m = gs(n) : (i = m.cachePool, i !== null ? (p = re._currentValue, i = i.parent !== p ? { parent: p, pool: p } : i) : i = Rm(), m = {
      baseLanes: m.baseLanes | n,
      cachePool: i
    }), a.memoizedState = m, a.childLanes = As(
      t,
      f,
      n
    ), e.memoizedState = hs, ho(t.child, a)) : (Ua(e), n = t.child, t = n.sibling, n = ea(n, {
      mode: "visible",
      children: a.children
    }), n.return = e, n.sibling = null, t !== null && (f = e.deletions, f === null ? (e.deletions = [t], e.flags |= 16) : f.push(t)), e.child = n, e.memoizedState = null, n);
  }
  function ps(t, e) {
    return e = Ir(
      { mode: "visible", children: e },
      t.mode
    ), e.return = t, t.child = e;
  }
  function Ir(t, e) {
    return t = qe(22, t, null, e), t.lanes = 0, t;
  }
  function ys(t, e, n) {
    return vl(e, t.child, null, n), t = ps(
      e,
      e.pendingProps.children
    ), t.flags |= 2, e.memoizedState = null, t;
  }
  function Kh(t, e, n) {
    t.lanes |= e;
    var a = t.alternate;
    a !== null && (a.lanes |= e), zu(t.return, e, n);
  }
  function vs(t, e, n, a, i, r) {
    var f = t.memoizedState;
    f === null ? t.memoizedState = {
      isBackwards: e,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: n,
      tailMode: i,
      treeForkCount: r
    } : (f.isBackwards = e, f.rendering = null, f.renderingStartTime = 0, f.last = a, f.tail = n, f.tailMode = i, f.treeForkCount = r);
  }
  function Zh(t, e, n) {
    var a = e.pendingProps, i = a.revealOrder, r = a.tail;
    a = a.children;
    var f = ae.current, m = (f & 2) !== 0;
    if (m ? (f = f & 1 | 2, e.flags |= 128) : f &= 1, W(ae, f), Oe(t, e, a, n), a = Et ? to : 0, !m && t !== null && (t.flags & 128) !== 0)
      t: for (t = e.child; t !== null; ) {
        if (t.tag === 13)
          t.memoizedState !== null && Kh(t, n, e);
        else if (t.tag === 19)
          Kh(t, n, e);
        else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break t;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            break t;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    switch (i) {
      case "forwards":
        for (n = e.child, i = null; n !== null; )
          t = n.alternate, t !== null && Mr(t) === null && (i = n), n = n.sibling;
        n = i, n === null ? (i = e.child, e.child = null) : (i = n.sibling, n.sibling = null), vs(
          e,
          !1,
          i,
          n,
          r,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (n = null, i = e.child, e.child = null; i !== null; ) {
          if (t = i.alternate, t !== null && Mr(t) === null) {
            e.child = i;
            break;
          }
          t = i.sibling, i.sibling = n, n = i, i = t;
        }
        vs(
          e,
          !0,
          n,
          null,
          r,
          a
        );
        break;
      case "together":
        vs(
          e,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        e.memoizedState = null;
    }
    return e.child;
  }
  function ra(t, e, n) {
    if (t !== null && (e.dependencies = t.dependencies), Qa |= e.lanes, (n & e.childLanes) === 0)
      if (t !== null) {
        if (ei(
          t,
          e,
          n,
          !1
        ), (n & e.childLanes) === 0)
          return null;
      } else return null;
    if (t !== null && e.child !== t.child)
      throw Error(u(153));
    if (e.child !== null) {
      for (t = e.child, n = ea(t, t.pendingProps), e.child = n, n.return = e; t.sibling !== null; )
        t = t.sibling, n = n.sibling = ea(t, t.pendingProps), n.return = e;
      n.sibling = null;
    }
    return e.child;
  }
  function bs(t, e) {
    return (t.lanes & e) !== 0 ? !0 : (t = t.dependencies, !!(t !== null && Er(t)));
  }
  function Qy(t, e, n) {
    switch (e.tag) {
      case 3:
        we(e, e.stateNode.containerInfo), Ma(e, re, t.memoizedState.cache), ml();
        break;
      case 27:
      case 5:
        nn(e);
        break;
      case 4:
        we(e, e.stateNode.containerInfo);
        break;
      case 10:
        Ma(
          e,
          e.type,
          e.memoizedProps.value
        );
        break;
      case 31:
        if (e.memoizedState !== null)
          return e.flags |= 128, ku(e), null;
        break;
      case 13:
        var a = e.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (Ua(e), e.flags |= 128, null) : (n & e.child.childLanes) !== 0 ? qh(t, e, n) : (Ua(e), t = ra(
            t,
            e,
            n
          ), t !== null ? t.sibling : null);
        Ua(e);
        break;
      case 19:
        var i = (t.flags & 128) !== 0;
        if (a = (n & e.childLanes) !== 0, a || (ei(
          t,
          e,
          n,
          !1
        ), a = (n & e.childLanes) !== 0), i) {
          if (a)
            return Zh(
              t,
              e,
              n
            );
          e.flags |= 128;
        }
        if (i = e.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), W(ae, ae.current), a) break;
        return null;
      case 22:
        return e.lanes = 0, Vh(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        Ma(e, re, t.memoizedState.cache);
    }
    return ra(t, e, n);
  }
  function Ph(t, e, n) {
    if (t !== null)
      if (t.memoizedProps !== e.pendingProps)
        ue = !0;
      else {
        if (!bs(t, n) && (e.flags & 128) === 0)
          return ue = !1, Qy(
            t,
            e,
            n
          );
        ue = (t.flags & 131072) !== 0;
      }
    else
      ue = !1, Et && (e.flags & 1048576) !== 0 && Nm(e, to, e.index);
    switch (e.lanes = 0, e.tag) {
      case 16:
        t: {
          var a = e.pendingProps;
          if (t = pl(e.elementType), e.type = t, typeof t == "function")
            xu(t) ? (a = Sl(t, a), e.tag = 1, e = Fh(
              null,
              e,
              t,
              a,
              n
            )) : (e.tag = 0, e = ms(
              null,
              e,
              t,
              a,
              n
            ));
          else {
            if (t != null) {
              var i = t.$$typeof;
              if (i === I) {
                e.tag = 11, e = jh(
                  null,
                  e,
                  t,
                  a,
                  n
                );
                break t;
              } else if (i === Z) {
                e.tag = 14, e = Xh(
                  null,
                  e,
                  t,
                  a,
                  n
                );
                break t;
              }
            }
            throw e = xt(t) || t, Error(u(306, e, ""));
          }
        }
        return e;
      case 0:
        return ms(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 1:
        return a = e.type, i = Sl(
          a,
          e.pendingProps
        ), Fh(
          t,
          e,
          a,
          i,
          n
        );
      case 3:
        t: {
          if (we(
            e,
            e.stateNode.containerInfo
          ), t === null) throw Error(u(387));
          a = e.pendingProps;
          var r = e.memoizedState;
          i = r.element, Vu(t, e), co(e, a, null, n);
          var f = e.memoizedState;
          if (a = f.cache, Ma(e, re, a), a !== r.cache && Ru(
            e,
            [re],
            n,
            !0
          ), ro(), a = f.element, r.isDehydrated)
            if (r = {
              element: a,
              isDehydrated: !1,
              cache: f.cache
            }, e.updateQueue.baseState = r, e.memoizedState = r, e.flags & 256) {
              e = kh(
                t,
                e,
                a,
                n
              );
              break t;
            } else if (a !== i) {
              i = fn(
                Error(u(424)),
                e
              ), eo(i), e = kh(
                t,
                e,
                a,
                n
              );
              break t;
            } else {
              switch (t = e.stateNode.containerInfo, t.nodeType) {
                case 9:
                  t = t.body;
                  break;
                default:
                  t = t.nodeName === "HTML" ? t.ownerDocument.body : t;
              }
              for (Ft = An(t.firstChild), be = e, Et = !0, Da = null, hn = !0, n = Vm(
                e,
                null,
                a,
                n
              ), e.child = n; n; )
                n.flags = n.flags & -3 | 4096, n = n.sibling;
            }
          else {
            if (ml(), a === i) {
              e = ra(
                t,
                e,
                n
              );
              break t;
            }
            Oe(t, e, a, n);
          }
          e = e.child;
        }
        return e;
      case 26:
        return Yr(t, e), t === null ? (n = oA(
          e.type,
          null,
          e.pendingProps,
          null
        )) ? e.memoizedState = n : Et || (n = e.type, t = e.pendingProps, a = ic(
          me.current
        ).createElement(n), a[oe] = e, a[ye] = t, Ee(a, n, t), g(a), e.stateNode = a) : e.memoizedState = oA(
          e.type,
          t.memoizedProps,
          e.pendingProps,
          t.memoizedState
        ), null;
      case 27:
        return nn(e), t === null && Et && (a = e.stateNode = aA(
          e.type,
          e.pendingProps,
          me.current
        ), be = e, hn = !0, i = Ft, Fa(e.type) ? ($s = i, Ft = An(a.firstChild)) : Ft = i), Oe(
          t,
          e,
          e.pendingProps.children,
          n
        ), Yr(t, e), t === null && (e.flags |= 4194304), e.child;
      case 5:
        return t === null && Et && ((i = a = Ft) && (a = gv(
          a,
          e.type,
          e.pendingProps,
          hn
        ), a !== null ? (e.stateNode = a, be = e, Ft = An(a.firstChild), hn = !1, i = !0) : i = !1), i || Ba(e)), nn(e), i = e.type, r = e.pendingProps, f = t !== null ? t.memoizedProps : null, a = r.children, Zs(i, r) ? a = null : f !== null && Zs(i, f) && (e.flags |= 32), e.memoizedState !== null && (i = Ku(
          t,
          e,
          By,
          null,
          null,
          n
        ), Do._currentValue = i), Yr(t, e), Oe(t, e, a, n), e.child;
      case 6:
        return t === null && Et && ((t = n = Ft) && (n = Av(
          n,
          e.pendingProps,
          hn
        ), n !== null ? (e.stateNode = n, be = e, Ft = null, t = !0) : t = !1), t || Ba(e)), null;
      case 13:
        return qh(t, e, n);
      case 4:
        return we(
          e,
          e.stateNode.containerInfo
        ), a = e.pendingProps, t === null ? e.child = vl(
          e,
          null,
          a,
          n
        ) : Oe(t, e, a, n), e.child;
      case 11:
        return jh(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 7:
        return Oe(
          t,
          e,
          e.pendingProps,
          n
        ), e.child;
      case 8:
        return Oe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 12:
        return Oe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 10:
        return a = e.pendingProps, Ma(e, e.type, a.value), Oe(t, e, a.children, n), e.child;
      case 9:
        return i = e.type._context, a = e.pendingProps.children, gl(e), i = Se(i), a = a(i), e.flags |= 1, Oe(t, e, a, n), e.child;
      case 14:
        return Xh(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 15:
        return Qh(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 19:
        return Zh(t, e, n);
      case 31:
        return Xy(t, e, n);
      case 22:
        return Vh(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        return gl(e), a = Se(re), t === null ? (i = ju(), i === null && (i = It, r = Uu(), i.pooledCache = r, r.refCount++, r !== null && (i.pooledCacheLanes |= n), i = r), e.memoizedState = { parent: a, cache: i }, Qu(e), Ma(e, re, i)) : ((t.lanes & n) !== 0 && (Vu(t, e), co(e, null, null, n), ro()), i = t.memoizedState, r = e.memoizedState, i.parent !== a ? (i = { parent: a, cache: a }, e.memoizedState = i, e.lanes === 0 && (e.memoizedState = e.updateQueue.baseState = i), Ma(e, re, a)) : (a = r.cache, Ma(e, re, a), a !== i.cache && Ru(
          e,
          [re],
          n,
          !0
        ))), Oe(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 29:
        throw e.pendingProps;
    }
    throw Error(u(156, e.tag));
  }
  function ca(t) {
    t.flags |= 4;
  }
  function Ss(t, e, n, a, i) {
    if ((e = (t.mode & 32) !== 0) && (e = !1), e) {
      if (t.flags |= 16777216, (i & 335544128) === i)
        if (t.stateNode.complete) t.flags |= 8192;
        else if (Og()) t.flags |= 8192;
        else
          throw yl = Nr, Xu;
    } else t.flags &= -16777217;
  }
  function Wh(t, e) {
    if (e.type !== "stylesheet" || (e.state.loading & 4) !== 0)
      t.flags &= -16777217;
    else if (t.flags |= 16777216, !fA(e))
      if (Og()) t.flags |= 8192;
      else
        throw yl = Nr, Xu;
  }
  function Fr(t, e) {
    e !== null && (t.flags |= 4), t.flags & 16384 && (e = t.tag !== 22 ? rr() : 536870912, t.lanes |= e, mi |= e);
  }
  function go(t, e) {
    if (!Et)
      switch (t.tailMode) {
        case "hidden":
          e = t.tail;
          for (var n = null; e !== null; )
            e.alternate !== null && (n = e), e = e.sibling;
          n === null ? t.tail = null : n.sibling = null;
          break;
        case "collapsed":
          n = t.tail;
          for (var a = null; n !== null; )
            n.alternate !== null && (a = n), n = n.sibling;
          a === null ? e || t.tail === null ? t.tail = null : t.tail.sibling = null : a.sibling = null;
      }
  }
  function kt(t) {
    var e = t.alternate !== null && t.alternate.child === t.child, n = 0, a = 0;
    if (e)
      for (var i = t.child; i !== null; )
        n |= i.lanes | i.childLanes, a |= i.subtreeFlags & 65011712, a |= i.flags & 65011712, i.return = t, i = i.sibling;
    else
      for (i = t.child; i !== null; )
        n |= i.lanes | i.childLanes, a |= i.subtreeFlags, a |= i.flags, i.return = t, i = i.sibling;
    return t.subtreeFlags |= a, t.childLanes = n, e;
  }
  function Vy(t, e, n) {
    var a = e.pendingProps;
    switch (Du(e), e.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return kt(e), null;
      case 1:
        return kt(e), null;
      case 3:
        return n = e.stateNode, a = null, t !== null && (a = t.memoizedState.cache), e.memoizedState.cache !== a && (e.flags |= 2048), la(re), ie(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (t === null || t.child === null) && (ti(e) ? ca(e) : t === null || t.memoizedState.isDehydrated && (e.flags & 256) === 0 || (e.flags |= 1024, Mu())), kt(e), null;
      case 26:
        var i = e.type, r = e.memoizedState;
        return t === null ? (ca(e), r !== null ? (kt(e), Wh(e, r)) : (kt(e), Ss(
          e,
          i,
          null,
          a,
          n
        ))) : r ? r !== t.memoizedState ? (ca(e), kt(e), Wh(e, r)) : (kt(e), e.flags &= -16777217) : (t = t.memoizedProps, t !== a && ca(e), kt(e), Ss(
          e,
          i,
          t,
          a,
          n
        )), null;
      case 27:
        if (ll(e), n = me.current, i = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (!a) {
            if (e.stateNode === null)
              throw Error(u(166));
            return kt(e), null;
          }
          t = Ot.current, ti(e) ? Dm(e) : (t = aA(i, a, n), e.stateNode = t, ca(e));
        }
        return kt(e), null;
      case 5:
        if (ll(e), i = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (!a) {
            if (e.stateNode === null)
              throw Error(u(166));
            return kt(e), null;
          }
          if (r = Ot.current, ti(e))
            Dm(e);
          else {
            var f = ic(
              me.current
            );
            switch (r) {
              case 1:
                r = f.createElementNS(
                  "http://www.w3.org/2000/svg",
                  i
                );
                break;
              case 2:
                r = f.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  i
                );
                break;
              default:
                switch (i) {
                  case "svg":
                    r = f.createElementNS(
                      "http://www.w3.org/2000/svg",
                      i
                    );
                    break;
                  case "math":
                    r = f.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      i
                    );
                    break;
                  case "script":
                    r = f.createElement("div"), r.innerHTML = "<script><\/script>", r = r.removeChild(
                      r.firstChild
                    );
                    break;
                  case "select":
                    r = typeof a.is == "string" ? f.createElement("select", {
                      is: a.is
                    }) : f.createElement("select"), a.multiple ? r.multiple = !0 : a.size && (r.size = a.size);
                    break;
                  default:
                    r = typeof a.is == "string" ? f.createElement(i, { is: a.is }) : f.createElement(i);
                }
            }
            r[oe] = e, r[ye] = a;
            t: for (f = e.child; f !== null; ) {
              if (f.tag === 5 || f.tag === 6)
                r.appendChild(f.stateNode);
              else if (f.tag !== 4 && f.tag !== 27 && f.child !== null) {
                f.child.return = f, f = f.child;
                continue;
              }
              if (f === e) break t;
              for (; f.sibling === null; ) {
                if (f.return === null || f.return === e)
                  break t;
                f = f.return;
              }
              f.sibling.return = f.return, f = f.sibling;
            }
            e.stateNode = r;
            t: switch (Ee(r, i, a), i) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break t;
              case "img":
                a = !0;
                break t;
              default:
                a = !1;
            }
            a && ca(e);
          }
        }
        return kt(e), Ss(
          e,
          e.type,
          t === null ? null : t.memoizedProps,
          e.pendingProps,
          n
        ), null;
      case 6:
        if (t && e.stateNode != null)
          t.memoizedProps !== a && ca(e);
        else {
          if (typeof a != "string" && e.stateNode === null)
            throw Error(u(166));
          if (t = me.current, ti(e)) {
            if (t = e.stateNode, n = e.memoizedProps, a = null, i = be, i !== null)
              switch (i.tag) {
                case 27:
                case 5:
                  a = i.memoizedProps;
              }
            t[oe] = e, t = !!(t.nodeValue === n || a !== null && a.suppressHydrationWarning === !0 || qg(t.nodeValue, n)), t || Ba(e, !0);
          } else
            t = ic(t).createTextNode(
              a
            ), t[oe] = e, e.stateNode = t;
        }
        return kt(e), null;
      case 31:
        if (n = e.memoizedState, t === null || t.memoizedState !== null) {
          if (a = ti(e), n !== null) {
            if (t === null) {
              if (!a) throw Error(u(318));
              if (t = e.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(u(557));
              t[oe] = e;
            } else
              ml(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            kt(e), t = !1;
          } else
            n = Mu(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = n), t = !0;
          if (!t)
            return e.flags & 256 ? (Ze(e), e) : (Ze(e), null);
          if ((e.flags & 128) !== 0)
            throw Error(u(558));
        }
        return kt(e), null;
      case 13:
        if (a = e.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
          if (i = ti(e), a !== null && a.dehydrated !== null) {
            if (t === null) {
              if (!i) throw Error(u(318));
              if (i = e.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(u(317));
              i[oe] = e;
            } else
              ml(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            kt(e), i = !1;
          } else
            i = Mu(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = i), i = !0;
          if (!i)
            return e.flags & 256 ? (Ze(e), e) : (Ze(e), null);
        }
        return Ze(e), (e.flags & 128) !== 0 ? (e.lanes = n, e) : (n = a !== null, t = t !== null && t.memoizedState !== null, n && (a = e.child, i = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (i = a.alternate.memoizedState.cachePool.pool), r = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (r = a.memoizedState.cachePool.pool), r !== i && (a.flags |= 2048)), n !== t && n && (e.child.flags |= 8192), Fr(e, e.updateQueue), kt(e), null);
      case 4:
        return ie(), t === null && Is(e.stateNode.containerInfo), kt(e), null;
      case 10:
        return la(e.type), kt(e), null;
      case 19:
        if (lt(ae), a = e.memoizedState, a === null) return kt(e), null;
        if (i = (e.flags & 128) !== 0, r = a.rendering, r === null)
          if (i) go(a, !1);
          else {
            if (ee !== 0 || t !== null && (t.flags & 128) !== 0)
              for (t = e.child; t !== null; ) {
                if (r = Mr(t), r !== null) {
                  for (e.flags |= 128, go(a, !1), t = r.updateQueue, e.updateQueue = t, Fr(e, t), e.subtreeFlags = 0, t = n, n = e.child; n !== null; )
                    Tm(n, t), n = n.sibling;
                  return W(
                    ae,
                    ae.current & 1 | 2
                  ), Et && na(e, a.treeForkCount), e.child;
                }
                t = t.sibling;
              }
            a.tail !== null && xe() > Pr && (e.flags |= 128, i = !0, go(a, !1), e.lanes = 4194304);
          }
        else {
          if (!i)
            if (t = Mr(r), t !== null) {
              if (e.flags |= 128, i = !0, t = t.updateQueue, e.updateQueue = t, Fr(e, t), go(a, !0), a.tail === null && a.tailMode === "hidden" && !r.alternate && !Et)
                return kt(e), null;
            } else
              2 * xe() - a.renderingStartTime > Pr && n !== 536870912 && (e.flags |= 128, i = !0, go(a, !1), e.lanes = 4194304);
          a.isBackwards ? (r.sibling = e.child, e.child = r) : (t = a.last, t !== null ? t.sibling = r : e.child = r, a.last = r);
        }
        return a.tail !== null ? (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = xe(), t.sibling = null, n = ae.current, W(
          ae,
          i ? n & 1 | 2 : n & 1
        ), Et && na(e, a.treeForkCount), t) : (kt(e), null);
      case 22:
      case 23:
        return Ze(e), Fu(), a = e.memoizedState !== null, t !== null ? t.memoizedState !== null !== a && (e.flags |= 8192) : a && (e.flags |= 8192), a ? (n & 536870912) !== 0 && (e.flags & 128) === 0 && (kt(e), e.subtreeFlags & 6 && (e.flags |= 8192)) : kt(e), n = e.updateQueue, n !== null && Fr(e, n.retryQueue), n = null, t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), a = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), a !== n && (e.flags |= 2048), t !== null && lt(Al), null;
      case 24:
        return n = null, t !== null && (n = t.memoizedState.cache), e.memoizedState.cache !== n && (e.flags |= 2048), la(re), kt(e), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(u(156, e.tag));
  }
  function Gy(t, e) {
    switch (Du(e), e.tag) {
      case 1:
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 3:
        return la(re), ie(), t = e.flags, (t & 65536) !== 0 && (t & 128) === 0 ? (e.flags = t & -65537 | 128, e) : null;
      case 26:
      case 27:
      case 5:
        return ll(e), null;
      case 31:
        if (e.memoizedState !== null) {
          if (Ze(e), e.alternate === null)
            throw Error(u(340));
          ml();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 13:
        if (Ze(e), t = e.memoizedState, t !== null && t.dehydrated !== null) {
          if (e.alternate === null)
            throw Error(u(340));
          ml();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 19:
        return lt(ae), null;
      case 4:
        return ie(), null;
      case 10:
        return la(e.type), null;
      case 22:
      case 23:
        return Ze(e), Fu(), t !== null && lt(Al), t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 24:
        return la(re), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Jh(t, e) {
    switch (Du(e), e.tag) {
      case 3:
        la(re), ie();
        break;
      case 26:
      case 27:
      case 5:
        ll(e);
        break;
      case 4:
        ie();
        break;
      case 31:
        e.memoizedState !== null && Ze(e);
        break;
      case 13:
        Ze(e);
        break;
      case 19:
        lt(ae);
        break;
      case 10:
        la(e.type);
        break;
      case 22:
      case 23:
        Ze(e), Fu(), t !== null && lt(Al);
        break;
      case 24:
        la(re);
    }
  }
  function Ao(t, e) {
    try {
      var n = e.updateQueue, a = n !== null ? n.lastEffect : null;
      if (a !== null) {
        var i = a.next;
        n = i;
        do {
          if ((n.tag & t) === t) {
            a = void 0;
            var r = n.create, f = n.inst;
            a = r(), f.destroy = a;
          }
          n = n.next;
        } while (n !== i);
      }
    } catch (m) {
      jt(e, e.return, m);
    }
  }
  function ja(t, e, n) {
    try {
      var a = e.updateQueue, i = a !== null ? a.lastEffect : null;
      if (i !== null) {
        var r = i.next;
        a = r;
        do {
          if ((a.tag & t) === t) {
            var f = a.inst, m = f.destroy;
            if (m !== void 0) {
              f.destroy = void 0, i = e;
              var p = n, x = m;
              try {
                x();
              } catch (L) {
                jt(
                  i,
                  p,
                  L
                );
              }
            }
          }
          a = a.next;
        } while (a !== r);
      }
    } catch (L) {
      jt(e, e.return, L);
    }
  }
  function _h(t) {
    var e = t.updateQueue;
    if (e !== null) {
      var n = t.stateNode;
      try {
        Ym(e, n);
      } catch (a) {
        jt(t, t.return, a);
      }
    }
  }
  function $h(t, e, n) {
    n.props = Sl(
      t.type,
      t.memoizedProps
    ), n.state = t.memoizedState;
    try {
      n.componentWillUnmount();
    } catch (a) {
      jt(t, e, a);
    }
  }
  function po(t, e) {
    try {
      var n = t.ref;
      if (n !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var a = t.stateNode;
            break;
          case 30:
            a = t.stateNode;
            break;
          default:
            a = t.stateNode;
        }
        typeof n == "function" ? t.refCleanup = n(a) : n.current = a;
      }
    } catch (i) {
      jt(t, e, i);
    }
  }
  function Yn(t, e) {
    var n = t.ref, a = t.refCleanup;
    if (n !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (i) {
          jt(t, e, i);
        } finally {
          t.refCleanup = null, t = t.alternate, t != null && (t.refCleanup = null);
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (i) {
          jt(t, e, i);
        }
      else n.current = null;
  }
  function tg(t) {
    var e = t.type, n = t.memoizedProps, a = t.stateNode;
    try {
      t: switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && a.focus();
          break t;
        case "img":
          n.src ? a.src = n.src : n.srcSet && (a.srcset = n.srcSet);
      }
    } catch (i) {
      jt(t, t.return, i);
    }
  }
  function Os(t, e, n) {
    try {
      var a = t.stateNode;
      uv(a, t.type, n, e), a[ye] = e;
    } catch (i) {
      jt(t, t.return, i);
    }
  }
  function eg(t) {
    return t.tag === 5 || t.tag === 3 || t.tag === 26 || t.tag === 27 && Fa(t.type) || t.tag === 4;
  }
  function Es(t) {
    t: for (; ; ) {
      for (; t.sibling === null; ) {
        if (t.return === null || eg(t.return)) return null;
        t = t.return;
      }
      for (t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
        if (t.tag === 27 && Fa(t.type) || t.flags & 2 || t.child === null || t.tag === 4) continue t;
        t.child.return = t, t = t.child;
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function Ts(t, e, n) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, e ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(t, e) : (e = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, e.appendChild(t), n = n._reactRootContainer, n != null || e.onclick !== null || (e.onclick = $n));
    else if (a !== 4 && (a === 27 && Fa(t.type) && (n = t.stateNode, e = null), t = t.child, t !== null))
      for (Ts(t, e, n), t = t.sibling; t !== null; )
        Ts(t, e, n), t = t.sibling;
  }
  function kr(t, e, n) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, e ? n.insertBefore(t, e) : n.appendChild(t);
    else if (a !== 4 && (a === 27 && Fa(t.type) && (n = t.stateNode), t = t.child, t !== null))
      for (kr(t, e, n), t = t.sibling; t !== null; )
        kr(t, e, n), t = t.sibling;
  }
  function ng(t) {
    var e = t.stateNode, n = t.memoizedProps;
    try {
      for (var a = t.type, i = e.attributes; i.length; )
        e.removeAttributeNode(i[0]);
      Ee(e, a, n), e[oe] = t, e[ye] = n;
    } catch (r) {
      jt(t, t.return, r);
    }
  }
  var ua = !1, se = !1, xs = !1, ag = typeof WeakSet == "function" ? WeakSet : Set, pe = null;
  function Yy(t, e) {
    if (t = t.containerInfo, qs = dc, t = gm(t), yu(t)) {
      if ("selectionStart" in t)
        var n = {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      else
        t: {
          n = (n = t.ownerDocument) && n.defaultView || window;
          var a = n.getSelection && n.getSelection();
          if (a && a.rangeCount !== 0) {
            n = a.anchorNode;
            var i = a.anchorOffset, r = a.focusNode;
            a = a.focusOffset;
            try {
              n.nodeType, r.nodeType;
            } catch {
              n = null;
              break t;
            }
            var f = 0, m = -1, p = -1, x = 0, L = 0, R = t, N = null;
            e: for (; ; ) {
              for (var M; R !== n || i !== 0 && R.nodeType !== 3 || (m = f + i), R !== r || a !== 0 && R.nodeType !== 3 || (p = f + a), R.nodeType === 3 && (f += R.nodeValue.length), (M = R.firstChild) !== null; )
                N = R, R = M;
              for (; ; ) {
                if (R === t) break e;
                if (N === n && ++x === i && (m = f), N === r && ++L === a && (p = f), (M = R.nextSibling) !== null) break;
                R = N, N = R.parentNode;
              }
              R = M;
            }
            n = m === -1 || p === -1 ? null : { start: m, end: p };
          } else n = null;
        }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (Ks = { focusedElem: t, selectionRange: n }, dc = !1, pe = e; pe !== null; )
      if (e = pe, t = e.child, (e.subtreeFlags & 1028) !== 0 && t !== null)
        t.return = e, pe = t;
      else
        for (; pe !== null; ) {
          switch (e = pe, r = e.alternate, t = e.flags, e.tag) {
            case 0:
              if ((t & 4) !== 0 && (t = e.updateQueue, t = t !== null ? t.events : null, t !== null))
                for (n = 0; n < t.length; n++)
                  i = t[n], i.ref.impl = i.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((t & 1024) !== 0 && r !== null) {
                t = void 0, n = e, i = r.memoizedProps, r = r.memoizedState, a = n.stateNode;
                try {
                  var J = Sl(
                    n.type,
                    i
                  );
                  t = a.getSnapshotBeforeUpdate(
                    J,
                    r
                  ), a.__reactInternalSnapshotBeforeUpdate = t;
                } catch (it) {
                  jt(
                    n,
                    n.return,
                    it
                  );
                }
              }
              break;
            case 3:
              if ((t & 1024) !== 0) {
                if (t = e.stateNode.containerInfo, n = t.nodeType, n === 9)
                  Ws(t);
                else if (n === 1)
                  switch (t.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      Ws(t);
                      break;
                    default:
                      t.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((t & 1024) !== 0) throw Error(u(163));
          }
          if (t = e.sibling, t !== null) {
            t.return = e.return, pe = t;
            break;
          }
          pe = e.return;
        }
  }
  function lg(t, e, n) {
    var a = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        fa(t, n), a & 4 && Ao(5, n);
        break;
      case 1:
        if (fa(t, n), a & 4)
          if (t = n.stateNode, e === null)
            try {
              t.componentDidMount();
            } catch (f) {
              jt(n, n.return, f);
            }
          else {
            var i = Sl(
              n.type,
              e.memoizedProps
            );
            e = e.memoizedState;
            try {
              t.componentDidUpdate(
                i,
                e,
                t.__reactInternalSnapshotBeforeUpdate
              );
            } catch (f) {
              jt(
                n,
                n.return,
                f
              );
            }
          }
        a & 64 && _h(n), a & 512 && po(n, n.return);
        break;
      case 3:
        if (fa(t, n), a & 64 && (t = n.updateQueue, t !== null)) {
          if (e = null, n.child !== null)
            switch (n.child.tag) {
              case 27:
              case 5:
                e = n.child.stateNode;
                break;
              case 1:
                e = n.child.stateNode;
            }
          try {
            Ym(t, e);
          } catch (f) {
            jt(n, n.return, f);
          }
        }
        break;
      case 27:
        e === null && a & 4 && ng(n);
      case 26:
      case 5:
        fa(t, n), e === null && a & 4 && tg(n), a & 512 && po(n, n.return);
        break;
      case 12:
        fa(t, n);
        break;
      case 31:
        fa(t, n), a & 4 && rg(t, n);
        break;
      case 13:
        fa(t, n), a & 4 && cg(t, n), a & 64 && (t = n.memoizedState, t !== null && (t = t.dehydrated, t !== null && (n = Jy.bind(
          null,
          n
        ), pv(t, n))));
        break;
      case 22:
        if (a = n.memoizedState !== null || ua, !a) {
          e = e !== null && e.memoizedState !== null || se, i = ua;
          var r = se;
          ua = a, (se = e) && !r ? da(
            t,
            n,
            (n.subtreeFlags & 8772) !== 0
          ) : fa(t, n), ua = i, se = r;
        }
        break;
      case 30:
        break;
      default:
        fa(t, n);
    }
  }
  function ig(t) {
    var e = t.alternate;
    e !== null && (t.alternate = null, ig(e)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (e = t.stateNode, e !== null && Yl(e)), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
  }
  var Zt = null, He = !1;
  function sa(t, e, n) {
    for (n = n.child; n !== null; )
      og(t, e, n), n = n.sibling;
  }
  function og(t, e, n) {
    if (Ce && typeof Ce.onCommitFiberUnmount == "function")
      try {
        Ce.onCommitFiberUnmount(Jn, n);
      } catch {
      }
    switch (n.tag) {
      case 26:
        se || Yn(n, e), sa(
          t,
          e,
          n
        ), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
        break;
      case 27:
        se || Yn(n, e);
        var a = Zt, i = He;
        Fa(n.type) && (Zt = n.stateNode, He = !1), sa(
          t,
          e,
          n
        ), Co(n.stateNode), Zt = a, He = i;
        break;
      case 5:
        se || Yn(n, e);
      case 6:
        if (a = Zt, i = He, Zt = null, sa(
          t,
          e,
          n
        ), Zt = a, He = i, Zt !== null)
          if (He)
            try {
              (Zt.nodeType === 9 ? Zt.body : Zt.nodeName === "HTML" ? Zt.ownerDocument.body : Zt).removeChild(n.stateNode);
            } catch (r) {
              jt(
                n,
                e,
                r
              );
            }
          else
            try {
              Zt.removeChild(n.stateNode);
            } catch (r) {
              jt(
                n,
                e,
                r
              );
            }
        break;
      case 18:
        Zt !== null && (He ? (t = Zt, _g(
          t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t,
          n.stateNode
        ), Si(t)) : _g(Zt, n.stateNode));
        break;
      case 4:
        a = Zt, i = He, Zt = n.stateNode.containerInfo, He = !0, sa(
          t,
          e,
          n
        ), Zt = a, He = i;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        ja(2, n, e), se || ja(4, n, e), sa(
          t,
          e,
          n
        );
        break;
      case 1:
        se || (Yn(n, e), a = n.stateNode, typeof a.componentWillUnmount == "function" && $h(
          n,
          e,
          a
        )), sa(
          t,
          e,
          n
        );
        break;
      case 21:
        sa(
          t,
          e,
          n
        );
        break;
      case 22:
        se = (a = se) || n.memoizedState !== null, sa(
          t,
          e,
          n
        ), se = a;
        break;
      default:
        sa(
          t,
          e,
          n
        );
    }
  }
  function rg(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null))) {
      t = t.dehydrated;
      try {
        Si(t);
      } catch (n) {
        jt(e, e.return, n);
      }
    }
  }
  function cg(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null && (t = t.dehydrated, t !== null))))
      try {
        Si(t);
      } catch (n) {
        jt(e, e.return, n);
      }
  }
  function Iy(t) {
    switch (t.tag) {
      case 31:
      case 13:
      case 19:
        var e = t.stateNode;
        return e === null && (e = t.stateNode = new ag()), e;
      case 22:
        return t = t.stateNode, e = t._retryCache, e === null && (e = t._retryCache = new ag()), e;
      default:
        throw Error(u(435, t.tag));
    }
  }
  function qr(t, e) {
    var n = Iy(t);
    e.forEach(function(a) {
      if (!n.has(a)) {
        n.add(a);
        var i = _y.bind(null, t, a);
        a.then(i, i);
      }
    });
  }
  function je(t, e) {
    var n = e.deletions;
    if (n !== null)
      for (var a = 0; a < n.length; a++) {
        var i = n[a], r = t, f = e, m = f;
        t: for (; m !== null; ) {
          switch (m.tag) {
            case 27:
              if (Fa(m.type)) {
                Zt = m.stateNode, He = !1;
                break t;
              }
              break;
            case 5:
              Zt = m.stateNode, He = !1;
              break t;
            case 3:
            case 4:
              Zt = m.stateNode.containerInfo, He = !0;
              break t;
          }
          m = m.return;
        }
        if (Zt === null) throw Error(u(160));
        og(r, f, i), Zt = null, He = !1, r = i.alternate, r !== null && (r.return = null), i.return = null;
      }
    if (e.subtreeFlags & 13886)
      for (e = e.child; e !== null; )
        ug(e, t), e = e.sibling;
  }
  var Dn = null;
  function ug(t, e) {
    var n = t.alternate, a = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        je(e, t), Xe(t), a & 4 && (ja(3, t, t.return), Ao(3, t), ja(5, t, t.return));
        break;
      case 1:
        je(e, t), Xe(t), a & 512 && (se || n === null || Yn(n, n.return)), a & 64 && ua && (t = t.updateQueue, t !== null && (a = t.callbacks, a !== null && (n = t.shared.hiddenCallbacks, t.shared.hiddenCallbacks = n === null ? a : n.concat(a))));
        break;
      case 26:
        var i = Dn;
        if (je(e, t), Xe(t), a & 512 && (se || n === null || Yn(n, n.return)), a & 4) {
          var r = n !== null ? n.memoizedState : null;
          if (a = t.memoizedState, n === null)
            if (a === null)
              if (t.stateNode === null) {
                t: {
                  a = t.type, n = t.memoizedProps, i = i.ownerDocument || i;
                  e: switch (a) {
                    case "title":
                      r = i.getElementsByTagName("title")[0], (!r || r[rl] || r[oe] || r.namespaceURI === "http://www.w3.org/2000/svg" || r.hasAttribute("itemprop")) && (r = i.createElement(a), i.head.insertBefore(
                        r,
                        i.querySelector("head > title")
                      )), Ee(r, a, n), r[oe] = t, g(r), a = r;
                      break t;
                    case "link":
                      var f = uA(
                        "link",
                        "href",
                        i
                      ).get(a + (n.href || ""));
                      if (f) {
                        for (var m = 0; m < f.length; m++)
                          if (r = f[m], r.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && r.getAttribute("rel") === (n.rel == null ? null : n.rel) && r.getAttribute("title") === (n.title == null ? null : n.title) && r.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
                            f.splice(m, 1);
                            break e;
                          }
                      }
                      r = i.createElement(a), Ee(r, a, n), i.head.appendChild(r);
                      break;
                    case "meta":
                      if (f = uA(
                        "meta",
                        "content",
                        i
                      ).get(a + (n.content || ""))) {
                        for (m = 0; m < f.length; m++)
                          if (r = f[m], r.getAttribute("content") === (n.content == null ? null : "" + n.content) && r.getAttribute("name") === (n.name == null ? null : n.name) && r.getAttribute("property") === (n.property == null ? null : n.property) && r.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && r.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
                            f.splice(m, 1);
                            break e;
                          }
                      }
                      r = i.createElement(a), Ee(r, a, n), i.head.appendChild(r);
                      break;
                    default:
                      throw Error(u(468, a));
                  }
                  r[oe] = t, g(r), a = r;
                }
                t.stateNode = a;
              } else
                sA(
                  i,
                  t.type,
                  t.stateNode
                );
            else
              t.stateNode = cA(
                i,
                a,
                t.memoizedProps
              );
          else
            r !== a ? (r === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : r.count--, a === null ? sA(
              i,
              t.type,
              t.stateNode
            ) : cA(
              i,
              a,
              t.memoizedProps
            )) : a === null && t.stateNode !== null && Os(
              t,
              t.memoizedProps,
              n.memoizedProps
            );
        }
        break;
      case 27:
        je(e, t), Xe(t), a & 512 && (se || n === null || Yn(n, n.return)), n !== null && a & 4 && Os(
          t,
          t.memoizedProps,
          n.memoizedProps
        );
        break;
      case 5:
        if (je(e, t), Xe(t), a & 512 && (se || n === null || Yn(n, n.return)), t.flags & 32) {
          i = t.stateNode;
          try {
            Fl(i, "");
          } catch (J) {
            jt(t, t.return, J);
          }
        }
        a & 4 && t.stateNode != null && (i = t.memoizedProps, Os(
          t,
          i,
          n !== null ? n.memoizedProps : i
        )), a & 1024 && (xs = !0);
        break;
      case 6:
        if (je(e, t), Xe(t), a & 4) {
          if (t.stateNode === null)
            throw Error(u(162));
          a = t.memoizedProps, n = t.stateNode;
          try {
            n.nodeValue = a;
          } catch (J) {
            jt(t, t.return, J);
          }
        }
        break;
      case 3:
        if (cc = null, i = Dn, Dn = oc(e.containerInfo), je(e, t), Dn = i, Xe(t), a & 4 && n !== null && n.memoizedState.isDehydrated)
          try {
            Si(e.containerInfo);
          } catch (J) {
            jt(t, t.return, J);
          }
        xs && (xs = !1, sg(t));
        break;
      case 4:
        a = Dn, Dn = oc(
          t.stateNode.containerInfo
        ), je(e, t), Xe(t), Dn = a;
        break;
      case 12:
        je(e, t), Xe(t);
        break;
      case 31:
        je(e, t), Xe(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, qr(t, a)));
        break;
      case 13:
        je(e, t), Xe(t), t.child.flags & 8192 && t.memoizedState !== null != (n !== null && n.memoizedState !== null) && (Zr = xe()), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, qr(t, a)));
        break;
      case 22:
        i = t.memoizedState !== null;
        var p = n !== null && n.memoizedState !== null, x = ua, L = se;
        if (ua = x || i, se = L || p, je(e, t), se = L, ua = x, Xe(t), a & 8192)
          t: for (e = t.stateNode, e._visibility = i ? e._visibility & -2 : e._visibility | 1, i && (n === null || p || ua || se || Ol(t)), n = null, e = t; ; ) {
            if (e.tag === 5 || e.tag === 26) {
              if (n === null) {
                p = n = e;
                try {
                  if (r = p.stateNode, i)
                    f = r.style, typeof f.setProperty == "function" ? f.setProperty("display", "none", "important") : f.display = "none";
                  else {
                    m = p.stateNode;
                    var R = p.memoizedProps.style, N = R != null && R.hasOwnProperty("display") ? R.display : null;
                    m.style.display = N == null || typeof N == "boolean" ? "" : ("" + N).trim();
                  }
                } catch (J) {
                  jt(p, p.return, J);
                }
              }
            } else if (e.tag === 6) {
              if (n === null) {
                p = e;
                try {
                  p.stateNode.nodeValue = i ? "" : p.memoizedProps;
                } catch (J) {
                  jt(p, p.return, J);
                }
              }
            } else if (e.tag === 18) {
              if (n === null) {
                p = e;
                try {
                  var M = p.stateNode;
                  i ? $g(M, !0) : $g(p.stateNode, !1);
                } catch (J) {
                  jt(p, p.return, J);
                }
              }
            } else if ((e.tag !== 22 && e.tag !== 23 || e.memoizedState === null || e === t) && e.child !== null) {
              e.child.return = e, e = e.child;
              continue;
            }
            if (e === t) break t;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t) break t;
              n === e && (n = null), e = e.return;
            }
            n === e && (n = null), e.sibling.return = e.return, e = e.sibling;
          }
        a & 4 && (a = t.updateQueue, a !== null && (n = a.retryQueue, n !== null && (a.retryQueue = null, qr(t, n))));
        break;
      case 19:
        je(e, t), Xe(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, qr(t, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        je(e, t), Xe(t);
    }
  }
  function Xe(t) {
    var e = t.flags;
    if (e & 2) {
      try {
        for (var n, a = t.return; a !== null; ) {
          if (eg(a)) {
            n = a;
            break;
          }
          a = a.return;
        }
        if (n == null) throw Error(u(160));
        switch (n.tag) {
          case 27:
            var i = n.stateNode, r = Es(t);
            kr(t, r, i);
            break;
          case 5:
            var f = n.stateNode;
            n.flags & 32 && (Fl(f, ""), n.flags &= -33);
            var m = Es(t);
            kr(t, m, f);
            break;
          case 3:
          case 4:
            var p = n.stateNode.containerInfo, x = Es(t);
            Ts(
              t,
              x,
              p
            );
            break;
          default:
            throw Error(u(161));
        }
      } catch (L) {
        jt(t, t.return, L);
      }
      t.flags &= -3;
    }
    e & 4096 && (t.flags &= -4097);
  }
  function sg(t) {
    if (t.subtreeFlags & 1024)
      for (t = t.child; t !== null; ) {
        var e = t;
        sg(e), e.tag === 5 && e.flags & 1024 && e.stateNode.reset(), t = t.sibling;
      }
  }
  function fa(t, e) {
    if (e.subtreeFlags & 8772)
      for (e = e.child; e !== null; )
        lg(t, e.alternate, e), e = e.sibling;
  }
  function Ol(t) {
    for (t = t.child; t !== null; ) {
      var e = t;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          ja(4, e, e.return), Ol(e);
          break;
        case 1:
          Yn(e, e.return);
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && $h(
            e,
            e.return,
            n
          ), Ol(e);
          break;
        case 27:
          Co(e.stateNode);
        case 26:
        case 5:
          Yn(e, e.return), Ol(e);
          break;
        case 22:
          e.memoizedState === null && Ol(e);
          break;
        case 30:
          Ol(e);
          break;
        default:
          Ol(e);
      }
      t = t.sibling;
    }
  }
  function da(t, e, n) {
    for (n = n && (e.subtreeFlags & 8772) !== 0, e = e.child; e !== null; ) {
      var a = e.alternate, i = t, r = e, f = r.flags;
      switch (r.tag) {
        case 0:
        case 11:
        case 15:
          da(
            i,
            r,
            n
          ), Ao(4, r);
          break;
        case 1:
          if (da(
            i,
            r,
            n
          ), a = r, i = a.stateNode, typeof i.componentDidMount == "function")
            try {
              i.componentDidMount();
            } catch (x) {
              jt(a, a.return, x);
            }
          if (a = r, i = a.updateQueue, i !== null) {
            var m = a.stateNode;
            try {
              var p = i.shared.hiddenCallbacks;
              if (p !== null)
                for (i.shared.hiddenCallbacks = null, i = 0; i < p.length; i++)
                  Gm(p[i], m);
            } catch (x) {
              jt(a, a.return, x);
            }
          }
          n && f & 64 && _h(r), po(r, r.return);
          break;
        case 27:
          ng(r);
        case 26:
        case 5:
          da(
            i,
            r,
            n
          ), n && a === null && f & 4 && tg(r), po(r, r.return);
          break;
        case 12:
          da(
            i,
            r,
            n
          );
          break;
        case 31:
          da(
            i,
            r,
            n
          ), n && f & 4 && rg(i, r);
          break;
        case 13:
          da(
            i,
            r,
            n
          ), n && f & 4 && cg(i, r);
          break;
        case 22:
          r.memoizedState === null && da(
            i,
            r,
            n
          ), po(r, r.return);
          break;
        case 30:
          break;
        default:
          da(
            i,
            r,
            n
          );
      }
      e = e.sibling;
    }
  }
  function Cs(t, e) {
    var n = null;
    t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), t = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (t = e.memoizedState.cachePool.pool), t !== n && (t != null && t.refCount++, n != null && no(n));
  }
  function Ns(t, e) {
    t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && no(t));
  }
  function Bn(t, e, n, a) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        fg(
          t,
          e,
          n,
          a
        ), e = e.sibling;
  }
  function fg(t, e, n, a) {
    var i = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Bn(
          t,
          e,
          n,
          a
        ), i & 2048 && Ao(9, e);
        break;
      case 1:
        Bn(
          t,
          e,
          n,
          a
        );
        break;
      case 3:
        Bn(
          t,
          e,
          n,
          a
        ), i & 2048 && (t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && no(t)));
        break;
      case 12:
        if (i & 2048) {
          Bn(
            t,
            e,
            n,
            a
          ), t = e.stateNode;
          try {
            var r = e.memoizedProps, f = r.id, m = r.onPostCommit;
            typeof m == "function" && m(
              f,
              e.alternate === null ? "mount" : "update",
              t.passiveEffectDuration,
              -0
            );
          } catch (p) {
            jt(e, e.return, p);
          }
        } else
          Bn(
            t,
            e,
            n,
            a
          );
        break;
      case 31:
        Bn(
          t,
          e,
          n,
          a
        );
        break;
      case 13:
        Bn(
          t,
          e,
          n,
          a
        );
        break;
      case 23:
        break;
      case 22:
        r = e.stateNode, f = e.alternate, e.memoizedState !== null ? r._visibility & 2 ? Bn(
          t,
          e,
          n,
          a
        ) : yo(t, e) : r._visibility & 2 ? Bn(
          t,
          e,
          n,
          a
        ) : (r._visibility |= 2, si(
          t,
          e,
          n,
          a,
          (e.subtreeFlags & 10256) !== 0 || !1
        )), i & 2048 && Cs(f, e);
        break;
      case 24:
        Bn(
          t,
          e,
          n,
          a
        ), i & 2048 && Ns(e.alternate, e);
        break;
      default:
        Bn(
          t,
          e,
          n,
          a
        );
    }
  }
  function si(t, e, n, a, i) {
    for (i = i && ((e.subtreeFlags & 10256) !== 0 || !1), e = e.child; e !== null; ) {
      var r = t, f = e, m = n, p = a, x = f.flags;
      switch (f.tag) {
        case 0:
        case 11:
        case 15:
          si(
            r,
            f,
            m,
            p,
            i
          ), Ao(8, f);
          break;
        case 23:
          break;
        case 22:
          var L = f.stateNode;
          f.memoizedState !== null ? L._visibility & 2 ? si(
            r,
            f,
            m,
            p,
            i
          ) : yo(
            r,
            f
          ) : (L._visibility |= 2, si(
            r,
            f,
            m,
            p,
            i
          )), i && x & 2048 && Cs(
            f.alternate,
            f
          );
          break;
        case 24:
          si(
            r,
            f,
            m,
            p,
            i
          ), i && x & 2048 && Ns(f.alternate, f);
          break;
        default:
          si(
            r,
            f,
            m,
            p,
            i
          );
      }
      e = e.sibling;
    }
  }
  function yo(t, e) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) {
        var n = t, a = e, i = a.flags;
        switch (a.tag) {
          case 22:
            yo(n, a), i & 2048 && Cs(
              a.alternate,
              a
            );
            break;
          case 24:
            yo(n, a), i & 2048 && Ns(a.alternate, a);
            break;
          default:
            yo(n, a);
        }
        e = e.sibling;
      }
  }
  var vo = 8192;
  function fi(t, e, n) {
    if (t.subtreeFlags & vo)
      for (t = t.child; t !== null; )
        dg(
          t,
          e,
          n
        ), t = t.sibling;
  }
  function dg(t, e, n) {
    switch (t.tag) {
      case 26:
        fi(
          t,
          e,
          n
        ), t.flags & vo && t.memoizedState !== null && Dv(
          n,
          Dn,
          t.memoizedState,
          t.memoizedProps
        );
        break;
      case 5:
        fi(
          t,
          e,
          n
        );
        break;
      case 3:
      case 4:
        var a = Dn;
        Dn = oc(t.stateNode.containerInfo), fi(
          t,
          e,
          n
        ), Dn = a;
        break;
      case 22:
        t.memoizedState === null && (a = t.alternate, a !== null && a.memoizedState !== null ? (a = vo, vo = 16777216, fi(
          t,
          e,
          n
        ), vo = a) : fi(
          t,
          e,
          n
        ));
        break;
      default:
        fi(
          t,
          e,
          n
        );
    }
  }
  function mg(t) {
    var e = t.alternate;
    if (e !== null && (t = e.child, t !== null)) {
      e.child = null;
      do
        e = t.sibling, t.sibling = null, t = e;
      while (t !== null);
    }
  }
  function bo(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          pe = a, gg(
            a,
            t
          );
        }
      mg(t);
    }
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        hg(t), t = t.sibling;
  }
  function hg(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        bo(t), t.flags & 2048 && ja(9, t, t.return);
        break;
      case 3:
        bo(t);
        break;
      case 12:
        bo(t);
        break;
      case 22:
        var e = t.stateNode;
        t.memoizedState !== null && e._visibility & 2 && (t.return === null || t.return.tag !== 13) ? (e._visibility &= -3, Kr(t)) : bo(t);
        break;
      default:
        bo(t);
    }
  }
  function Kr(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          pe = a, gg(
            a,
            t
          );
        }
      mg(t);
    }
    for (t = t.child; t !== null; ) {
      switch (e = t, e.tag) {
        case 0:
        case 11:
        case 15:
          ja(8, e, e.return), Kr(e);
          break;
        case 22:
          n = e.stateNode, n._visibility & 2 && (n._visibility &= -3, Kr(e));
          break;
        default:
          Kr(e);
      }
      t = t.sibling;
    }
  }
  function gg(t, e) {
    for (; pe !== null; ) {
      var n = pe;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          ja(8, n, e);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var a = n.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          no(n.memoizedState.cache);
      }
      if (a = n.child, a !== null) a.return = n, pe = a;
      else
        t: for (n = t; pe !== null; ) {
          a = pe;
          var i = a.sibling, r = a.return;
          if (ig(a), a === n) {
            pe = null;
            break t;
          }
          if (i !== null) {
            i.return = r, pe = i;
            break t;
          }
          pe = r;
        }
    }
  }
  var Fy = {
    getCacheForType: function(t) {
      var e = Se(re), n = e.data.get(t);
      return n === void 0 && (n = t(), e.data.set(t, n)), n;
    },
    cacheSignal: function() {
      return Se(re).controller.signal;
    }
  }, ky = typeof WeakMap == "function" ? WeakMap : Map, Lt = 0, It = null, pt = null, vt = 0, Ht = 0, Pe = null, Xa = !1, di = !1, ws = !1, ma = 0, ee = 0, Qa = 0, El = 0, Ds = 0, We = 0, mi = 0, So = null, Qe = null, Bs = !1, Zr = 0, Ag = 0, Pr = 1 / 0, Wr = null, Va = null, he = 0, Ga = null, hi = null, ha = 0, Ms = 0, Ls = null, pg = null, Oo = 0, zs = null;
  function Je() {
    return (Lt & 2) !== 0 && vt !== 0 ? vt & -vt : j.T !== null ? Qs() : Re();
  }
  function yg() {
    if (We === 0)
      if ((vt & 536870912) === 0 || Et) {
        var t = Xl;
        Xl <<= 1, (Xl & 3932160) === 0 && (Xl = 262144), We = t;
      } else We = 536870912;
    return t = Ke.current, t !== null && (t.flags |= 32), We;
  }
  function Ve(t, e, n) {
    (t === It && (Ht === 2 || Ht === 9) || t.cancelPendingCommit !== null) && (gi(t, 0), Ya(
      t,
      vt,
      We,
      !1
    )), rn(t, n), ((Lt & 2) === 0 || t !== It) && (t === It && ((Lt & 2) === 0 && (El |= n), ee === 4 && Ya(
      t,
      vt,
      We,
      !1
    )), In(t));
  }
  function vg(t, e, n) {
    if ((Lt & 6) !== 0) throw Error(u(327));
    var a = !n && (e & 127) === 0 && (e & t.expiredLanes) === 0 || En(t, e), i = a ? Zy(t, e) : Us(t, e, !0), r = a;
    do {
      if (i === 0) {
        di && !a && Ya(t, e, 0, !1);
        break;
      } else {
        if (n = t.current.alternate, r && !qy(n)) {
          i = Us(t, e, !1), r = !1;
          continue;
        }
        if (i === 2) {
          if (r = e, t.errorRecoveryDisabledLanes & r)
            var f = 0;
          else
            f = t.pendingLanes & -536870913, f = f !== 0 ? f : f & 536870912 ? 536870912 : 0;
          if (f !== 0) {
            e = f;
            t: {
              var m = t;
              i = So;
              var p = m.current.memoizedState.isDehydrated;
              if (p && (gi(m, f).flags |= 256), f = Us(
                m,
                f,
                !1
              ), f !== 2) {
                if (ws && !p) {
                  m.errorRecoveryDisabledLanes |= r, El |= r, i = 4;
                  break t;
                }
                r = Qe, Qe = i, r !== null && (Qe === null ? Qe = r : Qe.push.apply(
                  Qe,
                  r
                ));
              }
              i = f;
            }
            if (r = !1, i !== 2) continue;
          }
        }
        if (i === 1) {
          gi(t, 0), Ya(t, e, 0, !0);
          break;
        }
        t: {
          switch (a = t, r = i, r) {
            case 0:
            case 1:
              throw Error(u(345));
            case 4:
              if ((e & 4194048) !== e) break;
            case 6:
              Ya(
                a,
                e,
                We,
                !Xa
              );
              break t;
            case 2:
              Qe = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(u(329));
          }
          if ((e & 62914560) === e && (i = Zr + 300 - xe(), 10 < i)) {
            if (Ya(
              a,
              e,
              We,
              !Xa
            ), Ql(a, 0, !0) !== 0) break t;
            ha = e, a.timeoutHandle = Wg(
              bg.bind(
                null,
                a,
                n,
                Qe,
                Wr,
                Bs,
                e,
                We,
                El,
                mi,
                Xa,
                r,
                "Throttled",
                -0,
                0
              ),
              i
            );
            break t;
          }
          bg(
            a,
            n,
            Qe,
            Wr,
            Bs,
            e,
            We,
            El,
            mi,
            Xa,
            r,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    In(t);
  }
  function bg(t, e, n, a, i, r, f, m, p, x, L, R, N, M) {
    if (t.timeoutHandle = -1, R = e.subtreeFlags, R & 8192 || (R & 16785408) === 16785408) {
      R = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: $n
      }, dg(
        e,
        r,
        R
      );
      var J = (r & 62914560) === r ? Zr - xe() : (r & 4194048) === r ? Ag - xe() : 0;
      if (J = Bv(
        R,
        J
      ), J !== null) {
        ha = r, t.cancelPendingCommit = J(
          wg.bind(
            null,
            t,
            e,
            r,
            n,
            a,
            i,
            f,
            m,
            p,
            L,
            R,
            null,
            N,
            M
          )
        ), Ya(t, r, f, !x);
        return;
      }
    }
    wg(
      t,
      e,
      r,
      n,
      a,
      i,
      f,
      m,
      p
    );
  }
  function qy(t) {
    for (var e = t; ; ) {
      var n = e.tag;
      if ((n === 0 || n === 11 || n === 15) && e.flags & 16384 && (n = e.updateQueue, n !== null && (n = n.stores, n !== null)))
        for (var a = 0; a < n.length; a++) {
          var i = n[a], r = i.getSnapshot;
          i = i.value;
          try {
            if (!ke(r(), i)) return !1;
          } catch {
            return !1;
          }
        }
      if (n = e.child, e.subtreeFlags & 16384 && n !== null)
        n.return = e, e = n;
      else {
        if (e === t) break;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) return !0;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    }
    return !0;
  }
  function Ya(t, e, n, a) {
    e &= ~Ds, e &= ~El, t.suspendedLanes |= e, t.pingedLanes &= ~e, a && (t.warmLanes |= e), a = t.expirationTimes;
    for (var i = e; 0 < i; ) {
      var r = 31 - Ae(i), f = 1 << r;
      a[r] = -1, i &= ~f;
    }
    n !== 0 && Gi(t, n, e);
  }
  function Jr() {
    return (Lt & 6) === 0 ? (Eo(0), !1) : !0;
  }
  function Rs() {
    if (pt !== null) {
      if (Ht === 0)
        var t = pt.return;
      else
        t = pt, aa = hl = null, Wu(t), ii = null, lo = 0, t = pt;
      for (; t !== null; )
        Jh(t.alternate, t), t = t.return;
      pt = null;
    }
  }
  function gi(t, e) {
    var n = t.timeoutHandle;
    n !== -1 && (t.timeoutHandle = -1, dv(n)), n = t.cancelPendingCommit, n !== null && (t.cancelPendingCommit = null, n()), ha = 0, Rs(), It = t, pt = n = ea(t.current, null), vt = e, Ht = 0, Pe = null, Xa = !1, di = En(t, e), ws = !1, mi = We = Ds = El = Qa = ee = 0, Qe = So = null, Bs = !1, (e & 8) !== 0 && (e |= e & 32);
    var a = t.entangledLanes;
    if (a !== 0)
      for (t = t.entanglements, a &= e; 0 < a; ) {
        var i = 31 - Ae(a), r = 1 << i;
        e |= t[i], a &= ~r;
      }
    return ma = e, yr(), n;
  }
  function Sg(t, e) {
    ft = null, j.H = mo, e === li || e === Cr ? (e = jm(), Ht = 3) : e === Xu ? (e = jm(), Ht = 4) : Ht = e === ds ? 8 : e !== null && typeof e == "object" && typeof e.then == "function" ? 6 : 1, Pe = e, pt === null && (ee = 1, Vr(
      t,
      fn(e, t.current)
    ));
  }
  function Og() {
    var t = Ke.current;
    return t === null ? !0 : (vt & 4194048) === vt ? gn === null : (vt & 62914560) === vt || (vt & 536870912) !== 0 ? t === gn : !1;
  }
  function Eg() {
    var t = j.H;
    return j.H = mo, t === null ? mo : t;
  }
  function Tg() {
    var t = j.A;
    return j.A = Fy, t;
  }
  function _r() {
    ee = 4, Xa || (vt & 4194048) !== vt && Ke.current !== null || (di = !0), (Qa & 134217727) === 0 && (El & 134217727) === 0 || It === null || Ya(
      It,
      vt,
      We,
      !1
    );
  }
  function Us(t, e, n) {
    var a = Lt;
    Lt |= 2;
    var i = Eg(), r = Tg();
    (It !== t || vt !== e) && (Wr = null, gi(t, e)), e = !1;
    var f = ee;
    t: do
      try {
        if (Ht !== 0 && pt !== null) {
          var m = pt, p = Pe;
          switch (Ht) {
            case 8:
              Rs(), f = 6;
              break t;
            case 3:
            case 2:
            case 9:
            case 6:
              Ke.current === null && (e = !0);
              var x = Ht;
              if (Ht = 0, Pe = null, Ai(t, m, p, x), n && di) {
                f = 0;
                break t;
              }
              break;
            default:
              x = Ht, Ht = 0, Pe = null, Ai(t, m, p, x);
          }
        }
        Ky(), f = ee;
        break;
      } catch (L) {
        Sg(t, L);
      }
    while (!0);
    return e && t.shellSuspendCounter++, aa = hl = null, Lt = a, j.H = i, j.A = r, pt === null && (It = null, vt = 0, yr()), f;
  }
  function Ky() {
    for (; pt !== null; ) xg(pt);
  }
  function Zy(t, e) {
    var n = Lt;
    Lt |= 2;
    var a = Eg(), i = Tg();
    It !== t || vt !== e ? (Wr = null, Pr = xe() + 500, gi(t, e)) : di = En(
      t,
      e
    );
    t: do
      try {
        if (Ht !== 0 && pt !== null) {
          e = pt;
          var r = Pe;
          e: switch (Ht) {
            case 1:
              Ht = 0, Pe = null, Ai(t, e, r, 1);
              break;
            case 2:
            case 9:
              if (Um(r)) {
                Ht = 0, Pe = null, Cg(e);
                break;
              }
              e = function() {
                Ht !== 2 && Ht !== 9 || It !== t || (Ht = 7), In(t);
              }, r.then(e, e);
              break t;
            case 3:
              Ht = 7;
              break t;
            case 4:
              Ht = 5;
              break t;
            case 7:
              Um(r) ? (Ht = 0, Pe = null, Cg(e)) : (Ht = 0, Pe = null, Ai(t, e, r, 7));
              break;
            case 5:
              var f = null;
              switch (pt.tag) {
                case 26:
                  f = pt.memoizedState;
                case 5:
                case 27:
                  var m = pt;
                  if (f ? fA(f) : m.stateNode.complete) {
                    Ht = 0, Pe = null;
                    var p = m.sibling;
                    if (p !== null) pt = p;
                    else {
                      var x = m.return;
                      x !== null ? (pt = x, $r(x)) : pt = null;
                    }
                    break e;
                  }
              }
              Ht = 0, Pe = null, Ai(t, e, r, 5);
              break;
            case 6:
              Ht = 0, Pe = null, Ai(t, e, r, 6);
              break;
            case 8:
              Rs(), ee = 6;
              break t;
            default:
              throw Error(u(462));
          }
        }
        Py();
        break;
      } catch (L) {
        Sg(t, L);
      }
    while (!0);
    return aa = hl = null, j.H = a, j.A = i, Lt = n, pt !== null ? 0 : (It = null, vt = 0, yr(), ee);
  }
  function Py() {
    for (; pt !== null && !Ul(); )
      xg(pt);
  }
  function xg(t) {
    var e = Ph(t.alternate, t, ma);
    t.memoizedProps = t.pendingProps, e === null ? $r(t) : pt = e;
  }
  function Cg(t) {
    var e = t, n = e.alternate;
    switch (e.tag) {
      case 15:
      case 0:
        e = Ih(
          n,
          e,
          e.pendingProps,
          e.type,
          void 0,
          vt
        );
        break;
      case 11:
        e = Ih(
          n,
          e,
          e.pendingProps,
          e.type.render,
          e.ref,
          vt
        );
        break;
      case 5:
        Wu(e);
      default:
        Jh(n, e), e = pt = Tm(e, ma), e = Ph(n, e, ma);
    }
    t.memoizedProps = t.pendingProps, e === null ? $r(t) : pt = e;
  }
  function Ai(t, e, n, a) {
    aa = hl = null, Wu(e), ii = null, lo = 0;
    var i = e.return;
    try {
      if (jy(
        t,
        i,
        e,
        n,
        vt
      )) {
        ee = 1, Vr(
          t,
          fn(n, t.current)
        ), pt = null;
        return;
      }
    } catch (r) {
      if (i !== null) throw pt = i, r;
      ee = 1, Vr(
        t,
        fn(n, t.current)
      ), pt = null;
      return;
    }
    e.flags & 32768 ? (Et || a === 1 ? t = !0 : di || (vt & 536870912) !== 0 ? t = !1 : (Xa = t = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = Ke.current, a !== null && a.tag === 13 && (a.flags |= 16384))), Ng(e, t)) : $r(e);
  }
  function $r(t) {
    var e = t;
    do {
      if ((e.flags & 32768) !== 0) {
        Ng(
          e,
          Xa
        );
        return;
      }
      t = e.return;
      var n = Vy(
        e.alternate,
        e,
        ma
      );
      if (n !== null) {
        pt = n;
        return;
      }
      if (e = e.sibling, e !== null) {
        pt = e;
        return;
      }
      pt = e = t;
    } while (e !== null);
    ee === 0 && (ee = 5);
  }
  function Ng(t, e) {
    do {
      var n = Gy(t.alternate, t);
      if (n !== null) {
        n.flags &= 32767, pt = n;
        return;
      }
      if (n = t.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !e && (t = t.sibling, t !== null)) {
        pt = t;
        return;
      }
      pt = t = n;
    } while (t !== null);
    ee = 6, pt = null;
  }
  function wg(t, e, n, a, i, r, f, m, p) {
    t.cancelPendingCommit = null;
    do
      tc();
    while (he !== 0);
    if ((Lt & 6) !== 0) throw Error(u(327));
    if (e !== null) {
      if (e === t.current) throw Error(u(177));
      if (r = e.lanes | e.childLanes, r |= Eu, eu(
        t,
        n,
        r,
        f,
        m,
        p
      ), t === It && (pt = It = null, vt = 0), hi = e, Ga = t, ha = n, Ms = r, Ls = i, pg = a, (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0 ? (t.callbackNode = null, t.callbackPriority = 0, $y(Sn, function() {
        return zg(), null;
      })) : (t.callbackNode = null, t.callbackPriority = 0), a = (e.flags & 13878) !== 0, (e.subtreeFlags & 13878) !== 0 || a) {
        a = j.T, j.T = null, i = q.p, q.p = 2, f = Lt, Lt |= 4;
        try {
          Yy(t, e, n);
        } finally {
          Lt = f, q.p = i, j.T = a;
        }
      }
      he = 1, Dg(), Bg(), Mg();
    }
  }
  function Dg() {
    if (he === 1) {
      he = 0;
      var t = Ga, e = hi, n = (e.flags & 13878) !== 0;
      if ((e.subtreeFlags & 13878) !== 0 || n) {
        n = j.T, j.T = null;
        var a = q.p;
        q.p = 2;
        var i = Lt;
        Lt |= 4;
        try {
          ug(e, t);
          var r = Ks, f = gm(t.containerInfo), m = r.focusedElem, p = r.selectionRange;
          if (f !== m && m && m.ownerDocument && hm(
            m.ownerDocument.documentElement,
            m
          )) {
            if (p !== null && yu(m)) {
              var x = p.start, L = p.end;
              if (L === void 0 && (L = x), "selectionStart" in m)
                m.selectionStart = x, m.selectionEnd = Math.min(
                  L,
                  m.value.length
                );
              else {
                var R = m.ownerDocument || document, N = R && R.defaultView || window;
                if (N.getSelection) {
                  var M = N.getSelection(), J = m.textContent.length, it = Math.min(p.start, J), Vt = p.end === void 0 ? it : Math.min(p.end, J);
                  !M.extend && it > Vt && (f = Vt, Vt = it, it = f);
                  var O = mm(
                    m,
                    it
                  ), v = mm(
                    m,
                    Vt
                  );
                  if (O && v && (M.rangeCount !== 1 || M.anchorNode !== O.node || M.anchorOffset !== O.offset || M.focusNode !== v.node || M.focusOffset !== v.offset)) {
                    var T = R.createRange();
                    T.setStart(O.node, O.offset), M.removeAllRanges(), it > Vt ? (M.addRange(T), M.extend(v.node, v.offset)) : (T.setEnd(v.node, v.offset), M.addRange(T));
                  }
                }
              }
            }
            for (R = [], M = m; M = M.parentNode; )
              M.nodeType === 1 && R.push({
                element: M,
                left: M.scrollLeft,
                top: M.scrollTop
              });
            for (typeof m.focus == "function" && m.focus(), m = 0; m < R.length; m++) {
              var z = R[m];
              z.element.scrollLeft = z.left, z.element.scrollTop = z.top;
            }
          }
          dc = !!qs, Ks = qs = null;
        } finally {
          Lt = i, q.p = a, j.T = n;
        }
      }
      t.current = e, he = 2;
    }
  }
  function Bg() {
    if (he === 2) {
      he = 0;
      var t = Ga, e = hi, n = (e.flags & 8772) !== 0;
      if ((e.subtreeFlags & 8772) !== 0 || n) {
        n = j.T, j.T = null;
        var a = q.p;
        q.p = 2;
        var i = Lt;
        Lt |= 4;
        try {
          lg(t, e.alternate, e);
        } finally {
          Lt = i, q.p = a, j.T = n;
        }
      }
      he = 3;
    }
  }
  function Mg() {
    if (he === 4 || he === 3) {
      he = 0, ar();
      var t = Ga, e = hi, n = ha, a = pg;
      (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0 ? he = 5 : (he = 0, hi = Ga = null, Lg(t, t.pendingLanes));
      var i = t.pendingLanes;
      if (i === 0 && (Va = null), Ii(n), e = e.stateNode, Ce && typeof Ce.onCommitFiberRoot == "function")
        try {
          Ce.onCommitFiberRoot(
            Jn,
            e,
            void 0,
            (e.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        e = j.T, i = q.p, q.p = 2, j.T = null;
        try {
          for (var r = t.onRecoverableError, f = 0; f < a.length; f++) {
            var m = a[f];
            r(m.value, {
              componentStack: m.stack
            });
          }
        } finally {
          j.T = e, q.p = i;
        }
      }
      (ha & 3) !== 0 && tc(), In(t), i = t.pendingLanes, (n & 261930) !== 0 && (i & 42) !== 0 ? t === zs ? Oo++ : (Oo = 0, zs = t) : Oo = 0, Eo(0);
    }
  }
  function Lg(t, e) {
    (t.pooledCacheLanes &= e) === 0 && (e = t.pooledCache, e != null && (t.pooledCache = null, no(e)));
  }
  function tc() {
    return Dg(), Bg(), Mg(), zg();
  }
  function zg() {
    if (he !== 5) return !1;
    var t = Ga, e = Ms;
    Ms = 0;
    var n = Ii(ha), a = j.T, i = q.p;
    try {
      q.p = 32 > n ? 32 : n, j.T = null, n = Ls, Ls = null;
      var r = Ga, f = ha;
      if (he = 0, hi = Ga = null, ha = 0, (Lt & 6) !== 0) throw Error(u(331));
      var m = Lt;
      if (Lt |= 4, hg(r.current), fg(
        r,
        r.current,
        f,
        n
      ), Lt = m, Eo(0, !1), Ce && typeof Ce.onPostCommitFiberRoot == "function")
        try {
          Ce.onPostCommitFiberRoot(Jn, r);
        } catch {
        }
      return !0;
    } finally {
      q.p = i, j.T = a, Lg(t, e);
    }
  }
  function Rg(t, e, n) {
    e = fn(n, e), e = fs(t.stateNode, e, 2), t = Ra(t, e, 2), t !== null && (rn(t, 2), In(t));
  }
  function jt(t, e, n) {
    if (t.tag === 3)
      Rg(t, t, n);
    else
      for (; e !== null; ) {
        if (e.tag === 3) {
          Rg(
            e,
            t,
            n
          );
          break;
        } else if (e.tag === 1) {
          var a = e.stateNode;
          if (typeof e.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (Va === null || !Va.has(a))) {
            t = fn(n, t), n = Uh(2), a = Ra(e, n, 2), a !== null && (Hh(
              n,
              a,
              e,
              t
            ), rn(a, 2), In(a));
            break;
          }
        }
        e = e.return;
      }
  }
  function Hs(t, e, n) {
    var a = t.pingCache;
    if (a === null) {
      a = t.pingCache = new ky();
      var i = /* @__PURE__ */ new Set();
      a.set(e, i);
    } else
      i = a.get(e), i === void 0 && (i = /* @__PURE__ */ new Set(), a.set(e, i));
    i.has(n) || (ws = !0, i.add(n), t = Wy.bind(null, t, e, n), e.then(t, t));
  }
  function Wy(t, e, n) {
    var a = t.pingCache;
    a !== null && a.delete(e), t.pingedLanes |= t.suspendedLanes & n, t.warmLanes &= ~n, It === t && (vt & n) === n && (ee === 4 || ee === 3 && (vt & 62914560) === vt && 300 > xe() - Zr ? (Lt & 2) === 0 && gi(t, 0) : Ds |= n, mi === vt && (mi = 0)), In(t);
  }
  function Ug(t, e) {
    e === 0 && (e = rr()), t = fl(t, e), t !== null && (rn(t, e), In(t));
  }
  function Jy(t) {
    var e = t.memoizedState, n = 0;
    e !== null && (n = e.retryLane), Ug(t, n);
  }
  function _y(t, e) {
    var n = 0;
    switch (t.tag) {
      case 31:
      case 13:
        var a = t.stateNode, i = t.memoizedState;
        i !== null && (n = i.retryLane);
        break;
      case 19:
        a = t.stateNode;
        break;
      case 22:
        a = t.stateNode._retryCache;
        break;
      default:
        throw Error(u(314));
    }
    a !== null && a.delete(e), Ug(t, n);
  }
  function $y(t, e) {
    return Un(t, e);
  }
  var ec = null, pi = null, js = !1, nc = !1, Xs = !1, Ia = 0;
  function In(t) {
    t !== pi && t.next === null && (pi === null ? ec = pi = t : pi = pi.next = t), nc = !0, js || (js = !0, ev());
  }
  function Eo(t, e) {
    if (!Xs && nc) {
      Xs = !0;
      do
        for (var n = !1, a = ec; a !== null; ) {
          if (t !== 0) {
            var i = a.pendingLanes;
            if (i === 0) var r = 0;
            else {
              var f = a.suspendedLanes, m = a.pingedLanes;
              r = (1 << 31 - Ae(42 | t) + 1) - 1, r &= i & ~(f & ~m), r = r & 201326741 ? r & 201326741 | 1 : r ? r | 2 : 0;
            }
            r !== 0 && (n = !0, Qg(a, r));
          } else
            r = vt, r = Ql(
              a,
              a === It ? r : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (r & 3) === 0 || En(a, r) || (n = !0, Qg(a, r));
          a = a.next;
        }
      while (n);
      Xs = !1;
    }
  }
  function tv() {
    Hg();
  }
  function Hg() {
    nc = js = !1;
    var t = 0;
    Ia !== 0 && fv() && (t = Ia);
    for (var e = xe(), n = null, a = ec; a !== null; ) {
      var i = a.next, r = jg(a, e);
      r === 0 ? (a.next = null, n === null ? ec = i : n.next = i, i === null && (pi = n)) : (n = a, (t !== 0 || (r & 3) !== 0) && (nc = !0)), a = i;
    }
    he !== 0 && he !== 5 || Eo(t), Ia !== 0 && (Ia = 0);
  }
  function jg(t, e) {
    for (var n = t.suspendedLanes, a = t.pingedLanes, i = t.expirationTimes, r = t.pendingLanes & -62914561; 0 < r; ) {
      var f = 31 - Ae(r), m = 1 << f, p = i[f];
      p === -1 ? ((m & n) === 0 || (m & a) !== 0) && (i[f] = tu(m, e)) : p <= e && (t.expiredLanes |= m), r &= ~m;
    }
    if (e = It, n = vt, n = Ql(
      t,
      t === e ? n : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a = t.callbackNode, n === 0 || t === e && (Ht === 2 || Ht === 9) || t.cancelPendingCommit !== null)
      return a !== null && a !== null && ba(a), t.callbackNode = null, t.callbackPriority = 0;
    if ((n & 3) === 0 || En(t, n)) {
      if (e = n & -n, e === t.callbackPriority) return e;
      switch (a !== null && ba(a), Ii(n)) {
        case 2:
        case 8:
          n = Sa;
          break;
        case 32:
          n = Sn;
          break;
        case 268435456:
          n = jl;
          break;
        default:
          n = Sn;
      }
      return a = Xg.bind(null, t), n = Un(n, a), t.callbackPriority = e, t.callbackNode = n, e;
    }
    return a !== null && a !== null && ba(a), t.callbackPriority = 2, t.callbackNode = null, 2;
  }
  function Xg(t, e) {
    if (he !== 0 && he !== 5)
      return t.callbackNode = null, t.callbackPriority = 0, null;
    var n = t.callbackNode;
    if (tc() && t.callbackNode !== n)
      return null;
    var a = vt;
    return a = Ql(
      t,
      t === It ? a : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a === 0 ? null : (vg(t, a, e), jg(t, xe()), t.callbackNode != null && t.callbackNode === n ? Xg.bind(null, t) : null);
  }
  function Qg(t, e) {
    if (tc()) return null;
    vg(t, e, !0);
  }
  function ev() {
    mv(function() {
      (Lt & 6) !== 0 ? Un(
        Hl,
        tv
      ) : Hg();
    });
  }
  function Qs() {
    if (Ia === 0) {
      var t = ni;
      t === 0 && (t = Ea, Ea <<= 1, (Ea & 261888) === 0 && (Ea = 256)), Ia = t;
    }
    return Ia;
  }
  function Vg(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean" ? null : typeof t == "function" ? t : sr("" + t);
  }
  function Gg(t, e) {
    var n = e.ownerDocument.createElement("input");
    return n.name = e.name, n.value = e.value, t.id && n.setAttribute("form", t.id), e.parentNode.insertBefore(n, e), t = new FormData(t), n.parentNode.removeChild(n), t;
  }
  function nv(t, e, n, a, i) {
    if (e === "submit" && n && n.stateNode === i) {
      var r = Vg(
        (i[ye] || null).action
      ), f = a.submitter;
      f && (e = (e = f[ye] || null) ? Vg(e.formAction) : f.getAttribute("formAction"), e !== null && (r = e, f = null));
      var m = new hr(
        "action",
        "action",
        null,
        a,
        i
      );
      t.push({
        event: m,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (Ia !== 0) {
                  var p = f ? Gg(i, f) : new FormData(i);
                  is(
                    n,
                    {
                      pending: !0,
                      data: p,
                      method: i.method,
                      action: r
                    },
                    null,
                    p
                  );
                }
              } else
                typeof r == "function" && (m.preventDefault(), p = f ? Gg(i, f) : new FormData(i), is(
                  n,
                  {
                    pending: !0,
                    data: p,
                    method: i.method,
                    action: r
                  },
                  r,
                  p
                ));
            },
            currentTarget: i
          }
        ]
      });
    }
  }
  for (var Vs = 0; Vs < Ou.length; Vs++) {
    var Gs = Ou[Vs], av = Gs.toLowerCase(), lv = Gs[0].toUpperCase() + Gs.slice(1);
    wn(
      av,
      "on" + lv
    );
  }
  wn(ym, "onAnimationEnd"), wn(vm, "onAnimationIteration"), wn(bm, "onAnimationStart"), wn("dblclick", "onDoubleClick"), wn("focusin", "onFocus"), wn("focusout", "onBlur"), wn(by, "onTransitionRun"), wn(Sy, "onTransitionStart"), wn(Oy, "onTransitionCancel"), wn(Sm, "onTransitionEnd"), Yt("onMouseEnter", ["mouseout", "mouseover"]), Yt("onMouseLeave", ["mouseout", "mouseover"]), Yt("onPointerEnter", ["pointerout", "pointerover"]), Yt("onPointerLeave", ["pointerout", "pointerover"]), rt(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), rt(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), rt("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), rt(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), rt(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), rt(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var To = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), iv = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(To)
  );
  function Yg(t, e) {
    e = (e & 4) !== 0;
    for (var n = 0; n < t.length; n++) {
      var a = t[n], i = a.event;
      a = a.listeners;
      t: {
        var r = void 0;
        if (e)
          for (var f = a.length - 1; 0 <= f; f--) {
            var m = a[f], p = m.instance, x = m.currentTarget;
            if (m = m.listener, p !== r && i.isPropagationStopped())
              break t;
            r = m, i.currentTarget = x;
            try {
              r(i);
            } catch (L) {
              pr(L);
            }
            i.currentTarget = null, r = p;
          }
        else
          for (f = 0; f < a.length; f++) {
            if (m = a[f], p = m.instance, x = m.currentTarget, m = m.listener, p !== r && i.isPropagationStopped())
              break t;
            r = m, i.currentTarget = x;
            try {
              r(i);
            } catch (L) {
              pr(L);
            }
            i.currentTarget = null, r = p;
          }
      }
    }
  }
  function yt(t, e) {
    var n = e[xa];
    n === void 0 && (n = e[xa] = /* @__PURE__ */ new Set());
    var a = t + "__bubble";
    n.has(a) || (Ig(e, t, 2, !1), n.add(a));
  }
  function Ys(t, e, n) {
    var a = 0;
    e && (a |= 4), Ig(
      n,
      t,
      a,
      e
    );
  }
  var ac = "_reactListening" + Math.random().toString(36).slice(2);
  function Is(t) {
    if (!t[ac]) {
      t[ac] = !0, U.forEach(function(n) {
        n !== "selectionchange" && (iv.has(n) || Ys(n, !1, t), Ys(n, !0, t));
      });
      var e = t.nodeType === 9 ? t : t.ownerDocument;
      e === null || e[ac] || (e[ac] = !0, Ys("selectionchange", !1, e));
    }
  }
  function Ig(t, e, n, a) {
    switch (yA(e)) {
      case 2:
        var i = zv;
        break;
      case 8:
        i = Rv;
        break;
      default:
        i = lf;
    }
    n = i.bind(
      null,
      e,
      n,
      t
    ), i = void 0, !uu || e !== "touchstart" && e !== "touchmove" && e !== "wheel" || (i = !0), a ? i !== void 0 ? t.addEventListener(e, n, {
      capture: !0,
      passive: i
    }) : t.addEventListener(e, n, !0) : i !== void 0 ? t.addEventListener(e, n, {
      passive: i
    }) : t.addEventListener(e, n, !1);
  }
  function Fs(t, e, n, a, i) {
    var r = a;
    if ((e & 1) === 0 && (e & 2) === 0 && a !== null)
      t: for (; ; ) {
        if (a === null) return;
        var f = a.tag;
        if (f === 3 || f === 4) {
          var m = a.stateNode.containerInfo;
          if (m === i) break;
          if (f === 4)
            for (f = a.return; f !== null; ) {
              var p = f.tag;
              if ((p === 3 || p === 4) && f.stateNode.containerInfo === i)
                return;
              f = f.return;
            }
          for (; m !== null; ) {
            if (f = _n(m), f === null) return;
            if (p = f.tag, p === 5 || p === 6 || p === 26 || p === 27) {
              a = r = f;
              continue t;
            }
            m = m.parentNode;
          }
        }
        a = a.return;
      }
    Zd(function() {
      var x = r, L = ru(n), R = [];
      t: {
        var N = Om.get(t);
        if (N !== void 0) {
          var M = hr, J = t;
          switch (t) {
            case "keypress":
              if (dr(n) === 0) break t;
            case "keydown":
            case "keyup":
              M = _1;
              break;
            case "focusin":
              J = "focus", M = mu;
              break;
            case "focusout":
              J = "blur", M = mu;
              break;
            case "beforeblur":
            case "afterblur":
              M = mu;
              break;
            case "click":
              if (n.button === 2) break t;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              M = Jd;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              M = V1;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              M = ey;
              break;
            case ym:
            case vm:
            case bm:
              M = I1;
              break;
            case Sm:
              M = ay;
              break;
            case "scroll":
            case "scrollend":
              M = X1;
              break;
            case "wheel":
              M = iy;
              break;
            case "copy":
            case "cut":
            case "paste":
              M = k1;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              M = $d;
              break;
            case "toggle":
            case "beforetoggle":
              M = ry;
          }
          var it = (e & 4) !== 0, Vt = !it && (t === "scroll" || t === "scrollend"), O = it ? N !== null ? N + "Capture" : null : N;
          it = [];
          for (var v = x, T; v !== null; ) {
            var z = v;
            if (T = z.stateNode, z = z.tag, z !== 5 && z !== 26 && z !== 27 || T === null || O === null || (z = ki(v, O), z != null && it.push(
              xo(v, z, T)
            )), Vt) break;
            v = v.return;
          }
          0 < it.length && (N = new M(
            N,
            J,
            null,
            n,
            L
          ), R.push({ event: N, listeners: it }));
        }
      }
      if ((e & 7) === 0) {
        t: {
          if (N = t === "mouseover" || t === "pointerover", M = t === "mouseout" || t === "pointerout", N && n !== ou && (J = n.relatedTarget || n.fromElement) && (_n(J) || J[jn]))
            break t;
          if ((M || N) && (N = L.window === L ? L : (N = L.ownerDocument) ? N.defaultView || N.parentWindow : window, M ? (J = n.relatedTarget || n.toElement, M = x, J = J ? _n(J) : null, J !== null && (Vt = h(J), it = J.tag, J !== Vt || it !== 5 && it !== 27 && it !== 6) && (J = null)) : (M = null, J = x), M !== J)) {
            if (it = Jd, z = "onMouseLeave", O = "onMouseEnter", v = "mouse", (t === "pointerout" || t === "pointerover") && (it = $d, z = "onPointerLeave", O = "onPointerEnter", v = "pointer"), Vt = M == null ? N : Qn(M), T = J == null ? N : Qn(J), N = new it(
              z,
              v + "leave",
              M,
              n,
              L
            ), N.target = Vt, N.relatedTarget = T, z = null, _n(L) === x && (it = new it(
              O,
              v + "enter",
              J,
              n,
              L
            ), it.target = T, it.relatedTarget = Vt, z = it), Vt = z, M && J)
              e: {
                for (it = ov, O = M, v = J, T = 0, z = O; z; z = it(z))
                  T++;
                z = 0;
                for (var at = v; at; at = it(at))
                  z++;
                for (; 0 < T - z; )
                  O = it(O), T--;
                for (; 0 < z - T; )
                  v = it(v), z--;
                for (; T--; ) {
                  if (O === v || v !== null && O === v.alternate) {
                    it = O;
                    break e;
                  }
                  O = it(O), v = it(v);
                }
                it = null;
              }
            else it = null;
            M !== null && Fg(
              R,
              N,
              M,
              it,
              !1
            ), J !== null && Vt !== null && Fg(
              R,
              Vt,
              J,
              it,
              !0
            );
          }
        }
        t: {
          if (N = x ? Qn(x) : window, M = N.nodeName && N.nodeName.toLowerCase(), M === "select" || M === "input" && N.type === "file")
            var Dt = rm;
          else if (im(N))
            if (cm)
              Dt = py;
            else {
              Dt = gy;
              var tt = hy;
            }
          else
            M = N.nodeName, !M || M.toLowerCase() !== "input" || N.type !== "checkbox" && N.type !== "radio" ? x && iu(x.elementType) && (Dt = rm) : Dt = Ay;
          if (Dt && (Dt = Dt(t, x))) {
            om(
              R,
              Dt,
              n,
              L
            );
            break t;
          }
          tt && tt(t, N, x), t === "focusout" && x && N.type === "number" && x.memoizedProps.value != null && lu(N, "number", N.value);
        }
        switch (tt = x ? Qn(x) : window, t) {
          case "focusin":
            (im(tt) || tt.contentEditable === "true") && (Zl = tt, vu = x, $i = null);
            break;
          case "focusout":
            $i = vu = Zl = null;
            break;
          case "mousedown":
            bu = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            bu = !1, Am(R, n, L);
            break;
          case "selectionchange":
            if (vy) break;
          case "keydown":
          case "keyup":
            Am(R, n, L);
        }
        var dt;
        if (gu)
          t: {
            switch (t) {
              case "compositionstart":
                var bt = "onCompositionStart";
                break t;
              case "compositionend":
                bt = "onCompositionEnd";
                break t;
              case "compositionupdate":
                bt = "onCompositionUpdate";
                break t;
            }
            bt = void 0;
          }
        else
          Kl ? am(t, n) && (bt = "onCompositionEnd") : t === "keydown" && n.keyCode === 229 && (bt = "onCompositionStart");
        bt && (tm && n.locale !== "ko" && (Kl || bt !== "onCompositionStart" ? bt === "onCompositionEnd" && Kl && (dt = Pd()) : (Na = L, su = "value" in Na ? Na.value : Na.textContent, Kl = !0)), tt = lc(x, bt), 0 < tt.length && (bt = new _d(
          bt,
          t,
          null,
          n,
          L
        ), R.push({ event: bt, listeners: tt }), dt ? bt.data = dt : (dt = lm(n), dt !== null && (bt.data = dt)))), (dt = uy ? sy(t, n) : fy(t, n)) && (bt = lc(x, "onBeforeInput"), 0 < bt.length && (tt = new _d(
          "onBeforeInput",
          "beforeinput",
          null,
          n,
          L
        ), R.push({
          event: tt,
          listeners: bt
        }), tt.data = dt)), nv(
          R,
          t,
          x,
          n,
          L
        );
      }
      Yg(R, e);
    });
  }
  function xo(t, e, n) {
    return {
      instance: t,
      listener: e,
      currentTarget: n
    };
  }
  function lc(t, e) {
    for (var n = e + "Capture", a = []; t !== null; ) {
      var i = t, r = i.stateNode;
      if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || r === null || (i = ki(t, n), i != null && a.unshift(
        xo(t, i, r)
      ), i = ki(t, e), i != null && a.push(
        xo(t, i, r)
      )), t.tag === 3) return a;
      t = t.return;
    }
    return [];
  }
  function ov(t) {
    if (t === null) return null;
    do
      t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function Fg(t, e, n, a, i) {
    for (var r = e._reactName, f = []; n !== null && n !== a; ) {
      var m = n, p = m.alternate, x = m.stateNode;
      if (m = m.tag, p !== null && p === a) break;
      m !== 5 && m !== 26 && m !== 27 || x === null || (p = x, i ? (x = ki(n, r), x != null && f.unshift(
        xo(n, x, p)
      )) : i || (x = ki(n, r), x != null && f.push(
        xo(n, x, p)
      ))), n = n.return;
    }
    f.length !== 0 && t.push({ event: e, listeners: f });
  }
  var rv = /\r\n?/g, cv = /\u0000|\uFFFD/g;
  function kg(t) {
    return (typeof t == "string" ? t : "" + t).replace(rv, `
`).replace(cv, "");
  }
  function qg(t, e) {
    return e = kg(e), kg(t) === e;
  }
  function Qt(t, e, n, a, i, r) {
    switch (n) {
      case "children":
        typeof a == "string" ? e === "body" || e === "textarea" && a === "" || Fl(t, a) : (typeof a == "number" || typeof a == "bigint") && e !== "body" && Fl(t, "" + a);
        break;
      case "className":
        _t(t, "class", a);
        break;
      case "tabIndex":
        _t(t, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        _t(t, n, a);
        break;
      case "style":
        qd(t, a, r);
        break;
      case "data":
        if (e !== "object") {
          _t(t, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (e !== "a" || n !== "href")) {
          t.removeAttribute(n);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(n);
          break;
        }
        a = sr("" + a), t.setAttribute(n, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          t.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof r == "function" && (n === "formAction" ? (e !== "input" && Qt(t, e, "name", i.name, i, null), Qt(
            t,
            e,
            "formEncType",
            i.formEncType,
            i,
            null
          ), Qt(
            t,
            e,
            "formMethod",
            i.formMethod,
            i,
            null
          ), Qt(
            t,
            e,
            "formTarget",
            i.formTarget,
            i,
            null
          )) : (Qt(t, e, "encType", i.encType, i, null), Qt(t, e, "method", i.method, i, null), Qt(t, e, "target", i.target, i, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(n);
          break;
        }
        a = sr("" + a), t.setAttribute(n, a);
        break;
      case "onClick":
        a != null && (t.onclick = $n);
        break;
      case "onScroll":
        a != null && yt("scroll", t);
        break;
      case "onScrollEnd":
        a != null && yt("scrollend", t);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(u(61));
          if (n = a.__html, n != null) {
            if (i.children != null) throw Error(u(60));
            t.innerHTML = n;
          }
        }
        break;
      case "multiple":
        t.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        t.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          t.removeAttribute("xlink:href");
          break;
        }
        n = sr("" + a), t.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          n
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, "" + a) : t.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, "") : t.removeAttribute(n);
        break;
      case "capture":
      case "download":
        a === !0 ? t.setAttribute(n, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, a) : t.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? t.setAttribute(n, a) : t.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? t.removeAttribute(n) : t.setAttribute(n, a);
        break;
      case "popover":
        yt("beforetoggle", t), yt("toggle", t), Ca(t, "popover", a);
        break;
      case "xlinkActuate":
        cn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        cn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        cn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        cn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        cn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        cn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        cn(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        cn(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        cn(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        Ca(t, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = H1.get(n) || n, Ca(t, n, a));
    }
  }
  function ks(t, e, n, a, i, r) {
    switch (n) {
      case "style":
        qd(t, a, r);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(u(61));
          if (n = a.__html, n != null) {
            if (i.children != null) throw Error(u(60));
            t.innerHTML = n;
          }
        }
        break;
      case "children":
        typeof a == "string" ? Fl(t, a) : (typeof a == "number" || typeof a == "bigint") && Fl(t, "" + a);
        break;
      case "onScroll":
        a != null && yt("scroll", t);
        break;
      case "onScrollEnd":
        a != null && yt("scrollend", t);
        break;
      case "onClick":
        a != null && (t.onclick = $n);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!P.hasOwnProperty(n))
          t: {
            if (n[0] === "o" && n[1] === "n" && (i = n.endsWith("Capture"), e = n.slice(2, i ? n.length - 7 : void 0), r = t[ye] || null, r = r != null ? r[n] : null, typeof r == "function" && t.removeEventListener(e, r, i), typeof a == "function")) {
              typeof r != "function" && r !== null && (n in t ? t[n] = null : t.hasAttribute(n) && t.removeAttribute(n)), t.addEventListener(e, a, i);
              break t;
            }
            n in t ? t[n] = a : a === !0 ? t.setAttribute(n, "") : Ca(t, n, a);
          }
    }
  }
  function Ee(t, e, n) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        yt("error", t), yt("load", t);
        var a = !1, i = !1, r;
        for (r in n)
          if (n.hasOwnProperty(r)) {
            var f = n[r];
            if (f != null)
              switch (r) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  i = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(u(137, e));
                default:
                  Qt(t, e, r, f, n, null);
              }
          }
        i && Qt(t, e, "srcSet", n.srcSet, n, null), a && Qt(t, e, "src", n.src, n, null);
        return;
      case "input":
        yt("invalid", t);
        var m = r = f = i = null, p = null, x = null;
        for (a in n)
          if (n.hasOwnProperty(a)) {
            var L = n[a];
            if (L != null)
              switch (a) {
                case "name":
                  i = L;
                  break;
                case "type":
                  f = L;
                  break;
                case "checked":
                  p = L;
                  break;
                case "defaultChecked":
                  x = L;
                  break;
                case "value":
                  r = L;
                  break;
                case "defaultValue":
                  m = L;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (L != null)
                    throw Error(u(137, e));
                  break;
                default:
                  Qt(t, e, a, L, n, null);
              }
          }
        Yd(
          t,
          r,
          m,
          p,
          x,
          f,
          i,
          !1
        );
        return;
      case "select":
        yt("invalid", t), a = f = r = null;
        for (i in n)
          if (n.hasOwnProperty(i) && (m = n[i], m != null))
            switch (i) {
              case "value":
                r = m;
                break;
              case "defaultValue":
                f = m;
                break;
              case "multiple":
                a = m;
              default:
                Qt(t, e, i, m, n, null);
            }
        e = r, n = f, t.multiple = !!a, e != null ? Il(t, !!a, e, !1) : n != null && Il(t, !!a, n, !0);
        return;
      case "textarea":
        yt("invalid", t), r = i = a = null;
        for (f in n)
          if (n.hasOwnProperty(f) && (m = n[f], m != null))
            switch (f) {
              case "value":
                a = m;
                break;
              case "defaultValue":
                i = m;
                break;
              case "children":
                r = m;
                break;
              case "dangerouslySetInnerHTML":
                if (m != null) throw Error(u(91));
                break;
              default:
                Qt(t, e, f, m, n, null);
            }
        Fd(t, a, i, r);
        return;
      case "option":
        for (p in n)
          if (n.hasOwnProperty(p) && (a = n[p], a != null))
            switch (p) {
              case "selected":
                t.selected = a && typeof a != "function" && typeof a != "symbol";
                break;
              default:
                Qt(t, e, p, a, n, null);
            }
        return;
      case "dialog":
        yt("beforetoggle", t), yt("toggle", t), yt("cancel", t), yt("close", t);
        break;
      case "iframe":
      case "object":
        yt("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < To.length; a++)
          yt(To[a], t);
        break;
      case "image":
        yt("error", t), yt("load", t);
        break;
      case "details":
        yt("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        yt("error", t), yt("load", t);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (x in n)
          if (n.hasOwnProperty(x) && (a = n[x], a != null))
            switch (x) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(u(137, e));
              default:
                Qt(t, e, x, a, n, null);
            }
        return;
      default:
        if (iu(e)) {
          for (L in n)
            n.hasOwnProperty(L) && (a = n[L], a !== void 0 && ks(
              t,
              e,
              L,
              a,
              n,
              void 0
            ));
          return;
        }
    }
    for (m in n)
      n.hasOwnProperty(m) && (a = n[m], a != null && Qt(t, e, m, a, n, null));
  }
  function uv(t, e, n, a) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var i = null, r = null, f = null, m = null, p = null, x = null, L = null;
        for (M in n) {
          var R = n[M];
          if (n.hasOwnProperty(M) && R != null)
            switch (M) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                p = R;
              default:
                a.hasOwnProperty(M) || Qt(t, e, M, null, a, R);
            }
        }
        for (var N in a) {
          var M = a[N];
          if (R = n[N], a.hasOwnProperty(N) && (M != null || R != null))
            switch (N) {
              case "type":
                r = M;
                break;
              case "name":
                i = M;
                break;
              case "checked":
                x = M;
                break;
              case "defaultChecked":
                L = M;
                break;
              case "value":
                f = M;
                break;
              case "defaultValue":
                m = M;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (M != null)
                  throw Error(u(137, e));
                break;
              default:
                M !== R && Qt(
                  t,
                  e,
                  N,
                  M,
                  a,
                  R
                );
            }
        }
        au(
          t,
          f,
          m,
          p,
          x,
          L,
          r,
          i
        );
        return;
      case "select":
        M = f = m = N = null;
        for (r in n)
          if (p = n[r], n.hasOwnProperty(r) && p != null)
            switch (r) {
              case "value":
                break;
              case "multiple":
                M = p;
              default:
                a.hasOwnProperty(r) || Qt(
                  t,
                  e,
                  r,
                  null,
                  a,
                  p
                );
            }
        for (i in a)
          if (r = a[i], p = n[i], a.hasOwnProperty(i) && (r != null || p != null))
            switch (i) {
              case "value":
                N = r;
                break;
              case "defaultValue":
                m = r;
                break;
              case "multiple":
                f = r;
              default:
                r !== p && Qt(
                  t,
                  e,
                  i,
                  r,
                  a,
                  p
                );
            }
        e = m, n = f, a = M, N != null ? Il(t, !!n, N, !1) : !!a != !!n && (e != null ? Il(t, !!n, e, !0) : Il(t, !!n, n ? [] : "", !1));
        return;
      case "textarea":
        M = N = null;
        for (m in n)
          if (i = n[m], n.hasOwnProperty(m) && i != null && !a.hasOwnProperty(m))
            switch (m) {
              case "value":
                break;
              case "children":
                break;
              default:
                Qt(t, e, m, null, a, i);
            }
        for (f in a)
          if (i = a[f], r = n[f], a.hasOwnProperty(f) && (i != null || r != null))
            switch (f) {
              case "value":
                N = i;
                break;
              case "defaultValue":
                M = i;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (i != null) throw Error(u(91));
                break;
              default:
                i !== r && Qt(t, e, f, i, a, r);
            }
        Id(t, N, M);
        return;
      case "option":
        for (var J in n)
          if (N = n[J], n.hasOwnProperty(J) && N != null && !a.hasOwnProperty(J))
            switch (J) {
              case "selected":
                t.selected = !1;
                break;
              default:
                Qt(
                  t,
                  e,
                  J,
                  null,
                  a,
                  N
                );
            }
        for (p in a)
          if (N = a[p], M = n[p], a.hasOwnProperty(p) && N !== M && (N != null || M != null))
            switch (p) {
              case "selected":
                t.selected = N && typeof N != "function" && typeof N != "symbol";
                break;
              default:
                Qt(
                  t,
                  e,
                  p,
                  N,
                  a,
                  M
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var it in n)
          N = n[it], n.hasOwnProperty(it) && N != null && !a.hasOwnProperty(it) && Qt(t, e, it, null, a, N);
        for (x in a)
          if (N = a[x], M = n[x], a.hasOwnProperty(x) && N !== M && (N != null || M != null))
            switch (x) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (N != null)
                  throw Error(u(137, e));
                break;
              default:
                Qt(
                  t,
                  e,
                  x,
                  N,
                  a,
                  M
                );
            }
        return;
      default:
        if (iu(e)) {
          for (var Vt in n)
            N = n[Vt], n.hasOwnProperty(Vt) && N !== void 0 && !a.hasOwnProperty(Vt) && ks(
              t,
              e,
              Vt,
              void 0,
              a,
              N
            );
          for (L in a)
            N = a[L], M = n[L], !a.hasOwnProperty(L) || N === M || N === void 0 && M === void 0 || ks(
              t,
              e,
              L,
              N,
              a,
              M
            );
          return;
        }
    }
    for (var O in n)
      N = n[O], n.hasOwnProperty(O) && N != null && !a.hasOwnProperty(O) && Qt(t, e, O, null, a, N);
    for (R in a)
      N = a[R], M = n[R], !a.hasOwnProperty(R) || N === M || N == null && M == null || Qt(t, e, R, N, a, M);
  }
  function Kg(t) {
    switch (t) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function sv() {
    if (typeof performance.getEntriesByType == "function") {
      for (var t = 0, e = 0, n = performance.getEntriesByType("resource"), a = 0; a < n.length; a++) {
        var i = n[a], r = i.transferSize, f = i.initiatorType, m = i.duration;
        if (r && m && Kg(f)) {
          for (f = 0, m = i.responseEnd, a += 1; a < n.length; a++) {
            var p = n[a], x = p.startTime;
            if (x > m) break;
            var L = p.transferSize, R = p.initiatorType;
            L && Kg(R) && (p = p.responseEnd, f += L * (p < m ? 1 : (m - x) / (p - x)));
          }
          if (--a, e += 8 * (r + f) / (i.duration / 1e3), t++, 10 < t) break;
        }
      }
      if (0 < t) return e / t / 1e6;
    }
    return navigator.connection && (t = navigator.connection.downlink, typeof t == "number") ? t : 5;
  }
  var qs = null, Ks = null;
  function ic(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function Zg(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function Pg(t, e) {
    if (t === 0)
      switch (e) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return t === 1 && e === "foreignObject" ? 0 : t;
  }
  function Zs(t, e) {
    return t === "textarea" || t === "noscript" || typeof e.children == "string" || typeof e.children == "number" || typeof e.children == "bigint" || typeof e.dangerouslySetInnerHTML == "object" && e.dangerouslySetInnerHTML !== null && e.dangerouslySetInnerHTML.__html != null;
  }
  var Ps = null;
  function fv() {
    var t = window.event;
    return t && t.type === "popstate" ? t === Ps ? !1 : (Ps = t, !0) : (Ps = null, !1);
  }
  var Wg = typeof setTimeout == "function" ? setTimeout : void 0, dv = typeof clearTimeout == "function" ? clearTimeout : void 0, Jg = typeof Promise == "function" ? Promise : void 0, mv = typeof queueMicrotask == "function" ? queueMicrotask : typeof Jg < "u" ? function(t) {
    return Jg.resolve(null).then(t).catch(hv);
  } : Wg;
  function hv(t) {
    setTimeout(function() {
      throw t;
    });
  }
  function Fa(t) {
    return t === "head";
  }
  function _g(t, e) {
    var n = e, a = 0;
    do {
      var i = n.nextSibling;
      if (t.removeChild(n), i && i.nodeType === 8)
        if (n = i.data, n === "/$" || n === "/&") {
          if (a === 0) {
            t.removeChild(i), Si(e);
            return;
          }
          a--;
        } else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&")
          a++;
        else if (n === "html")
          Co(t.ownerDocument.documentElement);
        else if (n === "head") {
          n = t.ownerDocument.head, Co(n);
          for (var r = n.firstChild; r; ) {
            var f = r.nextSibling, m = r.nodeName;
            r[rl] || m === "SCRIPT" || m === "STYLE" || m === "LINK" && r.rel.toLowerCase() === "stylesheet" || n.removeChild(r), r = f;
          }
        } else
          n === "body" && Co(t.ownerDocument.body);
      n = i;
    } while (n);
    Si(e);
  }
  function $g(t, e) {
    var n = t;
    t = 0;
    do {
      var a = n.nextSibling;
      if (n.nodeType === 1 ? e ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (e ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), a && a.nodeType === 8)
        if (n = a.data, n === "/$") {
          if (t === 0) break;
          t--;
        } else
          n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || t++;
      n = a;
    } while (n);
  }
  function Ws(t) {
    var e = t.firstChild;
    for (e && e.nodeType === 10 && (e = e.nextSibling); e; ) {
      var n = e;
      switch (e = e.nextSibling, n.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Ws(n), Yl(n);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(n);
    }
  }
  function gv(t, e, n, a) {
    for (; t.nodeType === 1; ) {
      var i = n;
      if (t.nodeName.toLowerCase() !== e.toLowerCase()) {
        if (!a && (t.nodeName !== "INPUT" || t.type !== "hidden"))
          break;
      } else if (a) {
        if (!t[rl])
          switch (e) {
            case "meta":
              if (!t.hasAttribute("itemprop")) break;
              return t;
            case "link":
              if (r = t.getAttribute("rel"), r === "stylesheet" && t.hasAttribute("data-precedence"))
                break;
              if (r !== i.rel || t.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || t.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || t.getAttribute("title") !== (i.title == null ? null : i.title))
                break;
              return t;
            case "style":
              if (t.hasAttribute("data-precedence")) break;
              return t;
            case "script":
              if (r = t.getAttribute("src"), (r !== (i.src == null ? null : i.src) || t.getAttribute("type") !== (i.type == null ? null : i.type) || t.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && r && t.hasAttribute("async") && !t.hasAttribute("itemprop"))
                break;
              return t;
            default:
              return t;
          }
      } else if (e === "input" && t.type === "hidden") {
        var r = i.name == null ? null : "" + i.name;
        if (i.type === "hidden" && t.getAttribute("name") === r)
          return t;
      } else return t;
      if (t = An(t.nextSibling), t === null) break;
    }
    return null;
  }
  function Av(t, e, n) {
    if (e === "") return null;
    for (; t.nodeType !== 3; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !n || (t = An(t.nextSibling), t === null)) return null;
    return t;
  }
  function tA(t, e) {
    for (; t.nodeType !== 8; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !e || (t = An(t.nextSibling), t === null)) return null;
    return t;
  }
  function Js(t) {
    return t.data === "$?" || t.data === "$~";
  }
  function _s(t) {
    return t.data === "$!" || t.data === "$?" && t.ownerDocument.readyState !== "loading";
  }
  function pv(t, e) {
    var n = t.ownerDocument;
    if (t.data === "$~") t._reactRetry = e;
    else if (t.data !== "$?" || n.readyState !== "loading")
      e();
    else {
      var a = function() {
        e(), n.removeEventListener("DOMContentLoaded", a);
      };
      n.addEventListener("DOMContentLoaded", a), t._reactRetry = a;
    }
  }
  function An(t) {
    for (; t != null; t = t.nextSibling) {
      var e = t.nodeType;
      if (e === 1 || e === 3) break;
      if (e === 8) {
        if (e = t.data, e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&" || e === "F!" || e === "F")
          break;
        if (e === "/$" || e === "/&") return null;
      }
    }
    return t;
  }
  var $s = null;
  function eA(t) {
    t = t.nextSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "/$" || n === "/&") {
          if (e === 0)
            return An(t.nextSibling);
          e--;
        } else
          n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || e++;
      }
      t = t.nextSibling;
    }
    return null;
  }
  function nA(t) {
    t = t.previousSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
          if (e === 0) return t;
          e--;
        } else n !== "/$" && n !== "/&" || e++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function aA(t, e, n) {
    switch (e = ic(n), t) {
      case "html":
        if (t = e.documentElement, !t) throw Error(u(452));
        return t;
      case "head":
        if (t = e.head, !t) throw Error(u(453));
        return t;
      case "body":
        if (t = e.body, !t) throw Error(u(454));
        return t;
      default:
        throw Error(u(451));
    }
  }
  function Co(t) {
    for (var e = t.attributes; e.length; )
      t.removeAttributeNode(e[0]);
    Yl(t);
  }
  var pn = /* @__PURE__ */ new Map(), lA = /* @__PURE__ */ new Set();
  function oc(t) {
    return typeof t.getRootNode == "function" ? t.getRootNode() : t.nodeType === 9 ? t : t.ownerDocument;
  }
  var ga = q.d;
  q.d = {
    f: yv,
    r: vv,
    D: bv,
    C: Sv,
    L: Ov,
    m: Ev,
    X: xv,
    S: Tv,
    M: Cv
  };
  function yv() {
    var t = ga.f(), e = Jr();
    return t || e;
  }
  function vv(t) {
    var e = Xn(t);
    e !== null && e.tag === 5 && e.type === "form" ? Sh(e) : ga.r(t);
  }
  var yi = typeof document > "u" ? null : document;
  function iA(t, e, n) {
    var a = yi;
    if (a && typeof e == "string" && e) {
      var i = un(e);
      i = 'link[rel="' + t + '"][href="' + i + '"]', typeof n == "string" && (i += '[crossorigin="' + n + '"]'), lA.has(i) || (lA.add(i), t = { rel: t, crossOrigin: n, href: e }, a.querySelector(i) === null && (e = a.createElement("link"), Ee(e, "link", t), g(e), a.head.appendChild(e)));
    }
  }
  function bv(t) {
    ga.D(t), iA("dns-prefetch", t, null);
  }
  function Sv(t, e) {
    ga.C(t, e), iA("preconnect", t, e);
  }
  function Ov(t, e, n) {
    ga.L(t, e, n);
    var a = yi;
    if (a && t && e) {
      var i = 'link[rel="preload"][as="' + un(e) + '"]';
      e === "image" && n && n.imageSrcSet ? (i += '[imagesrcset="' + un(
        n.imageSrcSet
      ) + '"]', typeof n.imageSizes == "string" && (i += '[imagesizes="' + un(
        n.imageSizes
      ) + '"]')) : i += '[href="' + un(t) + '"]';
      var r = i;
      switch (e) {
        case "style":
          r = vi(t);
          break;
        case "script":
          r = bi(t);
      }
      pn.has(r) || (t = C(
        {
          rel: "preload",
          href: e === "image" && n && n.imageSrcSet ? void 0 : t,
          as: e
        },
        n
      ), pn.set(r, t), a.querySelector(i) !== null || e === "style" && a.querySelector(No(r)) || e === "script" && a.querySelector(wo(r)) || (e = a.createElement("link"), Ee(e, "link", t), g(e), a.head.appendChild(e)));
    }
  }
  function Ev(t, e) {
    ga.m(t, e);
    var n = yi;
    if (n && t) {
      var a = e && typeof e.as == "string" ? e.as : "script", i = 'link[rel="modulepreload"][as="' + un(a) + '"][href="' + un(t) + '"]', r = i;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          r = bi(t);
      }
      if (!pn.has(r) && (t = C({ rel: "modulepreload", href: t }, e), pn.set(r, t), n.querySelector(i) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(wo(r)))
              return;
        }
        a = n.createElement("link"), Ee(a, "link", t), g(a), n.head.appendChild(a);
      }
    }
  }
  function Tv(t, e, n) {
    ga.S(t, e, n);
    var a = yi;
    if (a && t) {
      var i = $(a).hoistableStyles, r = vi(t);
      e = e || "default";
      var f = i.get(r);
      if (!f) {
        var m = { loading: 0, preload: null };
        if (f = a.querySelector(
          No(r)
        ))
          m.loading = 5;
        else {
          t = C(
            { rel: "stylesheet", href: t, "data-precedence": e },
            n
          ), (n = pn.get(r)) && tf(t, n);
          var p = f = a.createElement("link");
          g(p), Ee(p, "link", t), p._p = new Promise(function(x, L) {
            p.onload = x, p.onerror = L;
          }), p.addEventListener("load", function() {
            m.loading |= 1;
          }), p.addEventListener("error", function() {
            m.loading |= 2;
          }), m.loading |= 4, rc(f, e, a);
        }
        f = {
          type: "stylesheet",
          instance: f,
          count: 1,
          state: m
        }, i.set(r, f);
      }
    }
  }
  function xv(t, e) {
    ga.X(t, e);
    var n = yi;
    if (n && t) {
      var a = $(n).hoistableScripts, i = bi(t), r = a.get(i);
      r || (r = n.querySelector(wo(i)), r || (t = C({ src: t, async: !0 }, e), (e = pn.get(i)) && ef(t, e), r = n.createElement("script"), g(r), Ee(r, "link", t), n.head.appendChild(r)), r = {
        type: "script",
        instance: r,
        count: 1,
        state: null
      }, a.set(i, r));
    }
  }
  function Cv(t, e) {
    ga.M(t, e);
    var n = yi;
    if (n && t) {
      var a = $(n).hoistableScripts, i = bi(t), r = a.get(i);
      r || (r = n.querySelector(wo(i)), r || (t = C({ src: t, async: !0, type: "module" }, e), (e = pn.get(i)) && ef(t, e), r = n.createElement("script"), g(r), Ee(r, "link", t), n.head.appendChild(r)), r = {
        type: "script",
        instance: r,
        count: 1,
        state: null
      }, a.set(i, r));
    }
  }
  function oA(t, e, n, a) {
    var i = (i = me.current) ? oc(i) : null;
    if (!i) throw Error(u(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string" ? (e = vi(n.href), n = $(
          i
        ).hoistableStyles, a = n.get(e), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
          t = vi(n.href);
          var r = $(
            i
          ).hoistableStyles, f = r.get(t);
          if (f || (i = i.ownerDocument || i, f = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, r.set(t, f), (r = i.querySelector(
            No(t)
          )) && !r._p && (f.instance = r, f.state.loading = 5), pn.has(t) || (n = {
            rel: "preload",
            as: "style",
            href: n.href,
            crossOrigin: n.crossOrigin,
            integrity: n.integrity,
            media: n.media,
            hrefLang: n.hrefLang,
            referrerPolicy: n.referrerPolicy
          }, pn.set(t, n), r || Nv(
            i,
            t,
            n,
            f.state
          ))), e && a === null)
            throw Error(u(528, ""));
          return f;
        }
        if (e && a !== null)
          throw Error(u(529, ""));
        return null;
      case "script":
        return e = n.async, n = n.src, typeof n == "string" && e && typeof e != "function" && typeof e != "symbol" ? (e = bi(n), n = $(
          i
        ).hoistableScripts, a = n.get(e), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(u(444, t));
    }
  }
  function vi(t) {
    return 'href="' + un(t) + '"';
  }
  function No(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function rA(t) {
    return C({}, t, {
      "data-precedence": t.precedence,
      precedence: null
    });
  }
  function Nv(t, e, n, a) {
    t.querySelector('link[rel="preload"][as="style"][' + e + "]") ? a.loading = 1 : (e = t.createElement("link"), a.preload = e, e.addEventListener("load", function() {
      return a.loading |= 1;
    }), e.addEventListener("error", function() {
      return a.loading |= 2;
    }), Ee(e, "link", n), g(e), t.head.appendChild(e));
  }
  function bi(t) {
    return '[src="' + un(t) + '"]';
  }
  function wo(t) {
    return "script[async]" + t;
  }
  function cA(t, e, n) {
    if (e.count++, e.instance === null)
      switch (e.type) {
        case "style":
          var a = t.querySelector(
            'style[data-href~="' + un(n.href) + '"]'
          );
          if (a)
            return e.instance = a, g(a), a;
          var i = C({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          return a = (t.ownerDocument || t).createElement(
            "style"
          ), g(a), Ee(a, "style", i), rc(a, n.precedence, t), e.instance = a;
        case "stylesheet":
          i = vi(n.href);
          var r = t.querySelector(
            No(i)
          );
          if (r)
            return e.state.loading |= 4, e.instance = r, g(r), r;
          a = rA(n), (i = pn.get(i)) && tf(a, i), r = (t.ownerDocument || t).createElement("link"), g(r);
          var f = r;
          return f._p = new Promise(function(m, p) {
            f.onload = m, f.onerror = p;
          }), Ee(r, "link", a), e.state.loading |= 4, rc(r, n.precedence, t), e.instance = r;
        case "script":
          return r = bi(n.src), (i = t.querySelector(
            wo(r)
          )) ? (e.instance = i, g(i), i) : (a = n, (i = pn.get(r)) && (a = C({}, n), ef(a, i)), t = t.ownerDocument || t, i = t.createElement("script"), g(i), Ee(i, "link", a), t.head.appendChild(i), e.instance = i);
        case "void":
          return null;
        default:
          throw Error(u(443, e.type));
      }
    else
      e.type === "stylesheet" && (e.state.loading & 4) === 0 && (a = e.instance, e.state.loading |= 4, rc(a, n.precedence, t));
    return e.instance;
  }
  function rc(t, e, n) {
    for (var a = n.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), i = a.length ? a[a.length - 1] : null, r = i, f = 0; f < a.length; f++) {
      var m = a[f];
      if (m.dataset.precedence === e) r = m;
      else if (r !== i) break;
    }
    r ? r.parentNode.insertBefore(t, r.nextSibling) : (e = n.nodeType === 9 ? n.head : n, e.insertBefore(t, e.firstChild));
  }
  function tf(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.title == null && (t.title = e.title);
  }
  function ef(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.integrity == null && (t.integrity = e.integrity);
  }
  var cc = null;
  function uA(t, e, n) {
    if (cc === null) {
      var a = /* @__PURE__ */ new Map(), i = cc = /* @__PURE__ */ new Map();
      i.set(n, a);
    } else
      i = cc, a = i.get(n), a || (a = /* @__PURE__ */ new Map(), i.set(n, a));
    if (a.has(t)) return a;
    for (a.set(t, null), n = n.getElementsByTagName(t), i = 0; i < n.length; i++) {
      var r = n[i];
      if (!(r[rl] || r[oe] || t === "link" && r.getAttribute("rel") === "stylesheet") && r.namespaceURI !== "http://www.w3.org/2000/svg") {
        var f = r.getAttribute(e) || "";
        f = t + f;
        var m = a.get(f);
        m ? m.push(r) : a.set(f, [r]);
      }
    }
    return a;
  }
  function sA(t, e, n) {
    t = t.ownerDocument || t, t.head.insertBefore(
      n,
      e === "title" ? t.querySelector("head > title") : null
    );
  }
  function wv(t, e, n) {
    if (n === 1 || e.itemProp != null) return !1;
    switch (t) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof e.precedence != "string" || typeof e.href != "string" || e.href === "")
          break;
        return !0;
      case "link":
        if (typeof e.rel != "string" || typeof e.href != "string" || e.href === "" || e.onLoad || e.onError)
          break;
        switch (e.rel) {
          case "stylesheet":
            return t = e.disabled, typeof e.precedence == "string" && t == null;
          default:
            return !0;
        }
      case "script":
        if (e.async && typeof e.async != "function" && typeof e.async != "symbol" && !e.onLoad && !e.onError && e.src && typeof e.src == "string")
          return !0;
    }
    return !1;
  }
  function fA(t) {
    return !(t.type === "stylesheet" && (t.state.loading & 3) === 0);
  }
  function Dv(t, e, n, a) {
    if (n.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (n.state.loading & 4) === 0) {
      if (n.instance === null) {
        var i = vi(a.href), r = e.querySelector(
          No(i)
        );
        if (r) {
          e = r._p, e !== null && typeof e == "object" && typeof e.then == "function" && (t.count++, t = uc.bind(t), e.then(t, t)), n.state.loading |= 4, n.instance = r, g(r);
          return;
        }
        r = e.ownerDocument || e, a = rA(a), (i = pn.get(i)) && tf(a, i), r = r.createElement("link"), g(r);
        var f = r;
        f._p = new Promise(function(m, p) {
          f.onload = m, f.onerror = p;
        }), Ee(r, "link", a), n.instance = r;
      }
      t.stylesheets === null && (t.stylesheets = /* @__PURE__ */ new Map()), t.stylesheets.set(n, e), (e = n.state.preload) && (n.state.loading & 3) === 0 && (t.count++, n = uc.bind(t), e.addEventListener("load", n), e.addEventListener("error", n));
    }
  }
  var nf = 0;
  function Bv(t, e) {
    return t.stylesheets && t.count === 0 && fc(t, t.stylesheets), 0 < t.count || 0 < t.imgCount ? function(n) {
      var a = setTimeout(function() {
        if (t.stylesheets && fc(t, t.stylesheets), t.unsuspend) {
          var r = t.unsuspend;
          t.unsuspend = null, r();
        }
      }, 6e4 + e);
      0 < t.imgBytes && nf === 0 && (nf = 62500 * sv());
      var i = setTimeout(
        function() {
          if (t.waitingForImages = !1, t.count === 0 && (t.stylesheets && fc(t, t.stylesheets), t.unsuspend)) {
            var r = t.unsuspend;
            t.unsuspend = null, r();
          }
        },
        (t.imgBytes > nf ? 50 : 800) + e
      );
      return t.unsuspend = n, function() {
        t.unsuspend = null, clearTimeout(a), clearTimeout(i);
      };
    } : null;
  }
  function uc() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) fc(this, this.stylesheets);
      else if (this.unsuspend) {
        var t = this.unsuspend;
        this.unsuspend = null, t();
      }
    }
  }
  var sc = null;
  function fc(t, e) {
    t.stylesheets = null, t.unsuspend !== null && (t.count++, sc = /* @__PURE__ */ new Map(), e.forEach(Mv, t), sc = null, uc.call(t));
  }
  function Mv(t, e) {
    if (!(e.state.loading & 4)) {
      var n = sc.get(t);
      if (n) var a = n.get(null);
      else {
        n = /* @__PURE__ */ new Map(), sc.set(t, n);
        for (var i = t.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), r = 0; r < i.length; r++) {
          var f = i[r];
          (f.nodeName === "LINK" || f.getAttribute("media") !== "not all") && (n.set(f.dataset.precedence, f), a = f);
        }
        a && n.set(null, a);
      }
      i = e.instance, f = i.getAttribute("data-precedence"), r = n.get(f) || a, r === a && n.set(null, i), n.set(f, i), this.count++, a = uc.bind(this), i.addEventListener("load", a), i.addEventListener("error", a), r ? r.parentNode.insertBefore(i, r.nextSibling) : (t = t.nodeType === 9 ? t.head : t, t.insertBefore(i, t.firstChild)), e.state.loading |= 4;
    }
  }
  var Do = {
    $$typeof: ot,
    Provider: null,
    Consumer: null,
    _currentValue: ut,
    _currentValue2: ut,
    _threadCount: 0
  };
  function Lv(t, e, n, a, i, r, f, m, p) {
    this.tag = 1, this.containerInfo = t, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Jt(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Jt(0), this.hiddenUpdates = Jt(null), this.identifierPrefix = a, this.onUncaughtError = i, this.onCaughtError = r, this.onRecoverableError = f, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = p, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function dA(t, e, n, a, i, r, f, m, p, x, L, R) {
    return t = new Lv(
      t,
      e,
      n,
      f,
      p,
      x,
      L,
      R,
      m
    ), e = 1, r === !0 && (e |= 24), r = qe(3, null, null, e), t.current = r, r.stateNode = t, e = Uu(), e.refCount++, t.pooledCache = e, e.refCount++, r.memoizedState = {
      element: a,
      isDehydrated: n,
      cache: e
    }, Qu(r), t;
  }
  function mA(t) {
    return t ? (t = Jl, t) : Jl;
  }
  function hA(t, e, n, a, i, r) {
    i = mA(i), a.context === null ? a.context = i : a.pendingContext = i, a = za(e), a.payload = { element: n }, r = r === void 0 ? null : r, r !== null && (a.callback = r), n = Ra(t, a, e), n !== null && (Ve(n, t, e), oo(n, t, e));
  }
  function gA(t, e) {
    if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
      var n = t.retryLane;
      t.retryLane = n !== 0 && n < e ? n : e;
    }
  }
  function af(t, e) {
    gA(t, e), (t = t.alternate) && gA(t, e);
  }
  function AA(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = fl(t, 67108864);
      e !== null && Ve(e, t, 67108864), af(t, 67108864);
    }
  }
  function pA(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = Je();
      e = Gl(e);
      var n = fl(t, e);
      n !== null && Ve(n, t, e), af(t, e);
    }
  }
  var dc = !0;
  function zv(t, e, n, a) {
    var i = j.T;
    j.T = null;
    var r = q.p;
    try {
      q.p = 2, lf(t, e, n, a);
    } finally {
      q.p = r, j.T = i;
    }
  }
  function Rv(t, e, n, a) {
    var i = j.T;
    j.T = null;
    var r = q.p;
    try {
      q.p = 8, lf(t, e, n, a);
    } finally {
      q.p = r, j.T = i;
    }
  }
  function lf(t, e, n, a) {
    if (dc) {
      var i = of(a);
      if (i === null)
        Fs(
          t,
          e,
          a,
          mc,
          n
        ), vA(t, a);
      else if (Hv(
        i,
        t,
        e,
        n,
        a
      ))
        a.stopPropagation();
      else if (vA(t, a), e & 4 && -1 < Uv.indexOf(t)) {
        for (; i !== null; ) {
          var r = Xn(i);
          if (r !== null)
            switch (r.tag) {
              case 3:
                if (r = r.stateNode, r.current.memoizedState.isDehydrated) {
                  var f = On(r.pendingLanes);
                  if (f !== 0) {
                    var m = r;
                    for (m.pendingLanes |= 2, m.entangledLanes |= 2; f; ) {
                      var p = 1 << 31 - Ae(f);
                      m.entanglements[1] |= p, f &= ~p;
                    }
                    In(r), (Lt & 6) === 0 && (Pr = xe() + 500, Eo(0));
                  }
                }
                break;
              case 31:
              case 13:
                m = fl(r, 2), m !== null && Ve(m, r, 2), Jr(), af(r, 2);
            }
          if (r = of(a), r === null && Fs(
            t,
            e,
            a,
            mc,
            n
          ), r === i) break;
          i = r;
        }
        i !== null && a.stopPropagation();
      } else
        Fs(
          t,
          e,
          a,
          null,
          n
        );
    }
  }
  function of(t) {
    return t = ru(t), rf(t);
  }
  var mc = null;
  function rf(t) {
    if (mc = null, t = _n(t), t !== null) {
      var e = h(t);
      if (e === null) t = null;
      else {
        var n = e.tag;
        if (n === 13) {
          if (t = A(e), t !== null) return t;
          t = null;
        } else if (n === 31) {
          if (t = y(e), t !== null) return t;
          t = null;
        } else if (n === 3) {
          if (e.stateNode.current.memoizedState.isDehydrated)
            return e.tag === 3 ? e.stateNode.containerInfo : null;
          t = null;
        } else e !== t && (t = null);
      }
    }
    return mc = t, null;
  }
  function yA(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (lr()) {
          case Hl:
            return 2;
          case Sa:
            return 8;
          case Sn:
          case ln:
            return 32;
          case jl:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var cf = !1, ka = null, qa = null, Ka = null, Bo = /* @__PURE__ */ new Map(), Mo = /* @__PURE__ */ new Map(), Za = [], Uv = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function vA(t, e) {
    switch (t) {
      case "focusin":
      case "focusout":
        ka = null;
        break;
      case "dragenter":
      case "dragleave":
        qa = null;
        break;
      case "mouseover":
      case "mouseout":
        Ka = null;
        break;
      case "pointerover":
      case "pointerout":
        Bo.delete(e.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Mo.delete(e.pointerId);
    }
  }
  function Lo(t, e, n, a, i, r) {
    return t === null || t.nativeEvent !== r ? (t = {
      blockedOn: e,
      domEventName: n,
      eventSystemFlags: a,
      nativeEvent: r,
      targetContainers: [i]
    }, e !== null && (e = Xn(e), e !== null && AA(e)), t) : (t.eventSystemFlags |= a, e = t.targetContainers, i !== null && e.indexOf(i) === -1 && e.push(i), t);
  }
  function Hv(t, e, n, a, i) {
    switch (e) {
      case "focusin":
        return ka = Lo(
          ka,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "dragenter":
        return qa = Lo(
          qa,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "mouseover":
        return Ka = Lo(
          Ka,
          t,
          e,
          n,
          a,
          i
        ), !0;
      case "pointerover":
        var r = i.pointerId;
        return Bo.set(
          r,
          Lo(
            Bo.get(r) || null,
            t,
            e,
            n,
            a,
            i
          )
        ), !0;
      case "gotpointercapture":
        return r = i.pointerId, Mo.set(
          r,
          Lo(
            Mo.get(r) || null,
            t,
            e,
            n,
            a,
            i
          )
        ), !0;
    }
    return !1;
  }
  function bA(t) {
    var e = _n(t.target);
    if (e !== null) {
      var n = h(e);
      if (n !== null) {
        if (e = n.tag, e === 13) {
          if (e = A(n), e !== null) {
            t.blockedOn = e, Hn(t.priority, function() {
              pA(n);
            });
            return;
          }
        } else if (e === 31) {
          if (e = y(n), e !== null) {
            t.blockedOn = e, Hn(t.priority, function() {
              pA(n);
            });
            return;
          }
        } else if (e === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function hc(t) {
    if (t.blockedOn !== null) return !1;
    for (var e = t.targetContainers; 0 < e.length; ) {
      var n = of(t.nativeEvent);
      if (n === null) {
        n = t.nativeEvent;
        var a = new n.constructor(
          n.type,
          n
        );
        ou = a, n.target.dispatchEvent(a), ou = null;
      } else
        return e = Xn(n), e !== null && AA(e), t.blockedOn = n, !1;
      e.shift();
    }
    return !0;
  }
  function SA(t, e, n) {
    hc(t) && n.delete(e);
  }
  function jv() {
    cf = !1, ka !== null && hc(ka) && (ka = null), qa !== null && hc(qa) && (qa = null), Ka !== null && hc(Ka) && (Ka = null), Bo.forEach(SA), Mo.forEach(SA);
  }
  function gc(t, e) {
    t.blockedOn === e && (t.blockedOn = null, cf || (cf = !0, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      jv
    )));
  }
  var Ac = null;
  function OA(t) {
    Ac !== t && (Ac = t, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      function() {
        Ac === t && (Ac = null);
        for (var e = 0; e < t.length; e += 3) {
          var n = t[e], a = t[e + 1], i = t[e + 2];
          if (typeof a != "function") {
            if (rf(a || n) === null)
              continue;
            break;
          }
          var r = Xn(n);
          r !== null && (t.splice(e, 3), e -= 3, is(
            r,
            {
              pending: !0,
              data: i,
              method: n.method,
              action: a
            },
            a,
            i
          ));
        }
      }
    ));
  }
  function Si(t) {
    function e(p) {
      return gc(p, t);
    }
    ka !== null && gc(ka, t), qa !== null && gc(qa, t), Ka !== null && gc(Ka, t), Bo.forEach(e), Mo.forEach(e);
    for (var n = 0; n < Za.length; n++) {
      var a = Za[n];
      a.blockedOn === t && (a.blockedOn = null);
    }
    for (; 0 < Za.length && (n = Za[0], n.blockedOn === null); )
      bA(n), n.blockedOn === null && Za.shift();
    if (n = (t.ownerDocument || t).$$reactFormReplay, n != null)
      for (a = 0; a < n.length; a += 3) {
        var i = n[a], r = n[a + 1], f = i[ye] || null;
        if (typeof r == "function")
          f || OA(n);
        else if (f) {
          var m = null;
          if (r && r.hasAttribute("formAction")) {
            if (i = r, f = r[ye] || null)
              m = f.formAction;
            else if (rf(i) !== null) continue;
          } else m = f.action;
          typeof m == "function" ? n[a + 1] = m : (n.splice(a, 3), a -= 3), OA(n);
        }
      }
  }
  function EA() {
    function t(r) {
      r.canIntercept && r.info === "react-transition" && r.intercept({
        handler: function() {
          return new Promise(function(f) {
            return i = f;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function e() {
      i !== null && (i(), i = null), a || setTimeout(n, 20);
    }
    function n() {
      if (!a && !navigation.transition) {
        var r = navigation.currentEntry;
        r && r.url != null && navigation.navigate(r.url, {
          state: r.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, i = null;
      return navigation.addEventListener("navigate", t), navigation.addEventListener("navigatesuccess", e), navigation.addEventListener("navigateerror", e), setTimeout(n, 100), function() {
        a = !0, navigation.removeEventListener("navigate", t), navigation.removeEventListener("navigatesuccess", e), navigation.removeEventListener("navigateerror", e), i !== null && (i(), i = null);
      };
    }
  }
  function uf(t) {
    this._internalRoot = t;
  }
  pc.prototype.render = uf.prototype.render = function(t) {
    var e = this._internalRoot;
    if (e === null) throw Error(u(409));
    var n = e.current, a = Je();
    hA(n, a, t, e, null, null);
  }, pc.prototype.unmount = uf.prototype.unmount = function() {
    var t = this._internalRoot;
    if (t !== null) {
      this._internalRoot = null;
      var e = t.containerInfo;
      hA(t.current, 2, null, t, null, null), Jr(), e[jn] = null;
    }
  };
  function pc(t) {
    this._internalRoot = t;
  }
  pc.prototype.unstable_scheduleHydration = function(t) {
    if (t) {
      var e = Re();
      t = { blockedOn: null, target: t, priority: e };
      for (var n = 0; n < Za.length && e !== 0 && e < Za[n].priority; n++) ;
      Za.splice(n, 0, t), n === 0 && bA(t);
    }
  };
  var TA = c.version;
  if (TA !== "19.2.6")
    throw Error(
      u(
        527,
        TA,
        "19.2.6"
      )
    );
  q.findDOMNode = function(t) {
    var e = t._reactInternals;
    if (e === void 0)
      throw typeof t.render == "function" ? Error(u(188)) : (t = Object.keys(t).join(","), Error(u(268, t)));
    return t = B(e), t = t !== null ? w(t) : null, t = t === null ? null : t.stateNode, t;
  };
  var Xv = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: j,
    reconcilerVersion: "19.2.6"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var yc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yc.isDisabled && yc.supportsFiber)
      try {
        Jn = yc.inject(
          Xv
        ), Ce = yc;
      } catch {
      }
  }
  return zo.createRoot = function(t, e) {
    if (!d(t)) throw Error(u(299));
    var n = !1, a = "", i = Mh, r = Lh, f = zh;
    return e != null && (e.unstable_strictMode === !0 && (n = !0), e.identifierPrefix !== void 0 && (a = e.identifierPrefix), e.onUncaughtError !== void 0 && (i = e.onUncaughtError), e.onCaughtError !== void 0 && (r = e.onCaughtError), e.onRecoverableError !== void 0 && (f = e.onRecoverableError)), e = dA(
      t,
      1,
      !1,
      null,
      null,
      n,
      a,
      null,
      i,
      r,
      f,
      EA
    ), t[jn] = e.current, Is(t), new uf(e);
  }, zo.hydrateRoot = function(t, e, n) {
    if (!d(t)) throw Error(u(299));
    var a = !1, i = "", r = Mh, f = Lh, m = zh, p = null;
    return n != null && (n.unstable_strictMode === !0 && (a = !0), n.identifierPrefix !== void 0 && (i = n.identifierPrefix), n.onUncaughtError !== void 0 && (r = n.onUncaughtError), n.onCaughtError !== void 0 && (f = n.onCaughtError), n.onRecoverableError !== void 0 && (m = n.onRecoverableError), n.formState !== void 0 && (p = n.formState)), e = dA(
      t,
      1,
      !0,
      e,
      n ?? null,
      a,
      i,
      p,
      r,
      f,
      m,
      EA
    ), e.context = mA(null), n = e.current, a = Je(), a = Gl(a), i = za(a), i.callback = null, Ra(n, i, a), n = a, e.current.lanes = n, rn(e, n), In(e), t[jn] = e.current, Is(t), new pc(e);
  }, zo.version = "19.2.6", zo;
}
var wA;
function Zv() {
  if (wA) return sf.exports;
  wA = 1;
  function l() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(l);
      } catch (o) {
        console.error(o);
      }
  }
  return l(), sf.exports = Kv(), sf.exports;
}
var Pp = Zv(), mf = { exports: {} }, Ro = {};
var DA;
function Pv() {
  if (DA) return Ro;
  DA = 1;
  var l = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function c(s, u, d) {
    var h = null;
    if (d !== void 0 && (h = "" + d), u.key !== void 0 && (h = "" + u.key), "key" in u) {
      d = {};
      for (var A in u)
        A !== "key" && (d[A] = u[A]);
    } else d = u;
    return u = d.ref, {
      $$typeof: l,
      type: s,
      key: h,
      ref: u !== void 0 ? u : null,
      props: d
    };
  }
  return Ro.Fragment = o, Ro.jsx = c, Ro.jsxs = c, Ro;
}
var BA;
function Wv() {
  return BA || (BA = 1, mf.exports = Pv()), mf.exports;
}
var b = Wv();
function MA(l, o) {
  (o == null || o > l.length) && (o = l.length);
  for (var c = 0, s = Array(o); c < o; c++) s[c] = l[c];
  return s;
}
function Jv(l) {
  if (Array.isArray(l)) return l;
}
function _v(l, o) {
  var c = l == null ? null : typeof Symbol < "u" && l[Symbol.iterator] || l["@@iterator"];
  if (c != null) {
    var s, u, d, h, A = [], y = !0, S = !1;
    try {
      if (d = (c = c.call(l)).next, o !== 0) for (; !(y = (s = d.call(c)).done) && (A.push(s.value), A.length !== o); y = !0) ;
    } catch (B) {
      S = !0, u = B;
    } finally {
      try {
        if (!y && c.return != null && (h = c.return(), Object(h) !== h)) return;
      } finally {
        if (S) throw u;
      }
    }
    return A;
  }
}
function $v() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tb(l, o) {
  return Jv(l) || _v(l, o) || eb(l, o) || $v();
}
function eb(l, o) {
  if (l) {
    if (typeof l == "string") return MA(l, o);
    var c = {}.toString.call(l).slice(8, -1);
    return c === "Object" && l.constructor && (c = l.constructor.name), c === "Map" || c === "Set" ? Array.from(l) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? MA(l, o) : void 0;
  }
}
const Wp = Object.entries, LA = Object.setPrototypeOf, nb = Object.isFrozen, ab = Object.getPrototypeOf, lb = Object.getOwnPropertyDescriptor;
let Le = Object.freeze, vn = Object.seal, Bi = Object.create, Jp = typeof Reflect < "u" && Reflect, Xf = Jp.apply, Qf = Jp.construct;
Le || (Le = function(o) {
  return o;
});
vn || (vn = function(o) {
  return o;
});
Xf || (Xf = function(o, c) {
  for (var s = arguments.length, u = new Array(s > 2 ? s - 2 : 0), d = 2; d < s; d++)
    u[d - 2] = arguments[d];
  return o.apply(c, u);
});
Qf || (Qf = function(o) {
  for (var c = arguments.length, s = new Array(c > 1 ? c - 1 : 0), u = 1; u < c; u++)
    s[u - 1] = arguments[u];
  return new o(...s);
});
const Oi = de(Array.prototype.forEach), ib = de(Array.prototype.lastIndexOf), zA = de(Array.prototype.pop), Ei = de(Array.prototype.push), ob = de(Array.prototype.splice), Me = Array.isArray, Qo = de(String.prototype.toLowerCase), hf = de(String.prototype.toString), RA = de(String.prototype.match), Ti = de(String.prototype.replace), UA = de(String.prototype.indexOf), rb = de(String.prototype.trim), cb = de(Number.prototype.toString), ub = de(Boolean.prototype.toString), HA = typeof BigInt > "u" ? null : de(BigInt.prototype.toString), jA = typeof Symbol > "u" ? null : de(Symbol.prototype.toString), ne = de(Object.prototype.hasOwnProperty), Uo = de(Object.prototype.toString), Te = de(RegExp.prototype.test), vc = sb(TypeError);
function de(l) {
  return function(o) {
    o instanceof RegExp && (o.lastIndex = 0);
    for (var c = arguments.length, s = new Array(c > 1 ? c - 1 : 0), u = 1; u < c; u++)
      s[u - 1] = arguments[u];
    return Xf(l, o, s);
  };
}
function sb(l) {
  return function() {
    for (var o = arguments.length, c = new Array(o), s = 0; s < o; s++)
      c[s] = arguments[s];
    return Qf(l, c);
  };
}
function mt(l, o) {
  let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Qo;
  if (LA && LA(l, null), !Me(o))
    return l;
  let s = o.length;
  for (; s--; ) {
    let u = o[s];
    if (typeof u == "string") {
      const d = c(u);
      d !== u && (nb(o) || (o[s] = d), u = d);
    }
    l[u] = !0;
  }
  return l;
}
function fb(l) {
  for (let o = 0; o < l.length; o++)
    ne(l, o) || (l[o] = null);
  return l;
}
function Ge(l) {
  const o = Bi(null);
  for (const s of Wp(l)) {
    var c = tb(s, 2);
    const u = c[0], d = c[1];
    ne(l, u) && (Me(d) ? o[u] = fb(d) : d && typeof d == "object" && d.constructor === Object ? o[u] = Ge(d) : o[u] = d);
  }
  return o;
}
function db(l) {
  switch (typeof l) {
    case "string":
      return l;
    case "number":
      return cb(l);
    case "boolean":
      return ub(l);
    case "bigint":
      return HA ? HA(l) : "0";
    case "symbol":
      return jA ? jA(l) : "Symbol()";
    case "undefined":
      return Uo(l);
    case "function":
    case "object": {
      if (l === null)
        return Uo(l);
      const o = l, c = Tl(o, "toString");
      if (typeof c == "function") {
        const s = c(o);
        return typeof s == "string" ? s : Uo(s);
      }
      return Uo(l);
    }
    default:
      return Uo(l);
  }
}
function Tl(l, o) {
  for (; l !== null; ) {
    const s = lb(l, o);
    if (s) {
      if (s.get)
        return de(s.get);
      if (typeof s.value == "function")
        return de(s.value);
    }
    l = ab(l);
  }
  function c() {
    return null;
  }
  return c;
}
function mb(l) {
  try {
    return Te(l, ""), !0;
  } catch {
    return !1;
  }
}
const XA = Le(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), gf = Le(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Af = Le(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), hb = Le(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), pf = Le(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), gb = Le(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), QA = Le(["#text"]), VA = Le(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), yf = Le(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), GA = Le(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), bc = Le(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Ab = vn(/{{[\w\W]*|^[\w\W]*}}/g), pb = vn(/<%[\w\W]*|^[\w\W]*%>/g), yb = vn(/\${[\w\W]*/g), vb = vn(/^data-[\-\w.\u00B7-\uFFFF]+$/), bb = vn(/^aria-[\-\w]+$/), YA = vn(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Sb = vn(/^(?:\w+script|data):/i), Ob = vn(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Eb = vn(/^html$/i), Tb = vn(/^[a-z][.\w]*(-[.\w]+)+$/i), xi = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, xb = function() {
  return typeof window > "u" ? null : window;
}, Cb = function(o, c) {
  if (typeof o != "object" || typeof o.createPolicy != "function")
    return null;
  let s = null;
  const u = "data-tt-policy-suffix";
  c && c.hasAttribute(u) && (s = c.getAttribute(u));
  const d = "dompurify" + (s ? "#" + s : "");
  try {
    return o.createPolicy(d, {
      createHTML(h) {
        return h;
      },
      createScriptURL(h) {
        return h;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + d + " could not be created."), null;
  }
}, IA = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function _p() {
  let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : xb();
  const o = ($) => _p($);
  if (o.version = "3.4.5", o.removed = [], !l || !l.document || l.document.nodeType !== xi.document || !l.Element)
    return o.isSupported = !1, o;
  let c = l.document;
  const s = c, u = s.currentScript, d = l.DocumentFragment, h = l.HTMLTemplateElement, A = l.Node, y = l.Element, S = l.NodeFilter, B = l.NamedNodeMap, w = B === void 0 ? l.NamedNodeMap || l.MozNamedAttrMap : B, C = l.HTMLFormElement, _ = l.DOMParser, H = l.trustedTypes, G = y.prototype, F = Tl(G, "cloneNode"), K = Tl(G, "remove"), X = Tl(G, "nextSibling"), nt = Tl(G, "childNodes"), ot = Tl(G, "parentNode"), I = A && A.prototype ? Tl(A.prototype, "nodeType") : null;
  if (typeof h == "function") {
    const $ = c.createElement("template");
    $.content && $.content.ownerDocument && (c = $.content.ownerDocument);
  }
  let k, Y = "";
  const Z = c, ct = Z.implementation, wt = Z.createNodeIterator, At = Z.createDocumentFragment, Gt = Z.getElementsByTagName, Tt = s.importNode;
  let St = IA();
  o.isSupported = typeof Wp == "function" && typeof ot == "function" && ct && ct.createHTMLDocument !== void 0;
  const xt = Ab, V = pb, j = yb, q = vb, ut = bb, ht = Sb, Wt = Ob, Ct = Tb;
  let lt = YA, W = null;
  const Ot = mt({}, [...XA, ...gf, ...Af, ...pf, ...QA]);
  let Mt = null;
  const me = mt({}, [...VA, ...yf, ...GA, ...bc]);
  let Ut = Object.seal(Bi(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), we = null, ie = null;
  const nn = Object.seal(Bi(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let ll = !0, il = !0, Qi = !1, Rn = !0, an = !1, Pn = !0, Wn = !1, Rl = !1, ol = !1, Un = !1, ba = !1, Ul = !1, ar = !0, xe = !1;
  const lr = "user-content-";
  let Hl = !0, Sa = !1, Sn = {}, ln = null;
  const jl = mt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ir = null;
  const or = mt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Jn = null;
  const Ce = mt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Fe = "http://www.w3.org/1998/Math/MathML", Ae = "http://www.w3.org/2000/svg", on = "http://www.w3.org/1999/xhtml";
  let Oa = on, Vi = !1, Ea = null;
  const Xl = mt({}, [Fe, Ae, on], hf);
  let Ta = mt({}, ["mi", "mo", "mn", "ms", "mtext"]), On = mt({}, ["annotation-xml"]);
  const Ql = mt({}, ["title", "style", "font", "a", "script"]);
  let En = null;
  const tu = ["application/xhtml+xml", "text/html"], rr = "text/html";
  let Jt = null, rn = null;
  const eu = c.createElement("form"), Gi = function(g) {
    return g instanceof RegExp || g instanceof Function;
  }, Vl = function() {
    let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (rn && rn === g)
      return;
    (!g || typeof g != "object") && (g = {}), g = Ge(g), En = // eslint-disable-next-line unicorn/prefer-includes
    tu.indexOf(g.PARSER_MEDIA_TYPE) === -1 ? rr : g.PARSER_MEDIA_TYPE, Jt = En === "application/xhtml+xml" ? hf : Qo, W = ne(g, "ALLOWED_TAGS") && Me(g.ALLOWED_TAGS) ? mt({}, g.ALLOWED_TAGS, Jt) : Ot, Mt = ne(g, "ALLOWED_ATTR") && Me(g.ALLOWED_ATTR) ? mt({}, g.ALLOWED_ATTR, Jt) : me, Ea = ne(g, "ALLOWED_NAMESPACES") && Me(g.ALLOWED_NAMESPACES) ? mt({}, g.ALLOWED_NAMESPACES, hf) : Xl, Jn = ne(g, "ADD_URI_SAFE_ATTR") && Me(g.ADD_URI_SAFE_ATTR) ? mt(Ge(Ce), g.ADD_URI_SAFE_ATTR, Jt) : Ce, ir = ne(g, "ADD_DATA_URI_TAGS") && Me(g.ADD_DATA_URI_TAGS) ? mt(Ge(or), g.ADD_DATA_URI_TAGS, Jt) : or, ln = ne(g, "FORBID_CONTENTS") && Me(g.FORBID_CONTENTS) ? mt({}, g.FORBID_CONTENTS, Jt) : jl, we = ne(g, "FORBID_TAGS") && Me(g.FORBID_TAGS) ? mt({}, g.FORBID_TAGS, Jt) : Ge({}), ie = ne(g, "FORBID_ATTR") && Me(g.FORBID_ATTR) ? mt({}, g.FORBID_ATTR, Jt) : Ge({}), Sn = ne(g, "USE_PROFILES") ? g.USE_PROFILES && typeof g.USE_PROFILES == "object" ? Ge(g.USE_PROFILES) : g.USE_PROFILES : !1, ll = g.ALLOW_ARIA_ATTR !== !1, il = g.ALLOW_DATA_ATTR !== !1, Qi = g.ALLOW_UNKNOWN_PROTOCOLS || !1, Rn = g.ALLOW_SELF_CLOSE_IN_ATTR !== !1, an = g.SAFE_FOR_TEMPLATES || !1, Pn = g.SAFE_FOR_XML !== !1, Wn = g.WHOLE_DOCUMENT || !1, Un = g.RETURN_DOM || !1, ba = g.RETURN_DOM_FRAGMENT || !1, Ul = g.RETURN_TRUSTED_TYPE || !1, ol = g.FORCE_BODY || !1, ar = g.SANITIZE_DOM !== !1, xe = g.SANITIZE_NAMED_PROPS || !1, Hl = g.KEEP_CONTENT !== !1, Sa = g.IN_PLACE || !1, lt = mb(g.ALLOWED_URI_REGEXP) ? g.ALLOWED_URI_REGEXP : YA, Oa = typeof g.NAMESPACE == "string" ? g.NAMESPACE : on, Ta = ne(g, "MATHML_TEXT_INTEGRATION_POINTS") && g.MATHML_TEXT_INTEGRATION_POINTS && typeof g.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ge(g.MATHML_TEXT_INTEGRATION_POINTS) : mt({}, ["mi", "mo", "mn", "ms", "mtext"]), On = ne(g, "HTML_INTEGRATION_POINTS") && g.HTML_INTEGRATION_POINTS && typeof g.HTML_INTEGRATION_POINTS == "object" ? Ge(g.HTML_INTEGRATION_POINTS) : mt({}, ["annotation-xml"]);
    const U = ne(g, "CUSTOM_ELEMENT_HANDLING") && g.CUSTOM_ELEMENT_HANDLING && typeof g.CUSTOM_ELEMENT_HANDLING == "object" ? Ge(g.CUSTOM_ELEMENT_HANDLING) : Bi(null);
    if (Ut = Bi(null), ne(U, "tagNameCheck") && Gi(U.tagNameCheck) && (Ut.tagNameCheck = U.tagNameCheck), ne(U, "attributeNameCheck") && Gi(U.attributeNameCheck) && (Ut.attributeNameCheck = U.attributeNameCheck), ne(U, "allowCustomizedBuiltInElements") && typeof U.allowCustomizedBuiltInElements == "boolean" && (Ut.allowCustomizedBuiltInElements = U.allowCustomizedBuiltInElements), an && (il = !1), ba && (Un = !0), Sn && (W = mt({}, QA), Mt = Bi(null), Sn.html === !0 && (mt(W, XA), mt(Mt, VA)), Sn.svg === !0 && (mt(W, gf), mt(Mt, yf), mt(Mt, bc)), Sn.svgFilters === !0 && (mt(W, Af), mt(Mt, yf), mt(Mt, bc)), Sn.mathMl === !0 && (mt(W, pf), mt(Mt, GA), mt(Mt, bc))), nn.tagCheck = null, nn.attributeCheck = null, ne(g, "ADD_TAGS") && (typeof g.ADD_TAGS == "function" ? nn.tagCheck = g.ADD_TAGS : Me(g.ADD_TAGS) && (W === Ot && (W = Ge(W)), mt(W, g.ADD_TAGS, Jt))), ne(g, "ADD_ATTR") && (typeof g.ADD_ATTR == "function" ? nn.attributeCheck = g.ADD_ATTR : Me(g.ADD_ATTR) && (Mt === me && (Mt = Ge(Mt)), mt(Mt, g.ADD_ATTR, Jt))), ne(g, "ADD_URI_SAFE_ATTR") && Me(g.ADD_URI_SAFE_ATTR) && mt(Jn, g.ADD_URI_SAFE_ATTR, Jt), ne(g, "FORBID_CONTENTS") && Me(g.FORBID_CONTENTS) && (ln === jl && (ln = Ge(ln)), mt(ln, g.FORBID_CONTENTS, Jt)), ne(g, "ADD_FORBID_CONTENTS") && Me(g.ADD_FORBID_CONTENTS) && (ln === jl && (ln = Ge(ln)), mt(ln, g.ADD_FORBID_CONTENTS, Jt)), Hl && (W["#text"] = !0), Wn && mt(W, ["html", "head", "body"]), W.table && (mt(W, ["tbody"]), delete we.tbody), g.TRUSTED_TYPES_POLICY) {
      if (typeof g.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw vc('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof g.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw vc('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      k = g.TRUSTED_TYPES_POLICY, Y = k.createHTML("");
    } else
      k === void 0 && (k = Cb(H, u)), k !== null && typeof Y == "string" && (Y = k.createHTML(""));
    Le && Le(g), rn = g;
  }, Yi = mt({}, [...gf, ...Af, ...hb]), Gl = mt({}, [...pf, ...gb]), Ii = function(g) {
    let U = ot(g);
    (!U || !U.tagName) && (U = {
      namespaceURI: Oa,
      tagName: "template"
    });
    const P = Qo(g.tagName), rt = Qo(U.tagName);
    return Ea[g.namespaceURI] ? g.namespaceURI === Ae ? U.namespaceURI === on ? P === "svg" : U.namespaceURI === Fe ? P === "svg" && (rt === "annotation-xml" || Ta[rt]) : !!Yi[P] : g.namespaceURI === Fe ? U.namespaceURI === on ? P === "math" : U.namespaceURI === Ae ? P === "math" && On[rt] : !!Gl[P] : g.namespaceURI === on ? U.namespaceURI === Ae && !On[rt] || U.namespaceURI === Fe && !Ta[rt] ? !1 : !Gl[P] && (Ql[P] || !Yi[P]) : !!(En === "application/xhtml+xml" && Ea[g.namespaceURI]) : !1;
  }, Re = function(g) {
    Ei(o.removed, {
      element: g
    });
    try {
      ot(g).removeChild(g);
    } catch {
      K(g);
    }
  }, Hn = function(g, U) {
    try {
      Ei(o.removed, {
        attribute: U.getAttributeNode(g),
        from: U
      });
    } catch {
      Ei(o.removed, {
        attribute: null,
        from: U
      });
    }
    if (U.removeAttribute(g), g === "is")
      if (Un || ba)
        try {
          Re(U);
        } catch {
        }
      else
        try {
          U.setAttribute(g, "");
        } catch {
        }
  }, Tn = function(g) {
    let U = null, P = null;
    if (ol)
      g = "<remove></remove>" + g;
    else {
      const $t = RA(g, /^[\r\n\t ]+/);
      P = $t && $t[0];
    }
    En === "application/xhtml+xml" && Oa === on && (g = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + g + "</body></html>");
    const rt = k ? k.createHTML(g) : g;
    if (Oa === on)
      try {
        U = new _().parseFromString(rt, En);
      } catch {
      }
    if (!U || !U.documentElement) {
      U = ct.createDocument(Oa, "template", null);
      try {
        U.documentElement.innerHTML = Vi ? Y : rt;
      } catch {
      }
    }
    const Yt = U.body || U.documentElement;
    return g && P && Yt.insertBefore(c.createTextNode(P), Yt.childNodes[0] || null), Oa === on ? Gt.call(U, Wn ? "html" : "body")[0] : Wn ? U.documentElement : Yt;
  }, oe = function(g) {
    return wt.call(
      g.ownerDocument || g,
      g,
      // eslint-disable-next-line no-bitwise
      S.SHOW_ELEMENT | S.SHOW_COMMENT | S.SHOW_TEXT | S.SHOW_PROCESSING_INSTRUCTION | S.SHOW_CDATA_SECTION,
      null
    );
  }, ye = function(g) {
    g.normalize();
    const U = wt.call(
      g.ownerDocument || g,
      g,
      // eslint-disable-next-line no-bitwise
      S.SHOW_TEXT | S.SHOW_COMMENT | S.SHOW_CDATA_SECTION | S.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let P = U.nextNode();
    for (; P; ) {
      let rt = P.data;
      Oi([xt, V, j], (Yt) => {
        rt = Ti(rt, Yt, " ");
      }), P.data = rt, P = U.nextNode();
    }
  }, jn = function(g) {
    return g instanceof C && (typeof g.nodeName != "string" || typeof g.textContent != "string" || typeof g.removeChild != "function" || !(g.attributes instanceof w) || typeof g.removeAttribute != "function" || typeof g.setAttribute != "function" || typeof g.namespaceURI != "string" || typeof g.insertBefore != "function" || typeof g.hasChildNodes != "function");
  }, xa = function(g) {
    if (!I || typeof g != "object" || g === null)
      return !1;
    try {
      return typeof I(g) == "number";
    } catch {
      return !1;
    }
  };
  function xn($, g, U) {
    Oi($, (P) => {
      P.call(o, g, U, rn);
    });
  }
  const cr = function(g) {
    let U = null;
    if (xn(St.beforeSanitizeElements, g, null), jn(g))
      return Re(g), !0;
    const P = Jt(g.nodeName);
    if (xn(St.uponSanitizeElement, g, {
      tagName: P,
      allowedTags: W
    }), Pn && g.hasChildNodes() && !xa(g.firstElementChild) && Te(/<[/\w!]/g, g.innerHTML) && Te(/<[/\w!]/g, g.textContent) || Pn && g.namespaceURI === on && P === "style" && xa(g.firstElementChild) || g.nodeType === xi.progressingInstruction || Pn && g.nodeType === xi.comment && Te(/<[/\w]/g, g.data))
      return Re(g), !0;
    if (we[P] || !(nn.tagCheck instanceof Function && nn.tagCheck(P)) && !W[P]) {
      if (!we[P] && Yl(P) && (Ut.tagNameCheck instanceof RegExp && Te(Ut.tagNameCheck, P) || Ut.tagNameCheck instanceof Function && Ut.tagNameCheck(P)))
        return !1;
      if (Hl && !ln[P]) {
        const rt = ot(g) || g.parentNode, Yt = nt(g) || g.childNodes;
        if (Yt && rt) {
          const $t = Yt.length;
          for (let ve = $t - 1; ve >= 0; --ve) {
            const Cn = F(Yt[ve], !0);
            rt.insertBefore(Cn, X(g));
          }
        }
      }
      return Re(g), !0;
    }
    return g instanceof y && !Ii(g) || (P === "noscript" || P === "noembed" || P === "noframes") && Te(/<\/no(script|embed|frames)/i, g.innerHTML) ? (Re(g), !0) : (an && g.nodeType === xi.text && (U = g.textContent, Oi([xt, V, j], (rt) => {
      U = Ti(U, rt, " ");
    }), g.textContent !== U && (Ei(o.removed, {
      element: g.cloneNode()
    }), g.textContent = U)), xn(St.afterSanitizeElements, g, null), !1);
  }, Fi = function(g, U, P) {
    if (ie[U] || ar && (U === "id" || U === "name") && (P in c || P in eu))
      return !1;
    const rt = Mt[U] || nn.attributeCheck instanceof Function && nn.attributeCheck(U, g);
    if (!(il && !ie[U] && Te(q, U))) {
      if (!(ll && Te(ut, U))) {
        if (!rt || ie[U]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Yl(g) && (Ut.tagNameCheck instanceof RegExp && Te(Ut.tagNameCheck, g) || Ut.tagNameCheck instanceof Function && Ut.tagNameCheck(g)) && (Ut.attributeNameCheck instanceof RegExp && Te(Ut.attributeNameCheck, U) || Ut.attributeNameCheck instanceof Function && Ut.attributeNameCheck(U, g)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            U === "is" && Ut.allowCustomizedBuiltInElements && (Ut.tagNameCheck instanceof RegExp && Te(Ut.tagNameCheck, P) || Ut.tagNameCheck instanceof Function && Ut.tagNameCheck(P)))
          ) return !1;
        } else if (!Jn[U]) {
          if (!Te(lt, Ti(P, Wt, ""))) {
            if (!((U === "src" || U === "xlink:href" || U === "href") && g !== "script" && UA(P, "data:") === 0 && ir[g])) {
              if (!(Qi && !Te(ht, Ti(P, Wt, "")))) {
                if (P)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, rl = mt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Yl = function(g) {
    return !rl[Qo(g)] && Te(Ct, g);
  }, _n = function(g) {
    xn(St.beforeSanitizeAttributes, g, null);
    const U = g.attributes;
    if (!U || jn(g))
      return;
    const P = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Mt,
      forceKeepAttr: void 0
    };
    let rt = U.length;
    for (; rt--; ) {
      const Yt = U[rt], $t = Yt.name, ve = Yt.namespaceURI, Cn = Yt.value, Nn = Jt($t), Ca = Cn;
      let _t = $t === "value" ? Ca : rb(Ca);
      if (P.attrName = Nn, P.attrValue = _t, P.keepAttr = !0, P.forceKeepAttr = void 0, xn(St.uponSanitizeAttribute, g, P), _t = P.attrValue, xe && (Nn === "id" || Nn === "name") && UA(_t, lr) !== 0 && (Hn($t, g), _t = lr + _t), Pn && Te(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, _t)) {
        Hn($t, g);
        continue;
      }
      if (Nn === "attributename" && RA(_t, "href")) {
        Hn($t, g);
        continue;
      }
      if (P.forceKeepAttr)
        continue;
      if (!P.keepAttr) {
        Hn($t, g);
        continue;
      }
      if (!Rn && Te(/\/>/i, _t)) {
        Hn($t, g);
        continue;
      }
      an && Oi([xt, V, j], (De) => {
        _t = Ti(_t, De, " ");
      });
      const cn = Jt(g.nodeName);
      if (!Fi(cn, Nn, _t)) {
        Hn($t, g);
        continue;
      }
      if (k && typeof H == "object" && typeof H.getAttributeType == "function" && !ve)
        switch (H.getAttributeType(cn, Nn)) {
          case "TrustedHTML": {
            _t = k.createHTML(_t);
            break;
          }
          case "TrustedScriptURL": {
            _t = k.createScriptURL(_t);
            break;
          }
        }
      if (_t !== Ca)
        try {
          ve ? g.setAttributeNS(ve, $t, _t) : g.setAttribute($t, _t), jn(g) ? Re(g) : zA(o.removed);
        } catch {
          Hn($t, g);
        }
    }
    xn(St.afterSanitizeAttributes, g, null);
  }, Xn = function(g) {
    let U = null;
    const P = oe(g);
    for (xn(St.beforeSanitizeShadowDOM, g, null); U = P.nextNode(); )
      xn(St.uponSanitizeShadowNode, U, null), cr(U), _n(U), U.content instanceof d && Xn(U.content);
    xn(St.afterSanitizeShadowDOM, g, null);
  }, Qn = function(g) {
    if (g.nodeType === xi.element && g.shadowRoot instanceof d) {
      const rt = g.shadowRoot;
      Qn(rt), Xn(rt);
    }
    const U = g.childNodes;
    if (!U)
      return;
    const P = [];
    Oi(U, (rt) => {
      Ei(P, rt);
    });
    for (const rt of P)
      Qn(rt);
  };
  return o.sanitize = function($) {
    let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, U = null, P = null, rt = null, Yt = null;
    if (Vi = !$, Vi && ($ = "<!-->"), typeof $ != "string" && !xa($) && ($ = db($), typeof $ != "string"))
      throw vc("dirty is not a string, aborting");
    if (!o.isSupported)
      return $;
    if (Rl || Vl(g), o.removed = [], typeof $ == "string" && (Sa = !1), Sa) {
      const Cn = $.nodeName;
      if (typeof Cn == "string") {
        const Nn = Jt(Cn);
        if (!W[Nn] || we[Nn])
          throw vc("root node is forbidden and cannot be sanitized in-place");
      }
      Qn($);
    } else if (xa($))
      U = Tn("<!---->"), P = U.ownerDocument.importNode($, !0), P.nodeType === xi.element && P.nodeName === "BODY" || P.nodeName === "HTML" ? U = P : U.appendChild(P), Qn(P);
    else {
      if (!Un && !an && !Wn && // eslint-disable-next-line unicorn/prefer-includes
      $.indexOf("<") === -1)
        return k && Ul ? k.createHTML($) : $;
      if (U = Tn($), !U)
        return Un ? null : Ul ? Y : "";
    }
    U && ol && Re(U.firstChild);
    const $t = oe(Sa ? $ : U);
    for (; rt = $t.nextNode(); )
      cr(rt), _n(rt), rt.content instanceof d && Xn(rt.content);
    if (Sa)
      return an && ye($), $;
    if (Un) {
      if (an && ye(U), ba)
        for (Yt = At.call(U.ownerDocument); U.firstChild; )
          Yt.appendChild(U.firstChild);
      else
        Yt = U;
      return (Mt.shadowroot || Mt.shadowrootmode) && (Yt = Tt.call(s, Yt, !0)), Yt;
    }
    let ve = Wn ? U.outerHTML : U.innerHTML;
    return Wn && W["!doctype"] && U.ownerDocument && U.ownerDocument.doctype && U.ownerDocument.doctype.name && Te(Eb, U.ownerDocument.doctype.name) && (ve = "<!DOCTYPE " + U.ownerDocument.doctype.name + `>
` + ve), an && Oi([xt, V, j], (Cn) => {
      ve = Ti(ve, Cn, " ");
    }), k && Ul ? k.createHTML(ve) : ve;
  }, o.setConfig = function() {
    let $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vl($), Rl = !0;
  }, o.clearConfig = function() {
    rn = null, Rl = !1;
  }, o.isValidAttribute = function($, g, U) {
    rn || Vl({});
    const P = Jt($), rt = Jt(g);
    return Fi(P, rt, U);
  }, o.addHook = function($, g) {
    typeof g == "function" && Ei(St[$], g);
  }, o.removeHook = function($, g) {
    if (g !== void 0) {
      const U = ib(St[$], g);
      return U === -1 ? void 0 : ob(St[$], U, 1)[0];
    }
    return zA(St[$]);
  }, o.removeHooks = function($) {
    St[$] = [];
  }, o.removeAllHooks = function() {
    St = IA();
  }, o;
}
_p();
function* $p(l = "id-", o = 0) {
  let c = o;
  for (; ; )
    c += 1, yield l + c;
}
let vf = !1;
const Nb = (l, o) => {
  vf || (vf = !0, setTimeout(() => {
    l(), vf = !1;
  }, o));
};
var bf = { exports: {} }, Sf, FA;
function wb() {
  if (FA) return Sf;
  FA = 1;
  var l = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Sf = l, Sf;
}
var Of, kA;
function Db() {
  if (kA) return Of;
  kA = 1;
  var l = /* @__PURE__ */ wb();
  function o() {
  }
  function c() {
  }
  return c.resetWarningCache = o, Of = function() {
    function s(h, A, y, S, B, w) {
      if (w !== l) {
        var C = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw C.name = "Invariant Violation", C;
      }
    }
    s.isRequired = s;
    function u() {
      return s;
    }
    var d = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: u,
      element: s,
      elementType: s,
      instanceOf: u,
      node: s,
      objectOf: u,
      oneOf: u,
      oneOfType: u,
      shape: u,
      exact: u,
      checkPropTypes: c,
      resetWarningCache: o
    };
    return d.PropTypes = d, d;
  }, Of;
}
var qA;
function Bb() {
  return qA || (qA = 1, bf.exports = /* @__PURE__ */ Db()()), bf.exports;
}
var _e = /* @__PURE__ */ Bb();
const E = /* @__PURE__ */ Fv(_e);
E.shape({
  event: E.string,
  action: E.string,
  name: E.string,
  region: E.string,
  section: E.string,
  component: E.string,
  type: E.string,
  text: E.string
});
const Nt = ({
  event: l = "",
  action: o = "",
  name: c = "",
  type: s = "",
  section: u = "",
  text: d = "",
  region: h = "",
  component: A = ""
}) => {
  const { dataLayer: y } = window, S = {
    event: l.toLowerCase(),
    action: o.toLowerCase(),
    name: c.toLowerCase(),
    type: s.toLowerCase(),
    region: h.toLowerCase(),
    section: u.toLowerCase(),
    text: d.toLowerCase(),
    component: A.toLowerCase()
  };
  y && y.push(S);
}, Wo = ({ children: l }) => /* @__PURE__ */ b.jsx(b.Fragment, { children: l });
Wo.propTypes = {
  children: E.oneOfType([
    E.arrayOf(E.node),
    E.node,
    E.string
  ])
};
var Ef = { exports: {} };
var KA;
function Mb() {
  return KA || (KA = 1, (function(l) {
    (function() {
      var o = {}.hasOwnProperty;
      function c() {
        for (var d = "", h = 0; h < arguments.length; h++) {
          var A = arguments[h];
          A && (d = u(d, s(A)));
        }
        return d;
      }
      function s(d) {
        if (typeof d == "string" || typeof d == "number")
          return d;
        if (typeof d != "object")
          return "";
        if (Array.isArray(d))
          return c.apply(null, d);
        if (d.toString !== Object.prototype.toString && !d.toString.toString().includes("[native code]"))
          return d.toString();
        var h = "";
        for (var A in d)
          o.call(d, A) && d[A] && (h = u(h, A));
        return h;
      }
      function u(d, h) {
        return h ? d ? d + " " + h : d + h : d;
      }
      l.exports ? (c.default = c, l.exports = c) : window.classNames = c;
    })();
  })(Ef)), Ef.exports;
}
Mb();
({
  ...Wo.propTypes
});
const t0 = ({ children: l, className: o = "container", ...c }) => /* @__PURE__ */ b.jsx("div", { className: o, ...c, children: /* @__PURE__ */ b.jsx("div", { className: "row", children: l }) });
t0.propTypes = {
  children: Wo.propTypes.children
};
({
  ...t0.propTypes
});
Wo.propTypes.children, E.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
Wo.propTypes.children;
function e0({
  packageName: l = "",
  component: o = "",
  type: c = "",
  configuration: s = {}
}) {
  if (!l || !o) {
    console.error("trackReactComponent: Missing required arguments.");
    return;
  }
  window.uds = window.uds || {}, window.uds.package = window.uds.package || {}, window.uds.package[l] = {
    component: o,
    type: c,
    configuration: s
  };
}
const ZA = {
  alt: E.string,
  title: E.string,
  src: E.string,
  mobileSrc: E.string,
  brandLink: E.string
}, Nc = {
  baseUrl: E.string,
  parentOrg: E.string,
  parentOrgUrl: E.string,
  animate: E.bool
}, Sc = {
  loggedIn: E.bool,
  loginLink: E.string,
  logoutLink: E.string,
  userName: E.string
}, Yc = {
  text: E.string.isRequired,
  color: E.oneOf(["gold", "maroon", "light", "dark"]),
  href: E.string,
  classes: E.string,
  onClick: E.func,
  onFocus: E.func
}, Vf = E.shape({
  id: E.number,
  href: E.string,
  text: E.string,
  type: E.string,
  selected: E.bool,
  items: E.arrayOf(E.arrayOf(E.object)),
  buttons: E.arrayOf(E.shape(Yc)),
  class: E.string
}), n0 = {
  isPartner: E.bool,
  navTree: E.arrayOf(Vf),
  partnerLogo: E.shape(ZA),
  logo: E.shape(ZA),
  title: E.string,
  parentOrg: Nc.parentOrg,
  parentOrgUrl: Nc.parentOrgUrl,
  baseUrl: Nc.baseUrl,
  loggedIn: Sc.loggedIn,
  userName: Sc.userName,
  loginLink: Sc.loginLink,
  onLoginClick: E.func,
  logoutLink: Sc.logoutLink,
  onLogoutClick: E.func,
  buttons: E.arrayOf(E.shape(Yc)),
  breakpoint: E.oneOf(["Lg", "Xl"]),
  animateTitle: E.bool,
  expandOnHover: E.bool,
  mobileNavTree: E.arrayOf(Vf),
  hasNavigation: E.bool,
  searchUrl: E.string,
  site: E.string,
  renderDiv: E.oneOf(["true", "false"])
}, Lb = {
  ...n0,
  headerTop: E.number,
  headerHeight: E.number,
  itemOpened: E.number,
  setItemOpened: E.func,
  mobileMenuOpen: E.bool,
  setMobileMenuOpen: E.func,
  singlePageAppReset: E.func
};
function zb(l) {
  var o = /* @__PURE__ */ Object.create(null);
  return function(c) {
    return o[c] === void 0 && (o[c] = l(c)), o[c];
  };
}
var Rb = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ub = /* @__PURE__ */ zb(
  function(l) {
    return Rb.test(l) || l.charCodeAt(0) === 111 && l.charCodeAt(1) === 110 && l.charCodeAt(2) < 91;
  }
  /* Z+1 */
), qt = "-ms-", Io = "-moz-", zt = "-webkit-", a0 = "comm", Ic = "rule", yd = "decl", Hb = "@import", jb = "@namespace", l0 = "@keyframes", Xb = "@layer", i0 = Math.abs, vd = String.fromCharCode, Gf = Object.assign;
function Qb(l, o) {
  return ge(l, 0) ^ 45 ? (((o << 2 ^ ge(l, 0)) << 2 ^ ge(l, 1)) << 2 ^ ge(l, 2)) << 2 ^ ge(l, 3) : 0;
}
function o0(l) {
  return l.trim();
}
function Aa(l, o) {
  return (l = o.exec(l)) ? l[0] : l;
}
function gt(l, o, c) {
  return l.replace(o, c);
}
function wc(l, o, c) {
  return l.indexOf(o, c);
}
function ge(l, o) {
  return l.charCodeAt(o) | 0;
}
function Dl(l, o, c) {
  return l.slice(o, c);
}
function Mn(l) {
  return l.length;
}
function r0(l) {
  return l.length;
}
function Vo(l, o) {
  return o.push(l), l;
}
function Vb(l, o) {
  return l.map(o).join("");
}
function PA(l, o) {
  return l.filter(function(c) {
    return !Aa(c, o);
  });
}
var Fc = 1, zi = 1, c0 = 0, bn = 0, fe = 0, Hi = "";
function kc(l, o, c, s, u, d, h, A) {
  return { value: l, root: o, parent: c, type: s, props: u, children: d, line: Fc, column: zi, length: h, return: "", siblings: A };
}
function Ja(l, o) {
  return Gf(kc("", null, null, "", null, null, 0, l.siblings), l, { length: -l.length }, o);
}
function Ci(l) {
  for (; l.root; )
    l = Ja(l.root, { children: [l] });
  Vo(l, l.siblings);
}
function Gb() {
  return fe;
}
function Yb() {
  return fe = bn > 0 ? ge(Hi, --bn) : 0, zi--, fe === 10 && (zi = 1, Fc--), fe;
}
function Ln() {
  return fe = bn < c0 ? ge(Hi, bn++) : 0, zi++, fe === 10 && (zi = 1, Fc++), fe;
}
function $a() {
  return ge(Hi, bn);
}
function Dc() {
  return bn;
}
function qc(l, o) {
  return Dl(Hi, l, o);
}
function Ko(l) {
  switch (l) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Ib(l) {
  return Fc = zi = 1, c0 = Mn(Hi = l), bn = 0, [];
}
function Fb(l) {
  return Hi = "", l;
}
function Tf(l) {
  return o0(qc(bn - 1, Yf(l === 91 ? l + 2 : l === 40 ? l + 1 : l)));
}
function kb(l) {
  for (; (fe = $a()) && fe < 33; )
    Ln();
  return Ko(l) > 2 || Ko(fe) > 3 ? "" : " ";
}
function qb(l, o) {
  for (; --o && Ln() && !(fe < 48 || fe > 102 || fe > 57 && fe < 65 || fe > 70 && fe < 97); )
    ;
  return qc(l, Dc() + (o < 6 && $a() == 32 && Ln() == 32));
}
function Yf(l) {
  for (; Ln(); )
    switch (fe) {
      // ] ) " '
      case l:
        return bn;
      // " '
      case 34:
      case 39:
        l !== 34 && l !== 39 && Yf(fe);
        break;
      // (
      case 40:
        l === 41 && Yf(l);
        break;
      // \
      case 92:
        Ln();
        break;
    }
  return bn;
}
function Kb(l, o) {
  for (; Ln() && l + fe !== 57; )
    if (l + fe === 84 && $a() === 47)
      break;
  return "/*" + qc(o, bn - 1) + "*" + vd(l === 47 ? l : Ln());
}
function Zb(l) {
  for (; !Ko($a()); )
    Ln();
  return qc(l, bn);
}
function Pb(l) {
  return Fb(Bc("", null, null, null, [""], l = Ib(l), 0, [0], l));
}
function Bc(l, o, c, s, u, d, h, A, y) {
  for (var S = 0, B = 0, w = h, C = 0, _ = 0, H = 0, G = 1, F = 1, K = 1, X = 0, nt = "", ot = u, I = d, k = s, Y = nt; F; )
    switch (H = X, X = Ln()) {
      // (
      case 40:
        if (H != 108 && ge(Y, w - 1) == 58) {
          wc(Y += gt(Tf(X), "&", "&\f"), "&\f", i0(S ? A[S - 1] : 0)) != -1 && (K = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        Y += Tf(X);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        Y += kb(H);
        break;
      // \
      case 92:
        Y += qb(Dc() - 1, 7);
        continue;
      // /
      case 47:
        switch ($a()) {
          case 42:
          case 47:
            Vo(Wb(Kb(Ln(), Dc()), o, c, y), y), (Ko(H || 1) == 5 || Ko($a() || 1) == 5) && Mn(Y) && Dl(Y, -1, void 0) !== " " && (Y += " ");
            break;
          default:
            Y += "/";
        }
        break;
      // {
      case 123 * G:
        A[S++] = Mn(Y) * K;
      // } ; \0
      case 125 * G:
      case 59:
      case 0:
        switch (X) {
          // \0 }
          case 0:
          case 125:
            F = 0;
          // ;
          case 59 + B:
            K == -1 && (Y = gt(Y, /\f/g, "")), _ > 0 && (Mn(Y) - w || G === 0 && H === 47) && Vo(_ > 32 ? JA(Y + ";", s, c, w - 1, y) : JA(gt(Y, " ", "") + ";", s, c, w - 2, y), y);
            break;
          // @ ;
          case 59:
            Y += ";";
          // { rule/at-rule
          default:
            if (Vo(k = WA(Y, o, c, S, B, u, A, nt, ot = [], I = [], w, d), d), X === 123)
              if (B === 0)
                Bc(Y, o, k, k, ot, d, w, A, I);
              else {
                switch (C) {
                  // c(ontainer)
                  case 99:
                    if (ge(Y, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (ge(Y, 2) === 97) break;
                  default:
                    B = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                B ? Bc(l, k, k, s && Vo(WA(l, k, k, 0, 0, u, A, nt, u, ot = [], w, I), I), u, I, w, A, s ? ot : I) : Bc(Y, k, k, k, [""], I, 0, A, I);
              }
        }
        S = B = _ = 0, G = K = 1, nt = Y = "", w = h;
        break;
      // :
      case 58:
        w = 1 + Mn(Y), _ = H;
      default:
        if (G < 1) {
          if (X == 123)
            --G;
          else if (X == 125 && G++ == 0 && Yb() == 125)
            continue;
        }
        switch (Y += vd(X), X * G) {
          // &
          case 38:
            K = B > 0 ? 1 : (Y += "\f", -1);
            break;
          // ,
          case 44:
            A[S++] = (Mn(Y) - 1) * K, K = 1;
            break;
          // @
          case 64:
            $a() === 45 && (Y += Tf(Ln())), C = $a(), B = w = Mn(nt = Y += Zb(Dc())), X++;
            break;
          // -
          case 45:
            H === 45 && Mn(Y) == 2 && (G = 0);
        }
    }
  return d;
}
function WA(l, o, c, s, u, d, h, A, y, S, B, w) {
  for (var C = u - 1, _ = u === 0 ? d : [""], H = r0(_), G = 0, F = 0, K = 0; G < s; ++G)
    for (var X = 0, nt = Dl(l, C + 1, C = i0(F = h[G])), ot = l; X < H; ++X)
      (ot = o0(F > 0 ? _[X] + " " + nt : gt(nt, /&\f/g, _[X]))) && (y[K++] = ot);
  return kc(l, o, c, u === 0 ? Ic : A, y, S, B, w);
}
function Wb(l, o, c, s) {
  return kc(l, o, c, a0, vd(Gb()), Dl(l, 2, -2), 0, s);
}
function JA(l, o, c, s, u) {
  return kc(l, o, c, yd, Dl(l, 0, s), Dl(l, s + 1, -1), s, u);
}
function u0(l, o, c) {
  switch (Qb(l, o)) {
    // color-adjust
    case 5103:
      return zt + "print-" + l + l;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return zt + l + l;
    // mask-composite
    case 4855:
      return zt + l.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + l;
    // tab-size
    case 4789:
      return Io + l + l;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return zt + l + Io + l + qt + l + l;
    // writing-mode
    case 5936:
      switch (ge(l, o + 11)) {
        // vertical-l(r)
        case 114:
          return zt + l + qt + gt(l, /[svh]\w+-[tblr]{2}/, "tb") + l;
        // vertical-r(l)
        case 108:
          return zt + l + qt + gt(l, /[svh]\w+-[tblr]{2}/, "tb-rl") + l;
        // horizontal(-)tb
        case 45:
          return zt + l + qt + gt(l, /[svh]\w+-[tblr]{2}/, "lr") + l;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return zt + l + qt + l + l;
    // order
    case 6165:
      return zt + l + qt + "flex-" + l + l;
    // align-items
    case 5187:
      return zt + l + gt(l, /(\w+).+(:[^]+)/, zt + "box-$1$2" + qt + "flex-$1$2") + l;
    // align-self
    case 5443:
      return zt + l + qt + "flex-item-" + gt(l, /flex-|-self/g, "") + (Aa(l, /flex-|baseline/) ? "" : qt + "grid-row-" + gt(l, /flex-|-self/g, "")) + l;
    // align-content
    case 4675:
      return zt + l + qt + "flex-line-pack" + gt(l, /align-content|flex-|-self/g, "") + l;
    // flex-shrink
    case 5548:
      return zt + l + qt + gt(l, "shrink", "negative") + l;
    // flex-basis
    case 5292:
      return zt + l + qt + gt(l, "basis", "preferred-size") + l;
    // flex-grow
    case 6060:
      return zt + "box-" + gt(l, "-grow", "") + zt + l + qt + gt(l, "grow", "positive") + l;
    // transition
    case 4554:
      return zt + gt(l, /([^-])(transform)/g, "$1" + zt + "$2") + l;
    // cursor
    case 6187:
      return gt(gt(gt(l, /(zoom-|grab)/, zt + "$1"), /(image-set)/, zt + "$1"), l, "") + l;
    // background, background-image
    case 5495:
    case 3959:
      return gt(l, /(image-set\([^]*)/, zt + "$1$`$1");
    // justify-content
    case 4968:
      return gt(gt(l, /(.+:)(flex-)?(.*)/, zt + "box-pack:$3" + qt + "flex-pack:$3"), /space-between/, "justify") + zt + l + l;
    // justify-self
    case 4200:
      if (!Aa(l, /flex-|baseline/)) return qt + "grid-column-align" + Dl(l, o) + l;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return qt + gt(l, "template-", "") + l;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return c && c.some(function(s, u) {
        return o = u, Aa(s.props, /grid-\w+-end/);
      }) ? ~wc(l + (c = c[o].value), "span", 0) ? l : qt + gt(l, "-start", "") + l + qt + "grid-row-span:" + (~wc(c, "span", 0) ? Aa(c, /\d+/) : +Aa(c, /\d+/) - +Aa(l, /\d+/)) + ";" : qt + gt(l, "-start", "") + l;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return c && c.some(function(s) {
        return Aa(s.props, /grid-\w+-start/);
      }) ? l : qt + gt(gt(l, "-end", "-span"), "span ", "") + l;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return gt(l, /(.+)-inline(.+)/, zt + "$1$2") + l;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Mn(l) - 1 - o > 6)
        switch (ge(l, o + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (ge(l, o + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return gt(l, /(.+:)(.+)-([^]+)/, "$1" + zt + "$2-$3$1" + Io + (ge(l, o + 3) == 108 ? "$3" : "$2-$3")) + l;
          // (s)tretch
          case 115:
            return ~wc(l, "stretch", 0) ? u0(gt(l, "stretch", "fill-available"), o, c) + l : l;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return gt(l, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(s, u, d, h, A, y, S) {
        return qt + u + ":" + d + S + (h ? qt + u + "-span:" + (A ? y : +y - +d) + S : "") + l;
      });
    // position: sticky
    case 4949:
      if (ge(l, o + 6) === 121)
        return gt(l, ":", ":" + zt) + l;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (ge(l, ge(l, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return gt(l, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + zt + (ge(l, 14) === 45 ? "inline-" : "") + "box$3$1" + zt + "$2$3$1" + qt + "$2box$3") + l;
        // (inline-)?gri(d)
        case 100:
          return gt(l, ":", ":" + qt) + l;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return gt(l, "scroll-", "scroll-snap-") + l;
  }
  return l;
}
function jc(l, o) {
  for (var c = "", s = 0; s < l.length; s++)
    c += o(l[s], s, l, o) || "";
  return c;
}
function Jb(l, o, c, s) {
  switch (l.type) {
    case Xb:
      if (l.children.length) break;
    case Hb:
    case jb:
    case yd:
      return l.return = l.return || l.value;
    case a0:
      return "";
    case l0:
      return l.return = l.value + "{" + jc(l.children, s) + "}";
    case Ic:
      if (!Mn(l.value = l.props.join(","))) return "";
  }
  return Mn(c = jc(l.children, s)) ? l.return = l.value + "{" + c + "}" : "";
}
function _b(l) {
  var o = r0(l);
  return function(c, s, u, d) {
    for (var h = "", A = 0; A < o; A++)
      h += l[A](c, s, u, d) || "";
    return h;
  };
}
function $b(l) {
  return function(o) {
    o.root || (o = o.return) && l(o);
  };
}
function t3(l, o, c, s) {
  if (l.length > -1 && !l.return)
    switch (l.type) {
      case yd:
        l.return = u0(l.value, l.length, c);
        return;
      case l0:
        return jc([Ja(l, { value: gt(l.value, "@", "@" + zt) })], s);
      case Ic:
        if (l.length)
          return Vb(c = l.props, function(u) {
            switch (Aa(u, s = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                Ci(Ja(l, { props: [gt(u, /:(read-\w+)/, ":" + Io + "$1")] })), Ci(Ja(l, { props: [u] })), Gf(l, { props: PA(c, s) });
                break;
              // :placeholder
              case "::placeholder":
                Ci(Ja(l, { props: [gt(u, /:(plac\w+)/, ":" + zt + "input-$1")] })), Ci(Ja(l, { props: [gt(u, /:(plac\w+)/, ":" + Io + "$1")] })), Ci(Ja(l, { props: [gt(u, /:(plac\w+)/, qt + "input-$1")] })), Ci(Ja(l, { props: [u] })), Gf(l, { props: PA(c, s) });
                break;
            }
            return "";
          });
    }
}
var Rt = { env: { NODE_ENV: "production" } }, xf, Cf;
const Bl = typeof Rt < "u" && Rt.env !== void 0 && (Rt.env.REACT_APP_SC_ATTR || Rt.env.SC_ATTR) || "data-styled", s0 = "active", f0 = "data-styled-version", Kc = "6.4.2", bd = `/*!sc*/
`, Fo = typeof window < "u" && typeof document < "u";
function _A(l) {
  if (typeof Rt < "u" && Rt.env !== void 0) {
    const o = Rt.env[l];
    if (o !== void 0 && o !== "") return o !== "false";
  }
}
const e3 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (Cf = (xf = _A("REACT_APP_SC_DISABLE_SPEEDY")) !== null && xf !== void 0 ? xf : _A("SC_DISABLE_SPEEDY")) !== null && Cf !== void 0 ? Cf : typeof Rt < "u" && Rt.env !== void 0 && Rt.env.NODE_ENV !== "production"), n3 = "sc-keyframes-", a3 = {}, l3 = Rt.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?

`, 18: `Accessing \`useTheme\` hook outside of a \`<ThemeProvider>\` element.

\`\`\`jsx
import { useTheme } from 'styled-components';
export function StyledCompoent({ children }) {
  const theme = useTheme();
  return <div style={{ width: theme.sizes.full }}>{children}</div>;
}

import { StyledComponent } from './StyledComponent';
import { theme } from './theme';
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <StyledComponent />
    </ThemeProvider>
  );
}
\`\`\`

If you need access to the theme in an uncertain composition scenario, \`React.useContext(ThemeContext)\` will not emit an error if there is no \`ThemeProvider\` ancestor.
` } : {};
function Jo(l, ...o) {
  return Rt.env.NODE_ENV === "production" ? new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${l} for more information.${o.length > 0 ? ` Args: ${o.join(", ")}` : ""}`) : new Error((function(...c) {
    let s = c[0];
    const u = [];
    for (let d = 1, h = c.length; d < h; d += 1) u.push(c[d]);
    return u.forEach((d) => {
      s = s.replace(/%[a-z]/, d);
    }), s;
  })(l3[l], ...o).trim());
}
const i3 = 1 << 30;
let Mc = /* @__PURE__ */ new Map(), Xc = /* @__PURE__ */ new Map(), Lc = 1;
const Oc = (l) => {
  if (Mc.has(l)) return Mc.get(l);
  for (; Xc.has(Lc); ) Lc++;
  const o = Lc++;
  if (Rt.env.NODE_ENV !== "production" && ((0 | o) < 0 || o > i3)) throw Jo(16, `${o}`);
  return Mc.set(l, o), Xc.set(o, l), o;
}, o3 = (l) => Xc.get(l), r3 = (l, o) => {
  Lc = o + 1, Mc.set(l, o), Xc.set(o, l);
}, $A = /invalid hook call/i, Ec = /* @__PURE__ */ new Set(), d0 = (l, o) => {
  if (Rt.env.NODE_ENV !== "production") {
    const c = `The component ${l}${o ? ` with the id of "${o}"` : ""} has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, s = console.error;
    try {
      let u = !0;
      console.error = (d, ...h) => {
        $A.test(d) ? (u = !1, Ec.delete(c)) : s(d, ...h);
      }, typeof Pt.useState == "function" && Pt.useState(null), u && !Ec.has(c) && (console.warn(c), Ec.add(c));
    } catch (u) {
      $A.test(u.message) && Ec.delete(c);
    } finally {
      console.error = s;
    }
  }
}, Sd = Object.freeze([]), Ri = Object.freeze({});
function m0(l, o, c = Ri) {
  return l.theme !== c.theme && l.theme || o || c.theme;
}
const c3 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, u3 = /(^-|-$)/g;
function h0(l) {
  return l.replace(c3, "-").replace(u3, "");
}
const s3 = /(a)(d)/gi, tp = (l) => String.fromCharCode(l + (l > 25 ? 39 : 97));
function g0(l) {
  let o, c = "";
  for (o = Math.abs(l); o > 52; o = o / 52 | 0) c = tp(o % 52) + c;
  return (tp(o % 52) + c).replace(s3, "$1-$2");
}
const If = 5381, Nl = (l, o) => {
  let c = o.length;
  for (; c; ) l = 33 * l ^ o.charCodeAt(--c);
  return l;
}, A0 = (l) => Nl(If, l);
function p0(l) {
  return g0(A0(l) >>> 0);
}
function Od(l) {
  return Rt.env.NODE_ENV !== "production" && typeof l == "string" && l || l.displayName || l.name || "Component";
}
function zc(l) {
  return typeof l == "string" && (Rt.env.NODE_ENV === "production" || l.charAt(0) === l.charAt(0).toLowerCase());
}
function f3(l) {
  return zc(l) ? `styled.${l}` : `Styled(${Od(l)})`;
}
const y0 = Symbol.for("react.memo"), d3 = Symbol.for("react.forward_ref"), m3 = { contextType: !0, defaultProps: !0, displayName: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, propTypes: !0, type: !0 }, h3 = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, v0 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, g3 = { [d3]: { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, [y0]: v0 };
function ep(l) {
  return ("type" in (o = l) && o.type.$$typeof) === y0 ? v0 : "$$typeof" in l ? g3[l.$$typeof] : m3;
  var o;
}
const A3 = Object.defineProperty, p3 = Object.getOwnPropertyNames, y3 = Object.getOwnPropertySymbols, v3 = Object.getOwnPropertyDescriptor, b3 = Object.getPrototypeOf, S3 = Object.prototype;
function b0(l, o, c) {
  if (typeof o != "string") {
    const s = b3(o);
    s && s !== S3 && b0(l, s, c);
    const u = p3(o).concat(y3(o)), d = ep(l), h = ep(o);
    for (let A = 0; A < u.length; ++A) {
      const y = u[A];
      if (!(y in h3 || c && c[y] || h && y in h || d && y in d)) {
        const S = v3(o, y);
        try {
          A3(l, y, S);
        } catch {
        }
      }
    }
  }
  return l;
}
function _o(l) {
  return typeof l == "function";
}
const O3 = Symbol.for("react.forward_ref");
function Ed(l) {
  return l != null && (typeof l == "object" || typeof l == "function") && l.$$typeof === O3 && "styledComponentId" in l;
}
function Go(l, o) {
  return l && o ? l + " " + o : l || o || "";
}
function Ff(l, o) {
  return l.join("");
}
function Ml(l) {
  return l !== null && typeof l == "object" && l.constructor.name === Object.name && !("props" in l && l.$$typeof);
}
function kf(l, o, c = !1) {
  if (!c && !Ml(l) && !Array.isArray(l)) return o;
  if (Array.isArray(o)) for (let s = 0; s < o.length; s++) l[s] = kf(l[s], o[s]);
  else if (Ml(o)) for (const s in o) l[s] = kf(l[s], o[s]);
  return l;
}
function S0(l, o) {
  Object.defineProperty(l, "toString", { value: o });
}
const E3 = class {
  constructor(l) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = l, this._cGroup = 0, this._cIndex = 0;
  }
  indexOfGroup(l) {
    if (l === this._cGroup) return this._cIndex;
    let o = this._cIndex;
    if (l > this._cGroup) for (let c = this._cGroup; c < l; c++) o += this.groupSizes[c];
    else for (let c = this._cGroup - 1; c >= l; c--) o -= this.groupSizes[c];
    return this._cGroup = l, this._cIndex = o, o;
  }
  insertRules(l, o) {
    if (l >= this.groupSizes.length) {
      const u = this.groupSizes, d = u.length;
      let h = d;
      for (; l >= h; ) if (h <<= 1, h < 0) throw Jo(16, `${l}`);
      this.groupSizes = new Uint32Array(h), this.groupSizes.set(u), this.length = h;
      for (let A = d; A < h; A++) this.groupSizes[A] = 0;
    }
    let c = this.indexOfGroup(l + 1), s = 0;
    for (let u = 0, d = o.length; u < d; u++) this.tag.insertRule(c, o[u]) && (this.groupSizes[l]++, c++, s++);
    s > 0 && this._cGroup > l && (this._cIndex += s);
  }
  clearGroup(l) {
    if (l < this.length) {
      const o = this.groupSizes[l], c = this.indexOfGroup(l), s = c + o;
      this.groupSizes[l] = 0;
      for (let u = c; u < s; u++) this.tag.deleteRule(c);
      o > 0 && this._cGroup > l && (this._cIndex -= o);
    }
  }
  getGroup(l) {
    let o = "";
    if (l >= this.length || this.groupSizes[l] === 0) return o;
    const c = this.groupSizes[l], s = this.indexOfGroup(l), u = s + c;
    for (let d = s; d < u; d++) o += this.tag.getRule(d) + bd;
    return o;
  }
}, T3 = `style[${Bl}][${f0}="${Kc}"]`, x3 = new RegExp(`^${Bl}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), np = (l) => typeof ShadowRoot < "u" && l instanceof ShadowRoot || "host" in l && l.nodeType === 11, qf = (l) => {
  if (!l) return document;
  if (np(l)) return l;
  if ("getRootNode" in l) {
    const o = l.getRootNode();
    if (np(o)) return o;
  }
  return document;
}, C3 = (l, o, c) => {
  const s = c.split(",");
  let u;
  for (let d = 0, h = s.length; d < h; d++) (u = s[d]) && l.registerName(o, u);
}, N3 = (l, o) => {
  var c;
  const s = ((c = o.textContent) !== null && c !== void 0 ? c : "").split(bd), u = [];
  for (let d = 0, h = s.length; d < h; d++) {
    const A = s[d].trim();
    if (!A) continue;
    const y = A.match(x3);
    if (y) {
      const S = 0 | parseInt(y[1], 10), B = y[2];
      S !== 0 && (r3(B, S), C3(l, B, y[3]), l.getTag().insertRules(S, u)), u.length = 0;
    } else u.push(A);
  }
}, Nf = (l) => {
  const o = qf(l.options.target).querySelectorAll(T3);
  for (let c = 0, s = o.length; c < s; c++) {
    const u = o[c];
    u && u.getAttribute(Bl) !== s0 && (N3(l, u), u.parentNode && u.parentNode.removeChild(u));
  }
};
let Ho = !1;
function w3() {
  if (Ho !== !1) return Ho;
  if (typeof document < "u") {
    const l = document.head.querySelector('meta[property="csp-nonce"]');
    if (l) return Ho = l.nonce || l.getAttribute("content") || void 0;
    const o = document.head.querySelector('meta[name="sc-nonce"]');
    if (o) return Ho = o.getAttribute("content") || void 0;
  }
  return Ho = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}
const O0 = (l, o) => {
  const c = document.head, s = l || c, u = document.createElement("style"), d = ((y) => {
    const S = Array.from(y.querySelectorAll(`style[${Bl}]`));
    return S[S.length - 1];
  })(s), h = d !== void 0 ? d.nextSibling : null;
  u.setAttribute(Bl, s0), u.setAttribute(f0, Kc);
  const A = o || w3();
  return A && u.setAttribute("nonce", A), s.insertBefore(u, h), u;
}, D3 = class {
  constructor(l, o) {
    this.element = O0(l, o), this.element.appendChild(document.createTextNode("")), this.sheet = ((c) => {
      var s;
      if (c.sheet) return c.sheet;
      const u = (s = c.getRootNode().styleSheets) !== null && s !== void 0 ? s : document.styleSheets;
      for (let d = 0, h = u.length; d < h; d++) {
        const A = u[d];
        if (A.ownerNode === c) return A;
      }
      throw Jo(17);
    })(this.element), this.length = 0;
  }
  insertRule(l, o) {
    try {
      return this.sheet.insertRule(o, l), this.length++, !0;
    } catch {
      return !1;
    }
  }
  deleteRule(l) {
    this.sheet.deleteRule(l), this.length--;
  }
  getRule(l) {
    const o = this.sheet.cssRules[l];
    return o && o.cssText ? o.cssText : "";
  }
}, B3 = class {
  constructor(l, o) {
    this.element = O0(l, o), this.nodes = this.element.childNodes, this.length = 0;
  }
  insertRule(l, o) {
    if (l <= this.length && l >= 0) {
      const c = document.createTextNode(o);
      return this.element.insertBefore(c, this.nodes[l] || null), this.length++, !0;
    }
    return !1;
  }
  deleteRule(l) {
    this.element.removeChild(this.nodes[l]), this.length--;
  }
  getRule(l) {
    return l < this.length ? this.nodes[l].textContent : "";
  }
};
let ap = Fo;
const M3 = { isServer: !Fo, useCSSOMInjection: !e3 };
class $o {
  static registerId(o) {
    return Oc(o);
  }
  constructor(o = Ri, c = {}, s) {
    this.options = Object.assign(Object.assign({}, M3), o), this.gs = c, this.keyframeIds = /* @__PURE__ */ new Set(), this.names = new Map(s), this.server = !!o.isServer, !this.server && Fo && ap && (ap = !1, Nf(this)), S0(this, () => ((u) => {
      const d = u.getTag(), { length: h } = d;
      let A = "";
      for (let y = 0; y < h; y++) {
        const S = o3(y);
        if (S === void 0) continue;
        const B = u.names.get(S);
        if (B === void 0 || !B.size) continue;
        const w = d.getGroup(y);
        if (w.length === 0) continue;
        const C = Bl + ".g" + y + '[id="' + S + '"]';
        let _ = "";
        for (const H of B) H.length > 0 && (_ += H + ",");
        A += w + C + '{content:"' + _ + '"}' + bd;
      }
      return A;
    })(this));
  }
  rehydrate() {
    !this.server && Fo && Nf(this);
  }
  reconstructWithOptions(o, c = !0) {
    const s = new $o(Object.assign(Object.assign({}, this.options), o), this.gs, c && this.names || void 0);
    return s.keyframeIds = new Set(this.keyframeIds), !this.server && Fo && o.target !== this.options.target && qf(this.options.target) !== qf(o.target) && Nf(s), s;
  }
  allocateGSInstance(o) {
    return this.gs[o] = (this.gs[o] || 0) + 1;
  }
  getTag() {
    return this.tag || (this.tag = (o = (({ useCSSOMInjection: c, target: s, nonce: u }) => c ? new D3(s, u) : new B3(s, u))(this.options), new E3(o)));
    var o;
  }
  hasNameForId(o, c) {
    var s, u;
    return (u = (s = this.names.get(o)) === null || s === void 0 ? void 0 : s.has(c)) !== null && u !== void 0 && u;
  }
  registerName(o, c) {
    Oc(o), o.startsWith(n3) && this.keyframeIds.add(o);
    const s = this.names.get(o);
    s ? s.add(c) : this.names.set(o, /* @__PURE__ */ new Set([c]));
  }
  insertRules(o, c, s) {
    this.registerName(o, c), this.getTag().insertRules(Oc(o), s);
  }
  clearNames(o) {
    this.names.has(o) && this.names.get(o).clear();
  }
  clearRules(o) {
    this.getTag().clearGroup(Oc(o)), this.clearNames(o);
  }
  clearTag() {
    this.tag = void 0;
  }
}
const E0 = /* @__PURE__ */ new WeakSet(), L3 = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexShrink: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, scale: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function z3(l, o) {
  return o == null || typeof o == "boolean" || o === "" ? "" : typeof o != "number" || o === 0 || l in L3 || l.startsWith("--") ? String(o).trim() : o + "px";
}
const xl = 47;
function lp(l) {
  if (l.charCodeAt(0) === 45 && l.charCodeAt(1) === 45) return l;
  let o = "";
  for (let c = 0; c < l.length; c++) {
    const s = l.charCodeAt(c);
    o += s >= 65 && s <= 90 ? "-" + String.fromCharCode(s + 32) : l[c];
  }
  return o.startsWith("ms-") ? "-" + o : o;
}
const R3 = Symbol.for("sc-keyframes");
function Kf(l) {
  return typeof l == "object" && l !== null && R3 in l;
}
function T0(l) {
  return _o(l) && !(l.prototype && l.prototype.isReactComponent);
}
const x0 = (l) => l == null || l === !1 || l === "", U3 = Symbol.for("react.client.reference");
function ip(l) {
  return l.$$typeof === U3;
}
function op(l) {
  const o = l.$$id, c = (o && o.includes("#") ? o.split("#").pop() : o) || l.name || "unknown";
  console.warn(`Interpolating a client component (${c}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function C0(l, o) {
  for (const c in l) {
    const s = l[c];
    l.hasOwnProperty(c) && !x0(s) && (Array.isArray(s) && E0.has(s) || _o(s) ? o.push(lp(c) + ":", s, ";") : Ml(s) ? (o.push(c + " {"), C0(s, o), o.push("}")) : o.push(lp(c) + ": " + z3(c, s) + ";"));
  }
}
function tl(l, o, c, s, u = []) {
  if (x0(l)) return u;
  const d = typeof l;
  if (d === "string") return u.push(l), u;
  if (d === "function") {
    if (ip(l)) return Rt.env.NODE_ENV !== "production" && op(l), u;
    if (T0(l) && o) {
      const h = l(o);
      return Rt.env.NODE_ENV === "production" || typeof h != "object" || Array.isArray(h) || Kf(h) || Ml(h) || h === null || console.error(`${Od(l)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), tl(h, o, c, s, u);
    }
    return u.push(l), u;
  }
  if (Array.isArray(l)) {
    for (let h = 0; h < l.length; h++) tl(l[h], o, c, s, u);
    return u;
  }
  return Ed(l) ? (u.push(`.${l.styledComponentId}`), u) : Kf(l) ? (c ? (l.inject(c, s), u.push(l.getName(s))) : u.push(l), u) : ip(l) ? (Rt.env.NODE_ENV !== "production" && op(l), u) : Ml(l) ? l.toString !== Object.prototype.toString ? (u.push(l.toString()), u) : (C0(l, u), u) : (u.push(l.toString()), u);
}
const H3 = A0(Kc);
class j3 {
  constructor(o, c, s) {
    this.rules = o, this.componentId = c, this.baseHash = Nl(H3, c), this.baseStyle = s, $o.registerId(c);
  }
  generateAndInjectStyles(o, c, s) {
    let u = this.baseStyle ? this.baseStyle.generateAndInjectStyles(o, c, s) : "";
    {
      let d = "";
      for (let h = 0; h < this.rules.length; h++) {
        const A = this.rules[h];
        if (typeof A == "string") d += A;
        else if (A) if (T0(A)) {
          const y = A(o);
          typeof y == "string" ? d += y : y != null && y !== !1 && (Rt.env.NODE_ENV === "production" || typeof y != "object" || Array.isArray(y) || Kf(y) || Ml(y) || console.error(`${Od(A)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), d += Ff(tl(y, o, c, s)));
        } else d += Ff(tl(A, o, c, s));
      }
      if (d) {
        this.dynamicNameCache || (this.dynamicNameCache = /* @__PURE__ */ new Map());
        const h = s.hash ? s.hash + d : d;
        let A = this.dynamicNameCache.get(h);
        if (!A) {
          if (A = g0(Nl(Nl(this.baseHash, s.hash), d) >>> 0), this.dynamicNameCache.size >= 200) {
            const y = this.dynamicNameCache.keys().next().value;
            y !== void 0 && this.dynamicNameCache.delete(y);
          }
          this.dynamicNameCache.set(h, A);
        }
        if (!c.hasNameForId(this.componentId, A)) {
          const y = s(d, "." + A, void 0, this.componentId);
          c.insertRules(this.componentId, A, y);
        }
        u = Go(u, A);
      }
    }
    return u;
  }
}
const X3 = /&/g;
function N0(l, o) {
  let c = 0;
  for (; --o >= 0 && l.charCodeAt(o) === 92; ) c++;
  return !(1 & ~c);
}
function wf(l) {
  const o = l.length;
  let c = "", s = 0, u = 0, d = 0, h = !1, A = !1;
  for (let y = 0; y < o; y++) {
    const S = l.charCodeAt(y);
    if (d !== 0 || h || S !== xl || l.charCodeAt(y + 1) !== 42) if (h) S === 42 && l.charCodeAt(y + 1) === xl && (h = !1, y++);
    else if (S !== 34 && S !== 39 || N0(l, y)) {
      if (d === 0) if (S === 123) u++;
      else if (S === 125) {
        if (u--, u < 0) {
          A = !0;
          let B = y + 1;
          for (; B < o; ) {
            const w = l.charCodeAt(B);
            if (w === 59 || w === 10) break;
            B++;
          }
          B < o && l.charCodeAt(B) === 59 && B++, u = 0, y = B - 1, s = B;
          continue;
        }
        u === 0 && (c += l.substring(s, y + 1), s = y + 1);
      } else S === 59 && u === 0 && (c += l.substring(s, y + 1), s = y + 1);
    } else d === 0 ? d = S : d === S && (d = 0);
    else h = !0, y++;
  }
  return A || u !== 0 || d !== 0 ? (s < o && u === 0 && d === 0 && (c += l.substring(s)), c) : l;
}
function w0(l, o) {
  const c = o + " ", s = "," + c;
  for (let u = 0; u < l.length; u++) {
    const d = l[u];
    if (d.type === "rule") {
      d.value = (c + d.value).replaceAll(",", s);
      const h = d.props, A = [];
      for (let y = 0; y < h.length; y++) A[y] = c + h[y];
      d.props = A;
    }
    Array.isArray(d.children) && d.type !== "@keyframes" && w0(d.children, o);
  }
  return l;
}
function Q3({ options: l = Ri, plugins: o = Sd } = Ri) {
  let c, s, u;
  const d = (C, _, H) => H.startsWith(s) && H.endsWith(s) && H.replaceAll(s, "").length > 0 ? `.${c}` : C, h = o.slice();
  h.push((C) => {
    C.type === Ic && C.value.includes("&") && (u || (u = new RegExp(`\\${s}\\b`, "g")), C.props[0] = C.props[0].replace(X3, s).replace(u, d));
  }), l.prefix && h.push(t3), h.push(Jb);
  let A = [];
  const y = _b(h.concat($b((C) => A.push(C)))), S = (C, _ = "", H = "", G = "&") => {
    c = G, s = _, u = void 0;
    const F = (function(X) {
      const nt = X.indexOf("//") !== -1, ot = X.indexOf("}") !== -1;
      if (!nt && !ot) return X;
      if (!nt) return wf(X);
      const I = X.length;
      let k = "", Y = 0, Z = 0, ct = 0, wt = 0, At = 0, Gt = !1;
      for (; Z < I; ) {
        const Tt = X.charCodeAt(Z);
        if (Tt !== 34 && Tt !== 39 || N0(X, Z)) if (ct === 0) if (Tt === xl && Z + 1 < I && X.charCodeAt(Z + 1) === 42) {
          for (Z += 2; Z + 1 < I && (X.charCodeAt(Z) !== 42 || X.charCodeAt(Z + 1) !== xl); ) Z++;
          Z += 2;
        } else if (Tt !== 40) if (Tt !== 41) if (wt > 0) Z++;
        else if (Tt === 42 && Z + 1 < I && X.charCodeAt(Z + 1) === xl) k += X.substring(Y, Z), Z += 2, Y = Z, Gt = !0;
        else if (Tt === xl && Z + 1 < I && X.charCodeAt(Z + 1) === xl) {
          for (k += X.substring(Y, Z); Z < I && X.charCodeAt(Z) !== 10; ) Z++;
          Y = Z, Gt = !0;
        } else Tt === 123 ? At++ : Tt === 125 && At--, Z++;
        else wt > 0 && wt--, Z++;
        else wt++, Z++;
        else Z++;
        else ct === 0 ? ct = Tt : ct === Tt && (ct = 0), Z++;
      }
      return Gt ? (Y < I && (k += X.substring(Y)), At === 0 ? k : wf(k)) : At === 0 ? X : wf(X);
    })(C);
    let K = Pb(H || _ ? H + " " + _ + " { " + F + " }" : F);
    return l.namespace && (K = w0(K, l.namespace)), A = [], jc(K, y), A;
  }, B = l;
  let w = If;
  for (let C = 0; C < o.length; C++) o[C].name || Jo(15), w = Nl(w, o[C].name);
  return B != null && B.namespace && (w = Nl(w, B.namespace)), B != null && B.prefix && (w = Nl(w, "p")), S.hash = w !== If ? w.toString() : "", S;
}
const V3 = new $o(), G3 = Q3(), D0 = Pt.createContext({ shouldForwardProp: void 0, styleSheet: V3, stylis: G3, stylisPlugins: void 0 });
D0.Consumer;
function B0() {
  return Pt.useContext(D0);
}
const Td = Pt.createContext(void 0);
Td.Consumer;
const rp = Object.prototype.hasOwnProperty, Df = {};
function Y3(l, o) {
  const c = typeof l != "string" ? "sc" : h0(l);
  Df[c] = (Df[c] || 0) + 1;
  const s = c + "-" + p0(Kc + c + Df[c]);
  return o ? o + "-" + s : s;
}
let Bf;
function I3(l, o, c) {
  const s = Ed(l), u = l, d = !zc(l), { attrs: h = Sd, componentId: A = Y3(o.displayName, o.parentComponentId), displayName: y = f3(l) } = o, S = o.displayName && o.componentId ? h0(o.displayName) + "-" + o.componentId : o.componentId || A, B = s && u.attrs ? u.attrs.concat(h).filter(Boolean) : h;
  let { shouldForwardProp: w } = o;
  if (s && u.shouldForwardProp) {
    const G = u.shouldForwardProp;
    if (o.shouldForwardProp) {
      const F = o.shouldForwardProp;
      w = (K, X) => G(K, X) && F(K, X);
    } else w = G;
  }
  const C = new j3(c, S, s ? u.componentStyle : void 0);
  function _(G, F) {
    return (function(K, X, nt) {
      const { attrs: ot, componentStyle: I, defaultProps: k, foldedComponentIds: Y, styledComponentId: Z, target: ct } = K, wt = Pt.useContext(Td), At = B0(), Gt = K.shouldForwardProp || At.shouldForwardProp;
      Rt.env.NODE_ENV !== "production" && Pt.useDebugValue && Pt.useDebugValue(Z);
      const Tt = m0(X, wt, k) || Ri;
      let St, xt;
      {
        const ut = Pt.useRef(null), ht = ut.current;
        if (ht !== null && ht[1] === Tt && ht[2] === At.styleSheet && ht[3] === At.stylis && ht[7] === I && (function(Wt, Ct, lt) {
          const W = Wt, Ot = Ct;
          let Mt = 0;
          for (const me in Ot) if (rp.call(Ot, me) && (Mt++, W[me] !== Ot[me])) return !1;
          return Mt === lt;
        })(ht[0], X, ht[4])) St = ht[5], xt = ht[6];
        else {
          St = (function(Ct, lt, W) {
            const Ot = Object.assign(Object.assign({}, lt), { className: void 0, theme: W }), Mt = Ct.length > 1;
            for (let me = 0; me < Ct.length; me++) {
              const Ut = Ct[me], we = _o(Ut) ? Ut(Mt ? Object.assign({}, Ot) : Ot) : Ut;
              for (const ie in we) ie === "className" ? Ot.className = Go(Ot.className, we[ie]) : ie === "style" ? Ot.style = Object.assign(Object.assign({}, Ot.style), we[ie]) : ie in lt && lt[ie] === void 0 || (Ot[ie] = we[ie]);
            }
            return "className" in lt && typeof lt.className == "string" && (Ot.className = Go(Ot.className, lt.className)), Ot;
          })(ot, X, Tt), xt = (function(Ct, lt, W, Ot) {
            const Mt = Ct.generateAndInjectStyles(lt, W, Ot);
            return Rt.env.NODE_ENV !== "production" && Pt.useDebugValue && Pt.useDebugValue(Mt), Mt;
          })(I, St, At.styleSheet, At.stylis);
          let Wt = 0;
          for (const Ct in X) rp.call(X, Ct) && Wt++;
          ut.current = [X, Tt, At.styleSheet, At.stylis, Wt, St, xt, I];
        }
      }
      Rt.env.NODE_ENV !== "production" && K.warnTooManyClasses && K.warnTooManyClasses(xt);
      const V = St.as || ct, j = (function(ut, ht, Wt, Ct) {
        const lt = {};
        for (const W in ut) ut[W] === void 0 || W[0] === "$" || W === "as" || W === "theme" && ut.theme === Wt || (W === "forwardedAs" ? lt.as = ut.forwardedAs : Ct && !Ct(W, ht) || (lt[W] = ut[W], Ct || Rt.env.NODE_ENV !== "development" || Ub(W) || (Bf || (Bf = /* @__PURE__ */ new Set())).has(W) || !zc(ht) || ht.includes("-") || (Bf.add(W), console.warn(`styled-components: it looks like an unknown prop "${W}" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via \`<StyleSheetManager shouldForwardProp={...}>\` (connect an API like \`@emotion/is-prop-valid\`) or consider using transient props (\`$\` prefix for automatic filtering.)`))));
        return lt;
      })(St, V, Tt, Gt);
      let q = Go(Y, Z);
      return xt && (q += " " + xt), St.className && (q += " " + St.className), j[zc(V) && V.includes("-") ? "class" : "className"] = q, nt && (j.ref = nt), Zp(V, j);
    })(H, G, F);
  }
  _.displayName = y;
  let H = Pt.forwardRef(_);
  return H.attrs = B, H.componentStyle = C, H.displayName = y, H.shouldForwardProp = w, H.foldedComponentIds = s ? Go(u.foldedComponentIds, u.styledComponentId) : "", H.styledComponentId = S, H.target = s ? u.target : l, Object.defineProperty(H, "defaultProps", { get() {
    return this._foldedDefaultProps;
  }, set(G) {
    this._foldedDefaultProps = s ? (function(F, ...K) {
      for (const X of K) kf(F, X, !0);
      return F;
    })({}, u.defaultProps, G) : G;
  } }), Rt.env.NODE_ENV !== "production" && (d0(y, S), H.warnTooManyClasses = /* @__PURE__ */ ((G, F) => {
    let K = {}, X = !1;
    return (nt) => {
      !X && (K[nt] = !0, Object.keys(K).length >= 200) && (console.warn(`Over 200 classes were generated for component ${G}${F ? ` with the id of "${F}"` : ""}.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), X = !0, K = {});
    };
  })(y, S)), S0(H, () => `.${H.styledComponentId}`), d && b0(H, l, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), H;
}
var F3 = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]);
function cp(l, o) {
  const c = [l[0]];
  for (let s = 0, u = o.length; s < u; s += 1) c.push(o[s], l[s + 1]);
  return c;
}
const up = (l) => (E0.add(l), l);
function Zc(l, ...o) {
  if (_o(l) || Ml(l)) return up(tl(cp(Sd, [l, ...o])));
  const c = l;
  return o.length === 0 && c.length === 1 && typeof c[0] == "string" ? tl(c) : up(tl(cp(c, o)));
}
function Zf(l, o, c = Ri) {
  if (!o) throw Jo(1, o);
  const s = (u, ...d) => l(o, c, Zc(u, ...d));
  return s.attrs = (u) => Zf(l, o, Object.assign(Object.assign({}, c), { attrs: Array.prototype.concat(c.attrs, u).filter(Boolean) })), s.withConfig = (u) => Zf(l, o, Object.assign(Object.assign({}, c), u)), s;
}
const M0 = (l) => Zf(I3, l), ze = M0;
F3.forEach((l) => {
  ze[l] = M0(l);
});
class k3 {
  constructor(o, c) {
    this.instanceRules = /* @__PURE__ */ new Map(), this.rules = o, this.componentId = c, this.isStatic = (function(s) {
      for (let u = 0; u < s.length; u += 1) {
        const d = s[u];
        if (_o(d) && !Ed(d)) return !1;
      }
      return !0;
    })(o), $o.registerId(this.componentId);
  }
  removeStyles(o, c) {
    this.instanceRules.delete(o), this.rebuildGroup(c);
  }
  renderStyles(o, c, s, u) {
    const d = this.componentId;
    if (this.isStatic) {
      if (s.hasNameForId(d, d + o)) this.instanceRules.has(o) || this.computeRules(o, c, s, u);
      else {
        const A = this.computeRules(o, c, s, u);
        s.insertRules(d, A.name, A.rules);
      }
      return;
    }
    const h = this.instanceRules.get(o);
    if (this.computeRules(o, c, s, u), !s.server && h) {
      const A = h.rules, y = this.instanceRules.get(o).rules;
      if (A.length === y.length) {
        let S = !0;
        for (let B = 0; B < A.length; B++) if (A[B] !== y[B]) {
          S = !1;
          break;
        }
        if (S) return;
      }
    }
    this.rebuildGroup(s);
  }
  computeRules(o, c, s, u) {
    const d = Ff(tl(this.rules, c, s, u)), h = { name: this.componentId + o, rules: u(d, "") };
    return this.instanceRules.set(o, h), h;
  }
  rebuildGroup(o) {
    const c = this.componentId;
    o.clearRules(c);
    for (const s of this.instanceRules.values()) o.insertRules(c, s.name, s.rules);
  }
}
function q3(l, ...o) {
  const c = Zc(l, ...o), s = `sc-global-${p0(JSON.stringify(c))}`, u = new k3(c, s);
  Rt.env.NODE_ENV !== "production" && d0(s);
  const d = (A) => {
    const y = B0(), S = Pt.useContext(Td);
    let B;
    {
      const w = Pt.useRef(null);
      w.current === null && (w.current = y.styleSheet.allocateGSInstance(s)), B = w.current;
    }
    Rt.env.NODE_ENV !== "production" && Pt.Children.count(A.children) && console.warn(`The global style component ${s} was given child JSX. createGlobalStyle does not render children.`), Rt.env.NODE_ENV !== "production" && c.some((w) => typeof w == "string" && w.indexOf("@import") !== -1) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), y.styleSheet.server && h(B, A, y.styleSheet, S, y.stylis);
    {
      const w = u.isStatic ? [B, y.styleSheet, u] : [B, A, y.styleSheet, S, y.stylis, u], C = Pt.useRef(u);
      Pt.useLayoutEffect(() => {
        y.styleSheet.server || (C.current !== u && (y.styleSheet.clearRules(s), C.current = u), h(B, A, y.styleSheet, S, y.stylis));
      }, w), Pt.useLayoutEffect(() => () => {
        y.styleSheet.server || u.removeStyles(B, y.styleSheet);
      }, [B, y.styleSheet, u]);
    }
    return y.styleSheet.server && u.instanceRules.delete(B), null;
  };
  function h(A, y, S, B, w) {
    if (u.isStatic) u.renderStyles(A, a3, S, w);
    else {
      const C = Object.assign(Object.assign({}, y), { theme: m0(y, B, d.defaultProps) });
      u.renderStyles(A, C, S, w);
    }
  }
  return Pt.memo(d);
}
Rt.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://styled-components.com/docs/basics#react-native`);
const Tc = `__sc-${Bl}__`;
Rt.env.NODE_ENV !== "production" && Rt.env.NODE_ENV !== "test" && typeof window < "u" && (window[Tc] || (window[Tc] = 0), window[Tc] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[Tc] += 1);
const xd = "#8c1d40", Cd = "#ffc627", Kn = "#ffffff", sp = "#000000", tn = "#191919", Rc = "#BFBFBF", $e = "#d0d0d0", K3 = "#e8e8e8", Z3 = "#bfbfbf", P3 = "#495057", W3 = ze.a`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  color: ${tn};
  padding: 0.5rem 1rem;
  border-radius: 400rem;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  transition: 0.03s ease-in-out;
  cursor: pointer;
  & + a {
    margin-left: 1rem;
  }
  &:hover {
    transform: scale(1.05);
  }
  &.button-light {
    background-color: ${Z3} !important;
    color: ${sp} !important;
  }
  &.button-gold {
    background-color: ${Cd} !important;
    color: ${sp} !important;
  }
  &.button-dark {
    background-color: ${tn} !important;
    color: ${Kn} !important;
  }
  &.button-maroon {
    background-color: ${xd} !important;
    color: ${Kn} !important;
  }
`, ji = ({
  href: l,
  color: o,
  text: c,
  classes: s,
  onClick: u,
  onKeyDown: d,
  onFocus: h,
  as: A,
  ...y
}) => /* @__PURE__ */ b.jsx(
  W3,
  {
    href: l,
    className: `button-${o} ${s ?? ""}`,
    onClick: u,
    onKeyDown: d,
    onFocus: h,
    as: A,
    ...y,
    children: c
  }
);
ji.propTypes = { ...Yc };
const J3 = {
  prefix: "fas",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
}, _3 = J3, $3 = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, Pf = $3, L0 = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, tS = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, eS = tS;
var nS = { env: { NODE_ENV: "production" } };
function aS(l, o, c) {
  return (o = iS(o)) in l ? Object.defineProperty(l, o, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : l[o] = c, l;
}
function fp(l, o) {
  var c = Object.keys(l);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(l);
    o && (s = s.filter(function(u) {
      return Object.getOwnPropertyDescriptor(l, u).enumerable;
    })), c.push.apply(c, s);
  }
  return c;
}
function Q(l) {
  for (var o = 1; o < arguments.length; o++) {
    var c = arguments[o] != null ? arguments[o] : {};
    o % 2 ? fp(Object(c), !0).forEach(function(s) {
      aS(l, s, c[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(c)) : fp(Object(c)).forEach(function(s) {
      Object.defineProperty(l, s, Object.getOwnPropertyDescriptor(c, s));
    });
  }
  return l;
}
function lS(l, o) {
  if (typeof l != "object" || !l) return l;
  var c = l[Symbol.toPrimitive];
  if (c !== void 0) {
    var s = c.call(l, o);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(l);
}
function iS(l) {
  var o = lS(l, "string");
  return typeof o == "symbol" ? o : o + "";
}
const dp = () => {
};
let Nd = {}, z0 = {}, R0 = null, U0 = {
  mark: dp,
  measure: dp
};
try {
  typeof window < "u" && (Nd = window), typeof document < "u" && (z0 = document), typeof MutationObserver < "u" && (R0 = MutationObserver), typeof performance < "u" && (U0 = performance);
} catch {
}
const {
  userAgent: mp = ""
} = Nd.navigator || {}, el = Nd, Kt = z0, hp = R0, xc = U0;
el.document;
const va = !!Kt.documentElement && !!Kt.head && typeof Kt.addEventListener == "function" && typeof Kt.createElement == "function", H0 = ~mp.indexOf("MSIE") || ~mp.indexOf("Trident/");
var oS = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, rS = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, j0 = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, cS = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, X0 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], Ne = "classic", Pc = "duotone", uS = "sharp", sS = "sharp-duotone", Q0 = [Ne, Pc, uS, sS], fS = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, dS = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, mS = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), hS = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, gS = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], gp = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, AS = ["kit"], pS = {
  kit: {
    "fa-kit": "fak"
  }
}, yS = ["fak", "fakd"], vS = {
  kit: {
    fak: "fa-kit"
  }
}, Ap = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Cc = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, bS = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], SS = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], OS = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, ES = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, TS = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, Wf = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, xS = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Jf = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...bS, ...xS], CS = ["solid", "regular", "light", "thin", "duotone", "brands"], V0 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], NS = V0.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), wS = [...Object.keys(TS), ...CS, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Cc.GROUP, Cc.SWAP_OPACITY, Cc.PRIMARY, Cc.SECONDARY].concat(V0.map((l) => "".concat(l, "x"))).concat(NS.map((l) => "w-".concat(l))), DS = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const pa = "___FONT_AWESOME___", _f = 16, G0 = "fa", Y0 = "svg-inline--fa", Ll = "data-fa-i2svg", $f = "data-fa-pseudo-element", BS = "data-fa-pseudo-element-pending", wd = "data-prefix", Dd = "data-icon", pp = "fontawesome-i2svg", MS = "async", LS = ["HTML", "HEAD", "STYLE", "SCRIPT"], I0 = (() => {
  try {
    return nS.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function tr(l) {
  return new Proxy(l, {
    get(o, c) {
      return c in o ? o[c] : o[Ne];
    }
  });
}
const F0 = Q({}, j0);
F0[Ne] = Q(Q(Q(Q({}, {
  "fa-duotone": "duotone"
}), j0[Ne]), gp.kit), gp["kit-duotone"]);
const zS = tr(F0), td = Q({}, hS);
td[Ne] = Q(Q(Q(Q({}, {
  duotone: "fad"
}), td[Ne]), Ap.kit), Ap["kit-duotone"]);
const yp = tr(td), ed = Q({}, Wf);
ed[Ne] = Q(Q({}, ed[Ne]), vS.kit);
const Bd = tr(ed), nd = Q({}, ES);
nd[Ne] = Q(Q({}, nd[Ne]), pS.kit);
tr(nd);
const RS = oS, k0 = "fa-layers-text", US = rS, HS = Q({}, fS);
tr(HS);
const jS = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Mf = cS, XS = [...AS, ...wS], ko = el.FontAwesomeConfig || {};
function QS(l) {
  var o = Kt.querySelector("script[" + l + "]");
  if (o)
    return o.getAttribute(l);
}
function VS(l) {
  return l === "" ? !0 : l === "false" ? !1 : l === "true" ? !0 : l;
}
Kt && typeof Kt.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((o) => {
  let [c, s] = o;
  const u = VS(QS(c));
  u != null && (ko[s] = u);
});
const q0 = {
  styleDefault: "solid",
  familyDefault: Ne,
  cssPrefix: G0,
  replacementClass: Y0,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
ko.familyPrefix && (ko.cssPrefix = ko.familyPrefix);
const Ui = Q(Q({}, q0), ko);
Ui.autoReplaceSvg || (Ui.observeMutations = !1);
const et = {};
Object.keys(q0).forEach((l) => {
  Object.defineProperty(et, l, {
    enumerable: !0,
    set: function(o) {
      Ui[l] = o, qo.forEach((c) => c(et));
    },
    get: function() {
      return Ui[l];
    }
  });
});
Object.defineProperty(et, "familyPrefix", {
  enumerable: !0,
  set: function(l) {
    Ui.cssPrefix = l, qo.forEach((o) => o(et));
  },
  get: function() {
    return Ui.cssPrefix;
  }
});
el.FontAwesomeConfig = et;
const qo = [];
function GS(l) {
  return qo.push(l), () => {
    qo.splice(qo.indexOf(l), 1);
  };
}
const Wa = _f, kn = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function YS(l) {
  if (!l || !va)
    return;
  const o = Kt.createElement("style");
  o.setAttribute("type", "text/css"), o.innerHTML = l;
  const c = Kt.head.childNodes;
  let s = null;
  for (let u = c.length - 1; u > -1; u--) {
    const d = c[u], h = (d.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(h) > -1 && (s = d);
  }
  return Kt.head.insertBefore(o, s), l;
}
const IS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Zo() {
  let l = 12, o = "";
  for (; l-- > 0; )
    o += IS[Math.random() * 62 | 0];
  return o;
}
function Xi(l) {
  const o = [];
  for (let c = (l || []).length >>> 0; c--; )
    o[c] = l[c];
  return o;
}
function Md(l) {
  return l.classList ? Xi(l.classList) : (l.getAttribute("class") || "").split(" ").filter((o) => o);
}
function K0(l) {
  return "".concat(l).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function FS(l) {
  return Object.keys(l || {}).reduce((o, c) => o + "".concat(c, '="').concat(K0(l[c]), '" '), "").trim();
}
function Wc(l) {
  return Object.keys(l || {}).reduce((o, c) => o + "".concat(c, ": ").concat(l[c].trim(), ";"), "");
}
function Ld(l) {
  return l.size !== kn.size || l.x !== kn.x || l.y !== kn.y || l.rotate !== kn.rotate || l.flipX || l.flipY;
}
function kS(l) {
  let {
    transform: o,
    containerWidth: c,
    iconWidth: s
  } = l;
  const u = {
    transform: "translate(".concat(c / 2, " 256)")
  }, d = "translate(".concat(o.x * 32, ", ").concat(o.y * 32, ") "), h = "scale(".concat(o.size / 16 * (o.flipX ? -1 : 1), ", ").concat(o.size / 16 * (o.flipY ? -1 : 1), ") "), A = "rotate(".concat(o.rotate, " 0 0)"), y = {
    transform: "".concat(d, " ").concat(h, " ").concat(A)
  }, S = {
    transform: "translate(".concat(s / 2 * -1, " -256)")
  };
  return {
    outer: u,
    inner: y,
    path: S
  };
}
function qS(l) {
  let {
    transform: o,
    width: c = _f,
    height: s = _f,
    startCentered: u = !1
  } = l, d = "";
  return u && H0 ? d += "translate(".concat(o.x / Wa - c / 2, "em, ").concat(o.y / Wa - s / 2, "em) ") : u ? d += "translate(calc(-50% + ".concat(o.x / Wa, "em), calc(-50% + ").concat(o.y / Wa, "em)) ") : d += "translate(".concat(o.x / Wa, "em, ").concat(o.y / Wa, "em) "), d += "scale(".concat(o.size / Wa * (o.flipX ? -1 : 1), ", ").concat(o.size / Wa * (o.flipY ? -1 : 1), ") "), d += "rotate(".concat(o.rotate, "deg) "), d;
}
var KS = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function Z0() {
  const l = G0, o = Y0, c = et.cssPrefix, s = et.replacementClass;
  let u = KS;
  if (c !== l || s !== o) {
    const d = new RegExp("\\.".concat(l, "\\-"), "g"), h = new RegExp("\\--".concat(l, "\\-"), "g"), A = new RegExp("\\.".concat(o), "g");
    u = u.replace(d, ".".concat(c, "-")).replace(h, "--".concat(c, "-")).replace(A, ".".concat(s));
  }
  return u;
}
let vp = !1;
function Lf() {
  et.autoAddCss && !vp && (YS(Z0()), vp = !0);
}
var ZS = {
  mixout() {
    return {
      dom: {
        css: Z0,
        insertCss: Lf
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        Lf();
      },
      beforeI2svg() {
        Lf();
      }
    };
  }
};
const ya = el || {};
ya[pa] || (ya[pa] = {});
ya[pa].styles || (ya[pa].styles = {});
ya[pa].hooks || (ya[pa].hooks = {});
ya[pa].shims || (ya[pa].shims = []);
var qn = ya[pa];
const P0 = [], W0 = function() {
  Kt.removeEventListener("DOMContentLoaded", W0), Qc = 1, P0.map((l) => l());
};
let Qc = !1;
va && (Qc = (Kt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Kt.readyState), Qc || Kt.addEventListener("DOMContentLoaded", W0));
function PS(l) {
  va && (Qc ? setTimeout(l, 0) : P0.push(l));
}
function er(l) {
  const {
    tag: o,
    attributes: c = {},
    children: s = []
  } = l;
  return typeof l == "string" ? K0(l) : "<".concat(o, " ").concat(FS(c), ">").concat(s.map(er).join(""), "</").concat(o, ">");
}
function bp(l, o, c) {
  if (l && l[o] && l[o][c])
    return {
      prefix: o,
      iconName: c,
      icon: l[o][c]
    };
}
var zf = function(o, c, s, u) {
  var d = Object.keys(o), h = d.length, A = c, y, S, B;
  for (s === void 0 ? (y = 1, B = o[d[0]]) : (y = 0, B = s); y < h; y++)
    S = d[y], B = A(B, o[S], S, o);
  return B;
};
function WS(l) {
  const o = [];
  let c = 0;
  const s = l.length;
  for (; c < s; ) {
    const u = l.charCodeAt(c++);
    if (u >= 55296 && u <= 56319 && c < s) {
      const d = l.charCodeAt(c++);
      (d & 64512) == 56320 ? o.push(((u & 1023) << 10) + (d & 1023) + 65536) : (o.push(u), c--);
    } else
      o.push(u);
  }
  return o;
}
function ad(l) {
  const o = WS(l);
  return o.length === 1 ? o[0].toString(16) : null;
}
function JS(l, o) {
  const c = l.length;
  let s = l.charCodeAt(o), u;
  return s >= 55296 && s <= 56319 && c > o + 1 && (u = l.charCodeAt(o + 1), u >= 56320 && u <= 57343) ? (s - 55296) * 1024 + u - 56320 + 65536 : s;
}
function Sp(l) {
  return Object.keys(l).reduce((o, c) => {
    const s = l[c];
    return !!s.icon ? o[s.iconName] = s.icon : o[c] = s, o;
  }, {});
}
function ld(l, o) {
  let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: s = !1
  } = c, u = Sp(o);
  typeof qn.hooks.addPack == "function" && !s ? qn.hooks.addPack(l, Sp(o)) : qn.styles[l] = Q(Q({}, qn.styles[l] || {}), u), l === "fas" && ld("fa", o);
}
const {
  styles: Po,
  shims: _S
} = qn, J0 = Object.keys(Bd), $S = J0.reduce((l, o) => (l[o] = Object.keys(Bd[o]), l), {});
let zd = null, _0 = {}, $0 = {}, t1 = {}, e1 = {}, n1 = {};
function tO(l) {
  return ~XS.indexOf(l);
}
function eO(l, o) {
  const c = o.split("-"), s = c[0], u = c.slice(1).join("-");
  return s === l && u !== "" && !tO(u) ? u : null;
}
const a1 = () => {
  const l = (s) => zf(Po, (u, d, h) => (u[h] = zf(d, s, {}), u), {});
  _0 = l((s, u, d) => (u[3] && (s[u[3]] = d), u[2] && u[2].filter((A) => typeof A == "number").forEach((A) => {
    s[A.toString(16)] = d;
  }), s)), $0 = l((s, u, d) => (s[d] = d, u[2] && u[2].filter((A) => typeof A == "string").forEach((A) => {
    s[A] = d;
  }), s)), n1 = l((s, u, d) => {
    const h = u[2];
    return s[d] = d, h.forEach((A) => {
      s[A] = d;
    }), s;
  });
  const o = "far" in Po || et.autoFetchSvg, c = zf(_S, (s, u) => {
    const d = u[0];
    let h = u[1];
    const A = u[2];
    return h === "far" && !o && (h = "fas"), typeof d == "string" && (s.names[d] = {
      prefix: h,
      iconName: A
    }), typeof d == "number" && (s.unicodes[d.toString(16)] = {
      prefix: h,
      iconName: A
    }), s;
  }, {
    names: {},
    unicodes: {}
  });
  t1 = c.names, e1 = c.unicodes, zd = Jc(et.styleDefault, {
    family: et.familyDefault
  });
};
GS((l) => {
  zd = Jc(l.styleDefault, {
    family: et.familyDefault
  });
});
a1();
function Rd(l, o) {
  return (_0[l] || {})[o];
}
function nO(l, o) {
  return ($0[l] || {})[o];
}
function Cl(l, o) {
  return (n1[l] || {})[o];
}
function l1(l) {
  return t1[l] || {
    prefix: null,
    iconName: null
  };
}
function aO(l) {
  const o = e1[l], c = Rd("fas", l);
  return o || (c ? {
    prefix: "fas",
    iconName: c
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function nl() {
  return zd;
}
const i1 = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function lO(l) {
  let o = Ne;
  const c = J0.reduce((s, u) => (s[u] = "".concat(et.cssPrefix, "-").concat(u), s), {});
  return Q0.forEach((s) => {
    (l.includes(c[s]) || l.some((u) => $S[s].includes(u))) && (o = s);
  }), o;
}
function Jc(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: c = Ne
  } = o, s = zS[c][l];
  if (c === Pc && !l)
    return "fad";
  const u = yp[c][l] || yp[c][s], d = l in qn.styles ? l : null;
  return u || d || null;
}
function iO(l) {
  let o = [], c = null;
  return l.forEach((s) => {
    const u = eO(et.cssPrefix, s);
    u ? c = u : s && o.push(s);
  }), {
    iconName: c,
    rest: o
  };
}
function Op(l) {
  return l.sort().filter((o, c, s) => s.indexOf(o) === c);
}
function _c(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: c = !1
  } = o;
  let s = null;
  const u = Jf.concat(SS), d = Op(l.filter((w) => u.includes(w))), h = Op(l.filter((w) => !Jf.includes(w))), A = d.filter((w) => (s = w, !X0.includes(w))), [y = null] = A, S = lO(d), B = Q(Q({}, iO(h)), {}, {
    prefix: Jc(y, {
      family: S
    })
  });
  return Q(Q(Q({}, B), uO({
    values: l,
    family: S,
    styles: Po,
    config: et,
    canonical: B,
    givenPrefix: s
  })), oO(c, s, B));
}
function oO(l, o, c) {
  let {
    prefix: s,
    iconName: u
  } = c;
  if (l || !s || !u)
    return {
      prefix: s,
      iconName: u
    };
  const d = o === "fa" ? l1(u) : {}, h = Cl(s, u);
  return u = d.iconName || h || u, s = d.prefix || s, s === "far" && !Po.far && Po.fas && !et.autoFetchSvg && (s = "fas"), {
    prefix: s,
    iconName: u
  };
}
const rO = Q0.filter((l) => l !== Ne || l !== Pc), cO = Object.keys(Wf).filter((l) => l !== Ne).map((l) => Object.keys(Wf[l])).flat();
function uO(l) {
  const {
    values: o,
    family: c,
    canonical: s,
    givenPrefix: u = "",
    styles: d = {},
    config: h = {}
  } = l, A = c === Pc, y = o.includes("fa-duotone") || o.includes("fad"), S = h.familyDefault === "duotone", B = s.prefix === "fad" || s.prefix === "fa-duotone";
  if (!A && (y || S || B) && (s.prefix = "fad"), (o.includes("fa-brands") || o.includes("fab")) && (s.prefix = "fab"), !s.prefix && rO.includes(c) && (Object.keys(d).find((C) => cO.includes(C)) || h.autoFetchSvg)) {
    const C = mS.get(c).defaultShortPrefixId;
    s.prefix = C, s.iconName = Cl(s.prefix, s.iconName) || s.iconName;
  }
  return (s.prefix === "fa" || u === "fa") && (s.prefix = nl() || "fas"), s;
}
class sO {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var o = arguments.length, c = new Array(o), s = 0; s < o; s++)
      c[s] = arguments[s];
    const u = c.reduce(this._pullDefinitions, {});
    Object.keys(u).forEach((d) => {
      this.definitions[d] = Q(Q({}, this.definitions[d] || {}), u[d]), ld(d, u[d]);
      const h = Bd[Ne][d];
      h && ld(h, u[d]), a1();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(o, c) {
    const s = c.prefix && c.iconName && c.icon ? {
      0: c
    } : c;
    return Object.keys(s).map((u) => {
      const {
        prefix: d,
        iconName: h,
        icon: A
      } = s[u], y = A[2];
      o[d] || (o[d] = {}), y.length > 0 && y.forEach((S) => {
        typeof S == "string" && (o[d][S] = A);
      }), o[d][h] = A;
    }), o;
  }
}
let Ep = [], Mi = {};
const Li = {}, fO = Object.keys(Li);
function dO(l, o) {
  let {
    mixoutsTo: c
  } = o;
  return Ep = l, Mi = {}, Object.keys(Li).forEach((s) => {
    fO.indexOf(s) === -1 && delete Li[s];
  }), Ep.forEach((s) => {
    const u = s.mixout ? s.mixout() : {};
    if (Object.keys(u).forEach((d) => {
      typeof u[d] == "function" && (c[d] = u[d]), typeof u[d] == "object" && Object.keys(u[d]).forEach((h) => {
        c[d] || (c[d] = {}), c[d][h] = u[d][h];
      });
    }), s.hooks) {
      const d = s.hooks();
      Object.keys(d).forEach((h) => {
        Mi[h] || (Mi[h] = []), Mi[h].push(d[h]);
      });
    }
    s.provides && s.provides(Li);
  }), c;
}
function id(l, o) {
  for (var c = arguments.length, s = new Array(c > 2 ? c - 2 : 0), u = 2; u < c; u++)
    s[u - 2] = arguments[u];
  return (Mi[l] || []).forEach((h) => {
    o = h.apply(null, [o, ...s]);
  }), o;
}
function zl(l) {
  for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
    c[s - 1] = arguments[s];
  (Mi[l] || []).forEach((d) => {
    d.apply(null, c);
  });
}
function al() {
  const l = arguments[0], o = Array.prototype.slice.call(arguments, 1);
  return Li[l] ? Li[l].apply(null, o) : void 0;
}
function od(l) {
  l.prefix === "fa" && (l.prefix = "fas");
  let {
    iconName: o
  } = l;
  const c = l.prefix || nl();
  if (o)
    return o = Cl(c, o) || o, bp(o1.definitions, c, o) || bp(qn.styles, c, o);
}
const o1 = new sO(), mO = () => {
  et.autoReplaceSvg = !1, et.observeMutations = !1, zl("noAuto");
}, hO = {
  i2svg: function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return va ? (zl("beforeI2svg", l), al("pseudoElements2svg", l), al("i2svg", l)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: o
    } = l;
    et.autoReplaceSvg === !1 && (et.autoReplaceSvg = !0), et.observeMutations = !0, PS(() => {
      AO({
        autoReplaceSvgRoot: o
      }), zl("watch", l);
    });
  }
}, gO = {
  icon: (l) => {
    if (l === null)
      return null;
    if (typeof l == "object" && l.prefix && l.iconName)
      return {
        prefix: l.prefix,
        iconName: Cl(l.prefix, l.iconName) || l.iconName
      };
    if (Array.isArray(l) && l.length === 2) {
      const o = l[1].indexOf("fa-") === 0 ? l[1].slice(3) : l[1], c = Jc(l[0]);
      return {
        prefix: c,
        iconName: Cl(c, o) || o
      };
    }
    if (typeof l == "string" && (l.indexOf("".concat(et.cssPrefix, "-")) > -1 || l.match(RS))) {
      const o = _c(l.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: o.prefix || nl(),
        iconName: Cl(o.prefix, o.iconName) || o.iconName
      };
    }
    if (typeof l == "string") {
      const o = nl();
      return {
        prefix: o,
        iconName: Cl(o, l) || l
      };
    }
  }
}, en = {
  noAuto: mO,
  config: et,
  dom: hO,
  parse: gO,
  library: o1,
  findIconDefinition: od,
  toHtml: er
}, AO = function() {
  let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: o = Kt
  } = l;
  (Object.keys(qn.styles).length > 0 || et.autoFetchSvg) && va && et.autoReplaceSvg && en.dom.i2svg({
    node: o
  });
};
function $c(l, o) {
  return Object.defineProperty(l, "abstract", {
    get: o
  }), Object.defineProperty(l, "html", {
    get: function() {
      return l.abstract.map((c) => er(c));
    }
  }), Object.defineProperty(l, "node", {
    get: function() {
      if (!va) return;
      const c = Kt.createElement("div");
      return c.innerHTML = l.html, c.children;
    }
  }), l;
}
function pO(l) {
  let {
    children: o,
    main: c,
    mask: s,
    attributes: u,
    styles: d,
    transform: h
  } = l;
  if (Ld(h) && c.found && !s.found) {
    const {
      width: A,
      height: y
    } = c, S = {
      x: A / y / 2,
      y: 0.5
    };
    u.style = Wc(Q(Q({}, d), {}, {
      "transform-origin": "".concat(S.x + h.x / 16, "em ").concat(S.y + h.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: u,
    children: o
  }];
}
function yO(l) {
  let {
    prefix: o,
    iconName: c,
    children: s,
    attributes: u,
    symbol: d
  } = l;
  const h = d === !0 ? "".concat(o, "-").concat(et.cssPrefix, "-").concat(c) : d;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: Q(Q({}, u), {}, {
        id: h
      }),
      children: s
    }]
  }];
}
function Ud(l) {
  const {
    icons: {
      main: o,
      mask: c
    },
    prefix: s,
    iconName: u,
    transform: d,
    symbol: h,
    title: A,
    maskId: y,
    titleId: S,
    extra: B,
    watchable: w = !1
  } = l, {
    width: C,
    height: _
  } = c.found ? c : o, H = yS.includes(s), G = [et.replacementClass, u ? "".concat(et.cssPrefix, "-").concat(u) : ""].filter((I) => B.classes.indexOf(I) === -1).filter((I) => I !== "" || !!I).concat(B.classes).join(" ");
  let F = {
    children: [],
    attributes: Q(Q({}, B.attributes), {}, {
      "data-prefix": s,
      "data-icon": u,
      class: G,
      role: B.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(C, " ").concat(_)
    })
  };
  const K = H && !~B.classes.indexOf("fa-fw") ? {
    width: "".concat(C / _ * 16 * 0.0625, "em")
  } : {};
  w && (F.attributes[Ll] = ""), A && (F.children.push({
    tag: "title",
    attributes: {
      id: F.attributes["aria-labelledby"] || "title-".concat(S || Zo())
    },
    children: [A]
  }), delete F.attributes.title);
  const X = Q(Q({}, F), {}, {
    prefix: s,
    iconName: u,
    main: o,
    mask: c,
    maskId: y,
    transform: d,
    symbol: h,
    styles: Q(Q({}, K), B.styles)
  }), {
    children: nt,
    attributes: ot
  } = c.found && o.found ? al("generateAbstractMask", X) || {
    children: [],
    attributes: {}
  } : al("generateAbstractIcon", X) || {
    children: [],
    attributes: {}
  };
  return X.children = nt, X.attributes = ot, h ? yO(X) : pO(X);
}
function Tp(l) {
  const {
    content: o,
    width: c,
    height: s,
    transform: u,
    title: d,
    extra: h,
    watchable: A = !1
  } = l, y = Q(Q(Q({}, h.attributes), d ? {
    title: d
  } : {}), {}, {
    class: h.classes.join(" ")
  });
  A && (y[Ll] = "");
  const S = Q({}, h.styles);
  Ld(u) && (S.transform = qS({
    transform: u,
    startCentered: !0,
    width: c,
    height: s
  }), S["-webkit-transform"] = S.transform);
  const B = Wc(S);
  B.length > 0 && (y.style = B);
  const w = [];
  return w.push({
    tag: "span",
    attributes: y,
    children: [o]
  }), d && w.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [d]
  }), w;
}
function vO(l) {
  const {
    content: o,
    title: c,
    extra: s
  } = l, u = Q(Q(Q({}, s.attributes), c ? {
    title: c
  } : {}), {}, {
    class: s.classes.join(" ")
  }), d = Wc(s.styles);
  d.length > 0 && (u.style = d);
  const h = [];
  return h.push({
    tag: "span",
    attributes: u,
    children: [o]
  }), c && h.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [c]
  }), h;
}
const {
  styles: Rf
} = qn;
function rd(l) {
  const o = l[0], c = l[1], [s] = l.slice(4);
  let u = null;
  return Array.isArray(s) ? u = {
    tag: "g",
    attributes: {
      class: "".concat(et.cssPrefix, "-").concat(Mf.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(et.cssPrefix, "-").concat(Mf.SECONDARY),
        fill: "currentColor",
        d: s[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(et.cssPrefix, "-").concat(Mf.PRIMARY),
        fill: "currentColor",
        d: s[1]
      }
    }]
  } : u = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: s
    }
  }, {
    found: !0,
    width: o,
    height: c,
    icon: u
  };
}
const bO = {
  found: !1,
  width: 512,
  height: 512
};
function SO(l, o) {
  !I0 && !et.showMissingIcons && l && console.error('Icon with name "'.concat(l, '" and prefix "').concat(o, '" is missing.'));
}
function cd(l, o) {
  let c = o;
  return o === "fa" && et.styleDefault !== null && (o = nl()), new Promise((s, u) => {
    if (c === "fa") {
      const d = l1(l) || {};
      l = d.iconName || l, o = d.prefix || o;
    }
    if (l && o && Rf[o] && Rf[o][l]) {
      const d = Rf[o][l];
      return s(rd(d));
    }
    SO(l, o), s(Q(Q({}, bO), {}, {
      icon: et.showMissingIcons && l ? al("missingIconAbstract") || {} : {}
    }));
  });
}
const xp = () => {
}, ud = et.measurePerformance && xc && xc.mark && xc.measure ? xc : {
  mark: xp,
  measure: xp
}, Yo = 'FA "6.7.2"', OO = (l) => (ud.mark("".concat(Yo, " ").concat(l, " begins")), () => r1(l)), r1 = (l) => {
  ud.mark("".concat(Yo, " ").concat(l, " ends")), ud.measure("".concat(Yo, " ").concat(l), "".concat(Yo, " ").concat(l, " begins"), "".concat(Yo, " ").concat(l, " ends"));
};
var Hd = {
  begin: OO,
  end: r1
};
const Uc = () => {
};
function Cp(l) {
  return typeof (l.getAttribute ? l.getAttribute(Ll) : null) == "string";
}
function EO(l) {
  const o = l.getAttribute ? l.getAttribute(wd) : null, c = l.getAttribute ? l.getAttribute(Dd) : null;
  return o && c;
}
function TO(l) {
  return l && l.classList && l.classList.contains && l.classList.contains(et.replacementClass);
}
function xO() {
  return et.autoReplaceSvg === !0 ? Hc.replace : Hc[et.autoReplaceSvg] || Hc.replace;
}
function CO(l) {
  return Kt.createElementNS("http://www.w3.org/2000/svg", l);
}
function NO(l) {
  return Kt.createElement(l);
}
function c1(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: c = l.tag === "svg" ? CO : NO
  } = o;
  if (typeof l == "string")
    return Kt.createTextNode(l);
  const s = c(l.tag);
  return Object.keys(l.attributes || []).forEach(function(d) {
    s.setAttribute(d, l.attributes[d]);
  }), (l.children || []).forEach(function(d) {
    s.appendChild(c1(d, {
      ceFn: c
    }));
  }), s;
}
function wO(l) {
  let o = " ".concat(l.outerHTML, " ");
  return o = "".concat(o, "Font Awesome fontawesome.com "), o;
}
const Hc = {
  replace: function(l) {
    const o = l[0];
    if (o.parentNode)
      if (l[1].forEach((c) => {
        o.parentNode.insertBefore(c1(c), o);
      }), o.getAttribute(Ll) === null && et.keepOriginalSource) {
        let c = Kt.createComment(wO(o));
        o.parentNode.replaceChild(c, o);
      } else
        o.remove();
  },
  nest: function(l) {
    const o = l[0], c = l[1];
    if (~Md(o).indexOf(et.replacementClass))
      return Hc.replace(l);
    const s = new RegExp("".concat(et.cssPrefix, "-.*"));
    if (delete c[0].attributes.id, c[0].attributes.class) {
      const d = c[0].attributes.class.split(" ").reduce((h, A) => (A === et.replacementClass || A.match(s) ? h.toSvg.push(A) : h.toNode.push(A), h), {
        toNode: [],
        toSvg: []
      });
      c[0].attributes.class = d.toSvg.join(" "), d.toNode.length === 0 ? o.removeAttribute("class") : o.setAttribute("class", d.toNode.join(" "));
    }
    const u = c.map((d) => er(d)).join(`
`);
    o.setAttribute(Ll, ""), o.innerHTML = u;
  }
};
function Np(l) {
  l();
}
function u1(l, o) {
  const c = typeof o == "function" ? o : Uc;
  if (l.length === 0)
    c();
  else {
    let s = Np;
    et.mutateApproach === MS && (s = el.requestAnimationFrame || Np), s(() => {
      const u = xO(), d = Hd.begin("mutate");
      l.map(u), d(), c();
    });
  }
}
let jd = !1;
function s1() {
  jd = !0;
}
function sd() {
  jd = !1;
}
let Vc = null;
function wp(l) {
  if (!hp || !et.observeMutations)
    return;
  const {
    treeCallback: o = Uc,
    nodeCallback: c = Uc,
    pseudoElementsCallback: s = Uc,
    observeMutationsRoot: u = Kt
  } = l;
  Vc = new hp((d) => {
    if (jd) return;
    const h = nl();
    Xi(d).forEach((A) => {
      if (A.type === "childList" && A.addedNodes.length > 0 && !Cp(A.addedNodes[0]) && (et.searchPseudoElements && s(A.target), o(A.target)), A.type === "attributes" && A.target.parentNode && et.searchPseudoElements && s(A.target.parentNode), A.type === "attributes" && Cp(A.target) && ~jS.indexOf(A.attributeName))
        if (A.attributeName === "class" && EO(A.target)) {
          const {
            prefix: y,
            iconName: S
          } = _c(Md(A.target));
          A.target.setAttribute(wd, y || h), S && A.target.setAttribute(Dd, S);
        } else TO(A.target) && c(A.target);
    });
  }), va && Vc.observe(u, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function DO() {
  Vc && Vc.disconnect();
}
function BO(l) {
  const o = l.getAttribute("style");
  let c = [];
  return o && (c = o.split(";").reduce((s, u) => {
    const d = u.split(":"), h = d[0], A = d.slice(1);
    return h && A.length > 0 && (s[h] = A.join(":").trim()), s;
  }, {})), c;
}
function MO(l) {
  const o = l.getAttribute("data-prefix"), c = l.getAttribute("data-icon"), s = l.innerText !== void 0 ? l.innerText.trim() : "";
  let u = _c(Md(l));
  return u.prefix || (u.prefix = nl()), o && c && (u.prefix = o, u.iconName = c), u.iconName && u.prefix || (u.prefix && s.length > 0 && (u.iconName = nO(u.prefix, l.innerText) || Rd(u.prefix, ad(l.innerText))), !u.iconName && et.autoFetchSvg && l.firstChild && l.firstChild.nodeType === Node.TEXT_NODE && (u.iconName = l.firstChild.data)), u;
}
function LO(l) {
  const o = Xi(l.attributes).reduce((u, d) => (u.name !== "class" && u.name !== "style" && (u[d.name] = d.value), u), {}), c = l.getAttribute("title"), s = l.getAttribute("data-fa-title-id");
  return et.autoA11y && (c ? o["aria-labelledby"] = "".concat(et.replacementClass, "-title-").concat(s || Zo()) : (o["aria-hidden"] = "true", o.focusable = "false")), o;
}
function zO() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: kn,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Dp(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: c,
    prefix: s,
    rest: u
  } = MO(l), d = LO(l), h = id("parseNodeAttributes", {}, l);
  let A = o.styleParser ? BO(l) : [];
  return Q({
    iconName: c,
    title: l.getAttribute("title"),
    titleId: l.getAttribute("data-fa-title-id"),
    prefix: s,
    transform: kn,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: u,
      styles: A,
      attributes: d
    }
  }, h);
}
const {
  styles: RO
} = qn;
function f1(l) {
  const o = et.autoReplaceSvg === "nest" ? Dp(l, {
    styleParser: !1
  }) : Dp(l);
  return ~o.extra.classes.indexOf(k0) ? al("generateLayersText", l, o) : al("generateSvgReplacementMutation", l, o);
}
function UO() {
  return [...gS, ...Jf];
}
function Bp(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!va) return Promise.resolve();
  const c = Kt.documentElement.classList, s = (B) => c.add("".concat(pp, "-").concat(B)), u = (B) => c.remove("".concat(pp, "-").concat(B)), d = et.autoFetchSvg ? UO() : X0.concat(Object.keys(RO));
  d.includes("fa") || d.push("fa");
  const h = [".".concat(k0, ":not([").concat(Ll, "])")].concat(d.map((B) => ".".concat(B, ":not([").concat(Ll, "])"))).join(", ");
  if (h.length === 0)
    return Promise.resolve();
  let A = [];
  try {
    A = Xi(l.querySelectorAll(h));
  } catch {
  }
  if (A.length > 0)
    s("pending"), u("complete");
  else
    return Promise.resolve();
  const y = Hd.begin("onTree"), S = A.reduce((B, w) => {
    try {
      const C = f1(w);
      C && B.push(C);
    } catch (C) {
      I0 || C.name === "MissingIcon" && console.error(C);
    }
    return B;
  }, []);
  return new Promise((B, w) => {
    Promise.all(S).then((C) => {
      u1(C, () => {
        s("active"), s("complete"), u("pending"), typeof o == "function" && o(), y(), B();
      });
    }).catch((C) => {
      y(), w(C);
    });
  });
}
function HO(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  f1(l).then((c) => {
    c && u1([c], o);
  });
}
function jO(l) {
  return function(o) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = (o || {}).icon ? o : od(o || {});
    let {
      mask: u
    } = c;
    return u && (u = (u || {}).icon ? u : od(u || {})), l(s, Q(Q({}, c), {}, {
      mask: u
    }));
  };
}
const XO = function(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: c = kn,
    symbol: s = !1,
    mask: u = null,
    maskId: d = null,
    title: h = null,
    titleId: A = null,
    classes: y = [],
    attributes: S = {},
    styles: B = {}
  } = o;
  if (!l) return;
  const {
    prefix: w,
    iconName: C,
    icon: _
  } = l;
  return $c(Q({
    type: "icon"
  }, l), () => (zl("beforeDOMElementCreation", {
    iconDefinition: l,
    params: o
  }), et.autoA11y && (h ? S["aria-labelledby"] = "".concat(et.replacementClass, "-title-").concat(A || Zo()) : (S["aria-hidden"] = "true", S.focusable = "false")), Ud({
    icons: {
      main: rd(_),
      mask: u ? rd(u.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: w,
    iconName: C,
    transform: Q(Q({}, kn), c),
    symbol: s,
    title: h,
    maskId: d,
    titleId: A,
    extra: {
      attributes: S,
      styles: B,
      classes: y
    }
  })));
};
var QO = {
  mixout() {
    return {
      icon: jO(XO)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(l) {
        return l.treeCallback = Bp, l.nodeCallback = HO, l;
      }
    };
  },
  provides(l) {
    l.i2svg = function(o) {
      const {
        node: c = Kt,
        callback: s = () => {
        }
      } = o;
      return Bp(c, s);
    }, l.generateSvgReplacementMutation = function(o, c) {
      const {
        iconName: s,
        title: u,
        titleId: d,
        prefix: h,
        transform: A,
        symbol: y,
        mask: S,
        maskId: B,
        extra: w
      } = c;
      return new Promise((C, _) => {
        Promise.all([cd(s, h), S.iconName ? cd(S.iconName, S.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((H) => {
          let [G, F] = H;
          C([o, Ud({
            icons: {
              main: G,
              mask: F
            },
            prefix: h,
            iconName: s,
            transform: A,
            symbol: y,
            maskId: B,
            title: u,
            titleId: d,
            extra: w,
            watchable: !0
          })]);
        }).catch(_);
      });
    }, l.generateAbstractIcon = function(o) {
      let {
        children: c,
        attributes: s,
        main: u,
        transform: d,
        styles: h
      } = o;
      const A = Wc(h);
      A.length > 0 && (s.style = A);
      let y;
      return Ld(d) && (y = al("generateAbstractTransformGrouping", {
        main: u,
        transform: d,
        containerWidth: u.width,
        iconWidth: u.width
      })), c.push(y || u.icon), {
        children: c,
        attributes: s
      };
    };
  }
}, VO = {
  mixout() {
    return {
      layer(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: c = []
        } = o;
        return $c({
          type: "layer"
        }, () => {
          zl("beforeDOMElementCreation", {
            assembler: l,
            params: o
          });
          let s = [];
          return l((u) => {
            Array.isArray(u) ? u.map((d) => {
              s = s.concat(d.abstract);
            }) : s = s.concat(u.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(et.cssPrefix, "-layers"), ...c].join(" ")
            },
            children: s
          }];
        });
      }
    };
  }
}, GO = {
  mixout() {
    return {
      counter(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: c = null,
          classes: s = [],
          attributes: u = {},
          styles: d = {}
        } = o;
        return $c({
          type: "counter",
          content: l
        }, () => (zl("beforeDOMElementCreation", {
          content: l,
          params: o
        }), vO({
          content: l.toString(),
          title: c,
          extra: {
            attributes: u,
            styles: d,
            classes: ["".concat(et.cssPrefix, "-layers-counter"), ...s]
          }
        })));
      }
    };
  }
}, YO = {
  mixout() {
    return {
      text(l) {
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: c = kn,
          title: s = null,
          classes: u = [],
          attributes: d = {},
          styles: h = {}
        } = o;
        return $c({
          type: "text",
          content: l
        }, () => (zl("beforeDOMElementCreation", {
          content: l,
          params: o
        }), Tp({
          content: l,
          transform: Q(Q({}, kn), c),
          title: s,
          extra: {
            attributes: d,
            styles: h,
            classes: ["".concat(et.cssPrefix, "-layers-text"), ...u]
          }
        })));
      }
    };
  },
  provides(l) {
    l.generateLayersText = function(o, c) {
      const {
        title: s,
        transform: u,
        extra: d
      } = c;
      let h = null, A = null;
      if (H0) {
        const y = parseInt(getComputedStyle(o).fontSize, 10), S = o.getBoundingClientRect();
        h = S.width / y, A = S.height / y;
      }
      return et.autoA11y && !s && (d.attributes["aria-hidden"] = "true"), Promise.resolve([o, Tp({
        content: o.innerHTML,
        width: h,
        height: A,
        transform: u,
        title: s,
        extra: d,
        watchable: !0
      })]);
    };
  }
};
const IO = new RegExp('"', "ug"), Mp = [1105920, 1112319], Lp = Q(Q(Q(Q({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), dS), DS), OS), fd = Object.keys(Lp).reduce((l, o) => (l[o.toLowerCase()] = Lp[o], l), {}), FO = Object.keys(fd).reduce((l, o) => {
  const c = fd[o];
  return l[o] = c[900] || [...Object.entries(c)][0][1], l;
}, {});
function kO(l) {
  const o = l.replace(IO, ""), c = JS(o, 0), s = c >= Mp[0] && c <= Mp[1], u = o.length === 2 ? o[0] === o[1] : !1;
  return {
    value: ad(u ? o[0] : o),
    isSecondary: s || u
  };
}
function qO(l, o) {
  const c = l.replace(/^['"]|['"]$/g, "").toLowerCase(), s = parseInt(o), u = isNaN(s) ? "normal" : s;
  return (fd[c] || {})[u] || FO[c];
}
function zp(l, o) {
  const c = "".concat(BS).concat(o.replace(":", "-"));
  return new Promise((s, u) => {
    if (l.getAttribute(c) !== null)
      return s();
    const h = Xi(l.children).filter((C) => C.getAttribute($f) === o)[0], A = el.getComputedStyle(l, o), y = A.getPropertyValue("font-family"), S = y.match(US), B = A.getPropertyValue("font-weight"), w = A.getPropertyValue("content");
    if (h && !S)
      return l.removeChild(h), s();
    if (S && w !== "none" && w !== "") {
      const C = A.getPropertyValue("content");
      let _ = qO(y, B);
      const {
        value: H,
        isSecondary: G
      } = kO(C), F = S[0].startsWith("FontAwesome");
      let K = Rd(_, H), X = K;
      if (F) {
        const nt = aO(H);
        nt.iconName && nt.prefix && (K = nt.iconName, _ = nt.prefix);
      }
      if (K && !G && (!h || h.getAttribute(wd) !== _ || h.getAttribute(Dd) !== X)) {
        l.setAttribute(c, X), h && l.removeChild(h);
        const nt = zO(), {
          extra: ot
        } = nt;
        ot.attributes[$f] = o, cd(K, _).then((I) => {
          const k = Ud(Q(Q({}, nt), {}, {
            icons: {
              main: I,
              mask: i1()
            },
            prefix: _,
            iconName: X,
            extra: ot,
            watchable: !0
          })), Y = Kt.createElementNS("http://www.w3.org/2000/svg", "svg");
          o === "::before" ? l.insertBefore(Y, l.firstChild) : l.appendChild(Y), Y.outerHTML = k.map((Z) => er(Z)).join(`
`), l.removeAttribute(c), s();
        }).catch(u);
      } else
        s();
    } else
      s();
  });
}
function KO(l) {
  return Promise.all([zp(l, "::before"), zp(l, "::after")]);
}
function ZO(l) {
  return l.parentNode !== document.head && !~LS.indexOf(l.tagName.toUpperCase()) && !l.getAttribute($f) && (!l.parentNode || l.parentNode.tagName !== "svg");
}
function Rp(l) {
  if (va)
    return new Promise((o, c) => {
      const s = Xi(l.querySelectorAll("*")).filter(ZO).map(KO), u = Hd.begin("searchPseudoElements");
      s1(), Promise.all(s).then(() => {
        u(), sd(), o();
      }).catch(() => {
        u(), sd(), c();
      });
    });
}
var PO = {
  hooks() {
    return {
      mutationObserverCallbacks(l) {
        return l.pseudoElementsCallback = Rp, l;
      }
    };
  },
  provides(l) {
    l.pseudoElements2svg = function(o) {
      const {
        node: c = Kt
      } = o;
      et.searchPseudoElements && Rp(c);
    };
  }
};
let Up = !1;
var WO = {
  mixout() {
    return {
      dom: {
        unwatch() {
          s1(), Up = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        wp(id("mutationObserverCallbacks", {}));
      },
      noAuto() {
        DO();
      },
      watch(l) {
        const {
          observeMutationsRoot: o
        } = l;
        Up ? sd() : wp(id("mutationObserverCallbacks", {
          observeMutationsRoot: o
        }));
      }
    };
  }
};
const Hp = (l) => {
  let o = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return l.toLowerCase().split(" ").reduce((c, s) => {
    const u = s.toLowerCase().split("-"), d = u[0];
    let h = u.slice(1).join("-");
    if (d && h === "h")
      return c.flipX = !0, c;
    if (d && h === "v")
      return c.flipY = !0, c;
    if (h = parseFloat(h), isNaN(h))
      return c;
    switch (d) {
      case "grow":
        c.size = c.size + h;
        break;
      case "shrink":
        c.size = c.size - h;
        break;
      case "left":
        c.x = c.x - h;
        break;
      case "right":
        c.x = c.x + h;
        break;
      case "up":
        c.y = c.y - h;
        break;
      case "down":
        c.y = c.y + h;
        break;
      case "rotate":
        c.rotate = c.rotate + h;
        break;
    }
    return c;
  }, o);
};
var JO = {
  mixout() {
    return {
      parse: {
        transform: (l) => Hp(l)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-transform");
        return c && (l.transform = Hp(c)), l;
      }
    };
  },
  provides(l) {
    l.generateAbstractTransformGrouping = function(o) {
      let {
        main: c,
        transform: s,
        containerWidth: u,
        iconWidth: d
      } = o;
      const h = {
        transform: "translate(".concat(u / 2, " 256)")
      }, A = "translate(".concat(s.x * 32, ", ").concat(s.y * 32, ") "), y = "scale(".concat(s.size / 16 * (s.flipX ? -1 : 1), ", ").concat(s.size / 16 * (s.flipY ? -1 : 1), ") "), S = "rotate(".concat(s.rotate, " 0 0)"), B = {
        transform: "".concat(A, " ").concat(y, " ").concat(S)
      }, w = {
        transform: "translate(".concat(d / 2 * -1, " -256)")
      }, C = {
        outer: h,
        inner: B,
        path: w
      };
      return {
        tag: "g",
        attributes: Q({}, C.outer),
        children: [{
          tag: "g",
          attributes: Q({}, C.inner),
          children: [{
            tag: c.icon.tag,
            children: c.icon.children,
            attributes: Q(Q({}, c.icon.attributes), C.path)
          }]
        }]
      };
    };
  }
};
const Uf = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function jp(l) {
  let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return l.attributes && (l.attributes.fill || o) && (l.attributes.fill = "black"), l;
}
function _O(l) {
  return l.tag === "g" ? l.children : [l];
}
var $O = {
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-mask"), s = c ? _c(c.split(" ").map((u) => u.trim())) : i1();
        return s.prefix || (s.prefix = nl()), l.mask = s, l.maskId = o.getAttribute("data-fa-mask-id"), l;
      }
    };
  },
  provides(l) {
    l.generateAbstractMask = function(o) {
      let {
        children: c,
        attributes: s,
        main: u,
        mask: d,
        maskId: h,
        transform: A
      } = o;
      const {
        width: y,
        icon: S
      } = u, {
        width: B,
        icon: w
      } = d, C = kS({
        transform: A,
        containerWidth: B,
        iconWidth: y
      }), _ = {
        tag: "rect",
        attributes: Q(Q({}, Uf), {}, {
          fill: "white"
        })
      }, H = S.children ? {
        children: S.children.map(jp)
      } : {}, G = {
        tag: "g",
        attributes: Q({}, C.inner),
        children: [jp(Q({
          tag: S.tag,
          attributes: Q(Q({}, S.attributes), C.path)
        }, H))]
      }, F = {
        tag: "g",
        attributes: Q({}, C.outer),
        children: [G]
      }, K = "mask-".concat(h || Zo()), X = "clip-".concat(h || Zo()), nt = {
        tag: "mask",
        attributes: Q(Q({}, Uf), {}, {
          id: K,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [_, F]
      }, ot = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: X
          },
          children: _O(w)
        }, nt]
      };
      return c.push(ot, {
        tag: "rect",
        attributes: Q({
          fill: "currentColor",
          "clip-path": "url(#".concat(X, ")"),
          mask: "url(#".concat(K, ")")
        }, Uf)
      }), {
        children: c,
        attributes: s
      };
    };
  }
}, t4 = {
  provides(l) {
    let o = !1;
    el.matchMedia && (o = el.matchMedia("(prefers-reduced-motion: reduce)").matches), l.missingIconAbstract = function() {
      const c = [], s = {
        fill: "currentColor"
      }, u = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      c.push({
        tag: "path",
        attributes: Q(Q({}, s), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const d = Q(Q({}, u), {}, {
        attributeName: "opacity"
      }), h = {
        tag: "circle",
        attributes: Q(Q({}, s), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return o || h.children.push({
        tag: "animate",
        attributes: Q(Q({}, u), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: Q(Q({}, d), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), c.push(h), c.push({
        tag: "path",
        attributes: Q(Q({}, s), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: o ? [] : [{
          tag: "animate",
          attributes: Q(Q({}, d), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), o || c.push({
        tag: "path",
        attributes: Q(Q({}, s), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: Q(Q({}, d), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: c
      };
    };
  }
}, e4 = {
  hooks() {
    return {
      parseNodeAttributes(l, o) {
        const c = o.getAttribute("data-fa-symbol"), s = c === null ? !1 : c === "" ? !0 : c;
        return l.symbol = s, l;
      }
    };
  }
}, n4 = [ZS, QO, VO, GO, YO, PO, WO, JO, $O, t4, e4];
dO(n4, {
  mixoutsTo: en
});
en.noAuto;
en.config;
en.library;
en.dom;
const dd = en.parse;
en.findIconDefinition;
en.toHtml;
const a4 = en.icon;
en.layer;
en.text;
en.counter;
var md = { env: { NODE_ENV: "production" } };
function hd(l, o) {
  (o == null || o > l.length) && (o = l.length);
  for (var c = 0, s = Array(o); c < o; c++) s[c] = l[c];
  return s;
}
function l4(l) {
  if (Array.isArray(l)) return l;
}
function i4(l) {
  if (Array.isArray(l)) return hd(l);
}
function _a(l, o, c) {
  return (o = m4(o)) in l ? Object.defineProperty(l, o, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : l[o] = c, l;
}
function o4(l) {
  if (typeof Symbol < "u" && l[Symbol.iterator] != null || l["@@iterator"] != null) return Array.from(l);
}
function r4(l, o) {
  var c = l == null ? null : typeof Symbol < "u" && l[Symbol.iterator] || l["@@iterator"];
  if (c != null) {
    var s, u, d, h, A = [], y = !0, S = !1;
    try {
      if (d = (c = c.call(l)).next, o !== 0) for (; !(y = (s = d.call(c)).done) && (A.push(s.value), A.length !== o); y = !0) ;
    } catch (B) {
      S = !0, u = B;
    } finally {
      try {
        if (!y && c.return != null && (h = c.return(), Object(h) !== h)) return;
      } finally {
        if (S) throw u;
      }
    }
    return A;
  }
}
function c4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function u4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xp(l, o) {
  var c = Object.keys(l);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(l);
    o && (s = s.filter(function(u) {
      return Object.getOwnPropertyDescriptor(l, u).enumerable;
    })), c.push.apply(c, s);
  }
  return c;
}
function Fn(l) {
  for (var o = 1; o < arguments.length; o++) {
    var c = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Xp(Object(c), !0).forEach(function(s) {
      _a(l, s, c[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(c)) : Xp(Object(c)).forEach(function(s) {
      Object.defineProperty(l, s, Object.getOwnPropertyDescriptor(c, s));
    });
  }
  return l;
}
function s4(l, o) {
  if (l == null) return {};
  var c, s, u = f4(l, o);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(l);
    for (s = 0; s < d.length; s++) c = d[s], o.indexOf(c) === -1 && {}.propertyIsEnumerable.call(l, c) && (u[c] = l[c]);
  }
  return u;
}
function f4(l, o) {
  if (l == null) return {};
  var c = {};
  for (var s in l) if ({}.hasOwnProperty.call(l, s)) {
    if (o.indexOf(s) !== -1) continue;
    c[s] = l[s];
  }
  return c;
}
function Qp(l, o) {
  return l4(l) || r4(l, o) || d1(l, o) || c4();
}
function gd(l) {
  return i4(l) || o4(l) || d1(l) || u4();
}
function d4(l, o) {
  if (typeof l != "object" || !l) return l;
  var c = l[Symbol.toPrimitive];
  if (c !== void 0) {
    var s = c.call(l, o);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(l);
}
function m4(l) {
  var o = d4(l, "string");
  return typeof o == "symbol" ? o : o + "";
}
function Gc(l) {
  "@babel/helpers - typeof";
  return Gc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Gc(l);
}
function d1(l, o) {
  if (l) {
    if (typeof l == "string") return hd(l, o);
    var c = {}.toString.call(l).slice(8, -1);
    return c === "Object" && l.constructor && (c = l.constructor.name), c === "Map" || c === "Set" ? Array.from(l) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? hd(l, o) : void 0;
  }
}
var h4 = "7.0.0", Ad;
try {
  var g4 = require("@fortawesome/fontawesome-svg-core/package.json");
  Ad = g4.version;
} catch {
  Ad = typeof md < "u" && md.env.FA_VERSION || "7.0.0";
}
function A4(l) {
  var o = l.beat, c = l.fade, s = l.beatFade, u = l.bounce, d = l.shake, h = l.flash, A = l.spin, y = l.spinPulse, S = l.spinReverse, B = l.pulse, w = l.fixedWidth, C = l.inverse, _ = l.border, H = l.listItem, G = l.flip, F = l.size, K = l.rotation, X = l.pull, nt = l.swapOpacity, ot = l.rotateBy, I = l.widthAuto, k = p4(Ad, h4), Y = _a(_a(_a(_a(_a(_a({
    "fa-beat": o,
    "fa-fade": c,
    "fa-beat-fade": s,
    "fa-bounce": u,
    "fa-shake": d,
    "fa-flash": h,
    "fa-spin": A,
    "fa-spin-reverse": S,
    "fa-spin-pulse": y,
    "fa-pulse": B,
    "fa-fw": w,
    "fa-inverse": C,
    "fa-border": _,
    "fa-li": H,
    "fa-flip": G === !0,
    "fa-flip-horizontal": G === "horizontal" || G === "both",
    "fa-flip-vertical": G === "vertical" || G === "both"
  }, "fa-".concat(F), typeof F < "u" && F !== null), "fa-rotate-".concat(K), typeof K < "u" && K !== null && K !== 0), "fa-pull-".concat(X), typeof X < "u" && X !== null), "fa-swap-opacity", nt), "fa-rotate-by", k && ot), "fa-width-auto", k && I);
  return Object.keys(Y).map(function(Z) {
    return Y[Z] ? Z : null;
  }).filter(function(Z) {
    return Z;
  });
}
function p4(l, o) {
  for (var c = l.split("-"), s = Qp(c, 2), u = s[0], d = s[1], h = o.split("-"), A = Qp(h, 2), y = A[0], S = A[1], B = u.split("."), w = y.split("."), C = 0; C < Math.max(B.length, w.length); C++) {
    var _ = B[C] || "0", H = w[C] || "0", G = parseInt(_, 10), F = parseInt(H, 10);
    if (G !== F)
      return G > F;
  }
  for (var K = 0; K < Math.max(B.length, w.length); K++) {
    var X = B[K] || "0", nt = w[K] || "0";
    if (X !== nt && X.length !== nt.length)
      return X.length < nt.length;
  }
  return !(d && !S);
}
function y4(l) {
  return l = l - 0, l === l;
}
function m1(l) {
  return y4(l) ? l : (l = l.replace(/[\-_\s]+(.)?/g, function(o, c) {
    return c ? c.toUpperCase() : "";
  }), l.substr(0, 1).toLowerCase() + l.substr(1));
}
var v4 = ["style"];
function b4(l) {
  return l.charAt(0).toUpperCase() + l.slice(1);
}
function S4(l) {
  return l.split(";").map(function(o) {
    return o.trim();
  }).filter(function(o) {
    return o;
  }).reduce(function(o, c) {
    var s = c.indexOf(":"), u = m1(c.slice(0, s)), d = c.slice(s + 1).trim();
    return u.startsWith("webkit") ? o[b4(u)] = d : o[u] = d, o;
  }, {});
}
function h1(l, o) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof o == "string")
    return o;
  var s = (o.children || []).map(function(y) {
    return h1(l, y);
  }), u = Object.keys(o.attributes || {}).reduce(function(y, S) {
    var B = o.attributes[S];
    switch (S) {
      case "class":
        y.attrs.className = B, delete o.attributes.class;
        break;
      case "style":
        y.attrs.style = S4(B);
        break;
      default:
        S.indexOf("aria-") === 0 || S.indexOf("data-") === 0 ? y.attrs[S.toLowerCase()] = B : y.attrs[m1(S)] = B;
    }
    return y;
  }, {
    attrs: {}
  }), d = c.style, h = d === void 0 ? {} : d, A = s4(c, v4);
  return u.attrs.style = Fn(Fn({}, u.attrs.style), h), l.apply(void 0, [o.tag, Fn(Fn({}, u.attrs), A)].concat(gd(s)));
}
var g1 = !1;
try {
  g1 = md.env.NODE_ENV === "production";
} catch {
}
function O4() {
  if (!g1 && console && typeof console.error == "function") {
    var l;
    (l = console).error.apply(l, arguments);
  }
}
function Vp(l) {
  if (l && Gc(l) === "object" && l.prefix && l.iconName && l.icon)
    return l;
  if (dd.icon)
    return dd.icon(l);
  if (l === null)
    return null;
  if (l && Gc(l) === "object" && l.prefix && l.iconName)
    return l;
  if (Array.isArray(l) && l.length === 2)
    return {
      prefix: l[0],
      iconName: l[1]
    };
  if (typeof l == "string")
    return {
      prefix: "fas",
      iconName: l
    };
}
function Hf(l, o) {
  return Array.isArray(o) && o.length > 0 || !Array.isArray(o) && o ? _a({}, l, o) : {};
}
var Gp = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  // the fixedWidth property has been deprecated as of version 7
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  rotateBy: !1,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1,
  widthAuto: !1
}, Ye = /* @__PURE__ */ Pt.forwardRef(function(l, o) {
  var c = Fn(Fn({}, Gp), l), s = c.icon, u = c.mask, d = c.symbol, h = c.className, A = c.title, y = c.titleId, S = c.maskId, B = Vp(s), w = Hf("classes", [].concat(gd(A4(c)), gd((h || "").split(" ")))), C = Hf("transform", typeof c.transform == "string" ? dd.transform(c.transform) : c.transform), _ = Hf("mask", Vp(u)), H = a4(B, Fn(Fn(Fn(Fn({}, w), C), _), {}, {
    symbol: d,
    title: A,
    titleId: y,
    maskId: S
  }));
  if (!H)
    return O4("Could not find icon", B), null;
  var G = H.abstract, F = {
    ref: o
  };
  return Object.keys(c).forEach(function(K) {
    Gp.hasOwnProperty(K) || (F[K] = c[K]);
  }), E4(G[0], F);
});
Ye.displayName = "FontAwesomeIcon";
Ye.propTypes = {
  beat: E.bool,
  border: E.bool,
  beatFade: E.bool,
  bounce: E.bool,
  className: E.string,
  fade: E.bool,
  flash: E.bool,
  mask: E.oneOfType([E.object, E.array, E.string]),
  maskId: E.string,
  // the fixedWidth property has been deprecated as of version 7
  fixedWidth: E.bool,
  inverse: E.bool,
  flip: E.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: E.oneOfType([E.object, E.array, E.string]),
  listItem: E.bool,
  pull: E.oneOf(["right", "left"]),
  pulse: E.bool,
  rotation: E.oneOf([0, 90, 180, 270]),
  rotateBy: E.bool,
  shake: E.bool,
  size: E.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: E.bool,
  spinPulse: E.bool,
  spinReverse: E.bool,
  symbol: E.oneOfType([E.bool, E.string]),
  title: E.string,
  titleId: E.string,
  transform: E.oneOfType([E.string, E.object]),
  swapOpacity: E.bool,
  widthAuto: E.bool
};
var E4 = h1.bind(null, Pt.createElement);
const A1 = ({
  columnIndex: l,
  column: { title: o, links: c },
  isOpen: s = !1,
  onToggle: u
}) => {
  const [d, h] = yn(s), y = typeof window < "u" ? window.innerWidth >= 1260 : !1, [S, B] = yn(y), w = wl(null);
  Ie(() => {
    !S && u && C(s), h(s);
  }, [s, S, u]), Ie(() => {
    const H = window.matchMedia("screen and (min-width: 1260px)"), G = (F) => B(F.matches);
    return H.addEventListener("change", G), G(H), () => H.removeEventListener("change", G);
  }, []);
  const C = (H) => {
    const G = w == null ? void 0 : w.current;
    if (!G || !G.animate) return;
    G.classList.add("footer-collapsing");
    const F = G.animate(
      [
        {
          maxHeight: H ? `${G.scrollHeight}px` : "0px"
        }
      ],
      {
        duration: 250,
        easing: "ease-in-out",
        fill: "forwards"
      }
    );
    F.onfinish = () => {
      G.classList.remove("footer-collapsing"), H ? G.classList.add("footer-column-show") : G.classList.remove("footer-column-show");
    };
  }, _ = () => {
    if (S) {
      h(!0);
      return;
    }
    u ? u() : h((H) => {
      const G = !H;
      return C(G), G;
    });
  };
  return /* @__PURE__ */ b.jsx("div", { className: "col-xl flex-footer testname-column", children: /* @__PURE__ */ b.jsxs("div", { className: "card accordion-item desktop-disable-xl", children: [
    /* @__PURE__ */ b.jsx("div", { className: "footer-accordion-header", children: /* @__PURE__ */ b.jsx("div", { className: "h5", children: S ? /* @__PURE__ */ b.jsx("p", { className: "accordion-button", children: o }) : /* @__PURE__ */ b.jsxs(
      "button",
      {
        id: `footlink-header-${l}`,
        className: "footer-accordion-button",
        "aria-expanded": d || S,
        "aria-controls": `footlink-${l}`,
        onClick: _,
        type: "button",
        disabled: S,
        children: [
          o,
          /* @__PURE__ */ b.jsx(
            Ye,
            {
              className: d || S ? "column-open" : "",
              icon: L0
            }
          )
        ]
      }
    ) }) }),
    /* @__PURE__ */ b.jsx(
      "div",
      {
        id: `footlink-${l}`,
        className: "footer-accordion-body",
        role: "region",
        ref: w,
        children: c.map((H) => /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: H.url,
            title: H.title,
            children: H.text
          },
          `footlink-${o}-link-${H.text}`
        ))
      }
    )
  ] }) });
};
A1.propTypes = {
  columnIndex: E.number.isRequired,
  column: _e.shape({
    title: E.string,
    links: _e.arrayOf(
      _e.shape({
        url: E.string.isRequired,
        title: E.string,
        text: E.string.isRequired
      })
    )
  }),
  isOpen: E.bool,
  onToggle: E.func
};
const Xd = ({
  contact: { title: l = "", contactLink: o = "", contributionLink: c = "", columns: s }
}) => {
  const [u, d] = yn(
    /** @type {number | null} */
    null
  );
  return /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-footer-columns", "data-testid": "contact", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-columns", children: /* @__PURE__ */ b.jsxs("div", { className: "row", "data-testid": "columns-container", children: [
    /* @__PURE__ */ b.jsxs("div", { className: "col-xl-3", id: "info-column", children: [
      /* @__PURE__ */ b.jsx("div", { className: "h5", children: l }),
      o && /* @__PURE__ */ b.jsx("p", { className: "contact-link", children: /* @__PURE__ */ b.jsx("a", { href: o, children: "Contact Us" }) }),
      c && /* @__PURE__ */ b.jsx(
        "p",
        {
          className: "contribute-button",
          "data-testid": "contact-contribution-link",
          children: /* @__PURE__ */ b.jsx(
            ji,
            {
              color: "gold",
              href: c,
              text: "Support ASU",
              classes: "btn"
            }
          )
        }
      )
    ] }),
    s && s.length && /* @__PURE__ */ b.jsx(b.Fragment, { children: s.map((h, A) => /* @__PURE__ */ b.jsx(
      A1,
      {
        columnIndex: A,
        column: h,
        isOpen: u === A,
        onToggle: () => {
          d(
            u === A ? null : A
          );
        }
      },
      `footlink-${h.title}`
    )) })
  ] }) }) });
};
Xd.propTypes = {
  contact: _e.shape({
    title: E.string.isRequired,
    contactLink: E.string.isRequired,
    contributionLink: E.string,
    columns: _e.arrayOf(
      _e.shape({
        title: E.string,
        links: _e.arrayOf(
          _e.shape({
            url: E.string.isRequired,
            title: E.string,
            text: E.string.isRequired
          })
        )
      })
    )
  })
};
const T4 = "data:image/png;base64,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", Ni = {
  MAPS_AND_LOCATIONS: "https://www.asu.edu/about/locations-maps",
  JOBS: "https://cfo.asu.edu/applicant",
  DIRECTORY: "https://search.asu.edu/?search-tabs=web_dir_faculty_staff",
  CONTACT_ASU: "https://www.asu.edu/about/contact",
  MY_ASU: "https://my.asu.edu/",
  RANKINGS: "https://www.asu.edu/rankings"
}, jo = {
  COPYRIGHT_AND_TRADEMARK: "https://www.asu.edu/about/copyright-trademark",
  ACCESSIBILITY_REPORT: "https://accessibility.asu.edu/report",
  PRIVACY: "https://www.asu.edu/about/privacy",
  TERMS_OF_USE: "https://www.asu.edu/about/terms-of-use",
  EMERGENCY: "https://www.asu.edu/emergency/"
}, wi = {
  type: "internal link",
  section: "secondary footer"
}, x4 = () => /* @__PURE__ */ b.jsx(
  "div",
  {
    className: "wrapper",
    id: "wrapper-footer-innovation",
    "data-testid": "innovation",
    children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-innovation", children: /* @__PURE__ */ b.jsx("div", { className: "row", children: /* @__PURE__ */ b.jsx("div", { className: "col", children: /* @__PURE__ */ b.jsxs("div", { className: "d-flex footer-innovation-links", children: [
      /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "University Services", children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Ni.MAPS_AND_LOCATIONS,
            onFocus: () => Nt({
              ...wi,
              text: "maps and locations"
            }),
            children: "Maps and Locations"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Ni.JOBS,
            onFocus: () => Nt({
              ...wi,
              text: "jobs"
            }),
            children: "Jobs"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Ni.DIRECTORY,
            onFocus: () => Nt({
              ...wi,
              text: "directory"
            }),
            children: "Directory"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Ni.CONTACT_ASU,
            onFocus: () => Nt({
              ...wi,
              text: "contact asu"
            }),
            children: "Contact ASU"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: Ni.MY_ASU,
            onFocus: () => Nt({
              ...wi,
              text: "my asu"
            }),
            children: "My ASU"
          }
        )
      ] }),
      /* @__PURE__ */ b.jsx(
        "a",
        {
          className: "img-link",
          href: Ni.RANKINGS,
          onFocus: () => Nt({
            ...wi,
            text: "#1 in the u.s. for innovation"
          }),
          children: /* @__PURE__ */ b.jsx(
            "img",
            {
              src: T4,
              alt: "Repeatedly ranked #1 on 30+ lists in the last 3 years",
              width: "459",
              height: "100",
              loading: "lazy",
              decoding: "async"
            }
          )
        }
      )
    ] }) }) }) })
  }
), Xo = {
  type: "internal link",
  section: "tertiary footer"
}, C4 = () => {
  function l() {
    try {
      return window.location.href;
    } catch (o) {
      return console.error(o), "";
    }
  }
  return /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-footer-colophon", "data-testid": "legal", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "footer-colophon", children: /* @__PURE__ */ b.jsx("div", { className: "row", children: /* @__PURE__ */ b.jsx("div", { className: "col", children: /* @__PURE__ */ b.jsxs(
    "nav",
    {
      className: "nav colophon",
      "aria-label": "University Legal and Compliance",
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: jo.COPYRIGHT_AND_TRADEMARK,
            onFocus: () => Nt({
              ...Xo,
              text: "copyright and trademark"
            }),
            children: "Copyright and Trademark"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: `${jo.ACCESSIBILITY_REPORT}#a11yref=${l()}`,
            onFocus: () => Nt({
              ...Xo,
              text: "accessibility"
            }),
            children: "Accessibility"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: jo.TERMS_OF_USE,
            onFocus: () => Nt({
              ...Xo,
              text: "terms of use"
            }),
            children: "Terms of Use"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: jo.EMERGENCY,
            onFocus: () => Nt({
              ...Xo,
              text: "emergency"
            }),
            children: "Emergency"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: "nav-link",
            href: jo.PRIVACY,
            onFocus: () => Nt({
              ...Xo,
              text: "privacy"
            }),
            children: "Privacy"
          }
        ),
        /* @__PURE__ */ b.jsx("button", { type: "button", id: "manualConsentoptout", children: "Manage my privacy settings" })
      ]
    }
  ) }) }) }) });
};
const N4 = {
  prefix: "fab",
  iconName: "square-instagram",
  icon: [448, 512, ["instagram-square"], "e055", "M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"]
}, w4 = N4, D4 = {
  prefix: "fab",
  iconName: "square-youtube",
  icon: [448, 512, [61798, "youtube-square"], "f431", "M282 256.2l-95.2-54.1V310.3L282 256.2zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm14.4 136.1c7.6 28.6 7.6 88.2 7.6 88.2s0 59.6-7.6 88.1c-4.2 15.8-16.5 27.7-32.2 31.9C337.9 384 224 384 224 384s-113.9 0-142.2-7.6c-15.7-4.2-28-16.1-32.2-31.9C42 315.9 42 256.3 42 256.3s0-59.7 7.6-88.2c4.2-15.8 16.5-28.2 32.2-32.4C110.1 128 224 128 224 128s113.9 0 142.2 7.7c15.7 4.2 28 16.6 32.2 32.4z"]
}, B4 = D4, M4 = {
  prefix: "fab",
  iconName: "square-facebook",
  icon: [448, 512, ["facebook-square"], "f082", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
}, L4 = M4, z4 = {
  prefix: "fab",
  iconName: "linkedin",
  icon: [448, 512, [], "f08c", "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"]
}, R4 = {
  prefix: "fab",
  iconName: "square-x-twitter",
  icon: [448, 512, [], "e61a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"]
}, U4 = "data:image/png;base64,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", Di = {
  type: "external link",
  section: "primary footer"
}, Qd = ({
  social: {
    logoUrl: l,
    unitLogo: o = U4,
    mediaLinks: c = {
      facebook: "",
      twitter: "",
      linkedIn: "",
      instagram: "",
      youtube: ""
    }
  }
}) => /* @__PURE__ */ b.jsx("div", { className: "wrapper", id: "wrapper-endorsed-footer", "data-testid": "social", children: /* @__PURE__ */ b.jsx("div", { className: "container", id: "endorsed-footer", children: /* @__PURE__ */ b.jsxs("div", { className: "row", children: [
  /* @__PURE__ */ b.jsx("div", { className: "col-md", id: "endorsed-logo", children: /* @__PURE__ */ b.jsx(
    "a",
    {
      href: l,
      onFocus: () => Nt({
        ...Di,
        type: "internal link",
        text: "asu logo"
      }),
      children: /* @__PURE__ */ b.jsx(
        "img",
        {
          src: o,
          alt: "ASU University Technology Office Arizona State University."
        }
      )
    }
  ) }),
  c && /* @__PURE__ */ b.jsx("div", { className: "col-md", id: "social-media", children: /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "Social Media", children: [
    c.facebook && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.facebook,
        "data-testid": "facebook",
        onFocus: () => Nt({
          ...Di,
          text: "facebook icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ye,
          {
            title: "Facebook Social Media Icon",
            icon: L4,
            className: "social-icon"
          }
        )
      }
    ),
    c.twitter && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.twitter,
        "data-testid": "twitter",
        onFocus: () => Nt({
          ...Di,
          text: "twitter icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ye,
          {
            title: "Twitter Social Media Icon",
            icon: R4,
            className: "social-icon"
          }
        )
      }
    ),
    c.instagram && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.instagram,
        "data-testid": "instagram",
        onFocus: () => Nt({
          ...Di,
          text: "instagram icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ye,
          {
            title: "Instagram Social Media Icon",
            icon: w4,
            className: "social-icon"
          }
        )
      }
    ),
    c.youtube && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.youtube,
        "data-testid": "youtube",
        onFocus: () => Nt({
          ...Di,
          text: "youtube icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ye,
          {
            title: "YouTube Social Media Icon",
            icon: B4,
            className: "social-icon"
          }
        )
      }
    ),
    c.linkedIn && /* @__PURE__ */ b.jsx(
      "a",
      {
        className: "nav-link",
        href: c.linkedIn,
        "data-testid": "linkedin",
        onFocus: () => Nt({
          ...Di,
          text: "linkedin icon"
        }),
        children: /* @__PURE__ */ b.jsx(
          Ye,
          {
            title: "LinkedIn Social Media Icon",
            icon: z4,
            className: "social-icon"
          }
        )
      }
    )
  ] }) })
] }) }) });
Qd.propTypes = {
  social: _e.shape({
    unitLogo: E.string,
    mediaLinks: _e.shape({
      facebook: E.string,
      twitter: E.string,
      linkedIn: E.string,
      instagram: E.string,
      youtube: E.string
    })
  })
};
const H4 = Zc`
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
`, j4 = Zc`
  display: flex;
  align-items: center;
`, X4 = ze.footer`
  // Variables
  --color-divider-darker: #1e1e1e;
  --color-base-white: #ffffff;
  --color-base-grey-2: #e8e8e8;
  --color-base-gold: #ffc627;
  --color-divider-lighter: #393939;
  --color-base-grey-7: #191919;
  --color-base-grey-4: #bfbfbf;

  // Base Styles
  * {
    box-sizing: border-box;
    font-family:
      Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
    line-height: 1.5rem;

    a:focus,
    button:focus {
      outline: none;
      box-shadow:
        0 0 0 2px var(--color-base-white),
        0 0 0 4px var(--color-base-grey-7) !important;
      -webkit-tap-highlight-color: transparent;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }

  .btn,
  a[class^="button-"] {
    text-decoration: none !important;
    padding: 1rem 2rem;
    white-space: nowrap;
    line-height: 1rem;
    width: max-content !important;
    font-size: 1rem;
    display: inline-block;
    &:active {
      transform: scale(0.95);
    }
  }

  h5,
  .h5 {
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: -0.015rem;
    margin: 1rem 0;
  }

  .nav {
    display: flex;
    flex-wrap: wrap;
    ${H4}
  }

  // Footer Sections
  #wrapper-endorsed-footer,
  #wrapper-footer-columns {
    background: var(--color-divider-darker);

    h5,
    .h5 {
      color: var(--color-base-white);
      font-weight: 700;
    }
  }

  #wrapper-endorsed-footer {
    a {
      color: var(--color-base-grey-2);
    }

    & + #wrapper-footer-columns {
      border-top: 2px solid var(--color-divider-lighter);
    }
  }

  #wrapper-footer-innovation {
    background-color: var(--color-base-gold);
  }

  #wrapper-footer-colophon {
    background-color: var(--color-base-grey-2);
  }

  #wrapper-footer-innovation,
  #wrapper-footer-colophon {
    a {
      margin-right: 1.5rem;
      text-decoration: none;
      color: var(--color-base-grey-7);
    }
  }

  // Endorsed Footer
  #endorsed-logo {
    --endorsed-logo-display: block;
    --endorsed-logo-padding-top: 12px;
    --endorsed-logo-padding-bottom: 12px;
    --endorsed-logo-img-max-height: 6rem;
    --endorsed-logo-img-width: 100%;
    --endorsed-logo-img-max-width: 320px;
    padding-top: var(--endorsed-logo-padding-top);
    padding-bottom: var(--endorsed-logo-padding-bottom);
    display: var(--endorsed-logo-display);
    align-items: center;

    img {
      width: var(--endorsed-logo-img-width);
      max-width: var(--endorsed-logo-img-max-width);
      height: auto;
      max-height: var(--endorsed-logo-img-max-height);
      transform: scale(1.13);
      padding: 0;
      margin: 0;
    }

    @media (min-width: 768px) {
      --endorsed-logo-display: flex;
      --endorsed-logo-padding-top: 20px;
      --endorsed-logo-padding-bottom: 20px;
      --endorsed-logo-img-max-height: 6rem;
      --endorsed-logo-img-width: auto;
    }
  }

  #endorsed-footer {
    #social-media {
      .nav {
        padding-bottom: 1.5rem;

        .nav-link .social-icon {
          &:hover {
            color: var(--color-base-white);
          }
        }

        @media (min-width: 768px) {
          padding: 2.5rem 0;
          justify-content: flex-end;
        }
      }

      .nav-link {
        padding: 0.75rem 1rem 0.5rem 1rem;
        font-size: 2rem;
        color: var(--color-base-grey-4);
        line-height: 1;
        padding-top: 7px;

        &:first-child {
          @media (max-width: 575.98px) {
            padding-left: 0;
          }
        }

        &:last-child {
          @media (min-width: 768px) {
            /* padding-right: 0; */
          }
        }
      }
    }
  }

  // Footer Columns
  #footer-columns {
    #info-column {
      .contact-link {
        margin-bottom: 1.5rem;

        a {
          color: var(--color-base-grey-2);
          line-height: 1.5rem;
          text-decoration: underline;

          &:hover {
            color: var(--color-base-gold);
          }
        }
      }

      .contribute-button {
        margin-bottom: 1.5rem;
      }
    }

    .flex-footer {
      .accordion-item,
      .footer-accordion-header,
      .footer-accordion-body {
        background: var(--color-divider-darker);
        color: var(--color-base-white);
        border: 0;
      }

      .footer-accordion-header {
        border-top: 1px solid var(--color-divider-lighter);
        padding-left: 0;

        h5,
        .h5 {
          margin: 0;
          a,
          .footer-accordion-button {
            ${j4}
            justify-content: space-between;
          }
        }

        a,
        .footer-accordion-button {
          color: var(--color-base-grey-2);
          padding: 1.5rem 0;
          text-decoration: none;
          background: none;
          border: none;
          font: inherit;
          color: inherit;
          cursor: pointer;
          text-align: inherit;
          width: 100%;
          transition: background-color 0.15s ease;

          &:hover {
            background: var(--color-divider-darker);
          }

          svg,
          fa-chevron-up {
            margin-left: 1rem;
            transition: 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            margin-left: 0.5rem;
            font-size: 1rem;

            &.column-open {
              transform: rotate(180deg);
            }
          }
        }

        @media (min-width: 1260px) {
          border-top: 0;
          padding: 0;
          a,
          .footer-accordion-button {
            padding: 0;
            cursor: default;
          }

          span {
            display: none;
          }
        }
      }

      .footer-accordion-body {
        display: none;
        overflow: hidden;
        padding: 0 0 0 1.5rem;

        &.footer-collapsing {
          display: block;
          max-height: 0px;
        }
        &.footer-column-show {
          display: block;
          max-height: 1000px;
        }

        .nav-link {
          color: var(--color-base-grey-2);
          padding: 0 0 1rem;
          line-height: 1.5rem;
          text-decoration: none;
          display: block;

          &:hover {
            color: var(--color-base-gold);
            text-decoration: underline;
          }
        }

        @media (min-width: 1260px) {
          padding: 0;
          display: block;
          min-height: fit-content;
          overflow: visible;
        }
      }
    }

    @media (min-width: 1260px) {
      padding-bottom: 3rem;
      padding-top: 3rem;
      h5,
      .h5 {
        margin: 0 0 1.5rem 0;
      }
      .footer-accordion-header:has(.h5, h5) {
        h5,
        .h5 {
          margin: 0 0 1.5rem 0;
        }
      }
    }
  }

  // Footer Innovation
  #footer-innovation {
    .footer-innovation-links {
      justify-content: space-between;
      align-items: center;
      font-weight: 700;

      .img-link {
        order: 2;
        margin-right: 0;
        transform: translate(1.5rem, 0);
        padding-top: 24px;
        padding-bottom: 24px;

        img {
          height: auto;
          width: auto;
          max-width: 320px;
        }
      }

      .nav-link {
        padding: 0;
      }

      @media (max-width: 991.98px) {
        flex-direction: column;
        padding: 0.5rem 0;

        .img-link {
          margin-right: 0;
          transform: none;

          img {
            width: 100%;
            height: auto;
            order: -1;
          }
        }

        .nav {
          display: grid;
          grid-template-rows: 1fr 1fr 1fr;
          grid-auto-flow: column;
          justify-items: start;
          width: 100%;

          .nav-link {
            margin-right: 0;
            padding: 0.5rem 0;

            &:nth-child(n + 4) {
              justify-self: end;
            }
          }
        }
      }
      @media (min-width: 991.98px) {
        .img-link {
          padding-right: 16px;
        }
      }
      @media (max-width: 576px) {
        .img-link {
          img {
            max-width: 100%;
          }
        }
      }
    }
  }

  // Footer Colophon
  #wrapper-footer-colophon {
    .colophon {
      margin: 1rem 0;
    }

    .nav-link {
      padding: 0;
    }

    @media (max-width: 767.98px) {
      .nav {
        display: grid;
        grid-template-rows: 1fr 1fr 1fr;
        grid-auto-flow: column;
        justify-items: start;
        width: 100%;

        .nav-link {
          margin-right: 0;
          padding: 0.5rem 0;

          &:nth-child(n + 4) {
            justify-self: end;
          }
        }
      }
    }
  }

  //footer manual consent opt-out
  .footer-legal-links,
  .footer-menu,
  .nav {
    &.colophon #manualConsentoptout,
    #manualConsentoptout {
      color: #484848;
      border: none;
      background-color: transparent;
      width: auto;
      cursor: pointer;
      padding: 0;
      text-align: right;
      justify-self: end;
      font-size: 1rem;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  // Bootstrap Default Stylings
  .row {
    --bs-gutter-x: 24px;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--bs-gutter-y));
    margin-right: calc(-0.5 * var(--bs-gutter-x));
    margin-left: calc(-0.5 * var(--bs-gutter-x));

    > * {
      flex-shrink: 0;
      width: 100%;
      max-width: 100%;
      padding-right: calc(var(--bs-gutter-x) * 0.5);
      padding-left: calc(var(--bs-gutter-x) * 0.5);
      margin-top: var(--bs-gutter-y);
    }
  }

  .col {
    flex: 1 0 0%;
  }

  .d-flex {
    display: flex;
  }

  .container {
    --bs-gutter-x: 24px;
    --bs-gutter-y: 0;
    width: 100%;
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    margin-right: auto;
    margin-left: auto;
  }

  @media (max-width: 767.98px) {
    .container,
    .container-fluid,
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  @media (min-width: 576px) {
    .container {
      max-width: 540px;
    }
  }

  @media (min-width: 768px) {
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 768px;
    }
    .col-md {
      flex: 1 0 0%;
    }
  }

  @media (min-width: 992px) {
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 992px;
    }
  }

  @media (min-width: 1260px) {
    .col-xl-3 {
      flex: 0 0 auto;
      width: 25%;
    }
    .col-xl {
      flex: 1 0 0%;
    }
    .accordion-item {
      svg,
      .fa-chevron-up {
        display: none;
      }
    }
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
      max-width: 1224px;
    }
  }
`, Q4 = () => /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
  /* @__PURE__ */ b.jsx(x4, {}),
  /* @__PURE__ */ b.jsx(C4, {})
] }), p1 = ({ social: l, contact: o }) => (Ie(() => {
  typeof window < "u" && e0({
    packageName: "component-StyledFooter",
    component: "Component Footer",
    type: "NA",
    configuration: {
      social: l,
      contact: o
    }
  });
}, []), /* @__PURE__ */ b.jsxs(X4, { role: "contentinfo", children: [
  l && /* @__PURE__ */ b.jsx(Qd, { social: l }),
  o && /* @__PURE__ */ b.jsx(Xd, { contact: o }),
  /* @__PURE__ */ b.jsx(Q4, {})
] }));
p1.propTypes = {
  social: _e.shape(Qd.propTypes),
  contact: _e.shape(Xd.propTypes)
};
const V4 = (l, o, c) => {
  Pp.createRoot(c).render(Pt.createElement(l, o));
}, yE = ({ targetSelector: l, props: o }) => {
  V4(p1, o, document.querySelector(l));
}, G4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAJYCAIAAAAVFBUnAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAEvGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSfvu78nIGlkPSdXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQnPz4KPHg6eG1wbWV0YSB4bWxuczp4PSdhZG9iZTpuczptZXRhLyc+CjxyZGY6UkRGIHhtbG5zOnJkZj0naHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyc+CgogPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9JycKICB4bWxuczpBdHRyaWI9J2h0dHA6Ly9ucy5hdHRyaWJ1dGlvbi5jb20vYWRzLzEuMC8nPgogIDxBdHRyaWI6QWRzPgogICA8cmRmOlNlcT4KICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0nUmVzb3VyY2UnPgogICAgIDxBdHRyaWI6Q3JlYXRlZD4yMDI1LTEwLTEwPC9BdHRyaWI6Q3JlYXRlZD4KICAgICA8QXR0cmliOkV4dElkPjExYTU0MmJlLTRhNWYtNDBmNy1iODljLTQyYTU3N2I1Mjg3YzwvQXR0cmliOkV4dElkPgogICAgIDxBdHRyaWI6RmJJZD41MjUyNjU5MTQxNzk1ODA8L0F0dHJpYjpGYklkPgogICAgIDxBdHRyaWI6VG91Y2hUeXBlPjI8L0F0dHJpYjpUb3VjaFR5cGU+CiAgICA8L3JkZjpsaT4KICAgPC9yZGY6U2VxPgogIDwvQXR0cmliOkFkcz4KIDwvcmRmOkRlc2NyaXB0aW9uPgoKIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PScnCiAgeG1sbnM6ZGM9J2h0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvJz4KICA8ZGM6dGl0bGU+CiAgIDxyZGY6QWx0PgogICAgPHJkZjpsaSB4bWw6bGFuZz0neC1kZWZhdWx0Jz5VbnRpdGxlZCBkZXNpZ24gLSAxPC9yZGY6bGk+CiAgIDwvcmRmOkFsdD4KICA8L2RjOnRpdGxlPgogPC9yZGY6RGVzY3JpcHRpb24+CgogPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9JycKICB4bWxuczpwZGY9J2h0dHA6Ly9ucy5hZG9iZS5jb20vcGRmLzEuMy8nPgogIDxwZGY6QXV0aG9yPkRhdmlkIE9ybmVsYXM8L3BkZjpBdXRob3I+CiA8L3JkZjpEZXNjcmlwdGlvbj4KCiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0nJwogIHhtbG5zOnhtcD0naHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyc+CiAgPHhtcDpDcmVhdG9yVG9vbD5DYW52YSAoUmVuZGVyZXIpIGRvYz1EQUcxYS1odFBYZyB1c2VyPVVBR210eENNWHpBIGJyYW5kPUJBR210NXFwYnpJIHRlbXBsYXRlPTwveG1wOkNyZWF0b3JUb29sPgogPC9yZGY6RGVzY3JpcHRpb24+CjwvcmRmOlJERj4KPC94OnhtcG1ldGE+Cjw/eHBhY2tldCBlbmQ9J3InPz5WT5+7AABWNUlEQVR4nOzdeVBV9f/Hce5FQEwMjJHtS6CCxSQ0JmqaQLgm4IayuCRNpE6KKy6lMzrhjGWWaIpN6ljoZOSC2ygaDGAKFAqaoii4JKKAOAgoslyR3x9981f+/FXalfc55z4ff9zBf+TpjHhf3nvu5+haWlrMAAAAYDx66QAAAACtYWABAAAYGQMLAADAyBhYAAAARsbAAgAAMDIGFgAAgJExsAAAAIyMgQUAAGBkDCwAAAAjY2ABAAAYGQMLAADAyBhYAAAARsbAAgAAMDIGFgAAgJExsAAAAIyMgQUAAGBkDCwAAAAjY2ABAAAYGQMLAADAyBhYAAAARsbAAgAAMDIGFgAAgJExsAAAAIyMgQUAAGBkDCwAAAAjY2ABAAAYGQMLAADAyBhYAAAARsbAAgAAMDIGFgAAgJExsAAAAIysjXQAoH319fUGg6Gpqenh4x9/aWlpaWFh8dvjwy9+e7S2tpZuBwA8DQYW8PRKSkrKyspu3bpVXV1dXV19+3c1NTVVVVXV1dUVFRX//rs4ODjY2dnZ2dnZ2tra2to+/NrOzu6FF15wdnZ2dXX9998FAGBEupaWFukGQNEMBkNJSUnp/1FeXt7c3CxdZ2ZmZmZubu7k5PSf37m6uj782sLCQroOAEwRAwt41J07d3755ZczZ86cPn36zJkzV65cUemPiV6v79Kli7e3t4+Pj4+Pj7e3d/v27aWjAMAkMLAAs5qamtO/O3PmzNWrVzX5c6HT6dzd3X3+wMbGRjoKALSJgQVT1NLScv78+by8vBMnThw/fvzKlSvSRQJ0Ol3Xrl179erVq1cvX19fDw8P6SIA0A4GFkxFXV1dfn7+8ePHT5w4kZ+fX1tbK12kLLa2tr6+vr6+vr169erRo0fbtm2liwBAxRhY0LijR49mZmYePXq0oKBAukVNXn311YCAgICAgL59+0q3AID6MLCgQSUlJenp6RkZGVlZWffu3ZPOUTcbGxs/P78BAwYMGDDA0dFROgcA1IGBBY1oaGjIzs7OyMjIyMi4fPmydI42vfzyy4GBgYGBgX369OEACAD4CwwsqFtTU1NaWtq+fftSU1Pr6+ulc0yFjY3NW2+9NWLEiICAgDZtOK8YAB7FwIIqGQyGzMzMvXv3/vDDD3fv3pXOMV22trZBQUGjRo3q27evubm5dA4AKAUDC2rS3Nx87NixPXv2pKSk8DFARbG3tw8JCRk5cmTv3r11Op10DgAIY2BBHU6dOrVjx47k5OSamhrpFvwVR0fH0NDQcePGde3aVboFAMQwsKBoVVVV33///fbt2y9cuCDdgifTo0eP8PDw0aNHd+jQQboFAFobAwtKZDAYDh8+vH379szMzPv370vn4OlZWVkNHTo0MjLS399fr9dL5wBAK2FgQVkKCws3b968f/9+LrHSGEdHxzFjxkycONHNzU26BQCeOQYWlCIrKyshISEzM1M6BM+Qubl5cHBwTExM9+7dpVsA4BliYEFYS0tLSkpKQkLCyZMnpVvQet58882YmJh+/fpJhwDAM8HAghiDwbBr166EhIRLly5Jt0DGa6+9FhMTM3ToUE52AKAxDCwIqK+vT0xM3LBhQ3l5uXQL5Hl4eEyfPj00NJTb7wDQDAYWWlV9ff2mTZu+/PLL6upq6RYoi4uLy5w5c8LDw7n3DgANYGChlTQ0NGzevHn9+vVVVVXSLVAuNze3OXPmjBkzhhvvAFA1Bhaeuaampm+++SYhIaGyslK6BerQuXPnefPmjRw5kqOzAKgUAwvPkMFg2Lp169q1aysqKqRboD6enp7z5s0LCQnhEngAqsPAwrOydevWVatWMa3wL3l6ei5evHjIkCHSIQDwBBhYML78/PwFCxacO3dOOgTa0b9//5UrV3IKPAC1YGDBmCoqKj766KM9e/ZIh0CDLCwsJk+ePHfu3Hbt2km3AMDfYGDBOJqamhISEtatW1dfXy/dAi3r1KnTokWLwsLCuDALgJIxsGAEBw4ciIuLu3btmnQITIWPj8+nn37q4+MjHQIAj8fAwr9y5cqVBQsWZGVlSYfAFIWHhy9ZsqRjx47SIQDwKAYWnpLBYFizZs3atWsNBoN0C0yXnZ3dkiVLIiIipEMA4E8YWHgaP//889y5c69cuSIdApiZmZn16dNn9erVfMYQgHIwsPBkampq4uLikpKS+JsDRbGyspo9e/a0adO4YzQAJWBg4Qns3r176dKlt27dkg4BHs/T03PVqlU9e/aUDgFg6hhY+Edu3Lgxd+7cH3/8UToE+HtRUVGLFy9u3769dAgA08XAwt87ePDgrFmz6urqpEOAf8rV1XXjxo2c4wBACgMLf6Wurm7hwoXJycnSIcATa9OmTWxs7IwZM/R6vXQLAJPDwML/69SpU1OmTCktLZUOAZ5e7969169f7+zsLB0CwLTwHzs8RnNz82effTZ8+HDWFdQuNzd3wIAB+/btkw4BYFp4BQuPKi0tnTJlyqlTp6RDAGOKiIhYvny5tbW1dAgAk8DAwp/s27dv7ty59+7dkw4BjM/NzW3jxo3du3eXDgGgfQws/Nf9+/eXLl369ddfS4cAz5ClpWV8fPzo0aOlQwBoHAMLZmZmZuXl5dHR0SdPnpQOAVrDuHHjPv74Y0tLS+kQAJrFwIJZTk5OdHR0dXW1dAjQery8vLZs2eLi4iIdAkCb+BShSWtpaYmPjw8LC2NdwdQUFhYOHDjw6NGj0iEAtIlXsExXbW3t5MmTeYKBKdPpdHPmzImNjdXpdNItADSFgWWiCgsL33777Rs3bkiHAPL8/f03bdrEvQsBGBEDyxRlZWW988473FsQeOill17atm2bk5OTdAgAjeAaLJOzY8eOyMhI1hXwRxcuXBg2bNjZs2elQwBoBAPLtHzyySezZs1qbm6WDgEU5+bNmyNGjOCqRABGwVuEpsJgMLz//vsHDx6UDgEUzdzcfOXKlZGRkdIhANSNgWUSamtrJ02alJubKx0CqMOsWbMWLlwoXQFAxRhY2nf9+vWIiIjLly9LhwBqEhoaGh8fb2FhIR0CQJUYWBpXVFQ0duzYW7duSYcA6tO/f/8tW7a0bdtWOgSA+jCwtOz06dPh4eG1tbXSIYBa9ezZc9u2bTY2NtIhAFSGgaVZeXl5ERER9+7dkw4B1M3Ly2v37t0dOnSQDgGgJhzToE3Hjh0LCwtjXQH/XmFh4YgRI3ifHcATYWBp0OHDhydMmNDQ0CAdAmhEUVFRSEjI9evXpUMAqAYDS2uSk5Ojo6MNBoN0CKApJSUlISEhJSUl0iEA1IGBpSmJiYkxMTEPHjyQDgE0qKKiIjg4+MKFC9IhAFSAi9y1Y+fOnTNnzpSuADTO3t5+//79bm5u0iEAFI2BpRGHDh167733eO0KaAXOzs4HDhxwcHCQDgGgXAwsLcjMzBw/frx0BR7DysrKycnJwcHBysrKysrK8s+srKysra3v37/f1NTU2NjY9GeNjY0NDQ1lZWWlpaXSfw48ysPDY+/evXZ2dtIhABSKgaV6ubm5kZGRfGZQlru7e+fOnR0dHZ2dnR0dHV1cXBwcHBwdHY31BFxZWVlWVnbz5s3S0tLy8vKysrKysrKLFy+Wl5cb5ffHU/D29t61a1f79u2lQwAoEQNL3X47oaeurk46xIRYWFh07tzZ09OzW7du3bp18/T09PDwsLS0FImpq6srKioqKioqLi7+7fHatWu8U9xqfH19d+zYYWVlJR0CQHEYWCpWXFw8atSo27dvS4don5ubm7+/f79+/by8vLp16yad81caGxuLiory8vJycnJycnI4HvNZGzhw4NatW6UrACgOA0utbty4ERwcXFFRIR2iWe7u7n379u3Xr5+fn1+nTp2kc57SxYsXs7Ozs7Ozc3JyKisrpXO0KTg4+KuvvtLrOfUGwP9iYKnS7du3g4ODf/31V+kQrbG3tx80aNAbb7wREBBgb28vnWNkxcXF2dnZR44cOXbs2N27d6VzNGXq1KlLly6VrgCgIAws9WlsbBw+fHhBQYF0iEZYWFj4+voGBgYGBga+8sor0jmt4f79+8ePH8/IyEhPTz937px0jkZ8/PHHUVFR0hUAlIKBpTLNzc2TJk3KyMiQDlE9FxeX30aVv7//c889J50jprKyMj09PSMj48iRIzU1NdI5KqbX67dt2+bv7y8dAkARGFgqM2PGjF27dklXqFiHDh1GjhwZHh7es2dP6RZlaW5uTk9PT0pKSktL416WT6ddu3YpKSmenp7SIQDkMbDUZOXKlfHx8dIVqqTX6/38/CIiIoKCgqSOVFCL6urqXbt2JSUlnT17VrpFfZycnFJSUtT7qQgAxsLAUo3vvvsuNjZWukJ9unTpEh4eHhkZyXPekzp37lxSUlJycnJVVZV0i5p4eXkdOHCgbdu20iEAJDGw1CE1NZXrZ5/UkCFDpk6d2rdvX+kQ1du7d++aNWvOnz8vHaIagwcPTkxMlK4AIImBpQIFBQUjRozgZjj/3KhRo2bMmOHl5SUdoimpqalr1qzJz8+XDlEHDm4ATBwDS+mqq6sHDx58/fp16RAVsLCwCAsLmzlz5osvvijdolk5OTlffPHFkSNHpENUYNOmTUFBQdIVAGQwsBTtwYMHY8eO/emnn6RDlM7a2nrixInTpk1zcHCQbjEJBQUF8fHxhw4d4h+Qv2BtbX348GEPDw/pEAACGFiKtnz58nXr1klXKJqVlVV0dPS0adM6duwo3WJyiouLP//883379kmHKJe7u3tqaqopH7QGmCwGlnKlpaVNmjRJukK5LCwsxo8fHxsbq7172qhLQUHB8uXLMzMzpUMUatCgQYmJiTqdTjoEQKtiYCnUxYsXhw0bVldXJx2iRHq9fsyYMQsWLHBxcZFuwX/l5uYuW7YsLy9POkSJFixYMHv2bOkKAK2KgaVEdXV1gwcP5l7OjxUUFPThhx927dpVOgSPkZaWtmLFCk4ofYROp0tKSvLz85MOAdB6GFhKFBUVlZqaKl2hOK+//npcXFz37t2lQ/A3kpOTly1bVlFRIR2iIDY2Nmlpaa6urtIhAFqJXjoAj9qwYQPr6hEdO3Zcu3ZtcnIy60oVQkNDs7OzZ86cKR2iIHfu3Jk8ebJ0BYDWwytYynL+/PmhQ4dyq92H9Hp9VFTUBx98YGNjI92CJ3bp0qX58+dzzshD06dPX7x4sXQFgNbAwFKQxsbGgQMHXr58WTpEKby9vVevXs2B7GqXnJwcFxd38+ZN6RB5Op1u586d3L4JMAUMLAWZP3/+t99+K12hCLa2tosWLZowYQIfbteGO3furFixIjExsbm5WbpFmIODQ2Zm5vPPPy8dAuDZYmApxaFDh959913pCkUYMmRIfHy8nZ2ddAiM7MyZM1OmTLl69ap0iLCgoKBNmzZJVwB4tv4HAAD//+zde1BU5R/H8V3dRUDAQITwAqioQSLlBYbUvEKjBlreIh1NS0cpTUkbzGa0ydRhvUUjSDJSKcGoJGKCCgvqqKCi5hUvgwKZ3CGQqyzs74+aMn/cds85+93n2c/rrzJy3lNBn33O2bO4yd0olJSUrF69mrqCnpmZ2aZNm3744QesKy55enqmp6cHBgZShxBLTk6Oj4+nrgAAaeEEi55Wq505cyZuBHZ1dY2JiRkyZAh1CEju0KFD69atq6urow4hY2lpqVarXVxcqEMAQCo4waL33XffYV3NnTtXrVZjXZmI2bNnp6WlmfK/7rq6uqVLl2o0GuoQAJAKBhaxe/fubd26lbqCkqWlZURExM6dOy0sLKhbwHBcXV0zMjI+/PBD6hAyN2/e/Pbbb6krAEAquERILCAgwJQ/vs3Dw2Pfvn3Ozs7UIUAmNTV1xYoV1dXV1CE00tPTX3nlFeoKABAfTrAoxcTEmPK6CgwMTE5OxroycX5+fmlpaSb74ZIrV67Eq1wALmFgkSktLd28eTN1BQ2FQvHVV1/t2bPHzMyMugXo9e3b9+TJk35+ftQhBG7duvX9999TVwCA+HCJkIzJfqKzra3tvn37fHx8qEPA6OzatUulUpnaDyVzc/MzZ87gc6ABOIMTLBopKSmmua48PDzS0tKwrqBVq1atio2NNbXPnWxoaPj000+pKwBAZBhYBGpra0NDQ6krCEydOjU5OdnJyYk6BIzX+PHjT5486erqSh1iUFlZWXj0KABnMLAIbN68ubS0lLrC0EJDQ6Ojo3HTFXTI1dX15MmTb775JnWIQW3YsAGfhw3AE9yDZWjXr1+fMmUKdYWhhYeHz5o1i7oCGLNs2bKkpCTqCsMJDAzcs2cPdQUAiAMnWAal1WpDQkKoKwzKzMzsxx9/xLoCPURGRs6bN4+6wnCSkpLwoQ4A3MDAMqj4+PicnBzqCsOxsrI6dOiQab79HoSTy+UqlcqkPgc9NDQUVxUA+NB148aN1A2moqamZuHChfX19dQhBmJvb5+QkODl5UUdAmwbPXq0nZ1dRkYGdYghlJeX9+rV67XXXqMOAQChcIJlOCqVqqKigrrCQHr37n38+HF3d3fqEODBokWLIiIiFAoFdYghbN26taamhroCAITCwDKQ3NzcvXv3UlcYiJub2/Hjx/HgRBDR9OnT9+3bR11hCFVVVWFhYdQVACAU3kVoINOnT798+TJ1hSH07t37xIkT9vb21CHAoVOnTi1evLilpYU6RFpdu3ZVq9WDBw+mDgEA/eEEyxBSUlJMZF3Z2tomJCRgXYFE/P39VSoVdYXkmpubTfNZxAA8wU3uknv27Nn8+fOfPn1KHSI5CwuLI0eODBo0iDoEeObp6SmTyTIzM6lDpPX48WNPT8+BAwdShwCAnnCCJbno6OgnT55QV0hOoVDs37/fw8ODOgT499lnnwUFBVFXSG7jxo3cXwwF4BgGlrTq6urCw8OpKyQnl8sjIyPfeOMN6hAwFSqVyt/fn7pCWnl5eSb1IHsAzmBgSSsiIqK6upq6QnJbtmyZNm0adQWYkC5duuzdu9fb25s6RFphYWE4xAJgFAaWhCorK6OioqgrJLd69eoFCxZQV4DJUSqVBw4c4PtZazjEAmAXBpaEwsPDa2trqSukNW3atLVr11JXgImysrKKi4tzcHCgDpEQDrEAGIWBJZXS0lLun4vo5eW1e/du6gowaQ4ODnFxcebm5tQhUsnLy0tMTKSuAACdYWBJRaVSNTU1UVdIqF+/frGxsWZmZtQhYOrc3d2joqLkcjl1iFS2bduGQywA5mBgSaKgoCAuLo66QkLW1tbx8fF2dnbUIQAymUzm5+e3fv166gqp5OXlHTlyhLoCAHSDgSUJlUrV3NxMXSGh6Ojo/v37U1cA/Cs4OHju3LnUFVLZuXMndQIA6AYDS3xFRUV8v9zcuXPn2LFjqSsAXhQWFjZixAjqCkk8fPgQbycEYAsGlvgiIyM5vmFiyZIlHJ8TANP+enCDi4sLdYgkIiMjqRMAQAdyrVZL3cCVmpqaYcOGNTQ0UIdIYujQocnJyQqFgjoEoE03b96cNm2aRqOhDhFfQkKCr68vdQUAdApOsET2008/8bquunXrFh0djXUFRs7T03PNmjXUFZLAIRYAQzCwxKTRaKKjo6krpPL11187OztTVwB07JNPPuHyZiy1Wp2bm0tdAQCdgoElpqNHjxYVFVFXSGLy5Mnz58+nrgDolC5dukRFRVlbW1OHiEyr1eLRvgCswD1YYpo0aVJOTg51hfjs7OzOnz/fo0cP6hAAHRw+fHjlypXUFSJTKpVXrlyxt7enDgGADuAESzTnzp3jcl3JZLLIyEisK2DOrFmzAgICqCtE1tTUtHfvXuoKAOgYBpZooqKiqBMksXjxYjz1Chi1bds2R0dH6gqRxcTE8PpOGgCeYGCJIz8/X61WU1eIb8CAAZs2baKuANCTtbV1REQEdYXIampqEhISqCsAoAMYWOLYv38/dYIkdu3aRZ0AIIivr29QUBB1hcj4/qhTAD7gJncRaDQaLy+vyspK6hCRzZgxg79X/2CCqqurfX19OfsOPXv2rJubG3UFALQJJ1giSE5O5uxnt0wms7Ky2rhxI3UFgAhsbGy2bNlCXSGy2NhY6gQAaA8Glgi4vD74+eefOzg4UFcAiCMwMHD8+PHUFWI6fPhwU1MTdQUAtAkDS6i8vLzz589TV4jM3d190aJF1BUAYtq+fbu5uTl1hWjKy8tTU1OpKwCgTRhYQnF5fLVjx46uXbtSVwCIycnJad26ddQVYsKt7gDGDANLEI1GEx8fT10hsqCgIC8vL+oKAPF99NFHw4YNo64QTUZGRnFxMXUFALQOA0uQ48ePc3Z7u7W19ZdffkldASAJuVy+Y8cO6grRtLS0HDx4kLoCAFqHgSXIzz//TJ0gsuDgYFtbW+oKAKl4eHjMmjWLukI0uEoIYLTwHCz9lZWVeXl58fQP8KWXXsrOzra0tKQOAZBQfn7+mDFjmpubqUPEceLECZ6uewJwAydY+ktKSuJpXclkspCQEKwr4J6Li8v7779PXSGapKQk6gQAaAVOsPQXEBBw5coV6grRODk5ZWVlKZVK6hAAyZWUlPj4+DQ2NlKHiKBPnz6XL1+mrgCAF+EES0+FhYU8rSuZTLZmzRqsKzARDg4O3Dzp7Y8//rh69Sp1BQC8CANLT7/88gt1gpicnZ3nzJlDXQFgOCtWrODmgjiuEgIYIQwsPSUmJlIniOmLL77Ak0XBpNja2i5btoy6QhyJiYm42QPA2GBg6SM/P//27dvUFaJxd3cPDAykrgAwtODgYBsbG+oKEZSUlGRnZ1NXAMB/YGDp4/Dhw9QJYgoJCaFOACBgaWm5ZMkS6gpxHD16lDoBAP4D7yLUx9ixY3Nzc6krxOHq6nrhwgXqCgAaFRUVI0eObGhooA4RytHR8dq1a9QVAPAvnGDp7OHDh9ysK5lMxs0reAA92NnZ8fH2juLiYs7e1wzAOgwsnanVauoE0fTo0SMoKIi6AoDS8uXL5XI5dYUITp8+TZ0AAP/CwNJZWloadYJoFi9ebG5uTl0BQMnFxcXf35+6QgTp6enUCQDwL9yDpZv6+vrBgwfz8SlmSqXy6tWrPXv2pA4BIHbp0qUZM2ZQVwgll8tzcnL4eF8kAAdwgqWbs2fP8rGuZDLZnDlzsK4AZDKZt7f38OHDqSuE0mq1OMQCMB4YWLrh5gYsuVy+fPly6goAY8HHQ0czMjKoEwDgbxhYuklNTaVOEMekSZMGDBhAXQFgLN5+++3evXtTVwiFEywA44GBpYOcnJzi4mLqCnG899571AkAxoWDb4ry8vKbN29SVwCATIaBpRNurg/a2Nj4+flRVwAYl9mzZ1MniABXCQGMBAaWDrj5yTV79mylUkldAWBcXFxcfHx8qCuEOnPmDHUCAMhkGFidp9FoLl++TF0hDj5eqQOIjoNvjezs7KamJuoKAMDA6rTs7GyNRkNdIQI3N7dhw4ZRVwAYo+nTp3fr1o26QpCmpqbr169TVwAABlanZWVlUSeIA5+NA9CW7t27T5kyhbpCqEuXLlEnAAAGVqfxMbC6dOnCx0fbAkiEg2+Q7Oxs6gQAwMDqnJaWlosXL1JXiGDChAl4ejtAO8aNG2dvb09dIQhOsACMAQZWp9y4caOxsZG6QgTvvPMOdQKAUZPL5TNnzqSuEKSioiIvL4+6AsDUYWB1SmZmJnWCCORy+eTJk6krAIzdpEmTqBOE4uYtzwDswsDqFD5uwBo1apSNjQ11BYCx8/X1tbS0pK4QBAMLgBwGVqdcuHCBOkEEeHo7QGd07dp14sSJ1BWC4D53AHIYWB178OBBbW0tdYUI/P39qRMA2MD6q5G7d+/W1NRQVwCYNAysjt2+fZs6QQSOjo6DBg2irgBgw8SJE+VyOXWFIPjUZwBaGFgd42NgTZ06lToBgBk9e/Z8/fXXqSsEycnJoU4AMGkYWB27c+cOdYIIWL/kAWBgrL+XkI8fXADsUlAHMICDn1MWFhajR4+mrgBgiZ+fn0qloq7QH06wXlBeXv7w4cOSkpLKysrKyspnz55RF4ERsbGx8fT09PT07N69u1i/JwZWByorK4uLi6krhBozZoxSqaSuAGDJ0KFD7e3ty8rKqEP0dPfuXeoEYvX19ZmZmZcuXcrMzLx//35VVRV1ETDA2dn51VdfHT58+IQJEzw8PIT8VhhYHeDjBqxRo0ZRJwCwZ+TIkSdOnKCu0FN9ff2jR4/69+9PHWJotbW1x44dO3bsWEZGBnULsKegoKCgoCAlJeWbb75xcnJ69913Fy5c2LdvXz1+K9yD1QEMLACTNXLkSOoEQTi4vUEn+fn569evHzp0aEhICNYVCFdYWLh7925vb+8PPvjgwYMHuv7tGFgd4OAnlEKhGDFiBHUFAHu8vb2pEwQxnduwCgsLP/74Y19f35iYGD4+NxaMyqlTp8aNG7dq1SqdbhnCwOoABwPLy8tLocC1YACdeXl5MX3zIgc/vjpj27ZtI0aMOHLkCHUIcO7gwYO+vr7bt2/v5NdjYHWAg0uErL8KB6CiVCqZfhoW9/e5l5WVTZ06dceOHdQhYCoaGhq2b98+YcKE3NzcDr8YA6s9BQUF1AkiwA1YAHpj+jas/Px8jUZDXSGVO3fuvPXWW7/99ht1CJice/fujR07Njk5uf0vw8BqDx8Dy8fHhzoBgFVMvz7RarVPnjyhrpBEZmZmQEBAYWEhdQiYriVLlsTGxrbzBRhY7cnPz6dOEKp///62trbUFQCsYnpgyWSy33//nTpBfImJiTNnzqyvr6cOAZOm1WrXrl0bERHR1hdgYLWHgxOs4cOHUycAMMzOzq5fv37UFfp7/PgxdYLIUlNTg4ODqSsA/rZp06bw8PBW/xIGVnvy8vKoE4QaPHgwdQIA2wYNGkSdoD8OXiU+79q1a0uXLqWuAPiPrVu3JiUl/f+vY2C1h4NLhBhYAAIxPbB4ukT4+PHjefPm4TFXYISWLVt248aNF34RA6s9jx49ok4QasiQIdQJAGxzc3OjTtAfNydYDQ0NCxYs+PPPP6lDAFq3fPnypqam538FA6tNVVVVT58+pa4QRKlUurq6UlcAsA0nWMZgw4YN3D/WC5j26NGjsLCw538FA6tNHFwfZPp/DABGgunvo6KiIg4ehXX//v0DBw5QVwB0YM+ePffv3//nTzGw2sTBwML1QQDhbG1t7e3tqSv0pNVqOXgjYWhoqFarpa4A6EBzc/O6dev++VMMrDaVlJRQJwiFO9wBRDFw4EDqBP0VFRVRJwhy+vTprKws6gqATsnMzDx9+vRff4yB1aaysjLqBKEwsABEwfRVwsrKSuoEQfBRg8CWf/6LxcBqU0VFBXWCUEy/7AYwHkx/KzH9zruLFy9mZ2dTVwDoIDs7+8KFCzIMrHZwcILVq1cv6gQAHrz88svUCfpj+rViTEwMdQKAzuLi4mQYWO1gfWApFAp8CiGAKBwcHKgT9MfuJcLq6uqUlBTqCgCd/frrr7W1tRhYbSovL6dOEMTR0ZE6AYATTH83sXuClZiY+MKTGwGY0NjYmJ6ejoHVJtYHFtOvuQGMCtPfTeyeYJ07d446AUBParUaA6t1Wq22qqqKukIQpv+XAGBUrKyslEoldYWe2B1YFy9epE4A0FNGRgYGVus4eAgWBhaAiPr06UOdoCdGB1ZeXl5paSl1BYCeSktLMbBax+5dC//AwAIQEbu3YTE6sG7dukWdACAIBlbrWL8+KGP8jeUAxobdgcXoG6Kf/0w3ABZhYLWuubmZOkGonj17UicA8IPdjyOUyWSNjY3UCTrLzc2lTgAQBAOrdS0tLdQJQllYWFAnAPDD0tKSOkF/NTU11Ak6Y7EZ4HkYWK3j4ATLzMyMOgGAH+bm5tQJ+mNxrHDwKhdMHAZW6zCwAOB5TB8J19XVUSfojIMfwmDiMLBax8GLp27dulEnAPADJ1gGxu6DxwD+goHVOg4GFk6wAETE9D1YtbW11Ak6Y/rIEECGgdUWDk6nMbAARIQTLAPr3r07dQKAIBhYreNgYOESIYCImD5QYfEEq0ePHtQJAIJgYLUOlwgB4HlMn2CxOLD69etHnQAgCAZW6+RyOXWCULhFFEBETN+DxeK7CAcMGECdACAIBlbrFAoFdYJQLD67GcBoMX3bQFNTE3WCztzc3KgTAATBwGodB8c/GFgAImL6G4rFOzL79OmDT6wHdpmbm/8PAAD//+zde1BUdR/H8bMLCIgIqICgCEgqYJm3CRTkIqshK6LQSIpKEElpJRcvU1ZDojbMqGSiKGM5ajZCoqZTkYCKglCQqIh4AQV0ULBCriKX5fmjZ8rHh9vunt3vnt9+Xn+ZWfP+w2U/+ztndzGweoYTLAB4nqAfUAK9I9PNzY06AUBB7u7uGFg9w8ACgOe1tbVRJyhOoEfy7u7u1AkACpJIJBhYPcPAAoDnCXpgCfESIcdxfn5+Ojo61BUAchOLxVKpFAOrZwJ9wfc8DCwAHgn6ASXQS4QmJiYeHh7UFQBy8/HxGT58OAZWzxh42STo5wMATSPoB5RABxbHcYGBgdQJAHJbsmQJh3cR9gYnWADwPEE/oAR6iZDjuAULFlhaWlJXAMhhzJgxc+fO5TCweiPoDxX8m6CfDwA0jaAfUMI9wdLT03v33XepKwDksHLlSrFYzGFg9cbY2Jg6QVl//vkndQIAO548eUKdoDjhDiyO40JDQ83NzakrAAZk1KhR4eHhf/8aA6tnQ4cOpU5Q1uPHj6kTANhRW1tLnaA44V4i5DjOwMBg06ZN1BUAAxIXF/fPrzGweqavr//3EZ9wPXr0iDoBgB2CHlhmZmbUCUoJCAjA2wlB80kkEqlU+s8/CntDqNSwYcOoE5RSV1dHnQDADgwsWjt27BgyZAh1BUCvRo4cmZSU9PzvYGD1SuhXCQX9fACgaR48eECdoCCRSGRiYkJdoSxra+udO3dSVwD0av/+/S/MBgysXgl9YOEEC4AvTU1NnZ2d1BUKMjMzE4lE1BU8mDdvXmhoKHUFQA927949derUF34TA6tXQh9Yjx8/7u7upq4AYIGgX64I/W6H533xxRdz5syhrgD4Hxs3bly0aNH//z4GVq+EftdCd3f3H3/8QV0BwAJBD6zhw4dTJ/Bp3759kydPpq4A+K/PPvts9erVPf4rDKxeMfDxwbgNC4AXgn4omZqaUifwycDAID09fdasWdQhoO3EYnFSUlIfH4SLgdUrCwsL6gRl3b17lzoBgAVVVVXUCYoT+mH8/zM0NExNTQ0ODqYOAe1lZGR08ODBvr8rEwOrVwx8dvCdO3eoEwBYIOiHEkv3YD0vMTExMTGRga81A8F5+eWXs7KyfHx8+v5jGFi9YuASYXl5OXUCAAswsDRTcHBwZmami4sLdQhokejo6DNnztja2vb7JzGwesXAJUJBPysAaI6bN29SJyiOgdeKfbC3tz9x4kRycrK1tTV1CzDO2dk5IyNj3bp1A/zzGFi9YuCnEk6wAJT34MGDjo4O6grFjRkzhjpB5QICAoqKihITE1966SXqFmCQr6/v8ePHs7KyJk2aNPD/CgOrV2ZmZnp6etQVSmlvb6+urqauABA2oZ8E29jYUCeoSXBw8IULFw4dOoT3GAIv7OzsYmNji4uLv/nmG1dXV3n/c11VNDFj5MiR9+/fp65QSnl5uTa8fgVQHaEPrJEjR1InqJVEIpFIJPfu3Tty5MjFixdLSkqoi0Bg3N3dJRLJ7NmzlTwQxcDqi42NjdAH1p07d2bPnk1dASBgt2/fpk5Q3NixY6kTaNjb23/yySccx7W0tBQVFd26dau8vLyysrKrq4s6DTSInp6eubm5paXliBEjzM3NrayspkyZYmhoyMv/HAOrL/b29pcuXaKuUIrQX3wDkBP0gwgH2EZGRp6enp6entQhoHVwD1ZfGHjxV1paSp0AIGyCfgshBhYAFQysvtjb21MnKKukpKStrY26AkCobt682dTURF2hOO25wx1A02Bg9YWBgSWTyYqKiqgrAISqsLCQOkEpGFgAVDCw+sLAwOKE/wwBQOi3336jTlAKLhECUMHA6sugQYNGjx5NXaEsnGABKEzoDx8GbiQFECgMrH4wcIiFEywAxTx+/Liqqoq6QnFWVlZDhw6lrgDQUhhY/ZgwYQJ1grKam5vLysqoKwCE59dff6VOUIqjoyN1AoD2wsDqh7OzM3UCD4R+mQOAhNBPf52cnKgTALQXBlY/2PgJJfTnCQASQn/gsPHjC0CgMLD6wcYZ+8WLF6kTAASmsbHxypUr1BVKwcACIISB1Q99fX0HBwfqCmXV1tZevXqVugJASM6dO0edoBSxWDxu3DjqCgDthYHVPzZuwzpz5gx1AoCQ/PLLL9QJShk3bpyenh51BYD2wsDqHxvH7BhYAAPX1dWVnZ1NXaEUNm5vABAuDKz+sXGCVVpaWltbS10BIAz5+fmC/gpCjpVXhgDChYHVv1dffZU6gR8///wzdQKAMDBw4jtx4kTqBACthoHVP0tLSza+z0vo95QAqM3p06epE5Tl6upKnQCg1TCwBmT69OnUCTy4dOnS06dPqSsANF1ZWZnQr6dPmDDByMiIugJAq2FgDYiLiwt1Ag86OjrOnj1LXQGg6TIzM6kTlMXGjywAQcPAGhA2TrA4jjtx4gR1AoCmO3bsGHWCsl577TXqBABth4E1IBMmTDA2Nqau4EFmZmZLSwt1BYDmKikpKS8vp65QFgYWADkMrAERi8XTpk2jruBBR0cHDrEA+pCWlkadoCwLC4vRo0dTVwBoOwysgWLmnobjx49TJwBoLgauD86cOZM6AQAwsAZsxowZ1An8KCgoePjwIXUFgCbKyMhoaGigrlAWrg8CaAIMrIGaOnWqvr4+dQU/GLgIAqAKqamp1Ak8YOa4HUDQMLAGSldX183NjbqCHwxcBAHgXX19PQMfxmtqaoovyQHQBBhYcnB3d6dO4EdFRcXVq1epKwA0S3p6OnUCD7y8vKgTAIDjMLDk4uHhQZ3AGzaeSwB4xMb1QR8fH+oEAOA4DCy5ODs7m5qaUlfw4+jRo83NzdQVAJqisLCwtLSUuoIH3t7e1AkAwHEYWPKaNWsWdQI/mpubjxw5Ql0BoClSUlKoE3gwadKkYcOGUVcAAMdhYMmLmYHFcdy+ffuoEwA0woMHD3788UfqCh7g+iCA5sDAks+cOXOoE3jz6NGjkydPUlcA0Nu/fz91Aj9whzuA5sDAko+lpeXUqVOpK3ize/du6gQAYm1tbd999x11BQ+GDh3KzNfSAzAAA0tufn5+1Am8KS0tzcvLo64AoHT48GE23vDh6ekpEomoKwDgvzCw5Obv70+dwKe9e/dSJwCQkclkycnJ1BX8mD17NnUCAPwLA0tuNjY2jo6O1BW8OXv27J07d6grAGhkZGQ8evSIuoIHIpHI19eXugIA/oWBpQiWrhJ2d3cnJSVRVwDQ2LNnD3UCP9zc3ExMTKgrAOBfGFiKmDdvHnUCn9LT08vLy6krANQtKyvr8uXL1BX8mD9/PnUCAPwPDCxFTJw40dbWlrqCNzKZbOvWrdQVAOrG0l97DCwATYOBpaCFCxdSJ/ApIyOjuLiYugJAfY4dO3bz5k3qCn64ubnhA9wBNA0GloKCg4OpE3gWHx9PnQCgJh0dHSwdX0mlUuoEAHgRBpaC7OzsnJycqCv4VFBQcP78eeoKAHU4dOgQG28e5DhOJBItWrSIugIAXoSBpTjGrhJyHLd582bqBACVa21t3b59O3UFb1xdXfH+QQANhIGluKCgIOoEnt24cePUqVPUFQCqlZyc/OTJE+oK3uD2dgDNJOru7qZuEDB/f//ff/+duoJPDg4OFy9epK4AUJW//vrLxcWlpaWFOoQ3V65csbCwoK4AgBfhBEspAQEB1Ak8q6io2LVrF3UFgKp8/vnnLK0riUSCdQWgmTCwlBIUFKSrq0tdwbPt27dXVVVRVwDw79KlS99//z11BZ+WLVtGnQAAPcPAUoqZmRlj3/3McVx7e/vatWupKwB41t7eHhMTQ13BJwsLC4lEQl0BAD3DwFLWihUrqBP4l5eX98MPP1BXAPDpq6++qq6upq7gU0hIiFiMn+EAGgo3ufPA29v71q1b1BU8s7CwyM3NHTJkCHUIAA8qKiq8vb07OzupQ3gjEomKi4txAxaAxsKrHx4weYhVV1eHj8UCZkRFRbG0rjiO8/b2xroC0GQYWDx48803DQ0NqSv4d/jw4atXr1JXACgrNTWVsY9T4XB7O4DGw8DigaGh4RtvvEFdwb/u7m7GbgoGLVRfXx8XF0ddwbMRI0b4+vpSVwBAXzCw+BEWFkadoBJlZWUJCQnUFQCKW7NmTUNDA3UFz3B8BaD5MLD44ejoOGPGDOoKldi1axd7l1dAS3z77bdZWVnUFTzT1dUNDQ2lrgCAfmBg8SYiIoI6QSVkMllkZGRTUxN1CIB8qqurP/30U+oK/i1atMjS0pK6AgD6gYHFm9dff93a2pq6QiVqamo+/vhj6goAOXR2dkZERDx79ow6hH9r1qyhTgCA/mFg8UYsFrN6iMVxXHp6+unTp6krAAZq27Zt169fp67gn5eX19ixY6krAKB/+KBRPjU1NU2ePPnp06fUISphbGx84cIFXJsAzXf58mV/f38mf7ilpaW5u7tTVwBA/3CCxSdjY+Pg4GDqClVpampatWoVk09awJLm5uaVK1cy+RfV0dER6wpAKDCwePb2229TJ6hQfn5+UlISdQVAX9auXVtTU0NdoRK4+wpAQDCweObg4ODv709doUIJCQm5ubnUFQA927Nnz6lTp6grVMLS0pLtny0AjMHA4l9sbKxIJKKuUBWZTBYREVFRUUEdAvCi8+fPb926lbpCVVavXi0W4yc2gGDg4cq/8ePHs/1Cs7GxcdmyZY2NjdQhAP+6e/fuO++8I5PJqENUwtTUdPny5dQVACAHDCyViImJYfgQi+O4qqqqiIgIVp/MQHCampqWLl3a0tJCHaIqsbGx+vr61BUAIAcMLJVg/hCL47jc3NwtW7ZQVwBwMpksPDy8urqaOkRVrKysVqxYQV0BAPLBwFKVmJgY5m+YSE5OZvWGYhCQTZs25eXlUVeoUExMjJ6eHnUFAMiH8QVAaPz48QEBAdQVKrdmzZorV65QV4D2SktLS0lJoa5QITs7u5CQEOoKAJAbBpYKbdiwQUdHh7pCtZ49exYSEnL37l3qENBG2dnZsbGx1BWqtXbtWuoEAFAEBpYKjRkzRhve+FNfXx8UFFRVVUUdAtqloKAgPDy8q6uLOkSFHBwcFi5cSF0BAIrAwFKt6OjowYMHU1eoXG1tbVBQUG1tLXUIaItr166FhIR0dHRQh6jWRx99xPytnACswkNXtczNzd977z3qCnWoqalZvHhxfX09dQiwr6ysbPHixax+q/o/XnnlFT8/P+oKAFCQiMmvRNUora2t06dPf/LkCXWIOjg7O588eXLIkCHUIcCse/fuSaVSbXhAHT9+3NXVlboCABSEEyyVGzx48Lp166gr1OTGjRtLly599uwZdQiwqaamJjAwUBvWla+vL9YVgKDhBEtNZsyYoT23gXt6eh44cMDAwIA6BJjy8OHDoKCgyspK6hB1yM/Pt7W1pa4AAMXhBEtNNm3aRJ2gPjk5OUFBQc3NzdQhwI7Kykp/f38tWVeRkZFYVwBChxMs9Vm+fHl2djZ1hfo4OTmlpqaOGDGCOgQE7/r168HBwVryFgoTE5PCwkLcyAggdDjBUp+EhIRBgwZRV6hPWVmZVCqtqamhDgFhy8vLW7hwoZasK47j1q9fj3UFwAAMLPWxtrZ+//33qSvU6v79+1KptLy8nDoEhCozM3Pp0qWtra3UIWpiZ2eH73UGYAMGllp9+OGH1tbW1BVqVVtbO3/+/OLiYuoQEJ60tLSwsDDmP030efHx8cx/vxaAlsDAUqtBgwZt2bKFukLdGhsbAwMDc3JyqENASPbs2RMVFSWTyahD1MfDw8PHx4e6AgD4gZvcCYSEhJw7d466gkBCQoI2fDkjKC86Ojo1NZW6Qq309fVzc3NHjRpFHQIA/MDAIvDw4UM3N7e2tjbqEAJhYWHx8fH4ejXoTUNDw/Lly4uKiqhD1G3z5s3h4eHUFQDAGzzPEbCystqwYQN1BY0DBw4sWbKkqamJOgQ0UWVl5dy5c7VwXU2ZMiUsLIy6AgD4hBMsGl1dXVKp9Nq1a9QhNOzs7FJTU21sbKhDQIPk5+e/9dZbWji+9fT0cnJy7OzsqEMAgE84waKho6Pz5Zdfau3bhbT2oAJ6k5qaunjxYi1cVxzHRUdHY10BsAcDi4yjo2NkZCR1BZmGhoYFCxYcPXqUOgTobdy4MTo6uqurizqEgJOTU1RUFHUFAPAPlwgptbW1eXl5VVdXU4dQ8vPzS0xMNDY2pg4BAvfu3YuIiCgrK6MOoaGjo5ORkTFx4kTqEADgH06wKBkYGOzYsYO6gthPP/3k5eVVUFBAHQLq9vXXX7u5uWntuuI4LjIyEusKgFU6cXFx1A1azcbG5unTp4WFhdQhlJqbm9PS0lpbW2fOnKm196Vplbq6urCwsIMHD1KHUHJ0dNy7dy/+wgOwCpcI6XV2dkql0pKSEuoQek5OTnv37h03bhx1CKhQZmbmBx980NjYSB1CSV9fPzs7e+zYsdQhAKAquERIT1dXNyUlZfDgwdQh9MrKyubMmZOSkoLdz6SWlpaoqKjQ0FAtX1ccx33++edYVwBsw8DSCLa2tvHx8dQVGqG9vT0uLm7+/Pm3b9+mbgE+nT592sPDIy0tjTqEnkQiWbFiBXUFAKgWLhFqkNDQ0MzMTOoKTaGjoxMeHr5+/XojIyPqFlBKZWXl+vXrc3NzqUM0goWFRU5OjomJCXUIAKgWBpYGaWxsnDZtWktLC3WIBrGwsIiPj/f396cOAQVt27YNb5V9Xlpamru7O3UFAKgcLhFqkJ07d2JdvaCuri4yMjIwMLCyspK6BeRz/vx5FxcXrKvnrVq1CusKQEv8BwAA///s3XtQVOXjx3EEl4siF43dZQzUkkLARECF1L7uqOEltcESU8eycKKU0RkqMdQkkpwxhcnMC5Kyxbgr3VSUMDVFibTAqcksAUtHBUW8RyKhvz/4dSIV5bK7z9lz3q8/nESEjzOmb59zOMsJllykpaV98MEHolfI2pw5c+bMmePq6ip6CO7j1KlTCxcuLCgoED1EXkJCQnbu3Cl6BQAbIbBkITU1dfXq1aJX2AGdTjdv3rxJkyY5OnL4KkdXr17NyMjIysq6ceOG6C3y4uHhsXv37u7du4seIke//fbbkSNHysvLy8rKKisra2pqLly4oM4XpoQoLi4uQUFBISEhwcHBISEhYWFh7f+YBJZ41FVrBQQELF26NCoqSvQQ/Ku+vj47Ozs9Pf3ixYuit8hOhw4dTCbT0KFDRQ+RkUuXLu3YsWP37t3fffcdv2cgQwaDYdSoUU8++aROp2vbRyCwBKOu2mzYsGEpKSk8lVQO8vLy0tLSuE+uOfPmzZszZ47oFXKxdevWTZs27du3T/QQoEXCwsImTpw4Y8aM1v5EAksk6qqdHB0dY2Njk5KSfHx8RG9RqR9//DE5Obm0tFT0EPkaMWKE0WgUvUK8v/76Kzc3d926dcePHxe9BWg1f3//+fPnjx8/vkOHDi38KQSWMNzVbikuLi7PP//8yy+/7OvrK3qLihw8eHDNmjXcyX5vPXv2LCgo6NKli+ghgu3YsSM1NfXEiROihwDtEhUVlZqaGhQU1JJ3JrDE4OzK4jp27Dh27NhZs2aFhISI3qJkDQ0NeXl569atO3z4sOgtcufm5lZQUNC7d2/RQ0T65ZdfFi5cWFxcLHoIYBmOjo7PP/98UlLSff/hRGAJQF1ZVWRkZHx8/MiRI1t+kIuWuHr1ak5OTlZW1unTp0VvsQ/r168fM2aM6BUilZeXv/jii+Xl5aKHABam1WpTUlImTJhwj/chsGxtyZIlq1atEr1C+fz9/ePj4ydPnsxzs9qvsrIyMzPTaDTW1taK3mI3Xn311QULFoheIdL+/fvj4uJ42gKUqlOnTtnZ2YMHD27uHQgsm+LsysY8PDwmTJgQGxtrkYeaqE19fX1+fr7ZbC4sLGxoaBA9x54MHz7caDSq+Qx127ZtCQkJPA4NyqbRaNLT02NiYu76owSW7VBXAvXu3Xvy5MnPPPOMVqsVvcUOHD58ePPmzV9++eXly5dFb7E/ffv23bJli5qPTjMzMxcvXsxfLlCJhISEpKSkO/9BRWDZCHUlB05OTv/73/9iY2NHjRql0WhEz5GdCxcumEymzZs3Hzt2TPQWe6XX63ft2tW1a1fRQ4Q5cODAlClT/v77b9FDANtZunTp9OnTb3sjgWULPJFBbjw8PMaMGTN69OiRI0eK3iJeTU1NXl5efn5+YWGh6C32zd3dffv27Wp++O3hw4djY2OvXbsmeghgUxqNJjc3d+DAgU3fSGBZHWdXctapU6dhw4Y1vh6Ch4eH6Dk2VV5e/tVXXxUUFJSWlvLnQPs5OTnl5uZGRkaKHiJMTU1NdHT0mTNnRA8BBPDz8/v666+b/j1CYFkXdWUvOnbsGBkZOWrUqDFjxuj1etFzrOXWrVulpaX5+fkFBQUVFRWi5yhKRkbGpEmTRK8Qpr6+/tlnnz106JDoIYAwo0ePzsrKkr5LYFkRdWWnevbsGR4eHhYWFhERERQU5OTkJHpRu1y9erW0tLSkpKSkpKS0tJT71q1h9uzZb775pugVIhmNxqSkJNErAMFWr14tPRyLwLIW6koZ3NzcQkNDw8PDw8PDIyIiunXrJnrR/d26dausrKykpOSHH34oLS09duwY/5tbVUxMzMqVK9X8UIZr165FRUXV1NSIHgII5uXltWfPnsbLIASWVVBXSqXT6QICAgICAh75h/Dkunnz5okTJ8rKyo79o7y8nCeC2kxMTMz777/v6OgoeohIPD8ZkMTFxb399tsOBJY18GeNqnh5eTWWVs+ePX19fX19ffV6fc+ePa3xuS5dulRZWVlVVVVZWVlZWVlWVlZWVnb06FFrfC60xLhx49auXSt6hWBXrlwZOHDglStXRA8BZMHV1bW4uFin0xFYFsYTGdDI29vb9x86nc75v1xcXDQajbOzs5ubW0NDQ11d3Y0bN27cuHHbf9TW1p45c6aqqqrx2+vXr4v+ZeFf0dHRGzZsEL1CvOXLly9fvlz0CkBGZs2alZycTGBZElcGAZUwGAzZ2dkdO3YUPUSw69evh4aGcnwFNOXl5VVSUqLq+wYsi7oCVGLIkCEbN26krhwcHPbu3UtdAbe5dOnSzp07CSzLoK4AlRg4cODHH3/MSy01MpvNoicAcpSfn88lQgugrgCVGDJkiNFoVPMLOTdVV1cXGBhYV1cnegggOz4+PpxgtRd1BahEdHR0Tk4OdSUpKSmhroC7qq6uJrDahboCVGLcuHFZWVlcGWyquLhY9ARAvgistqOuAJWYPHnymjVrVP400Tv99NNPoicA8sWfF21EXQEqMXPmzBUrVqj5lXCac/z4cdETAPniy4zbgroCVOKNN96YO3eu6BVyVFtb+/vvv4teAcgXgdVqaWlp1BWgBkuWLJkxY4boFTJ19uzZmzdvil4ByBeB1TqcXQFqoNFo1q9fP3LkSNFD5OvChQuiJwCyRmC1QnJyMi89Biiep6dnTk5OWFiY6CGyxgMagHsjsFqKugLUoEePHiaTqUePHqKHyB2BBdwbgdUi1BWgBo899pjZbPb09BQ9xA54eHiIngDIGo9puD/qClCDkSNHbtmyhbpqIZ5oD9wbgXUf1BWgBnFxcRs3bnRxcRE9xG507txZ9ARA1rhEeC8pKSnUFaB4y5Ytmzp1qugVdsbPz8/JyamhoUH0EECmCKxmcXYFKJ5erzcajSEhIaKH2B8nJydfX99Tp06JHgLIFJcI7466AhRv6NChe/bsoa7azM/PT/QEQL4IrLugrgBlc3R0TExMNJlMXl5eorfYMR4VBtwDgXU76gpQNi8vr02bNiUmJvL6ze1kMBhETwDkq8OtW7dEb5AR6gpQtpCQEKPRqNfrRQ9Rgrq6ul69eoleAchRp06dOMH6F18zCChbfHz8zp07qStLcXFxGTZsmOgVgByNGDGCwPp/KSkpa9euFb1CFvr27avT6USvACypW7duOTk5ixYtEj1EaSZMmCB6AiBHo0ePJrAcHBwckpOTqatGwcHBn376aWFh4dNPPy16C2AZBoOhsLCQG4asYezYsRqNRvQKQF48PT2jo6MJLO67+ldwcPDnn3/epUuXLl26fPjhh+vXr+flxmDXXF1dlyxZkpOT4+3tLXqLMrm7u0+ePFn0CkBepk2b5urqqvab3KkriVRXTd947ty52bNnHzhwQNQqoM0CAgI2btzIXdjW9vvvvw8ePFj0CkAuXFxcDh48qNVqVX2CRV1J7lpXDg4OWq128+bNqampvEYb7EiHDh1mzpy5a9cu6soGevXqFRsbK3oFIBfTp0/XarUOan5MA3Ulaa6umjpx4sTcuXMPHjxos1VA2/Tq1WvFihWDBg0SPURFKisrhw4dWltbK3oIIJi3t/f+/fu7du3qoNoHjVJXkpbUlYODQ48ePb744otly5ZxVxZky9nZOTExce/evdSVjfn6+s6bN0/0CkC8tLS0xrpyUOcJFnUlaWFdNXX+/PmkpKQdO3ZYbxXQBoMGDVqxYgXXBAV66qmnSktLRa8AhBk9enRWVpb0XdUFFnUlaUNdSXbt2vX666+fPXvW4quA1vLy8lq0aBFfyybcyZMno6OjL1++LHoIIICfn9/XX3/d9CKPui4R8qx2Sb9+/T777LO21ZWDg8OIESP27ds3c+ZMy64CWismJmb//v3UlRz4+/unpaWJXgGIsWbNmttuoVHRCRbPapf069fPbDZb5G6qY8eOJScnFxUVtf9DAa3y8MMPv/vuu0OGDBE9BP+xfPny5cuXi14B2NR77703ZcqU296olsDiyqCkPVcGm5OXl5eSknL69GkLfkygOR4eHq+99tqMGTOcnJxEb8FdLFiw4KOPPhK9ArCRxMTExMTEO9+uisCiriTWqKtGdXV1K1euXLVqVV1dncU/ONDI0dFx6tSp8+fP9/LyEr0Fzbp169bixYszMzNFDwGsS6PRpKenx8TE3PVHlR9YXBmUWPDKYHNOnTr1zjvvbN261XqfAqoVGRm5ZMmSPn36iB6CFsnMzHzrrbdErwCsxc3N7ZNPPomKimruHRQeWJxdSax3dnWn77//fv78+b/88osNPhfUoHv37gsXLhw/frzoIWidffv2zZ49u6amRvQQwMJ8fHyMRmO/fv3u8T5KDizOriQ2OLu6k8lkSk1NvXjxoi0/KRTG09MzISHhpZde4sWa7FR1dXVCQkJhYaHoIYDFTJs2beHChfc9sFBsYHF2JQkNDTWbzbY5u7rNtWvXMjIyMjMz6+vrbf/ZYdc8PT3j4+Pj4uI6d+4segvaq6CgICUl5Y8//hA9BGiXqKio1NTUoKCglryzMgOLsytJWFiYyWRyd3cXuOHkyZPp6elms1ngBtgRd3f3V155JS4uTsi/CmA92dnZq1atOnXqlOghQKv5+fklJye36kYFBQYWZ1eS0NDQ3NxcmRwAnD59Oj09PTc3l9MsNMfd3T0uLi4+Pp6XvFSwrVu3btiwgVeOh73o37//M888M2PGjNb+RKUF1jvvvPPhhx+KXiEL/fv3N5vNYs+u7nT69OmMjIycnBzRQyAvrq6uL7zwQkJCgre3t+gtsIWff/45Kyvrq6++4qV1IE8Gg2Hs2LHDhw/X6XRt+wiKCqzU1NTVq1eLXiEL8qwrydmzZzMyMkwmEw/NwgMPPPDKK69MnTqVUyt1Onr06HfffXfkyJGysrLy8nK+LAZCuLi49OnTp2/fviEhIX379g0NDW3/x1ROYHFlUCKrK4P3cPny5ezs7A0bNvCi0erk7+8fHx8/ZcoUZ2dn0VsAwMIUEljUlcRe6kpSX1//xRdfrF279ujRo6K3wEaCgoJmz549fvx4R0d1vd48APVQQmBRVxK7q6umDhw4sGbNmm+++UYBvyfRnMcff3zWrFkGg0H0EACwLrsPLOpKYtd1JTlx4kR2drbZbOZWDCXRarUTJ06cOnXqQw89JHoLANiCfQcWdSVRRl1J6uvr8/LyjEYjX8tt1zQaTXR09KRJkwwGg5OTk+g5AGA7dhxY1JVEYXXVVEVFxcaNG3Nzc69cuSJ6C1qhX79+kyZNmjhxIl8bCECd7DWwFi9evG7dOtErZCEsLMxsNiuyrpoqKCjIz8/Py8urra0VvQXN0uv1EydOfO6557gUCEDl7DKwOLuSKPjs6q7q6+v37t2bl5dXUFDAmZZ86PX6cePGjR8/Pjw8XPQWAJAF+wsszq4kKjm7as6uXbvy8/O3b99OaYni7e0dExMzduzYyMhI0VsAQF7sLLB4VrtE5s9qt6V9+/Zt27YtPz+fLzy0ja5duz755JMxMTFDhgwRvQUAZMqeAosrgxK1XRlsiZs3bx46dGj79u3bt2+vqqoSPUdpNBpNRESEwWAwGAzBwcGi5wCA3NlNYFFXEurqvn799ddvv/32wIEDxcXFvJRsezz44IONUfXEE0906tRJ9BwAsBv2EVjcdyVR+X1XbfDTTz8VFRUVFRUdPHjwzz//FD3HDvj4+ERERERGRg4bNiwgIED0HACwS3YQWJxdSTi7ao+GhoYff/yxuLi4qKjo+++/J7YkTk5OgYGBAwYMiIiIiIiI8Pf3F70IAOye3AOLu9ol3NVuWSUlJUVFRd9+++2hQ4euX78ueo6t6XS6kJCQsLCwAQMGhIeHu7m5iV4EAIoi68Di7ErC2ZX13Lx58+TJk+VNVFRU1NTUiN5lSV5eXoGBgYGBgY8++mhgYGCfPn14wDoAWJV8AyslJWXt2rWiV8hCWFiYyWTi7MqWrl69+uuvv1ZUVBw/frysrKyioqK8vFz0qBbp3Lnzg//w9/cPDg5+5JFH9Hq96F0AoC4yDSyuDErCw8NNJhNnV3Jw/PjxioqKioqKM2fOnDt3rqam5ty5c9XV1ZcuXbL9GF9fX71er9fre/XqpdPppKjy9va2/RgAwG3kGFjUlYT7ruxFVVXVuXPnLl68WFVVVV1dff78eenb6urq+15w7NKli0aj0Wg0zs7Ojd82/oebm1u3bt10Op1Wq9VqtTqdzsfHR6vVdu3a1Ta/LgBA28gusLjvSsJ9VwAA2ClH0QP+g7qSUFcAANgvGQUWdSWhrgAAsGtyCSzqSkJdAQBg72QRWNSVhLoCAEABxAcWdSWhrgAAUAbBgUVdSagrAAAUQ2RgUVcS6goAACURFljUlYS6AgBAYcQEFnUloa4AAFAeAYFFXUmoKwAAFMnWgUVdSagrAACUyqaBRV1JqCsAABTMdoFFXUmoKwAAlM1GgUVdSagrAAAUzxaBRV1JqCsAANTA6oFFXUmoKwAAVMK6gUVdSagrAADUw4qBRV1JqCsAAFTFWoFFXUmoKwAA1MYqgUVdSagrAABUyPKBRV1JqCsAANTJwoFFXUmoKwAAVMuSgUVdSagrAADUzGKBRV1JqCsAAFTOMoFFXUmoKwAAYIHAoq4k1BUAAHBof2BRVxLqCgAANGpXYFFXEuoKAABI2h5Y1JWEugIAAE21MbCoKwl1BQAAbtOWwKKuJNQVAAC4U6sDi7qSUFcAAOCuWhdY1JWEugIAAM1pRWBRVxLqCgAA3ENLA4u6klBXAADg3loUWNSVhLoCAAD39X8AAAD//+3da2jV9QPH8e04c7lRgYpYRios0jTG1OncknLa5YE5NCEVqUZFFhWEQTWpiIQspAK1qSQ0rF1MNCS1m09KR4kERiwNzVJYy4WWZpOR5/9g4l+Xl53td/b9bXu9Hs1z+Z3Pw7e/37lcObDU1TnqCgDoiCsElro6R10BAB10ucBSV+eoKwCg4y4ZWK+++qq6alNQUFBXV6euAIAOyrrorZWVlZWVld08JZ7y8/Nra2vVFQDQcZnJZLLdTdu2bXvkkUf+e3sf5MogANAJ7QNrz549s2fPbm1tDTUoPtQVANA5FwTWiRMniouLm5ubAw6KCXUFAHTaBW9yr6ioUFcZ6goA6Jr/B9aOHTs++uijgFNiQl0BAF109hJhS0tLUVFRU1NT6D2BjR8/vqamRl0BAF1x9gxWVVWVusrPz1dXAEDXZSaTydbW1sLCwj4eWK4MAgBRSWRkZNTW1qordQUARCWRkZHx3nvvhZ4R0vjx49UVABChxOHDh/ft2xd6RjDedwUARC6xZcuW0BuCcWUQAEiHfolEorGxMfSMANQVAJAm/U6cOBF6QwDjx4+vq6tTVwBAOiSu/JBex/uuAIC06nOB5cogAJBufSuw1BUA0A36UGCpKwCge/SVwFJXAEC36ROBpa4AgO7U+wNLXQEA3ayXB5a6AgC6X28OLHUFAATRawNLXQEAofTOwFJXAEBAvTCw1BUAEFZvCyx1BQAE16sCS10BAHHQewKroKBAXQEAcZCYOHFi6A0RyM/Pr62tVVcAQBwk7rnnntAbusqVQQAgVjJ//fXXSZMmhZ7ReeoKeq7m5uYDBw789NNPR44caW5uPnbs2J9//plMJkPvAvqWa665Zty4cePGjRszZswNN9wQyTEzk8lkaWlpQ0NDJIfrZgUFBa4MQs/S2Ni4Y8eO+vr6nTt3NjU1hZ4DcIFrr722oKDgzjvvnD59+ogRIzp9nMxkMvnhhx8uXrw4um3dxLkr6EH++uuvLVu21NXV7d69O/QWgA4pKCh48MEH77vvvgEDBqT63MxkMtna2lpYWNiz/iuprqCnOHLkSGVlZU1NzalTp0JvAUjZkCFDnn322QULFmRlZXX8WYmMjIz+/fsvWrQobcOip66gRzh+/HhFRUVhYeG6devUFdBDHT169IUXXpg6derWrVs7/qzMtveTtrS0FBUV9YiTWBMmTKiurlZXEHMbNmxYsmTJiRMnQg8BiExRUdHy5cs78t6ss180mp2d/eabb6Z3VBTy8/PVFcTcv//+u2TJkmeeeUZdAb1MfX39jBkzNmzYcMVHZp7/iegnn3xy06ZN6RzWJa4MQvydPHmyvLz866+/Dj0EII3Ky8tfe+21yzzggsA6fvz4lClTjh8/nv5hKVNXEH9NTU3z5s378ccfQw8BSLtZs2a9++67l7r3gt8ivO6669asWdOvX7/0r0qNuoL4++WXX+699151BfQRH3/88cKFCy91b/sfey4pKXnllVfSuyhF6gri79ixY/Pmzfvtt99CDwHoPl9++eX8+fMvele//+ZUQUHB4cOHf/jhh7Tv6gB1BfF36tSpuXPn7t+/P/QQgO526NChY8eOTZs2rd3t7c9gtXn77beLi4vTv+oKJkyYoK4g/p566qnvv/8+9AqAMNatW7dx48Z2N148sDIyMj744IP/5lh3KikpqaurU1cQc++88862bdtCrwAI6fnnnz969Oj5t1wysK666qr169eXlZWlf9VFzJw5s66uLjs7O8irAx3U0NCwbNmy0CsAAvv777/b/azzJQOrzapVq956663c3Nx0rrpATk7OG2+8sXr16m57RaDTKioqQk8AiIXPP//8iy++OPfPC74H61KOHDny4osvnv+0NJk+ffrrr79+/fXXp/uFgK7bvn17eXl56BUAcTFixIhdu3a1/X2FM1hthg8fXlVVtXHjxry8vDRtysvL27hxY1VVlbqCHiGZTLo4CHC+Q4cOVVVVtf3doTNY5ySTye3bt1dWVu7evTuqNZMnT37sscfuvvvuzMzMqI4JpNunn3768MMPh14BEC/Dhw/ftWtXVlZWaoF1zt69ezds2LB58+Y//vijcwuGDh06a9as+++/f+zYsZ07AhDQzJkz9+zZE3oFQOysWLFi9uzZnQysc+rr67/66qudO3d28JzW5MmTi4uLb7/99sLCwq68LhDQwYMHS0pKQq8AiKOpU6fW1NR0NbDO19DQsG/fvp9//vnMmTPn356VlTVy5Mibb775lltuieq1gIBefvnltWvXhl4BEFPfffddlIEF9BG33XZbc3Nz6BUAMbV06dIOfYoQ4JwDBw6oK4DL+OSTTwQWkJpvvvkm9ASAWNu1a5fAAlIT4be0APRWAgtITUNDQ+gJAHHnTe5Aam666abW1tbQKwBizRksIAVNTU3qCuCKBBaQgtOnT4eeANADCCwgBe2+RhiAixJYAAARE1hACq6++urQEwB6AIEFpGDgwIGhJwD0AAILSEFOTk7oCQA9gMACUpBIJAYPHhx6BUDcCSwgNSNHjgw9ASDuBBaQmlGjRoWeABB3AgtIzejRo0NPAIg7gQWkZsqUKaEnAMTaoEGDBBaQmjFjxvgsIcBlTJs2TWABqUkkEqWlpaFXAMTXjBkzBBaQsrKystATAGJq4MCBAgvojNLS0tzc3NArAOKorKxswIABAgtIWf/+/efOnRt6BUAcPfTQQxk+RQh0zuOPP56VlRV6BUC8FBYWjh07NkNgAZ1z4403zpkzJ/QKgHh54okn2v7ITCaTYacAPVRjY2NxcXFLS0voIQCxkJ+fv3Xr1ra/ncECOmnYsGHPPfdc6BUAsZCZmbl8+fJz/xRYQOctWrTo1ltvDb0CILynn376/F8Sc4kQ6JKDBw+WlpaePn069BCAYCZOnLhp06ZE4v/nrZzBArpk1KhRS5cuDb0CIJihQ4euW7fu/LrKEFhA182fP3/evHmhVwAEkJ2dvX79+kGDBrW73SVCIAJnzpwpLy//7LPPQg8B6D7Z2dnV1dWTJk36713OYAERSCQSq1ev9iPQQN+Rk5NTW1t70brKEFhAVAYMGPD+++/Pnj079BCAtBs0aNDmzZsnTpx4qQcILCAyiURixYoVS5YsCT0EII1Gjx69devWy39JjfdgAdHbu3fvo48+evjw4dBDAKKUmZlZXl7+0ksv9e/f/wqPFFhAOvzzzz+rVq1auXKl39IBeoehQ4euXLlyypQpHXmwwALSqLGxcdmyZXV1daGHAHReTk7OggULFi9enJub28GnCCwg7X7//fc1a9ZUVVWdPHky9BaAFOTl5S1cuPCBBx7oeFq1EVhAN2lpaamurl67du2hQ4dCbwG4nMGDB991111z5swpKirq3BEEFtDd9u3b9+2339bX1+/du/fgwYOh5wCcVVhYeMcdd5SWlo4bN66LhxJYQGD79+9vbm4OvQLou3Jzc4cMGTJs2LAIjymwAAAi5otGAQAiJrAAACImsAAAIiawAAAiJrAAACImsAAAIiawAAAiJrAAACImsAAAIiawAAAiJrAAACImsAAAIiawAAAiJrAAACImsAAAIiawAAAiJrAAACImsAAAIiawAAAi9j80rnSkWg3OzAAAAABJRU5ErkJggg==", Y4 = { Lg: "992px", Xl: "1260px" }, y1 = Vv(), v1 = ({ initialValue: l, children: o }) => {
  const c = {
    ...l,
    breakpoint: Y4[l.breakpoint]
  };
  return /* @__PURE__ */ b.jsx(y1.Provider, { value: c, children: o });
};
v1.propTypes = {
  initialValue: E.shape(Lb).isRequired,
  children: E.node.isRequired
};
const Zn = () => {
  const l = Gv(y1);
  if (l === void 0)
    throw new Error("useAppContext must be used within a AppContextProvider");
  return l;
}, st = "uds-hdr-", D = {
  // Login component
  LOGIN_STATUS: `${st}login-status`,
  USER_NAME: `${st}name`,
  SIGNOUT: `${st}signout`,
  // Navigation
  NAV_LINK: `${st}nav-link`,
  NAV_ITEM_SELECTED: `${st}nav-item-selected`,
  OPEN_LINK: `${st}open-link`,
  ICON_NAV_ITEM: `${st}icon-nav-item`,
  MOBILE_ONLY: `${st}mobile-only`,
  CHEVRON_ICON: `${st}chevron-icon`,
  OPEN: `${st}open`,
  // Dropdown
  HEADER_DROPDOWN: (l) => `${st}header-dropdown-${l}`,
  OPENED: `${st}opened`,
  DROPDOWN_CONTAINER: `${st}dropdown-container`,
  DROPDOWN_CONTAINER_COLUMN: `${st}dropdown-container-column`,
  DROPDOWN_BUTTON_CONTAINER: `${st}dropdown-button-container`,
  // Search
  SEARCH_BUTTON: `${st}search-button`,
  OPEN_SEARCH: `${st}open-search`,
  SEARCH_ICON: `${st}search-icon`,
  SUBMIT_BUTTON: `${st}submit-button`,
  SUBMIT_SEARCH: `${st}submit-search`,
  // Header sections
  UNIVERSAL_NAV: `${st}universal-nav`,
  HEADER_TOP: `${st}header-top`,
  LINKS_CONTAINER: `${st}links-container`,
  HEADER_MAIN: `${st}header-main`,
  CONTENT_CONTAINER: `${st}content-container`,
  NAV_LIST: `${st}nav-list`,
  BUTTONS_CONTAINER: `${st}buttons-container`,
  NAV_BUTTON: `${st}nav-button`,
  UL_HEADING: `${st}ul-heading`,
  // Title
  TITLE: `${st}title`,
  PARTNER_TITLE: `${st}partner-title`,
  UNIT_NAME: `${st}unit-name`,
  SUBUNIT_NAME: `${st}subunit-name`,
  TITLE_SUBUNIT_NAME: `${st}title-subunit-name`,
  EXPAND_TITLE: `${st}expand-title`,
  NO_NAVIGATION: `${st}no-navigation`,
  // Partner/Logo
  PARTNER: `${st}partner`,
  PARTNERS_LOGOS: `${st}partners-logos`,
  LOGO_VERT: `${st}vert`,
  LOGO_HORIZ: `${st}horiz`,
  // Menu icons
  MENU_SEARCH_ICON: `${st}menu-search-icon`,
  MENU_CLOSE_ICON: `${st}menu-close-icon`,
  NAVBAR: "navbar",
  NAVBAR_EXPAND_XL: "navbar-expand-xl",
  NAVBAR_BRAND: "navbar-brand",
  NAVBAR_TOGGLER: "navbar-toggler",
  NAVBAR_NAV: "navbar-nav",
  NAV_ITEM: "nav-item",
  COLLAPSED: "collapsed",
  CONTAINER: "container",
  CONTAINER_XL: "container-xl",
  FORM_CONTROL: "form-control",
  VISUALLY_HIDDEN: "visually-hidden",
  VISUALLY_HIDDEN_FOCUSABLE: "visually-hidden-focusable",
  MOBILE_MENU_OPEN: `${st}mobile-menu-open`
}, Yp = (l) => D.HEADER_DROPDOWN(l), zn = (...l) => l.filter(Boolean).join(" "), nr = (l) => {
  const o = window == null ? void 0 : window.matchMedia(`(max-width: ${l})`), [c, s] = yn(o == null ? void 0 : o.matches), u = (d) => {
    s(d.matches);
  };
  return Ie(() => (o.addEventListener("change", u), () => o.removeEventListener("change", u)), []), c;
}, I4 = ze.div`
  background-color: ${K3};
  padding: 0.5rem 0rem;
  transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
  .${D.HEADER_TOP} {
    height: 100%;
    .nav {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .${D.LINKS_CONTAINER} {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
        .${D.NAV_LINK} {
          color: ${tn};
          font-size: 0.75rem;
          line-height: 1;
          white-space: nowrap;
          text-decoration: none;
          display: flex;
          align-items: center;

          &:hover {
            text-decoration: underline;
          }

          &.visually-hidden-focusable:not(:focus):not(:active) {
            clip: rect(0 0 0 0);
            clip-path: inset(100%);
            height: 1px;
            overflow: hidden;
            position: absolute;
            white-space: nowrap;
            width: 1px;
          }
        }
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    min-height: auto;
    position: sticky;
    bottom: 0;
    padding: 0;
    .${D.HEADER_TOP} {
      width: 100%;
      .nav {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column-reverse;
        .${D.LINKS_CONTAINER} {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-auto-flow: row;
          justify-items: start;
          width: 100%;
          gap: 0;
          border-top: 1px solid ${$e};
          border-left: 1px solid ${$e};
          .${D.NAV_LINK} {
            white-space: normal;
            margin-right: 0;
            text-align: center;
            width: 100%;
            font-size: 0.875rem;
            padding: 1rem 1.5rem;
            border-bottom: 1px solid ${$e};
            border-right: 1px solid ${$e};
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;

            &.visually-hidden-focusable:not(:focus):not(:active) {
              border: none;
            }
          }
        }
      }
    }
  }

  @media screen and (orientation: landscape) and (max-width: ${({
  breakpoint: l
}) => l}) {
    .${D.HEADER_TOP} .nav .${D.LINKS_CONTAINER} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }
`, F4 = ze.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  > a {
    padding: 0;
    margin: 0;
    color: ${tn};
    text-decoration: none;
    line-height: 1;
    vertical-align: middle;
  }
  > span.${D.USER_NAME} {
    font-weight: 700;
    line-height: 1;
  }
  > a.${D.SIGNOUT}:before {
    content: "(";
    margin-left: 4px;
  }
  > a.${D.SIGNOUT}:after {
    content: ") ";
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    margin-right: 0;
    justify-content: center;
  }
`, Ip = {
  section: "topbar"
}, k4 = () => {
  const {
    loggedIn: l,
    userName: o,
    logoutLink: c,
    loginLink: s,
    onLoginClick: u,
    onLogoutClick: d,
    breakpoint: h
  } = Zn();
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsx(
      F4,
      {
        className: zn(D.NAV_LINK, D.LOGIN_STATUS),
        breakpoint: h,
        children: l ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          o ? /* @__PURE__ */ b.jsx("span", { className: D.USER_NAME, "data-testid": "user-name", children: o }) : "",
          /* @__PURE__ */ b.jsx(
            "a",
            {
              className: D.SIGNOUT,
              href: c,
              onFocus: () => Nt({
                ...Ip,
                text: "sign out"
              }),
              onClick: (A) => d == null ? void 0 : d(A),
              children: "Sign Out"
            }
          )
        ] }) : /* @__PURE__ */ b.jsx(
          "a",
          {
            href: s,
            onFocus: () => Nt({
              ...Ip,
              text: "sign in"
            }),
            onClick: (A) => u == null ? void 0 : u(A),
            children: "Sign In"
          }
        )
      }
    )
  );
}, q4 = ze.form`
  display: flex;
  align-items: center;
  button {
    border: none;
    background: transparent;
    cursor: pointer;
  }
  .${D.SEARCH_BUTTON} {
    transition: cubic-bezier(0.19, 1, 0.19, 1);
    font-size: 0.75rem;
    line-height: 1;
    color: ${tn};
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    span {
      margin-right: 0.25rem;
    }
  }
  input[name="q"] {
    width: 200px;
    background-color: ${Kn};
    border: 0;
    border-radius: 0;
    padding: 0.5rem 0.5rem;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1;
    color: ${P3};
    border: 1px solid ${$e};
    outline: ${tn};
    margin-left: 1.5rem;
    display: unset;
    vertical-align: middle;

    &::placeholder {
      font-size: 0.75rem;
      line-height: 1;
    }
    &:focus,
    &:focus-visible {
      border: 1px solid ${tn};
    }
  }
  .${D.SUBMIT_BUTTON} {
    margin-left: 0.5rem;
  }
  .${D.CLOSE_SEARCH} {
    background-color: ${Kn};
    border: 1px solid ${$e};
    border-radius: 100%;
    padding: 0.45rem 0.75rem;
    margin-left: 0.5rem;
  }
  &.${D.OPEN_SEARCH} {
    margin-left: -1rem;
    .${D.SEARCH_BUTTON} {
      transform: translate(1.9rem);
      pointer-events: none;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    padding: 0 1rem 1rem;
    label {
      position: relative;
      font-size: 0.875rem;
      margin-bottom: 0;
      width: 100%;
      svg.${D.SEARCH_ICON} {
        position: absolute;
        top: 50%;
        left: 1rem;
        transform: translate(0, -50%);
      }
      input[name="q"] {
        width: 100%;
        margin: 0;
        padding: 0.5rem 3rem 0.5rem 2.25rem;
        font-size: 1rem;
        line-height: 1.5;

        &::placeholder {
          font-size: 1rem;
          line-height: 1.5;
        }

        &::-webkit-search-cancel-button,
        &::-webkit-search-decoration,
        &::-webkit-search-results-button,
        &::-webkit-search-results-decoration {
          display: none;
        }
      }
      .${D.SUBMIT_SEARCH} {
        position: absolute;
        top: 50%;
        right: 0.5rem;
        transform: translate(0, -50%);
        border-radius: 50%;
        width: 2rem;
        height: 2rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        background-color: ${xd};
        color: ${Kn};
        font-size: 0.75rem;
      }
    }
  }
`, pd = ({
  inputRef: l,
  hasInputValue: o,
  setHasInputValue: c,
  isMobile: s,
  style: u = {},
  className: d = "",
  onBlur: h
}) => {
  const A = (S) => {
    const B = S.target.value;
    c(B.length > 0);
  }, y = {
    ref: l,
    className: `form-control ${d}`,
    type: "search",
    name: "q",
    placeholder: "Search asu.edu",
    required: !0,
    onChange: A,
    onBlur: h,
    style: {
      paddingLeft: o && s ? "1rem" : void 0,
      ...u
    }
  };
  return s ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    !o && /* @__PURE__ */ b.jsx(
      Ye,
      {
        className: D.SEARCH_ICON,
        icon: Pf
      }
    ),
    /* @__PURE__ */ b.jsx("input", { ...y }),
    o && /* @__PURE__ */ b.jsx(
      "button",
      {
        type: "submit",
        "aria-label": "Submit search",
        className: D.SUBMIT_SEARCH,
        children: /* @__PURE__ */ b.jsx(Ye, { icon: Pf, size: "lg" })
      }
    )
  ] }) : /* @__PURE__ */ b.jsx("input", { ...y });
};
pd.propTypes = {
  inputRef: E.shape({
    current: E.instanceOf(Element)
  }).isRequired,
  hasInputValue: E.bool.isRequired,
  setHasInputValue: E.func.isRequired,
  isMobile: E.bool.isRequired,
  style: E.object,
  className: E.string,
  onBlur: E.func
};
const Fp = {
  event: "search",
  action: "type",
  name: "onenter",
  type: "main search",
  region: "navbar",
  section: "topbar"
}, b1 = () => {
  const { breakpoint: l, searchUrl: o = "", site: c = "" } = Zn(), s = nr(l), u = wl(null), [d, h] = yn(!1), [A, y] = yn(!1);
  Ie(() => {
    var w;
    d && typeof ((w = u == null ? void 0 : u.current) == null ? void 0 : w.focus) == "function" && u.current.focus();
  }, [d]);
  const S = (w) => {
    const C = w == null ? void 0 : w.currentTarget;
    w.preventDefault();
    const _ = C && C.elements ? (
      /** @type {HTMLInputElement|null} */
      C.elements.namedItem("q")
    ) : null;
    Nt({
      ...Fp,
      text: _ ? _.value : ""
    }), setTimeout(() => {
      typeof (C == null ? void 0 : C.submit) == "function" && C.submit();
    }, 100);
  }, B = () => {
    h((w) => {
      const C = !w;
      return Nt({
        ...Fp,
        event: "link",
        action: "click",
        name: "onclick",
        text: C ? "search icon" : "close search icon"
      }), C;
    });
  };
  return /* @__PURE__ */ b.jsx("search", { children: /* @__PURE__ */ b.jsxs(
    q4,
    {
      breakpoint: l,
      action: o,
      onSubmit: S,
      method: "get",
      name: "gs",
      className: d ? D.OPEN_SEARCH : "",
      "data-testid": "universal-nav-search-form",
      role: "search",
      children: [
        s ? /* @__PURE__ */ b.jsx("label", { children: /* @__PURE__ */ b.jsx(
          pd,
          {
            inputRef: u,
            hasInputValue: A,
            setHasInputValue: y,
            isMobile: s
          }
        ) }) : /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          !d && /* @__PURE__ */ b.jsxs(
            "button",
            {
              type: "button",
              "aria-label": "Search asu.edu",
              onClick: B,
              className: D.SEARCH_BUTTON,
              "data-testid": "search-button",
              children: [
                /* @__PURE__ */ b.jsx("span", { children: "Search" }),
                /* @__PURE__ */ b.jsx(Ye, { icon: Pf })
              ]
            }
          ),
          d && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
            /* @__PURE__ */ b.jsx(
              pd,
              {
                inputRef: u,
                hasInputValue: A,
                setHasInputValue: y,
                isMobile: s,
                onBlur: () => {
                  A || h(!1);
                }
              }
            ),
            /* @__PURE__ */ b.jsx(
              ji,
              {
                color: "dark",
                text: "Search",
                as: "button",
                classes: D.SUBMIT_BUTTON
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ b.jsx("input", { name: "url_host", value: c, type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "site", value: "default_collection", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "sort", value: "date:D:L:d1", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "output", value: "xml_no_dtd", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "ie", value: "UTF-8", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "oe", value: "UTF-8", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "client", value: "asu_frontend", type: "hidden" }),
        /* @__PURE__ */ b.jsx("input", { name: "proxystylesheet", value: "asu_frontend", type: "hidden" })
      ]
    }
  ) });
}, K4 = {
  event: "link",
  action: "click",
  name: "onclick",
  region: "navbar",
  type: "internal link",
  section: "topbar",
  text: ""
}, S1 = () => {
  const { breakpoint: l } = Zn(), o = nr(l);
  function c() {
    try {
      return window.location.href;
    } catch (u) {
      return console.error(u), "";
    }
  }
  const s = [
    {
      className: zn(
        D.NAV_LINK,
        D.VISUALLY_HIDDEN_FOCUSABLE
      ),
      href: "#skip-to-content",
      text: "Skip to main content"
    },
    {
      className: zn(
        D.NAV_LINK,
        D.VISUALLY_HIDDEN_FOCUSABLE
      ),
      href: `https://accessibility.asu.edu/report#a11yref=${c()}`,
      text: "Report an accessibility problem"
    },
    {
      className: D.NAV_LINK,
      href: "https://asu.edu",
      text: "ASU Home"
    },
    {
      className: D.NAV_LINK,
      href: "https://my.asu.edu",
      text: "My ASU"
    },
    {
      className: D.NAV_LINK,
      href: "https://www.asu.edu/academics/colleges-schools",
      text: "Colleges and Schools"
    }
  ];
  return /* @__PURE__ */ b.jsx(
    I4,
    {
      breakpoint: l,
      className: D.UNIVERSAL_NAV,
      "data-testid": "universal-navbar",
      "data-elastic-exclude": "data-elastic-exclude",
      children: /* @__PURE__ */ b.jsx("div", { className: "container-xl", children: /* @__PURE__ */ b.jsx("div", { className: D.HEADER_TOP, children: /* @__PURE__ */ b.jsxs("nav", { className: "nav", "aria-label": "ASU Global", children: [
        /* @__PURE__ */ b.jsxs("div", { className: D.LINKS_CONTAINER, children: [
          s.map((u) => /* @__PURE__ */ b.jsx(
            "a",
            {
              className: u.className,
              href: u.href,
              onClick: () => Nt({ ...K4, text: u.text }),
              children: u.text
            },
            u.href
          )),
          /* @__PURE__ */ b.jsx(k4, {})
        ] }),
        !o && /* @__PURE__ */ b.jsx(b1, {})
      ] }) }) })
    }
  );
}, Z4 = ze.div`
  background-color: ${Kn};
  border-bottom: 1px solid ${$e};
  padding: 0 12px;
  .navbar {
    padding: 0;
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
  }
  .navbar.${D.MOBILE_MENU_OPEN} {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto auto 1fr;
    grid-template-areas:
      "logo . toggler"
      "title title title"
      "search search search"
      "nav nav nav";

    height: calc(100dvh - ${({ headerTop: l }) => l}px);
    overflow: hidden;
    .${D.PARTNER_TITLE}, .navbar-brand {
      grid-area: logo;
      grid-column: 1;
      grid-row: 1;
    }
    .navbar-toggler {
      grid-area: toggler;
      grid-column: 3;
      grid-row: 1;
    }
    .${D.EXPAND_TITLE} {
      grid-area: title;
    }
    & > * {
      grid-column: 1 / -1;
    }
    & > form {
      grid-area: search;
    }
    & > nav {
      grid-area: nav;
      display: grid;
      grid-template-rows: 1fr auto;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
  .navbar-brand {
    .${D.LOGO_VERT} {
      display: block;
      height: 72px;
      width: auto;
      margin: 20px 1rem 20px 0;
    }
    .${D.LOGO_HORIZ} {
      display: none;
    }
  }
  .navbar-toggler {
    display: none;
  }
  .${D.EXPAND_TITLE} {
    width: 100%;
  }
  @media (min-width: ${({ breakpoint: l }) => l}) {
    .${D.NO_NAVIGATION} {
      margin-top: 16px;
      display: flex;
      align-items: center;
      .${D.TITLE} {
        width: 100%;
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    padding: 0;
    .navbar {
      padding: 1.5rem 0 0 0;
      flex-wrap: wrap;
      justify-content: space-between;
      &.${D.PARTNER} {
        flex-direction: row-reverse;
      }
    }
    .${D.PARTNER} .${D.CONTENT_CONTAINER} {
      min-height: calc(100vh - 240px);
    }
    .navbar-brand {
      padding: 0;
      margin: 0;

      .${D.LOGO_VERT} {
        display: none;
      }

      .${D.LOGO_HORIZ} {
        display: block;
        height: 32px;
        width: auto;
        margin-bottom: 1rem;
        margin-left: 2rem;
      }
    }
    .navbar-toggler {
      display: initial;
      background: transparent;
      color: ${tn};
      border: 0;
      border-radius: 0;
      font-size: 1.25rem;
      margin-right: 2rem;
      cursor: pointer;
      min-width: 44px;
      min-height: 44px;
      padding: 0.25rem 0.45rem;

      .${D.MENU_SEARCH_ICON} {
        display: none;
      }

      &.collapsed {
        .${D.MENU_SEARCH_ICON} {
          width: 24px;
          height: auto;
          display: unset;
        }
        .${D.MENU_CLOSE_ICON} {
          display: none;
        }
      }
      .${D.NO_NAVIGATION} + nav .${D.BUTTONS_CONTAINER} {
        border-top: 1px solid ${Rc};
      }
    }
  }
`, O1 = "data:image/png;base64,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", E1 = "data:image/png;base64,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", P4 = ze.a`
  display: unset;
  padding: 0;
  margin: 0;
  font-size: unset;
  line-height: unset;
  white-space: unset;
`, W4 = () => {
  const { logo: l } = Zn();
  return /* @__PURE__ */ b.jsxs(
    P4,
    {
      href: (l == null ? void 0 : l.brandLink) ?? "https://asu.edu",
      className: D.NAVBAR_BRAND,
      "data-testid": "logo",
      onFocus: () => Nt({ text: "asu logo" }),
      children: [
        /* @__PURE__ */ b.jsx(
          "img",
          {
            className: D.LOGO_VERT,
            src: (l == null ? void 0 : l.src) ?? O1,
            alt: (l == null ? void 0 : l.alt) ?? "Arizona State University logo",
            title: (l == null ? void 0 : l.title) ?? "ASU homepage",
            width: "303",
            height: "234",
            decoding: "async",
            fetchpriority: "high"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "img",
          {
            className: D.LOGO_HORIZ,
            src: (l == null ? void 0 : l.mobileSrc) ?? E1,
            alt: (l == null ? void 0 : l.alt) ?? "Arizona State University logo",
            title: (l == null ? void 0 : l.title) ?? "ASU homepage",
            width: "400",
            height: "72",
            decoding: "async",
            fetchpriority: "high"
          }
        )
      ]
    }
  );
}, J4 = ze.nav`
  white-space: nowrap;
  > .${D.CONTENT_CONTAINER} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: none;
    height: auto;
    margin: inherit;
    font-size: inherit;
    color: inherit;
    flex-direction: row;
  }
  .${D.NAV_LIST} {
    display: flex;
    margin: 0;
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    width: 100%;
    > .${D.CONTENT_CONTAINER} {
      flex-direction: column;
      justify-content: flex-start;
      overflow-y: auto;
      min-height: 0;
      > *:last-child {
        margin-bottom: min(75px, 15vw);
      }
    }
    .${D.NAV_LIST} {
      flex-direction: column;
      width: 100%;
    }
    .${D.BUTTONS_CONTAINER} {
      display: flex;
      align-items: center;
      padding: 1rem 2rem;
      width: 100%;
    }
  }
`, _4 = ze.div`
  --container-width: 1200px;
  --gap: 2rem;
  position: fixed;
  background-color: ${Kn};
  border: 1px solid ${$e};
  margin: 0;
  z-index: 1031;
  visibility: hidden;
  white-space: normal;
  &.${D.OPENED} {
    visibility: visible;
  }
  &.mega {
    width: min(var(--container-width), 100%);
    left: calc((100% - var(--container-width)) / 2);
  }
  &.aligned-right:not(.mega) {
    position: absolute;
    right: 0;
  }
  > .${D.DROPDOWN_CONTAINER} {
    max-width: var(--container-width);
    margin: 0 auto;
    /*
      max-height is calculated from
      100% view Height
      minus header
      minus 2rem padding
      minus 4rem cta buttons - future we could add a ref to measure if needed
    */
    max-height: calc(
      100vh - ${({ headerHeight: l }) => l}px - 2rem - 4rem
    );
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: stretch;

    .${D.DROPDOWN_CONTAINER_COLUMN} {
      --span: 1; /* component overrides using inline style */
      --col: 1; /* component overrides using inline style */
      width: calc(var(--container-width) / var(--cols) * var(--span));
      padding: var(--gap);
      padding-bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      row-gap: var(--gap);

      & > *:last-child {
        padding-bottom: var(--gap);
      }

      &:not(:last-child) {
        border-right: 1px solid ${$e};
      }
    }

    .${D.UL_HEADING} {
      margin-top: 0;
      font-size: 1.5rem;
      letter-spacing: -0.035em;
      font-weight: 700;
      text-align: left;
      opacity: 1;
      margin: 0;
      margin-bottom: -1.5rem;
      line-height: calc(100% + 0.12em);
    }
    ul {
      --ul-gap: 1rem;
      &:is(:last-child) {
        flex-grow: 0;
      }
      margin: 0;
      width: calc(
        var(--container-width) / var(--cols, 1) * var(--span, 1) - var(--gap) *
          2
      );
      display: flex;
      flex-direction: row;
      column-gap: var(--ul-gap);
      flex-wrap: wrap;
      .${D.NAV_LINK} {
        padding: 0;
        flex-basis: calc(
          (100% / var(--span)) - var(--ul-gap) * (var(--span) - 1) / var(--span)
        );
        a {
          width: 100%;
          display: inline-block;
          margin: 0.75rem 0;
          position: relative;
          line-height: 1rem;
          color: ${tn};
          &:hover {
            color: ${xd};
            text-decoration: underline;
          }
        }
        & + .${D.NAV_BUTTON} {
          width: 100%;
          margin-top: auto;
          padding-top: var(--gap);
          & + .${D.NAV_BUTTON} {
            margin-top: 1rem;
          }
        }
      }
    }
  }

  .${D.NAV_BUTTON} {
    flex: 1 1;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-wrap: nowrap;
    width: fit-content;
  }
  .${D.DROPDOWN_BUTTON_CONTAINER} {
    border-top: 1px solid ${$e};
    border-bottom: 1px solid ${$e};
    > div {
      max-width: var(--container-width);
      margin: 0 auto;
      display: flex;
      padding: 1rem 2rem;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    position: initial;
    border: none;
    max-height: unset;
    visibility: visible;
    display: none;
    &.${D.OPENED} {
      display: block;
    }
    > .${D.DROPDOWN_CONTAINER} {
      max-width: 100%;
      max-height: unset;
      overflow-y: unset;
      overflow-x: unset;
      flex-direction: column;

      .${D.DROPDOWN_CONTAINER_COLUMN} {
        width: 100%;
        border-right: unset;
        &:not(:first-child) {
          padding-top: 0;
        }
      }
      ul {
        width: 100%;
        max-width: 100%;
        padding: 0;
        &:not(:last-child) {
          border: none;
        }
        .${D.UL_HEADING} {
          font-size: 1.25rem;
        }
        .${D.NAV_BUTTON} {
          // padding-top: 1.5rem;
        }
        .${D.NAV_LINK} {
          flex-basis: 100%;
          padding: 0 1rem;
          &:not(:last-child) {
            border-bottom: 1px solid ${$e};
          }
          a {
            padding: 1rem 0;
            margin: 0;
          }
        }
      }
    }
    .${D.DROPDOWN_BUTTON_CONTAINER} {
      margin-top: 0;
      > div {
        max-width: 100%;
        padding: 1rem 3rem;
      }
    }
  }
`, $4 = {
  event: "link",
  action: "click",
  name: "onclick",
  type: "internal link",
  region: "navbar",
  section: "main navbar",
  component: "dropdown menu",
  text: ""
}, T1 = ({ text: l }) => /* @__PURE__ */ b.jsx("h3", { className: D.UL_HEADING, children: l });
T1.propTypes = {
  text: E.string
};
const x1 = ({ link: l, dropdownName: o, handleLinkEvent: c }) => /* @__PURE__ */ b.jsx("div", { className: D.NAV_BUTTON, children: /* @__PURE__ */ b.jsx(
  ji,
  {
    text: l.text,
    color: l.color || "maroon",
    href: l.href,
    onClick: (s) => c(s, l),
    onKeyDown: (s) => c(s, l)
  }
) });
x1.propTypes = {
  link: E.shape({
    text: E.string,
    color: E.string,
    href: E.string
  }),
  dropdownName: E.string,
  handleLinkEvent: E.func
};
const C1 = ({ link: l, dropdownName: o, handleLinkEvent: c }) => /* @__PURE__ */ b.jsx("li", { className: D.NAV_LINK, children: /* @__PURE__ */ b.jsx(
  "a",
  {
    ...l.href ? {} : { tabIndex: 0 },
    href: l.href,
    onClick: (s) => c(s, l),
    onKeyDown: (s) => c(s, l),
    children: l.text
  }
) });
C1.propTypes = {
  link: E.shape({
    text: E.string,
    href: E.string
  }),
  dropdownName: E.string,
  handleLinkEvent: E.func
};
const N1 = ({
  dropdownName: l,
  items: o = [],
  buttons: c = [],
  classes: s = "",
  listId: u,
  opened: d,
  parentLink: h
}) => {
  const {
    breakpoint: A,
    headerHeight: y,
    setItemOpened: S,
    setMobileMenuOpen: B,
    mobileMenuOpen: w
  } = Zn(), C = o.reduce((I, k) => k != null && k[0] ? I + (k[0].span || 1) : I, 0), _ = C > 2, H = wl(null), [G, F] = yn(!1), K = o.length > 1;
  Ie(() => {
    var I;
    if (typeof window < "u" && H.current) {
      const k = (I = H == null ? void 0 : H.current) == null ? void 0 : I.getBoundingClientRect().left, Y = window.innerWidth * 0.55;
      F(k > Y);
    }
  }, []), Ie(() => {
    var I;
    d && ((I = H == null ? void 0 : H.current) != null && I.parentElement) && H.current.parentElement.scrollIntoView(
      /** @type {ScrollIntoViewOptions} */
      {
        behavior: "smooth",
        block: "start"
      }
    );
  }, [H, d]);
  const X = (I) => I == null ? void 0 : I.stopPropagation(), nt = (I, k) => {
    var Tt, St;
    const { key: Y, type: Z, target: ct } = I, wt = ct == null ? void 0 : ct.parentElement, At = () => {
      var V;
      const xt = (V = wt == null ? void 0 : wt.nextElementSibling) == null ? void 0 : V.firstChild;
      typeof (xt == null ? void 0 : xt.focus) == "function" && xt.focus();
    }, Gt = () => {
      var V;
      const xt = (V = wt == null ? void 0 : wt.previousElementSibling) == null ? void 0 : V.firstChild;
      typeof (xt == null ? void 0 : xt.focus) == "function" && xt.focus();
    };
    X(I), Y === "ArrowDown" ? (I.preventDefault(), At()) : Y === "ArrowUp" ? (I.preventDefault(), Gt()) : Y === "Escape" && d ? (S(), typeof ((Tt = h == null ? void 0 : h.current) == null ? void 0 : Tt.focus) == "function" && h.current.focus()) : Y === "Escape" && !d && w ? B(!1) : (Y === "Enter" || Y === " " || Z === "click") && (B(!1), S(), (St = k == null ? void 0 : k.onClick) == null || St.call(k, I), Nt({ ...$4, text: k.text }));
  }, ot = (I, k) => {
    if (!I) return null;
    const Y = `${I.text}-${I.href}-${k}`;
    return I.type === "heading" ? /* @__PURE__ */ b.jsx(T1, { text: I.text }, Y) : I.type === "button" ? /* @__PURE__ */ b.jsx(
      x1,
      {
        link: I,
        dropdownName: l,
        handleLinkEvent: nt
      },
      Y
    ) : /* @__PURE__ */ b.jsx(
      C1,
      {
        link: I,
        dropdownName: l,
        handleLinkEvent: nt
      },
      Y
    );
  };
  return /* @__PURE__ */ b.jsxs(
    _4,
    {
      ref: H,
      className: `${s}${G ? " aligned-right" : ""}${_ ? " mega" : ""}`,
      breakpoint: A,
      headerHeight: y,
      children: [
        /* @__PURE__ */ b.jsx(
          "div",
          {
            style: { "--cols": C < 3 ? 4 : C },
            id: K ? u : "",
            className: D.DROPDOWN_CONTAINER,
            children: /* @__PURE__ */ b.jsx(b.Fragment, { children: o == null ? void 0 : o.map((I, k) => {
              const Z = $p(`dropdown-item-${k}-`).next().value;
              return I != null && I.length ? /* @__PURE__ */ b.jsx(
                "div",
                {
                  className: D.DROPDOWN_CONTAINER_COLUMN,
                  style: { "--span": I[0].span || 1 },
                  id: K ? `${u}-${Z}` : u,
                  children: (() => {
                    let ct = [];
                    const wt = [];
                    return I.forEach((At, Gt) => {
                      At.type === "heading" ? (ct.length > 0 && (wt.push(ct), ct = []), wt.push([At])) : At.type === "button" ? (ct.length > 0 && (wt.push(ct), ct = []), wt.push([At])) : ct.push(At);
                    }), ct.length > 0 && wt.push(ct), wt.map((At, Gt) => {
                      const Tt = `${Z}-group-${Gt}`;
                      return At.length === 1 && At[0].type === "heading" || At.length === 1 && At[0].type === "button" ? ot(At[0], Gt) : /* @__PURE__ */ b.jsx("ul", { children: At.map((St, xt) => ot(St, xt)) }, Tt);
                    });
                  })()
                },
                `${u}-${Z}`
              ) : null;
            }) })
          }
        ),
        c.length > 0 && /* @__PURE__ */ b.jsx("div", { className: D.DROPDOWN_BUTTON_CONTAINER, children: /* @__PURE__ */ b.jsx("div", { children: c.map((I, k) => /* @__PURE__ */ b.jsx(
          ji,
          {
            color: I.color,
            text: I.text,
            href: I.href,
            onClick: X
          },
          `${I.text}-${I.href || k}`
        )) }) })
      ]
    }
  );
};
N1.propTypes = {
  dropdownName: E.string,
  items: E.arrayOf(
    E.arrayOf(
      E.shape({
        text: E.string,
        selected: E.bool,
        onClick: E.func,
        href: E.string
      })
    )
  ),
  buttons: E.arrayOf(E.shape(Yc)),
  classes: E.string,
  listId: E.string,
  opened: E.bool,
  setItemOpened: E.func,
  parentLink: E.shape({
    current: E.instanceOf(HTMLElement)
  })
};
const tE = ze.li`
  position: relative;
  padding: 0;
  max-width: 100%;
  margin: 0 0.5rem 0 0;
  &:has(.${D.OPEN_LINK}) > a:after,
  &:hover > a:after {
    width: calc(100% + 24px);
  }
  > a {
    display: inline-block;
    padding: 0.5rem 0.75rem;
    line-height: 1rem;
    color: ${tn};

    &[aria-expanded="true"] {
      background-color: ${Kn};
      position: sticky;
      top: 0;
      z-index: 1;
    }
    &:after {
      transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      content: "";
      display: block;
      height: 0.5rem;
      position: relative;
      top: 0.6rem;
      right: 12px;
      width: 0;
      background-image: linear-gradient(
        to right,
        transparent 0.5%,
        ${Cd} 0.5%
      );
    }
    &.${D.NAV_ITEM_SELECTED}:after {
      width: calc(100% + 24px);
    }
    &.nav-item {
      display: block;
    }
    > span {
      position: relative;
      .${D.CHEVRON_ICON} {
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin-left: 0.5rem;
        font-size: 0.75rem;

        &.${D.OPEN} {
          transform: rotate(180deg);
        }
      }
    }
    .${D.MOBILE_ONLY} {
      display: none;
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    border-bottom: 1px solid ${Rc};
    margin: 0;
    &:first-child {
      border-top: 1px solid ${Rc};
    }
    &:hover > a:after {
      width: 100%;
    }
    .${D.ICON_NAV_ITEM} {
      display: none;
    }
    > a {
      padding: 1rem 2rem 0.75rem;
      width: 100%;
      &.${D.OPEN_LINK} {
        border-bottom: 1px solid ${Rc};
      }
      &:after {
        right: 0;
        top: 0.8rem;
      }
      &.${D.NAV_ITEM_SELECTED}:after {
        width: 100%;
      }
      > span {
        display: flex;
        justify-content: space-between;
        .${D.CHEVRON_ICON} {
          font-size: 1.25rem;
        }
      }
      .${D.MOBILE_ONLY} {
        display: initial;
      }
    }
  }
`, eE = {
  event: "collapse",
  type: "click"
}, jf = {
  event: "link",
  action: "click",
  name: "onclick",
  type: "internal link",
  region: "navbar",
  section: "main navbar",
  component: "navigation link",
  text: ""
}, w1 = ({ children: l }) => /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
  /* @__PURE__ */ b.jsx(
    Ye,
    {
      icon: _3,
      className: D.ICON_NAV_ITEM,
      alt: ""
    }
  ),
  /* @__PURE__ */ b.jsx("span", { className: D.MOBILE_ONLY, children: l })
] });
w1.propTypes = {
  children: E.node
};
const D1 = ({ link: l, setItemOpened: o, itemOpened: c }) => {
  const s = wl(null), u = wl(null), d = l.id === c, {
    breakpoint: h,
    expandOnHover: A = !1,
    title: y,
    mobileMenuOpen: S = !1,
    setMobileMenuOpen: B
  } = Zn(), w = nr(h);
  Ie(() => {
    const F = (X) => {
      var nt;
      d && !w && !((nt = s == null ? void 0 : s.current) != null && nt.contains(X == null ? void 0 : X.target)) && o();
    }, K = () => {
      requestAnimationFrame(() => {
        const X = s.current;
        d && !w && X && !X.contains(document.activeElement) && o();
      });
    };
    return document.addEventListener("click", F, !0), document.addEventListener("focusin", K), () => {
      document.removeEventListener("click", F, !0), document.removeEventListener("focusin", K);
    };
  }, [d, o, w]);
  const C = Yv(() => {
    var F;
    return l.type === "icon-home" ? /* @__PURE__ */ b.jsx(w1, { children: l.text }) : /* @__PURE__ */ b.jsxs("span", { children: [
      l.text,
      !!((F = l.items) != null && F.length) && /* @__PURE__ */ b.jsx(
        Ye,
        {
          icon: L0,
          className: zn(
            D.CHEVRON_ICON,
            d && D.OPEN
          ),
          alt: ""
        }
      )
    ] });
  }, [l]), _ = () => {
    var nt;
    const F = !!((nt = l.items) != null && nt.length), K = d ? "close" : "open", { text: X } = l;
    Nt(
      // @ts-ignore
      F ? {
        ...jf,
        ...eE,
        action: K,
        text: X
      } : {
        ...jf,
        text: l.type === "icon-home" ? "home button" : X
      }
    );
  }, H = (F) => {
    var nt, ot, I, k;
    if (!l.items && (l.href || l.onClick) && (F.key === "Enter" || F.key === " " || F.type === "click")) {
      Nt({ ...jf, text: l.text }), B(!1), o(), (nt = l.onClick) == null || nt.call(l, F);
      return;
    }
    const { key: K } = F;
    if ([
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Enter",
      " ",
      "Escape",
      "Click"
    ].includes(K)) {
      if (F.preventDefault(), K === "Escape" && d) {
        typeof ((ot = s == null ? void 0 : s.current) == null ? void 0 : ot.focus) == "function" && s.current.focus(), o();
        return;
      }
      if (K === "Escape" && !d && S) {
        B(!1);
        return;
      }
      if ((K === "Enter" || K === " ") && (l.items ? o() : (B(!1), o(), (I = l.onClick) == null || I.call(l, F)), _()), (K === "ArrowDown" || K === "ArrowRight") && d) {
        const Y = document.querySelector(
          `.${Yp(l.id)} li.${D.NAV_LINK} a`
        );
        typeof (Y == null ? void 0 : Y.focus) == "function" && Y.focus();
      }
    } else F.type === "click" && l.items ? (F.preventDefault(), _(), o()) : F.type === "click" && (_(), (k = l.onClick) == null || k.call(l, F));
  }, G = () => {
    A && !w && (o(), _());
  };
  return /* @__PURE__ */ b.jsxs(
    tE,
    {
      breakpoint: h,
      ref: s,
      onMouseEnter: G,
      onMouseLeave: G,
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            onKeyDown: H,
            onClick: H,
            href: l.href,
            ...l.items ? { "aria-expanded": d } : {},
            ...l.href ? {} : { tabIndex: 0 },
            "aria-owns": l.items ? `dropdown-${l.id}` : null,
            className: zn(
              l.class,
              l.selected && D.NAV_ITEM_SELECTED,
              d && D.OPEN_LINK
            ),
            "data-testid": "nav-item",
            title: l.type === "icon-home" && y ? `${y} home page` : l.text,
            ref: u,
            children: C
          }
        ),
        l.items && /* @__PURE__ */ b.jsx(
          N1,
          {
            items: l.items,
            buttons: l.buttons,
            dropdownName: l.text,
            classes: zn(
              Yp(l.id),
              d && D.OPENED
            ),
            listId: `dropdown-${l.id}`,
            opened: d,
            parentLink: u
          }
        )
      ]
    }
  );
};
D1.propTypes = {
  link: Vf,
  setItemOpened: E.func,
  itemOpened: E.number
};
const nE = "Header buttons cannot have both an onClick and an href property as this breaks accessibility. Please remove one", kp = () => {
  const {
    navTree: l = [],
    mobileNavTree: o = [],
    buttons: c = [],
    breakpoint: s,
    itemOpened: u,
    setItemOpened: d
  } = Zn(), h = nr(s), A = (w) => {
    u === w ? d(() => {
    }) : setTimeout(() => d(() => w), 1);
  }, y = (w) => {
    w.onClick && w.href && console.error(nE);
  }, S = (w) => () => {
    Nt({
      event: "link",
      action: "click",
      name: "onclick",
      region: "navbar",
      type: "internal link",
      section: "main navbar",
      text: w.text
    }), w.onClick && w.onClick();
  }, B = (w, C) => {
    const _ = { ...w, id: C }, G = $p(`${w.text}-${C}-`).next().value;
    return /* @__PURE__ */ b.jsx(
      D1,
      {
        link: _,
        setItemOpened: () => A(C),
        itemOpened: u
      },
      G
    );
  };
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsxs(J4, { breakpoint: s, "data-testid": "navigation", "aria-label": "Site", children: [
      ((l == null ? void 0 : l.length) || (o == null ? void 0 : o.length) || (c == null ? void 0 : c.length)) && /* @__PURE__ */ b.jsxs("div", { className: D.CONTENT_CONTAINER, children: [
        ((l == null ? void 0 : l.length) || (o == null ? void 0 : o.length)) && /* @__PURE__ */ b.jsx("ul", { className: D.NAV_LIST, children: o != null && o.length && h ? o == null ? void 0 : o.map((w, C) => B(w, C)) : l == null ? void 0 : l.map((w, C) => B(w, C)) }),
        !!(c != null && c.length) && /* @__PURE__ */ b.jsx(
          "form",
          {
            className: D.BUTTONS_CONTAINER,
            "data-testid": "buttons-container",
            children: c.map((w) => (y(w), /* @__PURE__ */ Zp(
              ji,
              {
                ...w,
                key: w.text,
                onClick: S(w)
              }
            )))
          }
        )
      ] }),
      h && /* @__PURE__ */ b.jsx(S1, {})
    ] })
  );
}, aE = "data:image/png;base64,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", lE = ze.div`
  margin: 0.5rem 0;
  a {
    display: inline-block;
    &:not(:last-child) {
      border-right: 1px solid ${$e};
      margin-right: 1.5rem;
      padding-right: 1.5rem;
    }
    img {
      height: 52px;
      width: auto;
      &.${D.LOGO_VERT} {
        display: initial;
      }
      &.${D.LOGO_HORIZ} {
        display: none;
      }
    }
  }
  @media (max-width: ${({ breakpoint: l }) => l}) {
    margin: 0.5rem 0 1rem 1rem;
    a {
      &:not(:last-child) {
        margin-right: 1rem;
        padding-right: 1rem;
      }
      img {
        height: 32px;
        width: auto;
        &.${D.LOGO_VERT} {
          display: none;
        }
        &.${D.LOGO_HORIZ} {
          height: 24px;
          width: auto;
          display: initial;
        }
      }
    }
  }
  @media (max-width: 370px) {
    margin: 0.5rem 0 1rem 0.5rem;
    a {
      &:not(:last-child) {
        margin-right: 0.5rem;
        padding-right: 0.5rem;
      }
      img {
        height: 29px;
        &.${D.LOGO_HORIZ} {
          height: 21px;
        }
      }
    }
  }
`, iE = () => {
  const { partnerLogo: l, logo: o, breakpoint: c } = Zn();
  return (
    // @ts-ignore
    /* @__PURE__ */ b.jsxs(lE, { breakpoint: c, "data-testid": "partner", children: [
      /* @__PURE__ */ b.jsx(
        "a",
        {
          href: (l == null ? void 0 : l.brandLink) ?? "https://starbucks.asu.edu/",
          onClick: () => Nt({
            event: "link",
            action: "click",
            name: "onclick",
            region: "navbar",
            type: "internal link",
            section: "main navbar",
            text: "partner logo"
          }),
          children: /* @__PURE__ */ b.jsx(
            "img",
            {
              src: (l == null ? void 0 : l.src) ?? aE,
              alt: (l == null ? void 0 : l.alt) ?? "ASU Starbucks logo",
              width: "232",
              height: "81",
              decoding: "async",
              fetchpriority: "high"
            }
          )
        }
      ),
      /* @__PURE__ */ b.jsxs(
        "a",
        {
          href: (o == null ? void 0 : o.brandLink) ?? "https://asu.edu",
          onClick: () => Nt({ text: "asu logo" }),
          children: [
            /* @__PURE__ */ b.jsx(
              "img",
              {
                className: D.LOGO_VERT,
                src: (o == null ? void 0 : o.src) ?? O1,
                alt: (o == null ? void 0 : o.alt) ?? "Arizona State University logo",
                width: "303",
                height: "234",
                decoding: "async",
                fetchpriority: "high"
              }
            ),
            /* @__PURE__ */ b.jsx(
              "img",
              {
                className: D.LOGO_HORIZ,
                src: (o == null ? void 0 : o.mobileSrc) ?? E1,
                alt: (o == null ? void 0 : o.alt) ?? "Arizona State University logo",
                width: "400",
                height: "72",
                decoding: "async",
                fetchpriority: "high"
              }
            )
          ]
        }
      )
    ] })
  );
}, oE = (l, o) => {
  const c = new Date(l);
  return c.setMinutes(c.getMinutes() + o), c;
}, rE = (l) => {
  const o = "localhost", c = "title_loaded", s = /* @__PURE__ */ new Date(), u = l || window.location.hostname, d = localStorage.getItem("title_loaded"), h = s.getTime() > parseInt(d, 10), A = u === o, y = document.referrer.includes(u);
  if (A || !y && (!d || h)) {
    const B = oE(s, 10).getTime();
    return localStorage.setItem(c, B.toString()), !0;
  }
  return !1;
}, cE = {
  "992px": "993px",
  "1260px": "1261px"
}, qp = ze.div`
  line-height: 1;
  font-size: 1rem;
  font-weight: 700;
  padding: 0 2rem 1rem 2rem;
  letter-spacing: -1px;
  display: inline-block;
  margin: 0;
  width: max-content;

  &.active {
    background-position: -200%;
  }

  > .${D.UNIT_NAME} {
    display: none;
  }
  .${D.UNIT_NAME},
    .${D.SUBUNIT_NAME},
    .${D.TITLE_SUBUNIT_NAME} {
    color: ${tn};
  }

  .${D.SUBUNIT_NAME}, .${D.TITLE_SUBUNIT_NAME} {
    background-image: linear-gradient(
      to right,
      transparent 51%,
      ${Cd} 51%,
      95%,
      transparent
    );
    background-position: 0 0;
    background-size: 200%;
    display: inline-block;
    transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
    transition-duration: 1.5s;
    &.active {
      background-position: -200%;
    }
  }

  @media (min-width: ${({ breakpoint: l }) => cE[l]}) {
    line-height: 1;
    font-weight: 700;
    padding: 0;
    margin: 1rem 0 0.5rem 0;
    > .${D.UNIT_NAME} {
      font-size: 1rem;
      margin-bottom: 0.5rem;
      display: block;

      :hover {
        text-decoration: underline;
      }
    }
    .${D.SUBUNIT_NAME} {
      font-size: 1.5rem;
      margin-bottom: 0;
      display: inline-block;

      :hover {
        text-decoration: underline;
      }
    }
    .${D.TITLE_SUBUNIT_NAME} {
      font-size: 2rem;
      font-weight: 700;
      display: inline-block;
      margin: 0.5rem 0 0.5rem 0;

      :hover {
        text-decoration: underline;
      }
    }
  }
`, B1 = () => {
  const [l, o] = yn(!1), { title: c, parentOrg: s, parentOrgUrl: u, baseUrl: d, breakpoint: h, animateTitle: A } = Zn();
  return Ie(() => {
    if (A !== !1) {
      let y = d === "/" ? window.location.hostname : d;
      !y.includes(window.location.hostname) && y.indexOf("/") === 0 && (y = window.location.hostname + y), rE(y) && o(!0);
    }
  }, [l, A, d]), s ? /* @__PURE__ */ b.jsxs(
    qp,
    {
      breakpoint: h,
      className: D.TITLE,
      "data-testid": "title",
      children: [
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: D.UNIT_NAME,
            href: u,
            onClick: () => Nt({
              event: "link",
              action: "click",
              name: "onclick",
              region: "navbar",
              type: "internal link",
              section: "main navbar",
              text: s
            }),
            title: `${s} home page`,
            children: s
          }
        ),
        /* @__PURE__ */ b.jsx(
          "a",
          {
            className: zn(
              D.SUBUNIT_NAME,
              l && "active"
            ),
            href: d,
            onClick: () => Nt({
              event: "link",
              action: "click",
              name: "onclick",
              region: "navbar",
              type: "internal link",
              section: "main navbar",
              text: c
            }),
            title: `${c} home page`,
            children: c
          }
        )
      ]
    }
  ) : /* @__PURE__ */ b.jsx(
    qp,
    {
      breakpoint: h,
      className: D.TITLE,
      "data-testid": "title",
      children: /* @__PURE__ */ b.jsx(
        "a",
        {
          className: zn(
            D.TITLE_SUBUNIT_NAME,
            l && "active"
          ),
          href: d,
          onClick: () => Nt({
            event: "link",
            action: "click",
            name: "onclick",
            region: "navbar",
            type: "internal link",
            section: "main navbar",
            text: c
          }),
          title: `${c} home page`,
          children: c
        }
      )
    }
  );
};
B1.propTypes = { ...Nc };
const uE = () => {
  const {
    breakpoint: l,
    isPartner: o,
    hasNavigation: c,
    itemOpened: s,
    setItemOpened: u,
    mobileMenuOpen: d,
    setMobileMenuOpen: h,
    mobileMenuToggleRef: A,
    headerTop: y
  } = Zn(), S = nr(l), B = () => {
    h((C) => !C);
  };
  Ie(() => (document.body.style.overflow = d || s !== void 0 ? "hidden" : "unset", () => {
    document.body.style.overflow = "unset";
  }), [d, s, S]), Ie(() => {
    h(!1), u();
  }, [S]);
  const w = () => {
    B(), Nt({
      event: "collapse",
      action: d ? "close" : "open",
      type: "click",
      text: "menu button tablet"
    });
  };
  return /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    !S && /* @__PURE__ */ b.jsx(S1, {}),
    /* @__PURE__ */ b.jsx(Z4, { breakpoint: l, headerTop: y, children: /* @__PURE__ */ b.jsx("div", { className: "container-xl", children: /* @__PURE__ */ b.jsx("div", { className: D.HEADER_MAIN, children: /* @__PURE__ */ b.jsxs(
      "div",
      {
        className: zn(
          D.NAVBAR,
          D.NAVBAR_EXPAND_XL,
          o && D.PARTNER,
          d && D.MOBILE_MENU_OPEN
        ),
        children: [
          !o && /* @__PURE__ */ b.jsx(W4, {}),
          /* @__PURE__ */ b.jsxs(
            "button",
            {
              ref: A,
              className: zn(
                D.NAVBAR_TOGGLER,
                !d && D.COLLAPSED
              ),
              type: "button",
              onClick: w,
              "aria-label": d ? "Close menu" : "Open menu",
              "aria-expanded": d,
              children: [
                /* @__PURE__ */ b.jsx(
                  "img",
                  {
                    src: G4,
                    alt: "Menu and Search Icon",
                    className: D.MENU_SEARCH_ICON
                  }
                ),
                /* @__PURE__ */ b.jsx(
                  Ye,
                  {
                    icon: eS,
                    alt: "",
                    className: D.MENU_CLOSE_ICON
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ b.jsxs(
            "div",
            {
              className: zn(
                !o && D.EXPAND_TITLE,
                o && D.PARTNER_TITLE,
                !c && D.NO_NAVIGATION
              ),
              children: [
                o ? /* @__PURE__ */ b.jsx(iE, {}) : /* @__PURE__ */ b.jsx(B1, {}),
                !S && /* @__PURE__ */ b.jsx(kp, {})
              ]
            }
          ),
          d && S && /* @__PURE__ */ b.jsx(b1, {}),
          d && S && /* @__PURE__ */ b.jsx(kp, {})
        ]
      }
    ) }) }) })
  ] });
}, sE = (l, o) => l == null ? void 0 : l.findIndex(
  (c) => {
    var s;
    return (c == null ? void 0 : c.href) === o || // !Some applications might send invalid items props as an empty string
    Array.isArray(c.items) && ((s = c.items) == null ? void 0 : s.flat().find(({ href: u }) => u === o));
  }
), fE = (l) => l == null ? void 0 : l.find((o) => o.selected), Kp = (l) => {
  if (!Array.isArray(l) || l.length === 0 || fE(l))
    return l;
  let o = "";
  if (window != null && window.location && (o = window.location.pathname + window.location.search), !o)
    return l;
  const c = sE(l, o);
  if (c === -1)
    return l;
  const s = [...l];
  return s[c].selected = !0, s;
}, M1 = { Lg: "992px", Xl: "1260px" }, dE = q3`
  html {
    scrollbar-gutter: stable;
  }
`, mE = ze.header`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  .container-xl {
    height: 100%;
    max-width: 1224px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }
  button,
  a {
    text-decoration: none;
    &:focus {
      outline: none !important;
      box-shadow:
        0px 0px 0px 2px ${Kn},
        0px 0px 0px 4px ${tn} !important;
    }
  }
  @media (min-width: ${({ breakpoint: l }) => M1[l]}) {
    &.scrolled {
      .${D.TITLE} {
        margin: 0.5rem 0 0 0;
      }
      a.${D.UNIT_NAME} {
        display: none;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      a.${D.SUBUNIT_NAME} {
        margin: 0.52rem 0;
      }
      a.${D.SUBUNIT_NAME}, a.${D.TITLE_SUBUNIT_NAME} {
        font-size: 1.5em;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      .navbar-brand img {
        height: 64px;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin: 12px 1rem 12px 0;
      }
    }
  }
  @media (max-width: 1260px) {
    .container-xl {
      padding-left: 0;
      padding-right: 0;
      max-width: 100%;
    }
  }
`, hE = ze.div`
  font-family:
    Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, sans-serif;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  .container-xl {
    height: 100%;
    max-width: 1224px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }
  button,
  a {
    text-decoration: none;
    &:focus {
      outline: none !important;
      box-shadow:
        0px 0px 0px 2px ${Kn},
        0px 0px 0px 4px ${tn} !important;
    }
  }
  @media (min-width: ${({ breakpoint: l }) => M1[l]}) {
    &.scrolled {
      .${D.TITLE} {
        margin: 0.5rem 0 0 0;
      }
      a.${D.UNIT_NAME} {
        display: none;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      a.${D.SUBUNIT_NAME} {
        margin: 0.52rem 0;
      }
      a.${D.SUBUNIT_NAME}, a.${D.TITLE_SUBUNIT_NAME} {
        font-size: 1.5em;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
      }
      .navbar-brand img {
        height: 64px;
        transition: 0.5s cubic-bezier(0.19, 1, 0.19, 1);
        margin: 12px 1rem 12px 0;
      }
    }
  }
  @media (max-width: 1260px) {
    .container-xl {
      padding-left: 0;
      padding-right: 0;
      max-width: 100%;
    }
  }
`, L1 = ({
  isPartner: l = !1,
  navTree: o,
  title: c,
  baseUrl: s = "/",
  parentOrg: u,
  parentOrgUrl: d,
  partnerLogo: h,
  logo: A,
  loggedIn: y,
  userName: S,
  loginLink: B,
  onLoginClick: w,
  logoutLink: C,
  onLogoutClick: _,
  buttons: H,
  breakpoint: G = "Xl",
  animateTitle: F = !1,
  expandOnHover: K = !1,
  mobileNavTree: X,
  searchUrl: nt,
  site: ot,
  renderDiv: I = "false"
}) => {
  const k = Kp(o) || [], Y = Kp(X) || [], Z = wl(null), ct = wl(null), [wt, At] = yn(void 0), [Gt, Tt] = yn(!1), [St, xt] = yn(150), [V, j] = yn(0), q = (lt = void 0) => {
    At(lt);
  }, ut = (lt = !1) => {
    ct != null && ct.current && typeof ct.current.focus == "function" && ct.current.focus(), Tt(lt);
  }, ht = () => {
    Z != null && Z.current && (Z.current.focus(), typeof window < "u" && window.scrollTo(0, 0)), ut(), q(), typeof document < "u" && (document.body.style.overflow = "unset");
  }, Wt = () => {
    if (typeof window > "u") return;
    const lt = window.scrollY;
    Z != null && Z.current && (lt > Z.current.getBoundingClientRect().top ? Z.current.classList.add("scrolled") : Z.current.classList.remove("scrolled"), j(Z.current.getBoundingClientRect().top), xt(Z.current.getBoundingClientRect().bottom));
  };
  Ie(() => {
    typeof window < "u" && e0({
      packageName: "component-header",
      component: "Component Header",
      type: "NA",
      configuration: {
        site: ot,
        isPartner: l,
        searchUrl: nt,
        navTree: k,
        parentOrg: u,
        buttons: H,
        mobileNavTree: Y
      }
    });
  }, []), Ie(() => {
    Z != null && Z.current && (xt(Z.current.getBoundingClientRect().bottom), j(Z.current.getBoundingClientRect().top));
  }, [Z, Gt]), Ie(() => {
    if (typeof window > "u") return;
    const lt = () => Nb(Wt, 100);
    return window.addEventListener("scroll", lt), () => {
      window.removeEventListener("scroll", lt);
    };
  }, []);
  const Ct = () => {
    const lt = I === "true" ? hE : mE;
    return /* @__PURE__ */ b.jsx(lt, { id: "asuHeader", breakpoint: G, ref: Z, children: /* @__PURE__ */ b.jsx(uE, {}) });
  };
  return /* @__PURE__ */ b.jsxs(
    v1,
    {
      initialValue: {
        isPartner: l,
        navTree: k,
        title: c,
        baseUrl: s,
        parentOrg: u,
        parentOrgUrl: d,
        partnerLogo: h,
        logo: A,
        loggedIn: y,
        userName: S,
        loginLink: B,
        onLoginClick: w,
        logoutLink: C,
        onLogoutClick: _,
        buttons: H,
        breakpoint: G,
        animateTitle: F,
        expandOnHover: K,
        mobileNavTree: Y,
        hasNavigation: !!(k != null && k.length) || !!(Y != null && Y.length),
        searchUrl: nt,
        headerTop: V,
        headerHeight: St,
        itemOpened: wt,
        setItemOpened: q,
        mobileMenuOpen: Gt,
        setMobileMenuOpen: ut,
        singlePageAppReset: ht,
        mobileMenuToggleRef: ct,
        site: ot
      },
      children: [
        /* @__PURE__ */ b.jsx(dE, {}),
        Ct()
      ]
    }
  );
};
L1.propTypes = { ...n0 };
const gE = (l, o, c) => {
  Pp.createRoot(c).render(Pt.createElement(l, o));
}, vE = ({ targetSelector: l, props: o }) => {
  gE(L1, o, document.querySelector(l));
};
export {
  p1 as ASUFooter,
  L1 as ASUHeader,
  yE as initASUFooter,
  vE as initGlobalHeader
};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.5/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
